// This file is auto-generated. Do not edit manually.

const airports = [
  {
    "value": "AAL",
    "label": "Aalborg Aalborg Airport (AAL)"
  },
  {
    "value": "AAR",
    "label": "Aarhus Aarhus Airport (AAR)"
  },
  {
    "value": "JEG",
    "label": "Aasiaat Aasiaat Airport (JEG)"
  },
  {
    "value": "ABD",
    "label": "Abadan Abadan Airport (ABD)"
  },
  {
    "value": "ABA",
    "label": "Abakan Abakan International Airport (ABA)"
  },
  {
    "value": "CIS",
    "label": "Abariringa Canton Island Airport (CIS)"
  },
  {
    "value": "YXX",
    "label": "Abbotsford Abbotsford International Airport (YXX)"
  },
  {
    "value": "AEH",
    "label": "Abeche Abeche Airport (AEH)"
  },
  {
    "value": "ABZ",
    "label": "Aberdeen Aberdeen Dyce Airport (ABZ)"
  },
  {
    "value": "ABR",
    "label": "Aberdeen Aberdeen Regional Airport (ABR)"
  },
  {
    "value": "APG",
    "label": "Aberdeen Phillips Army Air Field (APG)"
  },
  {
    "value": "AHB",
    "label": "Abha Abha International Airport (AHB)"
  },
  {
    "value": "ABJ",
    "label": "Abidjan Félix-Houphouët-Boigny International Airport (ABJ)"
  },
  {
    "value": "ABI",
    "label": "Abilene Abilene Regional Airport (ABI)"
  },
  {
    "value": "DYS",
    "label": "Abilene Dyess Air Force Base (DYS)"
  },
  {
    "value": "MYG",
    "label": "Abrahams Bay Mayaguana Airport (MYG)"
  },
  {
    "value": "AZI",
    "label": "Abu Dhabi Al Bateen Executive Airport (AZI)"
  },
  {
    "value": "AUH",
    "label": "Abu Dhabi Zayed International Airport (AUH)"
  },
  {
    "value": "AEU",
    "label": "Abu Musa Abu Musa Island Airport (AEU)"
  },
  {
    "value": "ABS",
    "label": "Abu Simbel Abu Simbel Airport (ABS)"
  },
  {
    "value": "ABV",
    "label": "Abuja Nnamdi Azikiwe International Airport (ABV)"
  },
  {
    "value": "ACA",
    "label": "Acapulco General Juan N. Álvarez International Airport (ACA)"
  },
  {
    "value": "AGV",
    "label": "Acarigua Oswaldo Guevara Mujica Airport (AGV)"
  },
  {
    "value": "ACC",
    "label": "Accra Kotoka International Airport (ACC)"
  },
  {
    "value": "ACS",
    "label": "Achinsk Achinsk Airport (ACS)"
  },
  {
    "value": "DMM",
    "label": "Ad Dammam King Fahd International Airport (DMM)"
  },
  {
    "value": "ADT",
    "label": "Ada Ada Regional Airport (ADT)"
  },
  {
    "value": "ADK",
    "label": "Adak Adak Airport (ADK)"
  },
  {
    "value": "ADD",
    "label": "Addis Ababa Addis Ababa Bole International Airport (ADD)"
  },
  {
    "value": "ADL",
    "label": "Adelaide Adelaide International Airport (ADL)"
  },
  {
    "value": "ADE",
    "label": "Aden Aden International Airport (ADE)"
  },
  {
    "value": "ADF",
    "label": "Adıyaman Adıyaman Airport (ADF)"
  },
  {
    "value": "AZR",
    "label": "Adrar Touat Cheikh Sidi Mohamed Belkebir Airport (AZR)"
  },
  {
    "value": "AFY",
    "label": "Afyonkarahisar Afyon Air Base (AFY)"
  },
  {
    "value": "AJY",
    "label": "Agadez Mano Dayak International Airport (AJY)"
  },
  {
    "value": "AGA",
    "label": "Agadir (Temsia) Al Massira Airport (AGA)"
  },
  {
    "value": "IXA",
    "label": "Agartala Agartala - Maharaja Bir Bikram Airport (IXA)"
  },
  {
    "value": "AGX",
    "label": "Agatti Agatti Airport (AGX)"
  },
  {
    "value": "AGF",
    "label": "Agen/La Garenne Agen-La Garenne Airport (AGF)"
  },
  {
    "value": "AGZ",
    "label": "Aggeneys Aggeneys Airport (AGZ)"
  },
  {
    "value": "AKW",
    "label": "Aghajari Aghajari Airport (AKW)"
  },
  {
    "value": "LUG",
    "label": "Agno Lugano Airport (LUG)"
  },
  {
    "value": "AGR",
    "label": "Agra Agra Airport / Agra Air Force Station (AGR)"
  },
  {
    "value": "AJI",
    "label": "Ağrı Ağrı Airport (AJI)"
  },
  {
    "value": "BQN",
    "label": "Aguadilla Rafael Hernández International Airport (BQN)"
  },
  {
    "value": "AGU",
    "label": "Aguascalientes Jesús Terán Peredo International Airport (AGU)"
  },
  {
    "value": "AHE",
    "label": "Ahe Atoll Ahe Airport (AHE)"
  },
  {
    "value": "OUD",
    "label": "Ahl Angad Oujda Angads Airport (OUD)"
  },
  {
    "value": "XIJ",
    "label": "Ahmed Al Jaber AB Ahmed Al Jaber Air Base (XIJ)"
  },
  {
    "value": "AMD",
    "label": "Ahmedabad Sardar Vallabh Bhai Patel International Airport (AMD)"
  },
  {
    "value": "TNW",
    "label": "Ahuano Jumandy Airport (TNW)"
  },
  {
    "value": "AWZ",
    "label": "Ahvaz Lieutenant General Qasem Soleimani International Airport (AWZ)"
  },
  {
    "value": "AJL",
    "label": "Aizawl (Lengpui) Lengpui Airport (AJL)"
  },
  {
    "value": "AJA",
    "label": "Ajaccio/Napoléon Bonaparte Ajaccio-Napoléon Bonaparte Airport (AJA)"
  },
  {
    "value": "KQH",
    "label": "Ajmer (Kishangarh) Kishangarh Airport Ajmer (KQH)"
  },
  {
    "value": "AXT",
    "label": "Akita Akita Airport (AXT)"
  },
  {
    "value": "AKD",
    "label": "Akola Akola Airport (AKD)"
  },
  {
    "value": "CAK",
    "label": "Akron Akron Canton Regional Airport (CAK)"
  },
  {
    "value": "AKC",
    "label": "Akron Akron Fulton International Airport (AKC)"
  },
  {
    "value": "AKT",
    "label": "Akrotiri RAF Akrotiri (AKT)"
  },
  {
    "value": "AKU",
    "label": "Aksu (Onsu) Aksu Hongqipo Airport (AKU)"
  },
  {
    "value": "SCO",
    "label": "Aktau Aktau Airport (SCO)"
  },
  {
    "value": "AKX",
    "label": "Aktobe Aktobe Airport (AKX)"
  },
  {
    "value": "AKR",
    "label": "Akure Akure Airport (AKR)"
  },
  {
    "value": "AEY",
    "label": "Akureyri Akureyri Airport (AEY)"
  },
  {
    "value": "NDR",
    "label": "Al Aaroui Nador Al Aaroui International Airport (NDR)"
  },
  {
    "value": "AAN",
    "label": "Al Ain Al Ain International Airport (AAN)"
  },
  {
    "value": "LAQ",
    "label": "Al Albraq Al Abraq International Airport (LAQ)"
  },
  {
    "value": "AAY",
    "label": "Al Ghaydah Al Ghaydah International Airport (AAY)"
  },
  {
    "value": "TQD",
    "label": "Al Habbaniyah Al Taqaddum Air Base (TQD)"
  },
  {
    "value": "AHU",
    "label": "Al Hoceima Cherif Al Idrissi Airport (AHU)"
  },
  {
    "value": "SPX",
    "label": "Al Jiza Sphinx International Airport (SPX)"
  },
  {
    "value": "AKH",
    "label": "Al Kharj Prince Sultan Air Base (AKH)"
  },
  {
    "value": "MNH",
    "label": "Al Masna'ah Mussanah Airport (MNH)"
  },
  {
    "value": "ULH",
    "label": "Al Ula Majeed Bin Abdulaziz Airport (ULH)"
  },
  {
    "value": "EJH",
    "label": "Al Wajh Al Wajh Domestic Airport (EJH)"
  },
  {
    "value": "ABT",
    "label": "Al-Baha King Saud Bin Abdulaziz (Al Baha) Airport (ABT)"
  },
  {
    "value": "AJF",
    "label": "Al-Jawf Al-Jawf Domestic Airport (AJF)"
  },
  {
    "value": "ALM",
    "label": "Alamogordo Alamogordo White Sands Regional Airport (ALM)"
  },
  {
    "value": "HMN",
    "label": "Alamogordo Holloman Air Force Base (HMN)"
  },
  {
    "value": "ALS",
    "label": "Alamosa San Luis Valley Regional Airport/Bergman Field (ALS)"
  },
  {
    "value": "VIT",
    "label": "Alava Vitoria Airport (VIT)"
  },
  {
    "value": "ABC",
    "label": "Albacete Albacete Airport / Los Llanos Air Base (ABC)"
  },
  {
    "value": "ALH",
    "label": "Albany Albany Airport (ALH)"
  },
  {
    "value": "ALB",
    "label": "Albany Albany International Airport (ALB)"
  },
  {
    "value": "ABY",
    "label": "Albany Southwest Georgia Regional Airport (ABY)"
  },
  {
    "value": "LBI",
    "label": "Albi/Le Séquestre Albi-Le Séquestre Airport (LBI)"
  },
  {
    "value": "WOL",
    "label": "Albion Park Rail Shellharbour Airport (WOL)"
  },
  {
    "value": "PAC",
    "label": "Albrook Marcos A. Gelabert International Airport (PAC)"
  },
  {
    "value": "ABQ",
    "label": "Albuquerque Albuquerque International Sunport (ABQ)"
  },
  {
    "value": "TYS",
    "label": "Alcoa McGhee Tyson Airport (TYS)"
  },
  {
    "value": "WKK",
    "label": "Aleknagik Aleknagik / New Airport (WKK)"
  },
  {
    "value": "ALP",
    "label": "Aleppo Aleppo International Airport (ALP)"
  },
  {
    "value": "YLT",
    "label": "Alert Alert Airport (YLT)"
  },
  {
    "value": "AES",
    "label": "Ålesund Ålesund Airport, Vigra (AES)"
  },
  {
    "value": "ALJ",
    "label": "Alexander Bay Alexander Bay Airport (ALJ)"
  },
  {
    "value": "ALR",
    "label": "Alexandra Alexandra Aerodrome (ALR)"
  },
  {
    "value": "AEX",
    "label": "Alexandria Alexandria International Airport (AEX)"
  },
  {
    "value": "HBE",
    "label": "Alexandria Borj El Arab International Airport (HBE)"
  },
  {
    "value": "AXN",
    "label": "Alexandria Chandler Field (AXN)"
  },
  {
    "value": "ESF",
    "label": "Alexandria Esler Army Airfield / Esler Regional Airport (ESF)"
  },
  {
    "value": "AXD",
    "label": "Alexandroupolis Alexandroupoli Democritus Airport (AXD)"
  },
  {
    "value": "AHO",
    "label": "Alghero Alghero-Fertilia Airport (AHO)"
  },
  {
    "value": "ALG",
    "label": "Algiers Houari Boumediene Airport (ALG)"
  },
  {
    "value": "ALC",
    "label": "Alicante Alicante-Elche Miguel Hernández Airport (ALC)"
  },
  {
    "value": "ALI",
    "label": "Alice Alice International Airport (ALI)"
  },
  {
    "value": "ASP",
    "label": "Alice Springs Alice Springs Airport (ASP)"
  },
  {
    "value": "IXD",
    "label": "Allahabad Prayagraj Airport (IXD)"
  },
  {
    "value": "ABE",
    "label": "Allentown Lehigh Valley International Airport (ABE)"
  },
  {
    "value": "AIA",
    "label": "Alliance Alliance Municipal Airport (AIA)"
  },
  {
    "value": "YTF",
    "label": "Alma Alma Airport (YTF)"
  },
  {
    "value": "ALA",
    "label": "Almaty Almaty International Airport (ALA)"
  },
  {
    "value": "MEU",
    "label": "Almeirim Monte Dourado - Serra do Areão Airport (MEU)"
  },
  {
    "value": "LEI",
    "label": "Almería Almería Airport (LEI)"
  },
  {
    "value": "IUE",
    "label": "Alofi Niue International Airport (IUE)"
  },
  {
    "value": "AOR",
    "label": "Alor Satar Sultan Abdul Halim Airport (AOR)"
  },
  {
    "value": "APN",
    "label": "Alpena Alpena County Regional Airport (APN)"
  },
  {
    "value": "SSJ",
    "label": "Alstahaug Sandnessjøen Airport, Stokka (SSJ)"
  },
  {
    "value": "ALF",
    "label": "Alta Alta Airport (ALF)"
  },
  {
    "value": "AFL",
    "label": "Alta Floresta Piloto Osvaldo Marques Dias Airport (AFL)"
  },
  {
    "value": "LTI",
    "label": "Altai Altai Airport (LTI)"
  },
  {
    "value": "ATM",
    "label": "Altamira Altamira Interstate Airport (ATM)"
  },
  {
    "value": "AAT",
    "label": "Altay Altay Xuedu Airport (AAT)"
  },
  {
    "value": "RUI",
    "label": "Alto Sierra Blanca Regional Airport (RUI)"
  },
  {
    "value": "ALN",
    "label": "Alton/St Louis St Louis Regional Airport (ALN)"
  },
  {
    "value": "AOO",
    "label": "Altoona Altoona Blair County Airport (AOO)"
  },
  {
    "value": "LTS",
    "label": "Altus Altus Air Force Base (LTS)"
  },
  {
    "value": "TKN",
    "label": "Amagi Tokunoshima Airport (TKN)"
  },
  {
    "value": "ASJ",
    "label": "Amami Amami Airport (ASJ)"
  },
  {
    "value": "AMA",
    "label": "Amarillo Rick Husband Amarillo International Airport (AMA)"
  },
  {
    "value": "ATF",
    "label": "Ambato Chachoán Regional Airport (ATF)"
  },
  {
    "value": "ABL",
    "label": "Ambler Ambler Airport (ABL)"
  },
  {
    "value": "AMQ",
    "label": "Ambon Pattimura International Airport (AMQ)"
  },
  {
    "value": "ASV",
    "label": "Amboseli National Park Amboseli Airport (ASV)"
  },
  {
    "value": "AMV",
    "label": "Amderma Amderma Airport (AMV)"
  },
  {
    "value": "NUJ",
    "label": "Amirabad Nojeh Air Base (NUJ)"
  },
  {
    "value": "ADJ",
    "label": "Amman Amman Civil (Marka International) Airport (ADJ)"
  },
  {
    "value": "AMM",
    "label": "Amman Queen Alia International Airport (AMM)"
  },
  {
    "value": "YEY",
    "label": "Amos Amos/Magny Airport (YEY)"
  },
  {
    "value": "ADP",
    "label": "Ampara Ampara Airport (ADP)"
  },
  {
    "value": "SAY",
    "label": "Ampugnano (SI) Siena-Ampugnano Airport (SAY)"
  },
  {
    "value": "ATQ",
    "label": "Amritsar Sri Guru Ram Dass Jee International Airport (ATQ)"
  },
  {
    "value": "AMS",
    "label": "Amsterdam Amsterdam Airport Schiphol (AMS)"
  },
  {
    "value": "AAA",
    "label": "Anaa Anaa Airport (AAA)"
  },
  {
    "value": "AAO",
    "label": "Anaco Anaco Airport (AAO)"
  },
  {
    "value": "DYR",
    "label": "Anadyr Ugolny Yuri Ryktheu Airport (DYR)"
  },
  {
    "value": "YAA",
    "label": "Anahim Lake Anahim Lake Airport (YAA)"
  },
  {
    "value": "AKP",
    "label": "Anaktuvuk Pass Anaktuvuk Pass Airport (AKP)"
  },
  {
    "value": "HVA",
    "label": "Analalava Analalava Airport (HVA)"
  },
  {
    "value": "EDF",
    "label": "Anchorage Elmendorf Air Force Base (EDF)"
  },
  {
    "value": "MRI",
    "label": "Anchorage Merrill Field (MRI)"
  },
  {
    "value": "ANC",
    "label": "Anchorage Ted Stevens Anchorage International Airport (ANC)"
  },
  {
    "value": "ANX",
    "label": "Andenes Andøya Airport, Andenes (ANX)"
  },
  {
    "value": "AND",
    "label": "Anderson Anderson Regional Airport (AND)"
  },
  {
    "value": "AZN",
    "label": "Andizhan Andizhan Airport (AZN)"
  },
  {
    "value": "PYR",
    "label": "Andravida Andravida Air Base (PYR)"
  },
  {
    "value": "EBU",
    "label": "Andrézieux-Bouthéon, Loire Saint-Étienne-Bouthéon Airport (EBU)"
  },
  {
    "value": "TZN",
    "label": "Andros Congo Town Airport (TZN)"
  },
  {
    "value": "SAQ",
    "label": "Andros Island San Andros Airport (SAQ)"
  },
  {
    "value": "ASD",
    "label": "Andros Town Andros Town Airport (ASD)"
  },
  {
    "value": "AGH",
    "label": "Ängelholm Ängelholm-Helsingborg Airport (AGH)"
  },
  {
    "value": "VLY",
    "label": "Angelsey Anglesey Airport (VLY)"
  },
  {
    "value": "LJN",
    "label": "Angleton Texas Gulf Coast Regional Airport (LJN)"
  },
  {
    "value": "ANG",
    "label": "Angoulême/Brie/Champniers Angoulême-Brie-Champniers Airport (ANG)"
  },
  {
    "value": "ANI",
    "label": "Aniak Aniak Airport (ANI)"
  },
  {
    "value": "ESB",
    "label": "Ankara Esenboğa International Airport (ESB)"
  },
  {
    "value": "ANK",
    "label": "Ankara Etimesgut Air Base (ANK)"
  },
  {
    "value": "AAE",
    "label": "Annaba Annaba Rabah Bitat Airport (AAE)"
  },
  {
    "value": "ANB",
    "label": "Anniston Anniston Regional Airport (ANB)"
  },
  {
    "value": "AQG",
    "label": "Anqing Anqing Tianzhushan Airport / Anqing North Air Base (AQG)"
  },
  {
    "value": "AOG",
    "label": "Anshan Anshan Teng'ao Airport / Anshan Air Base (AOG)"
  },
  {
    "value": "AVA",
    "label": "Anshun (Xixiu) Anshun Huangguoshu Airport (AVA)"
  },
  {
    "value": "ATA",
    "label": "Anta Comandante FAP German Arias Graziani Airport (ATA)"
  },
  {
    "value": "HTY",
    "label": "Antakya Hatay Airport (HTY)"
  },
  {
    "value": "AYT",
    "label": "Antalya Antalya International Airport (AYT)"
  },
  {
    "value": "TNR",
    "label": "Antananarivo Ivato Airport (TNR)"
  },
  {
    "value": "DIE",
    "label": "Antisiranana Arrachart Airport (DIE)"
  },
  {
    "value": "ANF",
    "label": "Antofagasta Andrés Sabella Gálvez International Airport (ANF)"
  },
  {
    "value": "ANM",
    "label": "Antsirabe Antsirabe Airport (ANM)"
  },
  {
    "value": "WAI",
    "label": "Antsohihy Ambalabe Airport (WAI)"
  },
  {
    "value": "ANR",
    "label": "Antwerp Antwerp International Airport (Deurne) (ANR)"
  },
  {
    "value": "ACJ",
    "label": "Anuradhapura Anuradhapura Airport (ACJ)"
  },
  {
    "value": "ANV",
    "label": "Anvik Anvik Airport (ANV)"
  },
  {
    "value": "AOJ",
    "label": "Aomori Aomori Airport (AOJ)"
  },
  {
    "value": "PWE",
    "label": "Apapelgino Pevek Airport (PWE)"
  },
  {
    "value": "APW",
    "label": "Apia Faleolo International Airport (APW)"
  },
  {
    "value": "API",
    "label": "Apiay Gomez Nino Apiay Air Base (API)"
  },
  {
    "value": "ATW",
    "label": "Appleton Appleton International Airport (ATW)"
  },
  {
    "value": "AUF",
    "label": "Appoigny, Yonne Auxerre-Branches Airport (AUF)"
  },
  {
    "value": "AQJ",
    "label": "Aqaba Aqaba King Hussein International Airport (AQJ)"
  },
  {
    "value": "XJD",
    "label": "Ar Rayyan Al Udeid Air Base (XJD)"
  },
  {
    "value": "AJU",
    "label": "Aracaju Aracaju - Santa Maria International Airport (AJU)"
  },
  {
    "value": "ARX",
    "label": "Aracati Aracati Dragão do Mar Regional Airport (ARX)"
  },
  {
    "value": "ARU",
    "label": "Araçatuba Araçatuba Airport (ARU)"
  },
  {
    "value": "ARW",
    "label": "Arad Arad International Airport (ARW)"
  },
  {
    "value": "AUX",
    "label": "Araguaína Araguaína Airport (AUX)"
  },
  {
    "value": "ADI",
    "label": "Arandis Arandis Airport (ADI)"
  },
  {
    "value": "RAE",
    "label": "Arar Arar Domestic Airport (RAE)"
  },
  {
    "value": "AQA",
    "label": "Araraquara Araraquara Airport (AQA)"
  },
  {
    "value": "ARY",
    "label": "Ararat Ararat Airport (ARY)"
  },
  {
    "value": "AUC",
    "label": "Arauca Santiago Perez Airport (AUC)"
  },
  {
    "value": "AAX",
    "label": "Araxá Romeu Zema Airport (AAX)"
  },
  {
    "value": "AMH",
    "label": "Arba Minch Arba Minch Airport (AMH)"
  },
  {
    "value": "TTB",
    "label": "Arbatax Tortolì Airport (TTB)"
  },
  {
    "value": "EBL",
    "label": "Arbil Erbil International Airport (EBL)"
  },
  {
    "value": "ACV",
    "label": "Arcata/Eureka California Redwood Coast-Humboldt County Airport (ACV)"
  },
  {
    "value": "ARH",
    "label": "Archangelsk Talagi Airport (ARH)"
  },
  {
    "value": "ARC",
    "label": "Arctic Village Arctic Village Airport (ARC)"
  },
  {
    "value": "ADU",
    "label": "Ardabil Ardabil Airport (ADU)"
  },
  {
    "value": "ARE",
    "label": "Arecibo Antonio Nery Juarbe Pol Airport (ARE)"
  },
  {
    "value": "AQP",
    "label": "Arequipa Rodríguez Ballón International Airport (AQP)"
  },
  {
    "value": "ARI",
    "label": "Arica Chacalluta Airport (ARI)"
  },
  {
    "value": "VKV",
    "label": "Arkhangelsk Vaskovo Airport (VKV)"
  },
  {
    "value": "AXM",
    "label": "Armenia El Eden Airport (AXM)"
  },
  {
    "value": "ARM",
    "label": "Armidale Armidale Airport (ARM)"
  },
  {
    "value": "YYW",
    "label": "Armstrong Armstrong Airport (YYW)"
  },
  {
    "value": "IST",
    "label": "Arnavutköy, Istanbul İstanbul Airport (IST)"
  },
  {
    "value": "MOL",
    "label": "Årø Molde Airport, Årø (MOL)"
  },
  {
    "value": "ATC",
    "label": "Arthur's Town Arthur's Town Airport (ATC)"
  },
  {
    "value": "VVO",
    "label": "Artyom Vladivostok International Airport (VVO)"
  },
  {
    "value": "RUA",
    "label": "Arua Arua Airport (RUA)"
  },
  {
    "value": "ARK",
    "label": "Arusha Arusha Airport (ARK)"
  },
  {
    "value": "JRO",
    "label": "Arusha Kilimanjaro International Airport (JRO)"
  },
  {
    "value": "AVK",
    "label": "Arvaikheer Arvaikheer Airport (AVK)"
  },
  {
    "value": "AJR",
    "label": "Arvidsjaur Arvidsjaur Airport (AJR)"
  },
  {
    "value": "YIE",
    "label": "Arxan Arxan Yi'ershi Airport (YIE)"
  },
  {
    "value": "ABB",
    "label": "Asaba Asaba International Airport (ABB)"
  },
  {
    "value": "AVL",
    "label": "Asheville Asheville Regional Airport (AVL)"
  },
  {
    "value": "ASB",
    "label": "Ashgabat Ashgabat International Airport (ASB)"
  },
  {
    "value": "JFN",
    "label": "Ashtabula Northeast Ohio Regional Airport (JFN)"
  },
  {
    "value": "ASM",
    "label": "Asmara Asmara International Airport (ASM)"
  },
  {
    "value": "ASO",
    "label": "Asosa Asosa Airport (ASO)"
  },
  {
    "value": "ASE",
    "label": "Aspen Aspen-Pitkin County Airport (Sardy Field) (ASE)"
  },
  {
    "value": "ASA",
    "label": "Assab Assab International Airport (ASA)"
  },
  {
    "value": "NQZ",
    "label": "Astana Nursultan Nazarbayev International Airport (NQZ)"
  },
  {
    "value": "AST",
    "label": "Astoria Astoria Regional Airport (AST)"
  },
  {
    "value": "ASF",
    "label": "Astrakhan Astrakhan Narimanovo Boris M. Kustodiev International Airport (ASF)"
  },
  {
    "value": "ASU",
    "label": "Asunción Silvio Pettirossi International Airport (ASU)"
  },
  {
    "value": "ASW",
    "label": "Aswan Aswan International Airport (ASW)"
  },
  {
    "value": "ATZ",
    "label": "Asyut Asyut International Airport (ATZ)"
  },
  {
    "value": "AYX",
    "label": "Atalaya Teniente General Gerardo Pérez Pinedo Airport (AYX)"
  },
  {
    "value": "AXK",
    "label": "Ataq Ataq Airport (AXK)"
  },
  {
    "value": "ATR",
    "label": "Atar Atar International Airport (ATR)"
  },
  {
    "value": "AHN",
    "label": "Athens Athens Ben Epps Airport (AHN)"
  },
  {
    "value": "YIB",
    "label": "Atikokan Atikokan Municipal Airport (YIB)"
  },
  {
    "value": "PDK",
    "label": "Atlanta DeKalb Peachtree Airport (PDK)"
  },
  {
    "value": "FTY",
    "label": "Atlanta Fulton County Airport Brown Field (FTY)"
  },
  {
    "value": "ATL",
    "label": "Atlanta Hartsfield Jackson Atlanta International Airport (ATL)"
  },
  {
    "value": "ACY",
    "label": "Atlantic City Atlantic City International Airport (ACY)"
  },
  {
    "value": "ATK",
    "label": "Atqasuk Atqasuk Edward Burnell Sr Memorial Airport (ATK)"
  },
  {
    "value": "ISB",
    "label": "Attock Islamabad International Airport (ISB)"
  },
  {
    "value": "GUW",
    "label": "Atyrau Atyrau International Airport (GUW)"
  },
  {
    "value": "AKL",
    "label": "Auckland Auckland International Airport (AKL)"
  },
  {
    "value": "AGB",
    "label": "Augsburg Augsburg Airport (AGB)"
  },
  {
    "value": "AGS",
    "label": "Augusta Augusta Regional At Bush Field (AGS)"
  },
  {
    "value": "AUG",
    "label": "Augusta Augusta State Airport (AUG)"
  },
  {
    "value": "DNL",
    "label": "Augusta Daniel Field (DNL)"
  },
  {
    "value": "CFE",
    "label": "Aulnat, Puy-de-Dôme Clermont-Ferrand Auvergne Airport (CFE)"
  },
  {
    "value": "IXU",
    "label": "Aurangabad Aurangabad Airport (IXU)"
  },
  {
    "value": "AUR",
    "label": "Aurillac Aurillac Airport (AUR)"
  },
  {
    "value": "BFK",
    "label": "Aurora Buckley Space Force Base (BFK)"
  },
  {
    "value": "AUS",
    "label": "Austin Austin Bergstrom International Airport (AUS)"
  },
  {
    "value": "RAR",
    "label": "Avarua Rarotonga International Airport (RAR)"
  },
  {
    "value": "AVB",
    "label": "Aviano (PN) Aviano Air Base (AVB)"
  },
  {
    "value": "AVN",
    "label": "Avignon, Vaucluse Avignon-Caumont Airport (AVN)"
  },
  {
    "value": "KAT",
    "label": "Awanui Kaitaia Airport (KAT)"
  },
  {
    "value": "AXU",
    "label": "Axum Axum Airport (AXU)"
  },
  {
    "value": "AYP",
    "label": "Ayacucho Air Force Colonel Alfredo Mendivil Duarte Airport (AYP)"
  },
  {
    "value": "NJA",
    "label": "Ayase / Yamato JMSDF Atsugi Air Base / Naval Air Facility Atsugi (NJA)"
  },
  {
    "value": "AYO",
    "label": "Ayolas Juan de Ayolas National Airport (AYO)"
  },
  {
    "value": "GDQ",
    "label": "Azezo Gondar Airport (GDQ)"
  },
  {
    "value": "ROR",
    "label": "Babelthuap Island Babelthuap Airport (ROR)"
  },
  {
    "value": "BXB",
    "label": "Babo Babo Airport (BXB)"
  },
  {
    "value": "BCM",
    "label": "Bacău Bacău George Enescu International  Airport (BCM)"
  },
  {
    "value": "BCD",
    "label": "Bacolod City Bacolod-Silay Airport (BCD)"
  },
  {
    "value": "BJZ",
    "label": "Badajoz Badajoz Airport (BJZ)"
  },
  {
    "value": "BFX",
    "label": "Bafoussam Bafoussam Airport (BFX)"
  },
  {
    "value": "BGX",
    "label": "Bagé Comandante Gustavo Kraemer Airport (BGX)"
  },
  {
    "value": "BGW",
    "label": "Baghdad Baghdad International Airport / New Al Muthana Air Base (BGW)"
  },
  {
    "value": "OAI",
    "label": "Bagram Bagram Airfield (OAI)"
  },
  {
    "value": "BAG",
    "label": "Baguio Loakan Airport (BAG)"
  },
  {
    "value": "BHV",
    "label": "Bahawalpur Bahawalpur Airport (BHV)"
  },
  {
    "value": "BHI",
    "label": "Bahía Blanca Comandante Espora Airport (BHI)"
  },
  {
    "value": "BSC",
    "label": "Bahía Solano José Celestino Mutis Airport (BSC)"
  },
  {
    "value": "BJR",
    "label": "Bahir Dar Bahir Dar Airport (BJR)"
  },
  {
    "value": "DBC",
    "label": "Baicheng Baicheng Chang'an Airport (DBC)"
  },
  {
    "value": "YBC",
    "label": "Baie-Comeau Baie-Comeau Airport (YBC)"
  },
  {
    "value": "BXY",
    "label": "Baikonur Baikonur Krayniy Airport (BXY)"
  },
  {
    "value": "VMU",
    "label": "Baimuru Baimuru Airport (VMU)"
  },
  {
    "value": "BSJ",
    "label": "Bairnsdale Bairnsdale Airport (BSJ)"
  },
  {
    "value": "AEB",
    "label": "Baise (Tianyang) Baise (Bose) Bama Airport (AEB)"
  },
  {
    "value": "NBS",
    "label": "Baishan Changbaishan Airport (NBS)"
  },
  {
    "value": "BXE",
    "label": "Bakel Bakel Airport (BXE)"
  },
  {
    "value": "BKE",
    "label": "Baker City Baker City Municipal Airport (BKE)"
  },
  {
    "value": "YBK",
    "label": "Baker Lake Baker Lake Airport (YBK)"
  },
  {
    "value": "BFL",
    "label": "Bakersfield Meadows Field (BFL)"
  },
  {
    "value": "ISL",
    "label": "Bakırköy, Istanbul İstanbul Atatürk Airport (ISL)"
  },
  {
    "value": "GYD",
    "label": "Baku Heydar Aliyev International Airport (GYD)"
  },
  {
    "value": "BWO",
    "label": "Balakovo Balakovo Airport (BWO)"
  },
  {
    "value": "TRE",
    "label": "Balemartine Tiree Airport (TRE)"
  },
  {
    "value": "BQA",
    "label": "Baler Dr Juan C Angara Airport (BQA)"
  },
  {
    "value": "KRK",
    "label": "Balice Kraków John Paul II International Airport (KRK)"
  },
  {
    "value": "BPN",
    "label": "Balikpapan Sultan Aji Muhammad Sulaiman Sepinggan International Airport (BPN)"
  },
  {
    "value": "OPU",
    "label": "Balimo Balimo Airport (OPU)"
  },
  {
    "value": "BEB",
    "label": "Balivanich Benbecula Airport (BEB)"
  },
  {
    "value": "BZI",
    "label": "Balıkesir Balıkesir Airport (BZI)"
  },
  {
    "value": "BXH",
    "label": "Balkhash Balkhash Airport (BXH)"
  },
  {
    "value": "BNK",
    "label": "Ballina Ballina Byron Gateway Airport (BNK)"
  },
  {
    "value": "BBA",
    "label": "Balmaceda Balmaceda Airport (BBA)"
  },
  {
    "value": "BZY",
    "label": "Bălți Bălți International Airport (BZY)"
  },
  {
    "value": "BWI",
    "label": "Baltimore Baltimore/Washington International Thurgood Marshall Airport (BWI)"
  },
  {
    "value": "MTN",
    "label": "Baltimore Martin State Airport (MTN)"
  },
  {
    "value": "BXR",
    "label": "Bam Bam Airport (BXR)"
  },
  {
    "value": "BKO",
    "label": "Bamako Modibo Keita International Airport (BKO)"
  },
  {
    "value": "BPC",
    "label": "Bamenda Bamenda Airport (BPC)"
  },
  {
    "value": "BTJ",
    "label": "Banda Aceh Sultan Iskandar Muda International Airport (BTJ)"
  },
  {
    "value": "BND",
    "label": "Bandar Abbas Bandar Abbas International Airport (BND)"
  },
  {
    "value": "TKG",
    "label": "Bandar Lampung Radin Inten II International Airport (TKG)"
  },
  {
    "value": "BDH",
    "label": "Bandar Lengeh Bandar Lengeh International Airport (BDH)"
  },
  {
    "value": "BWN",
    "label": "Bandar Seri Begawan Brunei International Airport (BWN)"
  },
  {
    "value": "BDM",
    "label": "Bandırma Bandırma Airport (BDM)"
  },
  {
    "value": "FDU",
    "label": "Bandundu Bandundu Airport (FDU)"
  },
  {
    "value": "BDO",
    "label": "Bandung Husein Sastranegara International Airport (BDO)"
  },
  {
    "value": "BLR",
    "label": "Bangalore Kempegowda International Airport (BLR)"
  },
  {
    "value": "BPX",
    "label": "Bangda Qamdo Bangda Airport (BPX)"
  },
  {
    "value": "DMK",
    "label": "Bangkok Don Mueang International Airport (DMK)"
  },
  {
    "value": "BKK",
    "label": "Bangkok Suvarnabhumi Airport (BKK)"
  },
  {
    "value": "BGR",
    "label": "Bangor Bangor International Airport (BGR)"
  },
  {
    "value": "BGF",
    "label": "Bangui Bangui M'Poko International Airport (BGF)"
  },
  {
    "value": "BSD",
    "label": "Baoshan (Longyang) Baoshan Yunrui Airport (BSD)"
  },
  {
    "value": "TCZ",
    "label": "Baoshan (Tengchong) Tengchong Tuofeng Airport (TCZ)"
  },
  {
    "value": "BAV",
    "label": "Baotou Baotou Donghe Airport (BAV)"
  },
  {
    "value": "BHB",
    "label": "Bar Harbor Hancock County-Bar Harbor Airport (BHB)"
  },
  {
    "value": "BCA",
    "label": "Baracoa Gustavo Rizo Airport (BCA)"
  },
  {
    "value": "BRX",
    "label": "Barahona Maria Montez International Airport (BRX)"
  },
  {
    "value": "BCI",
    "label": "Barcaldine Barcaldine Airport (BCI)"
  },
  {
    "value": "BLA",
    "label": "Barcelona General José Antonio Anzoategui International Airport (BLA)"
  },
  {
    "value": "BCN",
    "label": "Barcelona Josep Tarradellas Barcelona-El Prat Airport (BCN)"
  },
  {
    "value": "BEK",
    "label": "Bareilly Bareilly Air Force Station (BEK)"
  },
  {
    "value": "BRI",
    "label": "Bari Bari Karol Wojtyła International Airport (BRI)"
  },
  {
    "value": "BNS",
    "label": "Barinas Barinas Airport (BNS)"
  },
  {
    "value": "BBN",
    "label": "Bario Bario Airport (BBN)"
  },
  {
    "value": "BZL",
    "label": "Barisal Barisal Airport (BZL)"
  },
  {
    "value": "BAX",
    "label": "Barnaul Barnaul Airport (BAX)"
  },
  {
    "value": "BRM",
    "label": "Barquisimeto Barquisimeto International Airport (BRM)"
  },
  {
    "value": "BPG",
    "label": "Barra do Garças Barra do Garças Airport (BPG)"
  },
  {
    "value": "EJA",
    "label": "Barrancabermeja Yariguíes Airport (EJA)"
  },
  {
    "value": "BAQ",
    "label": "Barranquilla Ernesto Cortissoz International Airport (BAQ)"
  },
  {
    "value": "MPV",
    "label": "Barre/Montpelier Edward F Knapp State Airport (MPV)"
  },
  {
    "value": "BAT",
    "label": "Barretos Chafei Amsei Airport (BAT)"
  },
  {
    "value": "YLK",
    "label": "Barrie Barrie-Lake Simcoe Regional Airport (YLK)"
  },
  {
    "value": "BWF",
    "label": "Barrow-in-Furness Barrow Walney Island Airport (BWF)"
  },
  {
    "value": "BTI",
    "label": "Barter Island Barter Island Long Range Radar Station Airport (BTI)"
  },
  {
    "value": "BSO",
    "label": "Basco Basco Airport (BSO)"
  },
  {
    "value": "BSR",
    "label": "Basra Basra International Airport (BSR)"
  },
  {
    "value": "SKB",
    "label": "Basseterre Robert L. Bradshaw International Airport (SKB)"
  },
  {
    "value": "BIA",
    "label": "Bastia/Poretta Bastia-Poretta Airport (BIA)"
  },
  {
    "value": "BSG",
    "label": "Bata Bata Airport (BSG)"
  },
  {
    "value": "BTH",
    "label": "Batam Hang Nadim International Airport (BTH)"
  },
  {
    "value": "BHS",
    "label": "Bathurst Bathurst Airport (BHS)"
  },
  {
    "value": "BAL",
    "label": "Batman Batman Airport (BAL)"
  },
  {
    "value": "BLJ",
    "label": "Batna Batna Mostefa Ben Boulaid Airport (BLJ)"
  },
  {
    "value": "BTR",
    "label": "Baton Rouge Baton Rouge Metropolitan Airport (BTR)"
  },
  {
    "value": "BJF",
    "label": "Båtsfjord Båtsfjord Airport (BJF)"
  },
  {
    "value": "BBM",
    "label": "Battambang Battambang Airport (BBM)"
  },
  {
    "value": "BTC",
    "label": "Batticaloa Batticaloa Airport (BTC)"
  },
  {
    "value": "BTL",
    "label": "Battle Creek Battle Creek Executive Airport at Kellogg Field (BTL)"
  },
  {
    "value": "BUS",
    "label": "Batumi Batumi International Airport (BUS)"
  },
  {
    "value": "BCH",
    "label": "Baucau Cakung Airport (BCH)"
  },
  {
    "value": "BCU",
    "label": "Bauchi Sir Abubakar Tafawa Balewa International Airport (BCU)"
  },
  {
    "value": "BDE",
    "label": "Baudette Baudette International Airport (BDE)"
  },
  {
    "value": "JTC",
    "label": "Bauru Bauru/Arealva–Moussa Nakhal Tobias State Airport (JTC)"
  },
  {
    "value": "RLK",
    "label": "Bavannur Bayannur Tianjitai Airport (RLK)"
  },
  {
    "value": "BYM",
    "label": "Bayamo Carlos Manuel de Cespedes Airport (BYM)"
  },
  {
    "value": "AXF",
    "label": "Bayanhot Alxa Left Banner Bayanhot Airport (AXF)"
  },
  {
    "value": "BYN",
    "label": "Bayankhongor Bayankhongor Airport (BYN)"
  },
  {
    "value": "BKA",
    "label": "Baykit Baykit Airport (BKA)"
  },
  {
    "value": "BZB",
    "label": "Bazaruto Island Bazaruto Island Airport (BZB)"
  },
  {
    "value": "IBL",
    "label": "Bazaruto Island Indigo Bay Lodge Airport (IBL)"
  },
  {
    "value": "BAB",
    "label": "Beale Air Force Base Beale Air Force Base (BAB)"
  },
  {
    "value": "BPT",
    "label": "Beaumont/Port Arthur Jack Brooks Regional Airport (BPT)"
  },
  {
    "value": "YXQ",
    "label": "Beaver Creek Beaver Creek Airport (YXQ)"
  },
  {
    "value": "BFP",
    "label": "Beaver Falls Beaver County Airport (BFP)"
  },
  {
    "value": "BKW",
    "label": "Beaver Raleigh County Memorial Airport (BKW)"
  },
  {
    "value": "CBH",
    "label": "Béchar Béchar Boudghene Ben Ali Lotfi Airport (CBH)"
  },
  {
    "value": "BED",
    "label": "Bedford Laurence G Hanscom Field (BED)"
  },
  {
    "value": "BEU",
    "label": "Bedourie Bedourie Airport (BEU)"
  },
  {
    "value": "EIS",
    "label": "Beef Island Terrance B. Lettsome International Airport (EIS)"
  },
  {
    "value": "VTM",
    "label": "Beersheba Nevatim Air Base (VTM)"
  },
  {
    "value": "MIP",
    "label": "Beersheba Ramon Air Base (MIP)"
  },
  {
    "value": "BHY",
    "label": "Beihai (Yinhai) Beihai Fucheng Airport (BHY)"
  },
  {
    "value": "PEK",
    "label": "Beijing Beijing Capital International Airport (PEK)"
  },
  {
    "value": "PKX",
    "label": "Beijing Beijing Daxing International Airport (PKX)"
  },
  {
    "value": "NAY",
    "label": "Beijing Beijing Nanjiao Airport (NAY)"
  },
  {
    "value": "BEW",
    "label": "Beira Beira Airport (BEW)"
  },
  {
    "value": "BEY",
    "label": "Beirut Beirut Rafic Hariri International Airport (BEY)"
  },
  {
    "value": "BYJ",
    "label": "Beja Beja Airport / Airbase (BYJ)"
  },
  {
    "value": "BJA",
    "label": "Béjaïa Soummam–Abane Ramdane Airport (BJA)"
  },
  {
    "value": "BGN",
    "label": "Belaya Gora Belaya Gora Airport (BGN)"
  },
  {
    "value": "BEL",
    "label": "Belém Val de Cans/Júlio Cezar Ribeiro International Airport (BEL)"
  },
  {
    "value": "BFS",
    "label": "Belfast Belfast International Airport (BFS)"
  },
  {
    "value": "BHD",
    "label": "Belfast George Best Belfast City Airport (BHD)"
  },
  {
    "value": "IXG",
    "label": "Belgaum Belagavi Airport (IXG)"
  },
  {
    "value": "EGO",
    "label": "Belgorod Belgorod International Airport (EGO)"
  },
  {
    "value": "BEG",
    "label": "Belgrade Belgrade Nikola Tesla Airport (BEG)"
  },
  {
    "value": "BZE",
    "label": "Belize City Philip S. W. Goldson International Airport (BZE)"
  },
  {
    "value": "TZA",
    "label": "Belize City Sir Barry Bowen Municipal Airport (TZA)"
  },
  {
    "value": "ZEL",
    "label": "Bella Bella Bella Bella (Campbell Island) Airport (ZEL)"
  },
  {
    "value": "QBC",
    "label": "Bella Coola Bella Coola Airport (QBC)"
  },
  {
    "value": "BEP",
    "label": "Bellary Bellary Airport (BEP)"
  },
  {
    "value": "BLV",
    "label": "Belleville Scott AFB/Midamerica Airport (BLV)"
  },
  {
    "value": "BLI",
    "label": "Bellingham Bellingham International Airport (BLI)"
  },
  {
    "value": "PLU",
    "label": "Belo Horizonte Pampulha - Carlos Drummond de Andrade Airport (PLU)"
  },
  {
    "value": "CNF",
    "label": "Belo Horizonte Tancredo Neves International Airport (CNF)"
  },
  {
    "value": "BJI",
    "label": "Bemidji Bemidji Regional Airport (BJI)"
  },
  {
    "value": "BLN",
    "label": "Benalla Benalla Airport (BLN)"
  },
  {
    "value": "BFU",
    "label": "Bengbu Bengbu Tenghu Airport (BFU)"
  },
  {
    "value": "BKS",
    "label": "Bengkulu Fatmawati Soekarno Airport (BKS)"
  },
  {
    "value": "BUG",
    "label": "Benguela Benguela 17th of September Airport (BUG)"
  },
  {
    "value": "BCW",
    "label": "Benguera Island Benguera Island Airport (BCW)"
  },
  {
    "value": "BNI",
    "label": "Benin Benin Airport (BNI)"
  },
  {
    "value": "BEN",
    "label": "Benina Benina International Airport (BEN)"
  },
  {
    "value": "BQU",
    "label": "Bequia J F Mitchell Airport (BQU)"
  },
  {
    "value": "BBO",
    "label": "Berbera Berbera Airport (BBO)"
  },
  {
    "value": "BBT",
    "label": "Berbérati Berbérati Airport (BBT)"
  },
  {
    "value": "ERD",
    "label": "Berdyansk Berdyansk Airport (ERD)"
  },
  {
    "value": "EES",
    "label": "Berenice Troglodytica Berenice International Airport / Banas Cape Air Base (EES)"
  },
  {
    "value": "BGO",
    "label": "Bergen Bergen Airport, Flesland (BGO)"
  },
  {
    "value": "EGC",
    "label": "Bergerac/Roumanière Bergerac Dordogne Périgord Airport (EGC)"
  },
  {
    "value": "KNO",
    "label": "Beringin Kualanamu International Airport (KNO)"
  },
  {
    "value": "BVG",
    "label": "Berlevåg Berlevåg Airport (BVG)"
  },
  {
    "value": "BER",
    "label": "Berlin Berlin Brandenburg Airport (BER)"
  },
  {
    "value": "BJO",
    "label": "Bermejo Bermejo Airport (BJO)"
  },
  {
    "value": "BRN",
    "label": "Bern Bern Airport (BRN)"
  },
  {
    "value": "BPY",
    "label": "Besalampy Besalampy Airport (BPY)"
  },
  {
    "value": "OGZ",
    "label": "Beslan Vladikavkaz Beslan International Airport (OGZ)"
  },
  {
    "value": "BET",
    "label": "Bethel Bethel Airport (BET)"
  },
  {
    "value": "BTZ",
    "label": "Betong Betong International Airport (BTZ)"
  },
  {
    "value": "BVY",
    "label": "Beverly / Danvers Beverly Regional Airport (BVY)"
  },
  {
    "value": "BZR",
    "label": "Béziers/Vias Béziers-Vias Airport (BZR)"
  },
  {
    "value": "JAM",
    "label": "Bezmer Bezmer Air Base (JAM)"
  },
  {
    "value": "BHU",
    "label": "Bhavnagar Bhavnagar Airport (BHU)"
  },
  {
    "value": "BHO",
    "label": "Bhopal Raja Bhoj International Airport (BHO)"
  },
  {
    "value": "BBI",
    "label": "Bhubaneswar Biju Patnaik Airport (BBI)"
  },
  {
    "value": "BHJ",
    "label": "Bhuj Bhuj Airport (BHJ)"
  },
  {
    "value": "KUU",
    "label": "Bhuntar Kullu Manali Airport (KUU)"
  },
  {
    "value": "BIK",
    "label": "Biak Frans Kaisiepo Airport (BIK)"
  },
  {
    "value": "BIQ",
    "label": "Biarritz/Anglet/Bayonne Biarritz-Anglet-Bayonne Airport (BIQ)"
  },
  {
    "value": "IXX",
    "label": "Bidar Bidar Airport / Bidar Air Force Station (IXX)"
  },
  {
    "value": "BPI",
    "label": "Big Piney Miley Memorial Field (BPI)"
  },
  {
    "value": "BFJ",
    "label": "Bijie Bijie Feixiong Airport (BFJ)"
  },
  {
    "value": "BKB",
    "label": "Bikaner Nal Airport (BKB)"
  },
  {
    "value": "PAB",
    "label": "Bilaspur Bilaspur Airport (PAB)"
  },
  {
    "value": "BIO",
    "label": "Bilbao Bilbao Airport (BIO)"
  },
  {
    "value": "BIL",
    "label": "Billings Billings Logan International Airport (BIL)"
  },
  {
    "value": "BLL",
    "label": "Billund Billund Airport (BLL)"
  },
  {
    "value": "THG",
    "label": "Biloela Thangool Airport (THG)"
  },
  {
    "value": "BIX",
    "label": "Biloxi Keesler Air Force Base (BIX)"
  },
  {
    "value": "BYU",
    "label": "Bindlach Bayreuth Airport (BYU)"
  },
  {
    "value": "BGM",
    "label": "Binghamton Greater Binghamton/Edwin A Link field (BGM)"
  },
  {
    "value": "BTU",
    "label": "Bintulu Bintulu Airport (BTU)"
  },
  {
    "value": "BIR",
    "label": "Biratnagar Biratnagar Airport (BIR)"
  },
  {
    "value": "XBJ",
    "label": "Birjand Birjand International Airport (XBJ)"
  },
  {
    "value": "BHM",
    "label": "Birmingham Birmingham-Shuttlesworth International Airport (BHM)"
  },
  {
    "value": "BHX",
    "label": "Birmingham, West Midlands Birmingham Airport (BHX)"
  },
  {
    "value": "BHH",
    "label": "Bisha Bisha Airport (BHH)"
  },
  {
    "value": "FRU",
    "label": "Bishkek Manas International Airport (FRU)"
  },
  {
    "value": "BIY",
    "label": "Bisho Bisho Airport (BIY)"
  },
  {
    "value": "BIH",
    "label": "Bishop Eastern Sierra Regional Airport (BIH)"
  },
  {
    "value": "BSK",
    "label": "Biskra Biskra - Mohamed Khider Airport (BSK)"
  },
  {
    "value": "BPH",
    "label": "Bislig Bislig Airport (BPH)"
  },
  {
    "value": "BIS",
    "label": "Bismarck Bismarck Municipal Airport (BIS)"
  },
  {
    "value": "OXB",
    "label": "Bissau Osvaldo Vieira International Airport (OXB)"
  },
  {
    "value": "BMM",
    "label": "Bitam Bitam Airport (BMM)"
  },
  {
    "value": "BKQ",
    "label": "Blackall Blackall Airport (BKQ)"
  },
  {
    "value": "BLK",
    "label": "Blackpool Blackpool International Airport (BLK)"
  },
  {
    "value": "BQS",
    "label": "Blagoveschensk Ignatyevo Airport (BQS)"
  },
  {
    "value": "YBX",
    "label": "Blanc-Sablon Lourdes-de-Blanc-Sablon Airport (YBX)"
  },
  {
    "value": "BLZ",
    "label": "Blantyre Chileka International Airport (BLZ)"
  },
  {
    "value": "BHE",
    "label": "Blenheim Woodbourne Airport (BHE)"
  },
  {
    "value": "QLD",
    "label": "Blida Blida Airport (QLD)"
  },
  {
    "value": "BFN",
    "label": "Bloemfontain Bram Fischer International Airport (BFN)"
  },
  {
    "value": "BMG",
    "label": "Bloomington Monroe County Airport (BMG)"
  },
  {
    "value": "BMI",
    "label": "Bloomington/Normal Central Illinois Regional Airport at Bloomington-Normal (BMI)"
  },
  {
    "value": "LYB",
    "label": "Blossom Village Edward Bodden Little Cayman Airfield (LYB)"
  },
  {
    "value": "TRI",
    "label": "Blountville Tri-Cities Regional TN/VA Airport (TRI)"
  },
  {
    "value": "BLF",
    "label": "Bluefield Mercer County Airport (BLF)"
  },
  {
    "value": "BEF",
    "label": "Bluefileds Bluefields Airport (BEF)"
  },
  {
    "value": "BLH",
    "label": "Blythe Blythe Airport (BLH)"
  },
  {
    "value": "BYH",
    "label": "Blytheville Arkansas International Airport (BYH)"
  },
  {
    "value": "KBS",
    "label": "Bo Bo Airport (KBS)"
  },
  {
    "value": "BVB",
    "label": "Boa Vista Atlas Brasil Cantanhede Airport (BVB)"
  },
  {
    "value": "BOY",
    "label": "Bobo Dioulasso Bobo Dioulasso Airport (BOY)"
  },
  {
    "value": "BCT",
    "label": "Boca Raton Boca Raton Airport (BCT)"
  },
  {
    "value": "BOO",
    "label": "Bodø Bodø Airport (BOO)"
  },
  {
    "value": "BJV",
    "label": "Bodrum Milas Bodrum International Airport (BJV)"
  },
  {
    "value": "BOG",
    "label": "Bogota El Dorado International Airport (BOG)"
  },
  {
    "value": "BOI",
    "label": "Boise Boise Air Terminal/Gowen Field (BOI)"
  },
  {
    "value": "BJB",
    "label": "Bojnord Bojnord Airport (BJB)"
  },
  {
    "value": "BPL",
    "label": "Bole Bole Alashankou Airport (BPL)"
  },
  {
    "value": "EOR",
    "label": "Bolivar El Dorado Airport (EOR)"
  },
  {
    "value": "BLQ",
    "label": "Bologna Bologna Guglielmo Marconi Airport (BLQ)"
  },
  {
    "value": "BZO",
    "label": "Bolzano (BZ) Bolzano Airport (BZO)"
  },
  {
    "value": "LAZ",
    "label": "Bom Jesus da Lapa Bom Jesus da Lapa Airport (LAZ)"
  },
  {
    "value": "YVB",
    "label": "Bonaventure Bonaventure Airport (YVB)"
  },
  {
    "value": "TWT",
    "label": "Bongao Sanga Sanga Airport (TWT)"
  },
  {
    "value": "YBY",
    "label": "Bonnyville Bonnyville Airport (YBY)"
  },
  {
    "value": "URO",
    "label": "Boos Rouen Vallée de Seine Airport (URO)"
  },
  {
    "value": "TGP",
    "label": "Bor Podkamennaya Tunguska Airport (TGP)"
  },
  {
    "value": "BOD",
    "label": "Bordeaux/Mérignac Bordeaux-Mérignac Airport (BOD)"
  },
  {
    "value": "BLE",
    "label": "Borlange Dala Airport (BLE)"
  },
  {
    "value": "KBP",
    "label": "Boryspil Boryspil International Airport (KBP)"
  },
  {
    "value": "OCJ",
    "label": "Boscobel Ian Fleming International Airport (OCJ)"
  },
  {
    "value": "BAD",
    "label": "Bossier City Barksdale Air Force Base (BAD)"
  },
  {
    "value": "BOS",
    "label": "Boston Logan International Airport (BOS)"
  },
  {
    "value": "BYK",
    "label": "Bouaké Bouaké Airport (BYK)"
  },
  {
    "value": "UAR",
    "label": "Bouarfa Bouarfa Airport (UAR)"
  },
  {
    "value": "BLD",
    "label": "Boulder City Boulder City Municipal Airport (BLD)"
  },
  {
    "value": "BOU",
    "label": "Bourges, Cher Bourges Airport (BOU)"
  },
  {
    "value": "BVJ",
    "label": "Bovanenkovo Bovanenkovo Airport (BVJ)"
  },
  {
    "value": "BWG",
    "label": "Bowling Green Bowling Green Warren County Regional Airport (BWG)"
  },
  {
    "value": "BZN",
    "label": "Bozeman Bozeman Yellowstone International Airport (BZN)"
  },
  {
    "value": "BFD",
    "label": "Bradford Bradford Regional Airport (BFD)"
  },
  {
    "value": "BBD",
    "label": "Brady Curtis Field (BBD)"
  },
  {
    "value": "BGZ",
    "label": "Braga Braga Municipal Aerodrome (BGZ)"
  },
  {
    "value": "BGC",
    "label": "Bragança Bragança Airport (BGC)"
  },
  {
    "value": "BRD",
    "label": "Brainerd Brainerd Lakes Regional Airport (BRD)"
  },
  {
    "value": "BCQ",
    "label": "Brak Brak Airport (BCQ)"
  },
  {
    "value": "YBR",
    "label": "Brandon Brandon Municipal Airport (YBR)"
  },
  {
    "value": "LKZ",
    "label": "Brandon, Suffolk RAF Lakenheath (LKZ)"
  },
  {
    "value": "BKG",
    "label": "Branson Branson Airport (BKG)"
  },
  {
    "value": "BSB",
    "label": "Brasília Presidente Juscelino Kubitschek International Airport (BSB)"
  },
  {
    "value": "GHV",
    "label": "Brașov (Ghimbav) Brașov-Ghimbav International Airport (GHV)"
  },
  {
    "value": "BTS",
    "label": "Bratislava M. R. Štefánik Airport (BTS)"
  },
  {
    "value": "BTK",
    "label": "Bratsk Bratsk Airport (BTK)"
  },
  {
    "value": "BWE",
    "label": "Braunschweig Braunschweig-Wolfsburg Airport (BWE)"
  },
  {
    "value": "BZV",
    "label": "Brazzaville Maya-Maya Airport (BZV)"
  },
  {
    "value": "BRE",
    "label": "Bremen Bremen Airport (BRE)"
  },
  {
    "value": "PWT",
    "label": "Bremerton Bremerton National Airport (PWT)"
  },
  {
    "value": "YKF",
    "label": "Breslau Region of Waterloo International Airport (YKF)"
  },
  {
    "value": "BQT",
    "label": "Brest Brest Airport (BQT)"
  },
  {
    "value": "BES",
    "label": "Brest/Guipavas Brest Bretagne Airport (BES)"
  },
  {
    "value": "GFR",
    "label": "Bréville-sur-Mer, Manche Granville Airport (GFR)"
  },
  {
    "value": "BDR",
    "label": "Bridgeport Igor I Sikorsky Memorial Airport (BDR)"
  },
  {
    "value": "CKB",
    "label": "Bridgeport North Central West Virginia Airport (CKB)"
  },
  {
    "value": "BGI",
    "label": "Bridgetown Grantley Adams International Airport (BGI)"
  },
  {
    "value": "ESH",
    "label": "Brighton, East Sussex Brighton City Airport (ESH)"
  },
  {
    "value": "BDS",
    "label": "Brindisi Brindisi Airport (BDS)"
  },
  {
    "value": "BNE",
    "label": "Brisbane Brisbane International Airport (BNE)"
  },
  {
    "value": "BRS",
    "label": "Bristol Bristol Airport (BRS)"
  },
  {
    "value": "BVE",
    "label": "Brive la Gaillarde Brive-Souillac (BVE)"
  },
  {
    "value": "BRQ",
    "label": "Brno Brno-Tuřany Airport (BRQ)"
  },
  {
    "value": "KGI",
    "label": "Broadwood Kalgoorlie Boulder Airport (KGI)"
  },
  {
    "value": "BHQ",
    "label": "Broken Hill Broken Hill Airport (BHQ)"
  },
  {
    "value": "ZBM",
    "label": "Bromont Bromont (Roland Désourdy) Airport (ZBM)"
  },
  {
    "value": "BNN",
    "label": "Brønnøy Brønnøysund Airport, Brønnøy (BNN)"
  },
  {
    "value": "BME",
    "label": "Broome Broome International Airport (BME)"
  },
  {
    "value": "CEG",
    "label": "Broughton Hawarden Airport (CEG)"
  },
  {
    "value": "BRO",
    "label": "Brownsville Brownsville South Padre Island International Airport (BRO)"
  },
  {
    "value": "NHZ",
    "label": "Brunswick Brunswick Executive Airport (NHZ)"
  },
  {
    "value": "BQK",
    "label": "Brunswick Brunswick Golden Isles Airport (BQK)"
  },
  {
    "value": "BZK",
    "label": "Bryansk Bryansk Airport (BZK)"
  },
  {
    "value": "BCE",
    "label": "Bryce Canyon Bryce Canyon Airport (BCE)"
  },
  {
    "value": "BGA",
    "label": "Bucaramanga Palonegro Airport (BGA)"
  },
  {
    "value": "BBU",
    "label": "Bucharest Bucharest Băneasa Aurel Vlaicu International Airport (BBU)"
  },
  {
    "value": "BUD",
    "label": "Budapest Budapest Liszt Ferenc International Airport (BUD)"
  },
  {
    "value": "BUN",
    "label": "Buenaventura Gerardo Tobar López Airport (BUN)"
  },
  {
    "value": "EZE",
    "label": "Buenos Aires (Ezeiza) Minister Pistarini International Airport (EZE)"
  },
  {
    "value": "AEP",
    "label": "Buenos Aires Jorge Newbery Airpark (AEP)"
  },
  {
    "value": "BUF",
    "label": "Buffalo Buffalo Niagara International Airport (BUF)"
  },
  {
    "value": "UUA",
    "label": "Bugulma Bugulma Airport (UUA)"
  },
  {
    "value": "BJM",
    "label": "Bujumbura Bujumbura Melchior Ndadaye International Airport (BJM)"
  },
  {
    "value": "BUA",
    "label": "Buka Island Buka Airport (BUA)"
  },
  {
    "value": "BHK",
    "label": "Bukhara Bukhara International Airport (BHK)"
  },
  {
    "value": "BUQ",
    "label": "Bulawayo Joshua Mqabuko Nkomo International Airport (BUQ)"
  },
  {
    "value": "UGA",
    "label": "Bulgan Bulgan Airport (UGA)"
  },
  {
    "value": "IFP",
    "label": "Bullhead City Laughlin Bullhead International Airport (IFP)"
  },
  {
    "value": "GHC",
    "label": "Bullocks Harbour Great Harbour Cay Airport (GHC)"
  },
  {
    "value": "BDB",
    "label": "Bundaberg Bundaberg Airport (BDB)"
  },
  {
    "value": "BUX",
    "label": "Bunia Bunia Airport (BUX)"
  },
  {
    "value": "BMV",
    "label": "Buon Ma Thuot Buon Ma Thuot Airport (BMV)"
  },
  {
    "value": "ELQ",
    "label": "Buraidah Gassim Airport (ELQ)"
  },
  {
    "value": "APJ",
    "label": "Burang Town Ali Pulan Airport (APJ)"
  },
  {
    "value": "SGE",
    "label": "Burbach Siegerland Airport (SGE)"
  },
  {
    "value": "BUR",
    "label": "Burbank Hollywood Burbank Airport (BUR)"
  },
  {
    "value": "PAD",
    "label": "Büren Paderborn Lippstadt Airport (PAD)"
  },
  {
    "value": "BOJ",
    "label": "Burgas Burgas Airport (BOJ)"
  },
  {
    "value": "RGS",
    "label": "Burgos Burgos Airport (RGS)"
  },
  {
    "value": "BFV",
    "label": "Buriram Buri Ram Airport (BFV)"
  },
  {
    "value": "BYI",
    "label": "Burley Burley Municipal Airport (BYI)"
  },
  {
    "value": "BRL",
    "label": "Burlington Southeast Iowa Regional Airport (BRL)"
  },
  {
    "value": "BWT",
    "label": "Burnie Wynyard Airport (BWT)"
  },
  {
    "value": "BNO",
    "label": "Burns Burns Municipal Airport (BNO)"
  },
  {
    "value": "YPZ",
    "label": "Burns Lake Burns Lake Airport (YPZ)"
  },
  {
    "value": "NLK",
    "label": "Burnt Pine Norfolk Island International Airport (NLK)"
  },
  {
    "value": "KJI",
    "label": "Burqin Burqin Kanas Airport (KJI)"
  },
  {
    "value": "YDB",
    "label": "Burwash Landing Burwash Airport (YDB)"
  },
  {
    "value": "BEQ",
    "label": "Bury Saint Edmunds, Suffolk RAF Honington (BEQ)"
  },
  {
    "value": "MHZ",
    "label": "Bury Saint Edmunds, Suffolk RAF Mildenhall (MHZ)"
  },
  {
    "value": "PUS",
    "label": "Busan Gimhae International Airport (PUS)"
  },
  {
    "value": "BUZ",
    "label": "Bushehr Bushehr Airport (BUZ)"
  },
  {
    "value": "XCR",
    "label": "Bussy-Lettrée Châlons-Vatry Airport (XCR)"
  },
  {
    "value": "BZU",
    "label": "Buta Buta Zega Airport (BZU)"
  },
  {
    "value": "BTM",
    "label": "Butte Bert Mooney Airport (BTM)"
  },
  {
    "value": "BWH",
    "label": "Butterworth RMAF Butterworth Air Base (BWH)"
  },
  {
    "value": "BXU",
    "label": "Butuan Bancasi Airport (BXU)"
  },
  {
    "value": "BZG",
    "label": "Bydgoszcz Bydgoszcz Ignacy Jan Paderewski Airport (BZG)"
  },
  {
    "value": "CAH",
    "label": "Ca Mau City Cà Mau Airport (CAH)"
  },
  {
    "value": "ILO",
    "label": "Cabatuan Iloilo International Airport (ILO)"
  },
  {
    "value": "CAB",
    "label": "Cabinda Cabinda Airport (CAB)"
  },
  {
    "value": "BZC",
    "label": "Cabo Frio Umberto Modiano Airport (BZC)"
  },
  {
    "value": "CBJ",
    "label": "Cabo Rojo Cabo Rojo Airport (CBJ)"
  },
  {
    "value": "YZA",
    "label": "Cache Creek Cache Creek-Ashcroft Regional Airport (YZA)"
  },
  {
    "value": "CAG",
    "label": "Cagliari Cagliari Elmas Airport (CAG)"
  },
  {
    "value": "ZAO",
    "label": "Cahors/Lalbenque Aérodrome de Cahors-Lalbenque (ZAO)"
  },
  {
    "value": "CNS",
    "label": "Cairns Cairns International Airport (CNS)"
  },
  {
    "value": "CAI",
    "label": "Cairo Cairo International Airport (CAI)"
  },
  {
    "value": "CJA",
    "label": "Cajamarca Mayor General FAP Armando Revoredo Iglesias Airport (CJA)"
  },
  {
    "value": "CBQ",
    "label": "Calabar Margaret Ekpo International Airport (CBQ)"
  },
  {
    "value": "CJC",
    "label": "Calama El Loa Airport (CJC)"
  },
  {
    "value": "CYP",
    "label": "Calbayog City Calbayog Airport (CYP)"
  },
  {
    "value": "KSF",
    "label": "Calden Kassel Airport (KSF)"
  },
  {
    "value": "YYC",
    "label": "Calgary Calgary International Airport (YYC)"
  },
  {
    "value": "CLO",
    "label": "Cali Alfonso Bonilla Aragon International Airport (CLO)"
  },
  {
    "value": "CCJ",
    "label": "Calicut Calicut International Airport (CCJ)"
  },
  {
    "value": "CLY",
    "label": "Calvi/Sainte-Catherine Calvi-Sainte-Catherine Airport (CLY)"
  },
  {
    "value": "CXR",
    "label": "Cam Ranh Cam Ranh International Airport / Cam Ranh Air Base (CXR)"
  },
  {
    "value": "CMW",
    "label": "Camaguey Ignacio Agramonte International Airport (CMW)"
  },
  {
    "value": "BBS",
    "label": "Camberley, Surrey Blackbushe Airport (BBS)"
  },
  {
    "value": "YCB",
    "label": "Cambridge Bay Cambridge Bay Airport (YCB)"
  },
  {
    "value": "CBG",
    "label": "Cambridge, Cambridgeshire Cambridge City Airport (CBG)"
  },
  {
    "value": "VOK",
    "label": "Camp Douglas Volk Field (VOK)"
  },
  {
    "value": "ADW",
    "label": "Camp Springs Joint Base Andrews (ADW)"
  },
  {
    "value": "YBL",
    "label": "Campbell River Campbell River Airport (YBL)"
  },
  {
    "value": "CAL",
    "label": "Campbeltown Campbeltown Airport (CAL)"
  },
  {
    "value": "CPE",
    "label": "Campeche Ingeniero Alberto Acuña Ongay International Airport (CPE)"
  },
  {
    "value": "CPV",
    "label": "Campina Grande Presidente João Suassuna Airport (CPV)"
  },
  {
    "value": "VCP",
    "label": "Campinas Viracopos International Airport (VCP)"
  },
  {
    "value": "CGR",
    "label": "Campo Grande Campo Grande Airport (CGR)"
  },
  {
    "value": "EBA",
    "label": "Campo nell'Elba (LI) Marina di Campo Airport (EBA)"
  },
  {
    "value": "CAW",
    "label": "Campos Dos Goytacazes Bartolomeu Lisandro Airport (CAW)"
  },
  {
    "value": "VCA",
    "label": "Can Tho Can Tho International Airport (VCA)"
  },
  {
    "value": "CAJ",
    "label": "Canaima Canaima Airport (CAJ)"
  },
  {
    "value": "CKZ",
    "label": "Çanakkale Çanakkale Airport (CKZ)"
  },
  {
    "value": "CBR",
    "label": "Canberra Canberra Airport (CBR)"
  },
  {
    "value": "CUN",
    "label": "Cancún Cancún International Airport (CUN)"
  },
  {
    "value": "DCF",
    "label": "Canefield Canefield Airport (DCF)"
  },
  {
    "value": "CEQ",
    "label": "Cannes, Alpes-Maritimes Cannes-Mandelieu Airport (CEQ)"
  },
  {
    "value": "CIW",
    "label": "Canouan Canouan Airport (CIW)"
  },
  {
    "value": "CAP",
    "label": "Cap Haitien Cap Haitien International Airport (CAP)"
  },
  {
    "value": "CSK",
    "label": "Cap Skirring Cap Skirring Airport (CSK)"
  },
  {
    "value": "CGI",
    "label": "Cape Girardeau Cape Girardeau Regional Airport (CGI)"
  },
  {
    "value": "LUR",
    "label": "Cape Lisburne Cape Lisburne LRRS Airport (LUR)"
  },
  {
    "value": "EHM",
    "label": "Cape Newenham Cape Newenham LRRS Airport (EHM)"
  },
  {
    "value": "CZF",
    "label": "Cape Romanzof Cape Romanzof LRRS Airport (CZF)"
  },
  {
    "value": "CPT",
    "label": "Cape Town Cape Town International Airport (CPT)"
  },
  {
    "value": "CSB",
    "label": "Caransebeş Caransebeş Airport (CSB)"
  },
  {
    "value": "CRQ",
    "label": "Caravelas Caravelas Airport (CRQ)"
  },
  {
    "value": "CCF",
    "label": "Carcassonne/Salvaza Carcassonne Airport (CCF)"
  },
  {
    "value": "APO",
    "label": "Carepa Antonio Roldán Betancur Airport (APO)"
  },
  {
    "value": "CAR",
    "label": "Caribou Caribou Municipal Airport (CAR)"
  },
  {
    "value": "CAX",
    "label": "Carlisle Carlisle Lake District Airport (CAX)"
  },
  {
    "value": "CNM",
    "label": "Carlsbad Cavern City Air Terminal (CNM)"
  },
  {
    "value": "CLD",
    "label": "Carlsbad McClellan-Palomar Airport (CLD)"
  },
  {
    "value": "CVQ",
    "label": "Carnarvon Carnarvon Airport (CVQ)"
  },
  {
    "value": "CLN",
    "label": "Carolina Brig. Lysias Augusto Rodrigues Airport (CLN)"
  },
  {
    "value": "CFR",
    "label": "Carpiquet, Calvados Caen-Carpiquet Airport (CFR)"
  },
  {
    "value": "CTG",
    "label": "Cartagena Rafael Nuñez International Airport (CTG)"
  },
  {
    "value": "CRC",
    "label": "Cartago Santa Ana Airport (CRC)"
  },
  {
    "value": "BZZ",
    "label": "Carterton, Oxfordshire RAF Brize Norton (BZZ)"
  },
  {
    "value": "CUP",
    "label": "Carúpano General Francisco Bermúdez Airport (CUP)"
  },
  {
    "value": "CMN",
    "label": "Casablanca Mohammed V International Airport (CMN)"
  },
  {
    "value": "CAT",
    "label": "Cascais Cascais Airport (CAT)"
  },
  {
    "value": "CAC",
    "label": "Cascavel Coronel Adalberto Mendes da Silva Airport (CAC)"
  },
  {
    "value": "VRN",
    "label": "Caselle (VR) Verona Villafranca Valerio Catullo Airport (VRN)"
  },
  {
    "value": "TRN",
    "label": "Caselle Torinese (TO) Turin Airport (TRN)"
  },
  {
    "value": "CPR",
    "label": "Casper Casper-Natrona County International Airport (CPR)"
  },
  {
    "value": "CDT",
    "label": "Castellón de la Plana Castellón-Costa Azahar Airport (CDT)"
  },
  {
    "value": "YCG",
    "label": "Castlegar Castlegar/West Kootenay Regional Airport (YCG)"
  },
  {
    "value": "IOM",
    "label": "Castletown Isle of Man Airport (IOM)"
  },
  {
    "value": "DCM",
    "label": "Castres/Mazamet Castres-Mazamet Airport (DCM)"
  },
  {
    "value": "SLU",
    "label": "Castries George F. L. Charles Airport (SLU)"
  },
  {
    "value": "ASI",
    "label": "Cat Hill RAF Ascension Island (ASI)"
  },
  {
    "value": "TBI",
    "label": "Cat Island New Bight Airport (TBI)"
  },
  {
    "value": "CTC",
    "label": "Catamarca Coronel Felipe Varela International Airport (CTC)"
  },
  {
    "value": "CTA",
    "label": "Catania Catania-Fontanarossa Airport (CTA)"
  },
  {
    "value": "CRM",
    "label": "Catarman Catarman National Airport (CRM)"
  },
  {
    "value": "MPH",
    "label": "Caticlan Godofredo P. Ramos Airport (MPH)"
  },
  {
    "value": "CBT",
    "label": "Catumbela Catumbela Airport (CBT)"
  },
  {
    "value": "CYZ",
    "label": "Cauayan City Cauayan Airport (CYZ)"
  },
  {
    "value": "CAQ",
    "label": "Caucasia Juan H White Airport (CAQ)"
  },
  {
    "value": "SGL",
    "label": "Cavite Danilo Atienza Air Base (SGL)"
  },
  {
    "value": "CXJ",
    "label": "Caxias Do Sul Hugo Cantergiani Regional Airport (CXJ)"
  },
  {
    "value": "CUK",
    "label": "Caye Caulker Caye Caulker Airport (CUK)"
  },
  {
    "value": "CYC",
    "label": "Caye Chapel Caye Chapel Airport (CYC)"
  },
  {
    "value": "CCC",
    "label": "Cayo Coco Jardines Del Rey Airport (CCC)"
  },
  {
    "value": "CYO",
    "label": "Cayo Largo del Sur Vilo Acuña International Airport (CYO)"
  },
  {
    "value": "CDC",
    "label": "Cedar City Cedar City Regional Airport (CDC)"
  },
  {
    "value": "CID",
    "label": "Cedar Rapids The Eastern Iowa Airport (CID)"
  },
  {
    "value": "NRR",
    "label": "Ceiba José Aponte de la Torre Airport (NRR)"
  },
  {
    "value": "CYW",
    "label": "Celaya Captain Rogelio Castillo National Airport (CYW)"
  },
  {
    "value": "VAF",
    "label": "Chabeuil, Drôme Valence-Chabeuil Airport (VAF)"
  },
  {
    "value": "PSO",
    "label": "Chachagüí Antonio Nariño Airport (PSO)"
  },
  {
    "value": "CHH",
    "label": "Chachapoyas Chachapoyas Airport (CHH)"
  },
  {
    "value": "CDR",
    "label": "Chadron Chadron Municipal Airport (CDR)"
  },
  {
    "value": "WCH",
    "label": "Chaitén Nuevo Chaitén Airport (WCH)"
  },
  {
    "value": "PMA",
    "label": "Chake Chake Pemba Airport (PMA)"
  },
  {
    "value": "NAK",
    "label": "Chaloem Phra Kiat Nakhon Ratchasima Airport (NAK)"
  },
  {
    "value": "CNR",
    "label": "Chañaral Chañaral Airport (CNR)"
  },
  {
    "value": "IXC",
    "label": "Chandigarh Chandigarh International Airport (IXC)"
  },
  {
    "value": "CGQ",
    "label": "Changchun Changchun Longjia International Airport (CGQ)"
  },
  {
    "value": "CGD",
    "label": "Changde (Dingcheng) Changde Taohuayuan Airport (CGD)"
  },
  {
    "value": "CSX",
    "label": "Changsha (Changsha) Changsha Huanghua International Airport (CSX)"
  },
  {
    "value": "CHX",
    "label": "Changuinola Changuinola Captain Manuel Niño International Airport (CHX)"
  },
  {
    "value": "CZX",
    "label": "Changzhou Changzhou Benniu International Airport (CZX)"
  },
  {
    "value": "CNU",
    "label": "Chanute Chanute Martin Johnson Airport (CNU)"
  },
  {
    "value": "XAP",
    "label": "Chapecó Serafin Enoss Bertaso Airport (XAP)"
  },
  {
    "value": "CPC",
    "label": "Chapelco/San Martin de los Andes Aviador C. Campos Airport (CPC)"
  },
  {
    "value": "YLD",
    "label": "Chapleau Chapleau Airport (YLD)"
  },
  {
    "value": "CRL",
    "label": "Charleroi Brussels South Charleroi Airport (CRL)"
  },
  {
    "value": "CCY",
    "label": "Charles City Northeast Iowa Regional Airport (CCY)"
  },
  {
    "value": "CHS",
    "label": "Charleston Charleston International Airport (CHS)"
  },
  {
    "value": "CRW",
    "label": "Charleston Yeager Airport (CRW)"
  },
  {
    "value": "NOC",
    "label": "Charlestown Ireland West Knock Airport (NOC)"
  },
  {
    "value": "NEV",
    "label": "Charlestown Vance W. Amory International Airport (NEV)"
  },
  {
    "value": "CTL",
    "label": "Charleville Charleville Airport (CTL)"
  },
  {
    "value": "YML",
    "label": "Charlevoix Charlevoix Airport (YML)"
  },
  {
    "value": "YCL",
    "label": "Charlo Charlo Airport (YCL)"
  },
  {
    "value": "STT",
    "label": "Charlotte Amalie Cyril E. King Airport (STT)"
  },
  {
    "value": "CLT",
    "label": "Charlotte Charlotte Douglas International Airport (CLT)"
  },
  {
    "value": "CHO",
    "label": "Charlottesville Charlottesville Albemarle Airport (CHO)"
  },
  {
    "value": "YYG",
    "label": "Charlottetown Charlottetown Airport (YYG)"
  },
  {
    "value": "VHY",
    "label": "Charmeil, Allier Vichy-Charmeil Airport (VHY)"
  },
  {
    "value": "LPY",
    "label": "Chaspuzac, Haute-Loire Le Puy-Loudes Airfield (LPY)"
  },
  {
    "value": "LYN",
    "label": "Chassieu, Lyon Lyon Bron Airport (LYN)"
  },
  {
    "value": "CHA",
    "label": "Chattanooga Chattanooga Metropolitan Airport (Lovell Field) (CHA)"
  },
  {
    "value": "CGP",
    "label": "Chattogram (Chittagong) Shah Amanat International Airport (CGP)"
  },
  {
    "value": "CSY",
    "label": "Cheboksary Cheboksary Airport (CSY)"
  },
  {
    "value": "CEK",
    "label": "Chelyabinsk Chelyabinsk Balandino Airport (CEK)"
  },
  {
    "value": "CDE",
    "label": "Chengde Chengde Puning Airport (CDE)"
  },
  {
    "value": "TFU",
    "label": "Chengdu (Jianyang) Chengdu Tianfu International Airport (TFU)"
  },
  {
    "value": "HZU",
    "label": "Chengdu (Jintang) Chengdu Huaizhou Airport (HZU)"
  },
  {
    "value": "CTU",
    "label": "Chengdu (Shuangliu) Chengdu Shuangliu International Airport (CTU)"
  },
  {
    "value": "MAA",
    "label": "Chennai Chennai International Airport (MAA)"
  },
  {
    "value": "HCZ",
    "label": "Chenzhou Chenzhou Beihu Airport (HCZ)"
  },
  {
    "value": "CJJ",
    "label": "Cheongju Cheongju International Airport/Cheongju Air Base (K-59/G-513) (CJJ)"
  },
  {
    "value": "ULY",
    "label": "Cherdakly Ulyanovsk East Airport (ULY)"
  },
  {
    "value": "CEE",
    "label": "Cherepovets Cherepovets Airport (CEE)"
  },
  {
    "value": "CKC",
    "label": "Cherkasy Cherkasy International Airport (CKC)"
  },
  {
    "value": "CWC",
    "label": "Chernivtsi Chernivtsi International Airport (CWC)"
  },
  {
    "value": "CYX",
    "label": "Cherskiy Cherskiy Airport (CYX)"
  },
  {
    "value": "CTM",
    "label": "Chetumal Chetumal International Airport (CTM)"
  },
  {
    "value": "YCQ",
    "label": "Chetwynd Chetwynd Airport (YCQ)"
  },
  {
    "value": "CYS",
    "label": "Cheyenne Cheyenne Regional Jerry Olson Field (CYS)"
  },
  {
    "value": "CNX",
    "label": "Chiang Mai Chiang Mai International Airport (CNX)"
  },
  {
    "value": "CEI",
    "label": "Chiang Rai Mae Fah Luang - Chiang Rai International Airport (CEI)"
  },
  {
    "value": "YMT",
    "label": "Chibougamau Chapais Airport (YMT)"
  },
  {
    "value": "MDW",
    "label": "Chicago Chicago Midway International Airport (MDW)"
  },
  {
    "value": "ORD",
    "label": "Chicago Chicago O'Hare International Airport (ORD)"
  },
  {
    "value": "PWK",
    "label": "Chicago/Prospect Heights/Wheeling Chicago Executive Airport (PWK)"
  },
  {
    "value": "RFD",
    "label": "Chicago/Rockford Chicago Rockford International Airport (RFD)"
  },
  {
    "value": "DPA",
    "label": "Chicago/West Chicago Dupage Airport (DPA)"
  },
  {
    "value": "CIX",
    "label": "Chiclayo Air Force Captain Jose A Quinones Gonzales International Airport (CIX)"
  },
  {
    "value": "CEF",
    "label": "Chicopee Westover Metropolitan Airport / Westover Air Reserve Base (CEF)"
  },
  {
    "value": "CIF",
    "label": "Chifeng Chifeng Yulong Airport (CIF)"
  },
  {
    "value": "CUU",
    "label": "Chihuahua General Roberto Fierro Villalobos International Airport (CUU)"
  },
  {
    "value": "CDS",
    "label": "Childress Childress Municipal Airport (CDS)"
  },
  {
    "value": "CCH",
    "label": "Chile Chico Chile Chico Airport (CCH)"
  },
  {
    "value": "YAI",
    "label": "Chillan Gral. Bernardo O´Higgins Airport (YAI)"
  },
  {
    "value": "CHM",
    "label": "Chimbote FAP Lieutenant Jaime Andres de Montreuil Morales Airport (CHM)"
  },
  {
    "value": "VPY",
    "label": "Chimoio Chimoio Airport (VPY)"
  },
  {
    "value": "CCL",
    "label": "Chinchilla Chinchilla Airport (CCL)"
  },
  {
    "value": "CGJ",
    "label": "Chingola Kasompe Airport (CGJ)"
  },
  {
    "value": "JKH",
    "label": "Chios Island Chios Island National Airport (JKH)"
  },
  {
    "value": "BFO",
    "label": "Chiredzi Buffalo Range Airport (BFO)"
  },
  {
    "value": "RMO",
    "label": "Chişinău Chişinău International Airport (RMO)"
  },
  {
    "value": "HTA",
    "label": "Chita Chita-Kadala International Airport (HTA)"
  },
  {
    "value": "DUE",
    "label": "Chitato Dundo Airport (DUE)"
  },
  {
    "value": "CJL",
    "label": "Chitral Chitral Airport (CJL)"
  },
  {
    "value": "CTD",
    "label": "Chitré Alonso Valderrama Airport (CTD)"
  },
  {
    "value": "CFK",
    "label": "Chlef Chlef Aboubakr Belkaid International Airport (CFK)"
  },
  {
    "value": "CKH",
    "label": "Chokurdah Chokurdakh Airport (CKH)"
  },
  {
    "value": "CKG",
    "label": "Chongqing Chongqing Jiangbei International Airport (CKG)"
  },
  {
    "value": "CHC",
    "label": "Christchurch Christchurch International Airport (CHC)"
  },
  {
    "value": "BOH",
    "label": "Christchurch, Dorset Bournemouth Airport (BOH)"
  },
  {
    "value": "STX",
    "label": "Christiansted Henry E Rohlsen Airport (STX)"
  },
  {
    "value": "CCZ",
    "label": "Chub Cay Chub Cay Airport (CCZ)"
  },
  {
    "value": "PVS",
    "label": "Chukotka Provideniya Bay Airport (PVS)"
  },
  {
    "value": "CJM",
    "label": "Chumphon Chumphon Airport (CJM)"
  },
  {
    "value": "YYQ",
    "label": "Churchill Churchill Airport (YYQ)"
  },
  {
    "value": "YUA",
    "label": "Chuxiong (Yuanmou) Yuanmou Air Base (YUA)"
  },
  {
    "value": "CFG",
    "label": "Cienfuegos Jaime Gonzalez Airport (CFG)"
  },
  {
    "value": "IGL",
    "label": "Çiğli Çiğli Airbase (IGL)"
  },
  {
    "value": "CXP",
    "label": "Cilacap Tunggul Wulung Airport (CXP)"
  },
  {
    "value": "DBV",
    "label": "Čilipi Dubrovnik Ruđer Bošković Airport (DBV)"
  },
  {
    "value": "CVG",
    "label": "Cincinnati / Covington Cincinnati Northern Kentucky International Airport (CVG)"
  },
  {
    "value": "LUK",
    "label": "Cincinnati Cincinnati Municipal Airport Lunken Field (LUK)"
  },
  {
    "value": "AVI",
    "label": "Ciro Redondo Máximo Gómez Airport (AVI)"
  },
  {
    "value": "CBL",
    "label": "Ciudad Bolivar General Tomas de Heres Airport (CBL)"
  },
  {
    "value": "MVD",
    "label": "Ciudad de la Costa Carrasco General Cesáreo L. Berisso International Airport (MVD)"
  },
  {
    "value": "MEX",
    "label": "Ciudad de México Benito Juárez International Airport (MEX)"
  },
  {
    "value": "CME",
    "label": "Ciudad del Carmen Ciudad del Carmen International Airport (CME)"
  },
  {
    "value": "AGT",
    "label": "Ciudad del Este Guaraní International Airport (AGT)"
  },
  {
    "value": "CJS",
    "label": "Ciudad Juárez Abraham González International Airport (CJS)"
  },
  {
    "value": "CEN",
    "label": "Ciudad Obregón Ciudad Obregón International Airport (CEN)"
  },
  {
    "value": "CQM",
    "label": "Ciudad Real Ciudad Real International Airport (CQM)"
  },
  {
    "value": "CVM",
    "label": "Ciudad Victoria General Pedro Jose Mendez International Airport (CVM)"
  },
  {
    "value": "BKL",
    "label": "Cleveland Burke Lakefront Airport (BKL)"
  },
  {
    "value": "CLE",
    "label": "Cleveland Cleveland Hopkins International Airport (CLE)"
  },
  {
    "value": "CGF",
    "label": "Cleveland Cuyahoga County Airport (CGF)"
  },
  {
    "value": "CNJ",
    "label": "Cloncurry Cloncurry Airport (CNJ)"
  },
  {
    "value": "CVS",
    "label": "Clovis Cannon Air Force Base (CVS)"
  },
  {
    "value": "CVN",
    "label": "Clovis Clovis Municipal Airport (CVN)"
  },
  {
    "value": "CLJ",
    "label": "Cluj-Napoca Cluj Avram Iancu International Airport (CLJ)"
  },
  {
    "value": "CBV",
    "label": "Coban Coban Airport (CBV)"
  },
  {
    "value": "CDU",
    "label": "Cobbitty Camden Airport (CDU)"
  },
  {
    "value": "CIJ",
    "label": "Cobija Capitán Aníbal Arab Airport (CIJ)"
  },
  {
    "value": "OCC",
    "label": "Coca Francisco De Orellana Airport (OCC)"
  },
  {
    "value": "CBB",
    "label": "Cochabamba Jorge Wilsterman International Airport (CBB)"
  },
  {
    "value": "LGR",
    "label": "Cochrane Cochrane Airport (LGR)"
  },
  {
    "value": "YCN",
    "label": "Cochrane Cochrane Airport (YCN)"
  },
  {
    "value": "GDT",
    "label": "Cockburn Town JAGS McCartney International Airport (GDT)"
  },
  {
    "value": "COF",
    "label": "Cocoa Beach Patrick Space Force Base (COF)"
  },
  {
    "value": "BBQ",
    "label": "Codrington Codrington Airport (BBQ)"
  },
  {
    "value": "COD",
    "label": "Cody Yellowstone Regional Airport (COD)"
  },
  {
    "value": "CUQ",
    "label": "Coen Coen Airport (CUQ)"
  },
  {
    "value": "COE",
    "label": "Coeur d'Alene Coeur D'Alene Airport - Pappy Boyington Field (COE)"
  },
  {
    "value": "CFS",
    "label": "Coffs Harbour Coffs Harbour Airport (CFS)"
  },
  {
    "value": "CNG",
    "label": "Cognac/Châteaubernard Cognac-Châteaubernard (BA 709) Air Base (CNG)"
  },
  {
    "value": "CJB",
    "label": "Coimbatore Coimbatore International Airport (CJB)"
  },
  {
    "value": "CBP",
    "label": "Coimbra Aerodromo Municipal de Coimbra (CBP)"
  },
  {
    "value": "CDB",
    "label": "Cold Bay Cold Bay Airport (CDB)"
  },
  {
    "value": "YOD",
    "label": "Cold Lake CFB Cold Lake (YOD)"
  },
  {
    "value": "CLQ",
    "label": "Colima Licenciado Miguel de la Madrid International Airport (CLQ)"
  },
  {
    "value": "CLL",
    "label": "College Station Easterwood Field (CLL)"
  },
  {
    "value": "CMR",
    "label": "Colmar, Haut-Rhin Colmar-Houssen Airport (CMR)"
  },
  {
    "value": "LYS",
    "label": "Colombier-Saugnieu, Rhône Lyon Saint-Exupéry Airport (LYS)"
  },
  {
    "value": "CMB",
    "label": "Colombo Bandaranaike International Colombo Airport (CMB)"
  },
  {
    "value": "RML",
    "label": "Colombo Colombo Ratmalana Airport (RML)"
  },
  {
    "value": "ONX",
    "label": "Colón Enrique Adolfo Jimenez Airport (ONX)"
  },
  {
    "value": "CRI",
    "label": "Colonel Hill Colonel Hill Airport (CRI)"
  },
  {
    "value": "COS",
    "label": "Colorado Springs City of Colorado Springs Municipal Airport (COS)"
  },
  {
    "value": "CAE",
    "label": "Columbia Columbia Metropolitan Airport (CAE)"
  },
  {
    "value": "COU",
    "label": "Columbia Columbia Regional Airport (COU)"
  },
  {
    "value": "CUB",
    "label": "Columbia Jim Hamilton L.B. Owens Airport (CUB)"
  },
  {
    "value": "CBM",
    "label": "Columbus Columbus Air Force Base (CBM)"
  },
  {
    "value": "CSG",
    "label": "Columbus Columbus Metropolitan Airport (CSG)"
  },
  {
    "value": "CLU",
    "label": "Columbus Columbus Municipal Airport (CLU)"
  },
  {
    "value": "OLU",
    "label": "Columbus Columbus Municipal Airport (OLU)"
  },
  {
    "value": "CMH",
    "label": "Columbus John Glenn Columbus International Airport (CMH)"
  },
  {
    "value": "LCK",
    "label": "Columbus Rickenbacker International Airport (LCK)"
  },
  {
    "value": "OSU",
    "label": "Columbus The Ohio State University Airport - Don Scott Field (OSU)"
  },
  {
    "value": "GTR",
    "label": "Columbus/W Point/Starkville Golden Triangle Regional Airport (GTR)"
  },
  {
    "value": "CIY",
    "label": "Comiso Comiso Airport (CIY)"
  },
  {
    "value": "CRD",
    "label": "Comodoro Rivadavia General E. Mosconi Airport (CRD)"
  },
  {
    "value": "YQQ",
    "label": "Comox Comox Valley Airport / CFB Comox (YQQ)"
  },
  {
    "value": "VCS",
    "label": "Con Dao Con Dao Airport (VCS)"
  },
  {
    "value": "CKY",
    "label": "Conakry Conakry International Airport (CKY)"
  },
  {
    "value": "CDJ",
    "label": "Conceição do Araguaia Conceição do Araguaia Airport (CDJ)"
  },
  {
    "value": "CCP",
    "label": "Concepcion Carriel Sur Airport (CCP)"
  },
  {
    "value": "CIO",
    "label": "Concepción Lieutenant Colonel Carmelo Peralta National Airport (CIO)"
  },
  {
    "value": "CCR",
    "label": "Concord Buchanan Field (CCR)"
  },
  {
    "value": "CON",
    "label": "Concord Concord Municipal Airport (CON)"
  },
  {
    "value": "USA",
    "label": "Concord Concord-Padgett Regional Airport (USA)"
  },
  {
    "value": "COC",
    "label": "Concordia Comodoro Pierrestegui Airport (COC)"
  },
  {
    "value": "CZL",
    "label": "Constantine Mohamed Boudiaf International Airport (CZL)"
  },
  {
    "value": "CPD",
    "label": "Coober Pedy Coober Pedy Airport (CPD)"
  },
  {
    "value": "OOM",
    "label": "Cooma Cooma Snowy Mountains Airport (OOM)"
  },
  {
    "value": "CPH",
    "label": "Copenhagen Copenhagen Kastrup Airport (CPH)"
  },
  {
    "value": "CPO",
    "label": "Copiapo Desierto de Atacama Airport (CPO)"
  },
  {
    "value": "YZS",
    "label": "Coral Harbour Coral Harbour Airport (YZS)"
  },
  {
    "value": "ODB",
    "label": "Córdoba Córdoba Airport (ODB)"
  },
  {
    "value": "COR",
    "label": "Cordoba Ingeniero Ambrosio Taravella Airport (COR)"
  },
  {
    "value": "CDV",
    "label": "Cordova Merle K (Mudhole) Smith Airport (CDV)"
  },
  {
    "value": "ORK",
    "label": "Cork Cork Airport (ORK)"
  },
  {
    "value": "TEQ",
    "label": "Çorlu Tekirdağ Çorlu Airport (TEQ)"
  },
  {
    "value": "POX",
    "label": "Cormeilles-en-Vexin, Val-d'Oise Pontoise-Cormeilles Aerodrome (POX)"
  },
  {
    "value": "YCC",
    "label": "Cornwall Cornwall Regional Airport (YCC)"
  },
  {
    "value": "CZE",
    "label": "Coro José Leonardo Chirinos Airport (CZE)"
  },
  {
    "value": "USU",
    "label": "Coron Francisco B. Reyes (Busuanga) Airport (USU)"
  },
  {
    "value": "CZH",
    "label": "Corozal Corozal Airport (CZH)"
  },
  {
    "value": "CZU",
    "label": "Corozal Las Brujas Airport (CZU)"
  },
  {
    "value": "CRP",
    "label": "Corpus Christi Corpus Christi International Airport (CRP)"
  },
  {
    "value": "NGP",
    "label": "Corpus Christi Naval Air Station Corpus Christi Truax Field (NGP)"
  },
  {
    "value": "OTR",
    "label": "Corredores Coto 47 Airport (OTR)"
  },
  {
    "value": "EEA",
    "label": "Correia Pinto Planalto Serrano Regional Airport (EEA)"
  },
  {
    "value": "CNQ",
    "label": "Corrientes Corrientes Airport (CNQ)"
  },
  {
    "value": "CEZ",
    "label": "Cortez Cortez Municipal Airport (CEZ)"
  },
  {
    "value": "CMG",
    "label": "Corumbá Corumbá International Airport (CMG)"
  },
  {
    "value": "CVO",
    "label": "Corvallis Corvallis Municipal Airport (CVO)"
  },
  {
    "value": "RMU",
    "label": "Corvera Región de Murcia International Airport (RMU)"
  },
  {
    "value": "MTT",
    "label": "Cosoleacaque Minatitlán/Coatzacoalcos International Airport (MTT)"
  },
  {
    "value": "COO",
    "label": "Cotonou Cadjehoun Airport (COO)"
  },
  {
    "value": "CVE",
    "label": "Coveñas Coveñas Airport (CVE)"
  },
  {
    "value": "CVT",
    "label": "Coventry, West Midlands Coventry Airport (CVT)"
  },
  {
    "value": "CXB",
    "label": "Cox's Bazar Cox's Bazar Airport (CXB)"
  },
  {
    "value": "RTB",
    "label": "Coxen Hole Juan Manuel Gálvez International Airport (RTB)"
  },
  {
    "value": "GXQ",
    "label": "Coyhaique Teniente Vidal Airport (GXQ)"
  },
  {
    "value": "CZM",
    "label": "Cozumel Cozumel International Airport (CZM)"
  },
  {
    "value": "CRA",
    "label": "Craiova Craiova International Airport (CRA)"
  },
  {
    "value": "YXC",
    "label": "Cranbrook Cranbrook/Canadian Rockies International Airport (YXC)"
  },
  {
    "value": "CSF",
    "label": "Creil Creil Air Base (CSF)"
  },
  {
    "value": "CEC",
    "label": "Crescent City Jack Mc Namara Field Airport (CEC)"
  },
  {
    "value": "CEW",
    "label": "Crestview Bob Sikes Airport (CEW)"
  },
  {
    "value": "EGI",
    "label": "Crestview Duke Field (EGI)"
  },
  {
    "value": "JSH",
    "label": "Crete Island Sitia Airport (JSH)"
  },
  {
    "value": "CCM",
    "label": "Criciúma Forquilhinha - Criciúma  Airport (CCM)"
  },
  {
    "value": "CSV",
    "label": "Crossville Crossville Memorial Airport Whitson Field (CSV)"
  },
  {
    "value": "JJD",
    "label": "Cruz Comandante Ariston Pessoa Airport (JJD)"
  },
  {
    "value": "CZS",
    "label": "Cruzeiro Do Sul Cruzeiro do Sul Airport (CZS)"
  },
  {
    "value": "CUC",
    "label": "Cúcuta Camilo Daza International Airport (CUC)"
  },
  {
    "value": "CUE",
    "label": "Cuenca Mariscal Lamar Airport (CUE)"
  },
  {
    "value": "CGB",
    "label": "Cuiabá Marechal Rondon Airport (CGB)"
  },
  {
    "value": "CPX",
    "label": "Culebra Benjamin Rivera Noriega Airport (CPX)"
  },
  {
    "value": "CUL",
    "label": "Culiacán Bachigualato Federal International Airport (CUL)"
  },
  {
    "value": "LCG",
    "label": "Culleredo A Coruña Airport (LCG)"
  },
  {
    "value": "CWB",
    "label": "Curitiba Afonso Pena Airport (CWB)"
  },
  {
    "value": "BFH",
    "label": "Curitiba Bacacheri Airport (BFH)"
  },
  {
    "value": "UZU",
    "label": "Curuzu Cuatia Curuzu Cuatia Airport (UZU)"
  },
  {
    "value": "CUZ",
    "label": "Cusco Alejandro Velasco Astete International Airport (CUZ)"
  },
  {
    "value": "CTB",
    "label": "Cut Bank Cut Bank International Airport (CTB)"
  },
  {
    "value": "CUT",
    "label": "Cutral-Co Cutral-Co Airport (CUT)"
  },
  {
    "value": "DLI",
    "label": "Da Lat Lien Khuong Airport (DLI)"
  },
  {
    "value": "DAD",
    "label": "Da Nang Da Nang International Airport (DAD)"
  },
  {
    "value": "TAE",
    "label": "Daegu Daegu Airport (TAE)"
  },
  {
    "value": "DTE",
    "label": "Daet Daet Airport (DTE)"
  },
  {
    "value": "DAG",
    "label": "Daggett Barstow Daggett Airport (DAG)"
  },
  {
    "value": "DSS",
    "label": "Dakar Blaise Diagne International Airport (DSS)"
  },
  {
    "value": "DKR",
    "label": "Dakar Léopold Sédar Senghor International Airport (DKR)"
  },
  {
    "value": "VIL",
    "label": "Dakhla Dakhla Airport (VIL)"
  },
  {
    "value": "DLM",
    "label": "Dalaman Dalaman International Airport (DLM)"
  },
  {
    "value": "DLZ",
    "label": "Dalanzadgad Dalanzadgad Airport (DLZ)"
  },
  {
    "value": "DHT",
    "label": "Dalhart Dalhart Municipal Airport (DHT)"
  },
  {
    "value": "DLU",
    "label": "Dali (Xiaguan) Dali Fengyi Airport (DLU)"
  },
  {
    "value": "CNI",
    "label": "Dalian (Changhai) Changhai Airport (CNI)"
  },
  {
    "value": "DLC",
    "label": "Dalian (Ganjingzi) Dalian Zhoushuizi International Airport (DLC)"
  },
  {
    "value": "DAL",
    "label": "Dallas Dallas Love Field (DAL)"
  },
  {
    "value": "DFW",
    "label": "Dallas-Fort Worth Dallas Fort Worth International Airport (DFW)"
  },
  {
    "value": "DLS",
    "label": "Dallesport / The Dalles Columbia Gorge Regional Airport (DLS)"
  },
  {
    "value": "NMB",
    "label": "Daman Daman Airport (NMB)"
  },
  {
    "value": "DAM",
    "label": "Damascus Damascus International Airport (DAM)"
  },
  {
    "value": "DXR",
    "label": "Danbury Danbury Municipal Airport (DXR)"
  },
  {
    "value": "DDG",
    "label": "Dandong (Zhenxing) Dandong Langtou Airport (DDG)"
  },
  {
    "value": "DGA",
    "label": "Dangriga Dangriga Airport (DGA)"
  },
  {
    "value": "DAN",
    "label": "Danville Danville Regional Airport (DAN)"
  },
  {
    "value": "DAR",
    "label": "Dar es Salaam Julius Nyerere International Airport (DAR)"
  },
  {
    "value": "DBR",
    "label": "Darbhanga Darbhanga Airport (DBR)"
  },
  {
    "value": "MME",
    "label": "Darlington, Durham Teesside International Airport (MME)"
  },
  {
    "value": "DAU",
    "label": "Daru Daru Airport (DAU)"
  },
  {
    "value": "DRW",
    "label": "Darwin Darwin International Airport / RAAF Darwin (DRW)"
  },
  {
    "value": "TAZ",
    "label": "Daşoguz Daşoguz Airport (TAZ)"
  },
  {
    "value": "CBO",
    "label": "Datu Odin Sinsuat Cotabato (Awang) Airport (CBO)"
  },
  {
    "value": "YDN",
    "label": "Dauphin Dauphin Barker Airport (YDN)"
  },
  {
    "value": "DVO",
    "label": "Davao Francisco Bangoy International Airport (DVO)"
  },
  {
    "value": "DAV",
    "label": "David Enrique Malek International Airport (DAV)"
  },
  {
    "value": "DWD",
    "label": "Dawadmi King Salman Abdulaziz Airport (DWD)"
  },
  {
    "value": "TVY",
    "label": "Dawei Dawei Airport (TVY)"
  },
  {
    "value": "YDA",
    "label": "Dawson City Dawson City Airport (YDA)"
  },
  {
    "value": "YDQ",
    "label": "Dawson Creek Dawson Creek Airport (YDQ)"
  },
  {
    "value": "DAY",
    "label": "Dayton James M Cox Dayton International Airport (DAY)"
  },
  {
    "value": "FFO",
    "label": "Dayton Wright-Patterson Air Force Base (FFO)"
  },
  {
    "value": "DAB",
    "label": "Daytona Beach Daytona Beach International Airport (DAB)"
  },
  {
    "value": "DZH",
    "label": "Dazhou (Dachuan) Dazhou Jinya Airport (DZH)"
  },
  {
    "value": "SCC",
    "label": "Deadhorse Deadhorse Airport (SCC)"
  },
  {
    "value": "LGI",
    "label": "Deadman's Cay Deadman's Cay Airport (LGI)"
  },
  {
    "value": "DOL",
    "label": "Deauville, Calvados Deauville-Normandie Airport (DOL)"
  },
  {
    "value": "QHR",
    "label": "Debre Zeyit Harar Meda Airport (QHR)"
  },
  {
    "value": "DEB",
    "label": "Debrecen Debrecen International Airport (DEB)"
  },
  {
    "value": "DEC",
    "label": "Decatur Decatur Airport (DEC)"
  },
  {
    "value": "DCI",
    "label": "Decimomannu Decimomannu Air Base (DCI)"
  },
  {
    "value": "YDF",
    "label": "Deer Lake Deer Lake Airport (YDF)"
  },
  {
    "value": "DRG",
    "label": "Deering Deering Airport (DRG)"
  },
  {
    "value": "LUM",
    "label": "Dehong (Mangshi) Dehong Mangshi Airport (LUM)"
  },
  {
    "value": "DED",
    "label": "Dehradun (Jauligrant) Dehradun Jolly Grant Airport (DED)"
  },
  {
    "value": "DEZ",
    "label": "Deir ez-Zor Deir ez-Zor Airport (DEZ)"
  },
  {
    "value": "DRT",
    "label": "Del Rio Del Rio International Airport (DRT)"
  },
  {
    "value": "DLF",
    "label": "Del Rio Laughlin Air Force Base (DLF)"
  },
  {
    "value": "YDT",
    "label": "Delta Boundary Bay Airport (YDT)"
  },
  {
    "value": "BIG",
    "label": "Delta Junction Ft Greely Allen Army Airfield (BIG)"
  },
  {
    "value": "DMN",
    "label": "Deming Deming Municipal Airport (DMN)"
  },
  {
    "value": "DHR",
    "label": "Den Helder De Kooy Airfield / Den Helder Naval Air Station (DHR)"
  },
  {
    "value": "MJK",
    "label": "Denham Shark Bay Airport (MJK)"
  },
  {
    "value": "DNQ",
    "label": "Deniliquin Deniliquin Airport (DNQ)"
  },
  {
    "value": "PNX",
    "label": "Denison North Texas Regional Airport Perrin Field (PNX)"
  },
  {
    "value": "DNZ",
    "label": "Denizli Çardak Airport (DNZ)"
  },
  {
    "value": "APA",
    "label": "Denver Centennial Airport (APA)"
  },
  {
    "value": "DEN",
    "label": "Denver Denver International Airport (DEN)"
  },
  {
    "value": "BJC",
    "label": "Denver Rocky Mountain Metropolitan Airport (BJC)"
  },
  {
    "value": "CHR",
    "label": "Déols, Indre Châteauroux-Déols Marcel Dassault Airport (CHR)"
  },
  {
    "value": "DEA",
    "label": "Dera Ghazi Khan Dera Ghazi Khan Airport (DEA)"
  },
  {
    "value": "DSK",
    "label": "Dera Ismael Khan Dera Ismael Khan Airport (DSK)"
  },
  {
    "value": "DRB",
    "label": "Derby Derby Airport (DRB)"
  },
  {
    "value": "DCN",
    "label": "Derby RAAF Base Curtin (DCN)"
  },
  {
    "value": "DRI",
    "label": "DeRidder Beauregard Regional Airport (DRI)"
  },
  {
    "value": "LDY",
    "label": "Derry City of Derry Airport (LDY)"
  },
  {
    "value": "DSM",
    "label": "Des Moines Des Moines International Airport (DSM)"
  },
  {
    "value": "DSI",
    "label": "Destin Destin Executive Airport (DSI)"
  },
  {
    "value": "DET",
    "label": "Detroit Coleman A. Young Municipal Airport (DET)"
  },
  {
    "value": "DTW",
    "label": "Detroit Detroit Metropolitan Wayne County Airport (DTW)"
  },
  {
    "value": "YIP",
    "label": "Detroit Willow Run Airport (YIP)"
  },
  {
    "value": "DVL",
    "label": "Devils Lake Devils Lake Regional Airport (DVL)"
  },
  {
    "value": "DPO",
    "label": "Devonport Devonport Airport (DPO)"
  },
  {
    "value": "DEF",
    "label": "Dezful Dezful Airport (DEF)"
  },
  {
    "value": "DHA",
    "label": "Dhahran King Abdulaziz Air Base (DHA)"
  },
  {
    "value": "DAC",
    "label": "Dhaka Hazrat Shahjalal International Airport (DAC)"
  },
  {
    "value": "DIB",
    "label": "Dibrugarh Dibrugarh Airport (DIB)"
  },
  {
    "value": "DIK",
    "label": "Dickinson Dickinson Theodore Roosevelt Regional Airport (DIK)"
  },
  {
    "value": "NKW",
    "label": "Diego Garcia Diego Garcia Naval Support Facility (NKW)"
  },
  {
    "value": "DIN",
    "label": "Dien Bien Phu Dien Bien Phu Airport (DIN)"
  },
  {
    "value": "YDG",
    "label": "Digby Digby / Annapolis Regional Airport (YDG)"
  },
  {
    "value": "DKS",
    "label": "Dikson Dikson Airport (DKS)"
  },
  {
    "value": "DIL",
    "label": "Dili Presidente Nicolau Lobato International Airport (DIL)"
  },
  {
    "value": "DLG",
    "label": "Dillingham Dillingham Airport (DLG)"
  },
  {
    "value": "DMU",
    "label": "Dimapur Dimapur Airport (DMU)"
  },
  {
    "value": "DPL",
    "label": "Dipolog Dipolog Airport (DPL)"
  },
  {
    "value": "DIG",
    "label": "Diqing (Shangri-La) Diqing Shangri-La Airport (DIG)"
  },
  {
    "value": "DIR",
    "label": "Dire Dawa Aba Tenna Dejazmach Yilma International Airport (DIR)"
  },
  {
    "value": "DIY",
    "label": "Diyarbakır Diyarbakır Airport (DIY)"
  },
  {
    "value": "DJG",
    "label": "Djanet Djanet Inedbirene Airport (DJG)"
  },
  {
    "value": "JIB",
    "label": "Djibouti City Djibouti-Ambouli Airport (JIB)"
  },
  {
    "value": "DNK",
    "label": "Dnipro Dnipro International Airport (DNK)"
  },
  {
    "value": "DDC",
    "label": "Dodge City Dodge City Regional Airport (DDC)"
  },
  {
    "value": "DOD",
    "label": "Dodoma Dodoma Airport (DOD)"
  },
  {
    "value": "DIA",
    "label": "Doha Doha International Airport (DIA)"
  },
  {
    "value": "DOH",
    "label": "Doha Hamad International Airport (DOH)"
  },
  {
    "value": "YDO",
    "label": "Dolbeau-Saint-Felicien Dolbeau-Saint-Felicien Airport (YDO)"
  },
  {
    "value": "DIS",
    "label": "Dolisie Ngot Nzoungou Airport (DIS)"
  },
  {
    "value": "ILZ",
    "label": "Dolný Hričov Žilina-Dolný Hričov Airport (ILZ)"
  },
  {
    "value": "CFN",
    "label": "Donegal Donegal Airport (CFN)"
  },
  {
    "value": "VDH",
    "label": "Dong Hoi Dong Hoi Airport (VDH)"
  },
  {
    "value": "DOG",
    "label": "Dongola Dongola Airport (DOG)"
  },
  {
    "value": "DOY",
    "label": "Dongying (Kenli) Dongying Shengli Airport (DOY)"
  },
  {
    "value": "DTM",
    "label": "Dortmund Dortmund Airport (DTM)"
  },
  {
    "value": "DHN",
    "label": "Dothan Dothan Regional Airport (DHN)"
  },
  {
    "value": "DLA",
    "label": "Douala Douala International Airport (DLA)"
  },
  {
    "value": "DUG",
    "label": "Douglas Bisbee Bisbee Douglas International Airport (DUG)"
  },
  {
    "value": "DOV",
    "label": "Dover Dover Air Force Base (DOV)"
  },
  {
    "value": "DRS",
    "label": "Dresden Dresden Airport (DRS)"
  },
  {
    "value": "YHD",
    "label": "Dryden Dryden Regional Airport (YHD)"
  },
  {
    "value": "NHD",
    "label": "Dubai Al Minhad Air Base (NHD)"
  },
  {
    "value": "DXB",
    "label": "Dubai Dubai International Airport (DXB)"
  },
  {
    "value": "DBO",
    "label": "Dubbo Dubbo City Regional Airport (DBO)"
  },
  {
    "value": "DUB",
    "label": "Dublin Dublin Airport (DUB)"
  },
  {
    "value": "DUJ",
    "label": "Dubois DuBois Regional Airport (DUJ)"
  },
  {
    "value": "TZL",
    "label": "Dubrave Gornje Tuzla International Airport (TZL)"
  },
  {
    "value": "DBQ",
    "label": "Dubuque Dubuque Regional Airport (DBQ)"
  },
  {
    "value": "IAD",
    "label": "Dulles Washington Dulles International Airport (IAD)"
  },
  {
    "value": "DLH",
    "label": "Duluth Duluth International Airport (DLH)"
  },
  {
    "value": "DGT",
    "label": "Dumaguete City Sibulan Airport (DGT)"
  },
  {
    "value": "DUM",
    "label": "Dumai Pinang Kampai Airport (DUM)"
  },
  {
    "value": "DCT",
    "label": "Duncan Town Duncan Town Airport (DCT)"
  },
  {
    "value": "DND",
    "label": "Dundee Dundee Airport (DND)"
  },
  {
    "value": "DUD",
    "label": "Dunedin Dunedin International Airport (DUD)"
  },
  {
    "value": "DNH",
    "label": "Dunhuang Dunhuang Mogao International Airport (DNH)"
  },
  {
    "value": "DQM",
    "label": "Duqm Duqm International Airport (DQM)"
  },
  {
    "value": "DRO",
    "label": "Durango Durango La Plata County Airport (DRO)"
  },
  {
    "value": "DGO",
    "label": "Durango General Guadalupe Victoria International Airport (DGO)"
  },
  {
    "value": "DUA",
    "label": "Durant Durant Regional Airport - Eaker Field (DUA)"
  },
  {
    "value": "DZO",
    "label": "Durazno Santa Bernardina International Airport (DZO)"
  },
  {
    "value": "DUR",
    "label": "Durban King Shaka International Airport (DUR)"
  },
  {
    "value": "VIR",
    "label": "Durban Virginia Airport (VIR)"
  },
  {
    "value": "RDP",
    "label": "Durgapur Kazi Nazrul Islam Airport (RDP)"
  },
  {
    "value": "DYU",
    "label": "Dushanbe Dushanbe International Airport (DYU)"
  },
  {
    "value": "DUS",
    "label": "Düsseldorf Düsseldorf Airport (DUS)"
  },
  {
    "value": "DWA",
    "label": "Dwangwa Dwangwa Airport (DWA)"
  },
  {
    "value": "DZA",
    "label": "Dzaoudzi Dzaoudzi Pamandzi International Airport (DZA)"
  },
  {
    "value": "EGE",
    "label": "Eagle Eagle County Regional Airport (EGE)"
  },
  {
    "value": "YXR",
    "label": "Earlton Earlton (Timiskaming Regional) Airport (YXR)"
  },
  {
    "value": "ABX",
    "label": "East Albury Albury Airport (ABX)"
  },
  {
    "value": "ELS",
    "label": "East London King Phalo Airport (ELS)"
  },
  {
    "value": "MMT",
    "label": "Eastover Mc Entire Joint National Guard Base (MMT)"
  },
  {
    "value": "ESD",
    "label": "Eastsound Orcas Island Airport (ESD)"
  },
  {
    "value": "EAU",
    "label": "Eau Claire Chippewa Valley Regional Airport (EAU)"
  },
  {
    "value": "EOI",
    "label": "Eday Eday Airport (EOI)"
  },
  {
    "value": "EDI",
    "label": "Edinburgh Edinburgh Airport (EDI)"
  },
  {
    "value": "YEG",
    "label": "Edmonton Edmonton International Airport (YEG)"
  },
  {
    "value": "EDO",
    "label": "Edremit Balıkesir Koca Seyit Airport (EDO)"
  },
  {
    "value": "YET",
    "label": "Edson Edson Airport (YET)"
  },
  {
    "value": "EDW",
    "label": "Edwards Edwards Air Force Base (EDW)"
  },
  {
    "value": "EGX",
    "label": "Egegik Egegik Airport (EGX)"
  },
  {
    "value": "EGS",
    "label": "Egilsstaðir Egilsstaðir Airport (EGS)"
  },
  {
    "value": "ETM",
    "label": "Eilat Ramon International Airport (ETM)"
  },
  {
    "value": "EIN",
    "label": "Eindhoven Eindhoven Airport (EIN)"
  },
  {
    "value": "YOA",
    "label": "Ekati Ekati Airport (YOA)"
  },
  {
    "value": "EKB",
    "label": "Ekibastuz Ekibastuz Airport (EKB)"
  },
  {
    "value": "EUN",
    "label": "El Aaiún Hassan I Airport (EUN)"
  },
  {
    "value": "DBB",
    "label": "El Alamein El Alamein International Airport (DBB)"
  },
  {
    "value": "AAC",
    "label": "El Arish El Arish International Airport (AAC)"
  },
  {
    "value": "GHA",
    "label": "El Atteuf Noumérat - Moufdi Zakaria Airport (GHA)"
  },
  {
    "value": "EBG",
    "label": "El Bagre El Bagre Airport (EBG)"
  },
  {
    "value": "ELB",
    "label": "El Banco Las Flores Airport (ELB)"
  },
  {
    "value": "EHL",
    "label": "El Bolsón El Bolsón Airfield (EHL)"
  },
  {
    "value": "EBM",
    "label": "El Borma El Borma Airport (EBM)"
  },
  {
    "value": "FTE",
    "label": "El Calafate El Calafate - Commander Armando Tola International Airport (FTE)"
  },
  {
    "value": "NJK",
    "label": "El Centro El Centro NAF Airport (Vraciu Field) (NJK)"
  },
  {
    "value": "ELD",
    "label": "El Dorado South Arkansas Regional Airport at Goodwin Field (ELD)"
  },
  {
    "value": "ELF",
    "label": "El Fasher El Fasher Airport (ELF)"
  },
  {
    "value": "RDL",
    "label": "El Hassana Bardawil International Airport (RDL)"
  },
  {
    "value": "VDE",
    "label": "El Hierro Island El Hierro Airport (VDE)"
  },
  {
    "value": "EGH",
    "label": "El Jora El Jora Airport (EGH)"
  },
  {
    "value": "FUE",
    "label": "El Matorral Fuerteventura Airport (FUE)"
  },
  {
    "value": "ELG",
    "label": "El Menia El Golea Airport (ELG)"
  },
  {
    "value": "EPA",
    "label": "El Palomar El Palomar Airport (EPA)"
  },
  {
    "value": "ELP",
    "label": "El Paso El Paso International Airport (ELP)"
  },
  {
    "value": "ESR",
    "label": "El Salvador Ricardo García Posada Airport (ESR)"
  },
  {
    "value": "SOM",
    "label": "El Tigre San Tomé Airport (SOM)"
  },
  {
    "value": "VIG",
    "label": "El Vigía Juan Pablo Pérez Alfonso Airport (VIG)"
  },
  {
    "value": "EBD",
    "label": "El-Obeid El-Obeid Airport (EBD)"
  },
  {
    "value": "EZS",
    "label": "Elazığ Elazığ Airport (EZS)"
  },
  {
    "value": "ELC",
    "label": "Elcho Island Elcho Island Airport (ELC)"
  },
  {
    "value": "EDL",
    "label": "Eldoret Eldoret International Airport (EDL)"
  },
  {
    "value": "ESL",
    "label": "Elista Elista Airport (ESL)"
  },
  {
    "value": "ECG",
    "label": "Elizabeth City Elizabeth City Regional Airport & Coast Guard Air Station (ECG)"
  },
  {
    "value": "EKN",
    "label": "Elkins Elkins-Randolph County Regional Airport (EKN)"
  },
  {
    "value": "EKO",
    "label": "Elko Elko Regional Airport (EKO)"
  },
  {
    "value": "YEL",
    "label": "Elliot Lake Elliot Lake Municipal Airport (YEL)"
  },
  {
    "value": "ELM",
    "label": "Elmira/Corning Elmira Corning Regional Airport (ELM)"
  },
  {
    "value": "ELY",
    "label": "Ely Ely Airport Yelland Field (ELY)"
  },
  {
    "value": "LYU",
    "label": "Ely Ely Municipal Airport (LYU)"
  },
  {
    "value": "EMD",
    "label": "Emerald Emerald Airport (EMD)"
  },
  {
    "value": "JAL",
    "label": "Emiliano Zapata El Lencero Airport (JAL)"
  },
  {
    "value": "EML",
    "label": "Emmen Emmen Air Base (EML)"
  },
  {
    "value": "EMK",
    "label": "Emmonak Emmonak Airport (EMK)"
  },
  {
    "value": "ENO",
    "label": "Encarnación Lieutenant Amin Ayub González International Airport (ENO)"
  },
  {
    "value": "ENU",
    "label": "Enegu Akanu Ibiam International Airport (ENU)"
  },
  {
    "value": "NBE",
    "label": "Enfidha Enfidha - Hammamet International Airport (NBE)"
  },
  {
    "value": "END",
    "label": "Enid Vance Air Force Base (END)"
  },
  {
    "value": "ENK",
    "label": "Enniskillen Enniskillen/St Angelo Airport (ENK)"
  },
  {
    "value": "ENF",
    "label": "Enontekio Enontekio Airport (ENF)"
  },
  {
    "value": "ENS",
    "label": "Enschede Twente Airport (ENS)"
  },
  {
    "value": "ENH",
    "label": "Enshi (Enshi) Enshi Xujiaping Airport (ENH)"
  },
  {
    "value": "BRR",
    "label": "Eoligarry Barra Airport (BRR)"
  },
  {
    "value": "NCY",
    "label": "Epagny Metz-Tessy Annecy Haute-Savoie Mont Blanc Airport (NCY)"
  },
  {
    "value": "ERL",
    "label": "Erenhot Erenhot Saiwusu International Airport (ERL)"
  },
  {
    "value": "ERF",
    "label": "Erfurt Erfurt-Weimar Airport (ERF)"
  },
  {
    "value": "ERI",
    "label": "Erie Erie International Tom Ridge Field (ERI)"
  },
  {
    "value": "ERH",
    "label": "Errachidia Moulay Ali Cherif Airport (ERH)"
  },
  {
    "value": "ERC",
    "label": "Erzincan Erzincan Airport (ERC)"
  },
  {
    "value": "ERZ",
    "label": "Erzurum Erzurum International Airport (ERZ)"
  },
  {
    "value": "ORN",
    "label": "Es-Sénia Oran Es-Sénia (Ahmed Ben Bella) International Airport (ORN)"
  },
  {
    "value": "EBJ",
    "label": "Esbjerg Esbjerg Airport (EBJ)"
  },
  {
    "value": "ESC",
    "label": "Escanaba Delta County Airport (ESC)"
  },
  {
    "value": "EKT",
    "label": "Eskilstuna Eskilstuna Airport (EKT)"
  },
  {
    "value": "AOE",
    "label": "Eskişehir Anadolu Airport (AOE)"
  },
  {
    "value": "ESK",
    "label": "Eskişehir Eskişehir Air Base (ESK)"
  },
  {
    "value": "SID",
    "label": "Espargos Amílcar Cabral International Airport (SID)"
  },
  {
    "value": "EPR",
    "label": "Esperance Esperance Airport (EPR)"
  },
  {
    "value": "EQS",
    "label": "Esquel Esquel Brigadier Antonio Parodi International Airport (EQS)"
  },
  {
    "value": "ESU",
    "label": "Essaouira Essaouira-Mogador Airport (ESU)"
  },
  {
    "value": "MEB",
    "label": "Essendon Fields Melbourne Essendon Airport (MEB)"
  },
  {
    "value": "YEN",
    "label": "Estevan Estevan Airport (YEN)"
  },
  {
    "value": "EUG",
    "label": "Eugene Mahlon Sweet Field (EUG)"
  },
  {
    "value": "EKA",
    "label": "Eureka Murray Field (EKA)"
  },
  {
    "value": "EVW",
    "label": "Evanston Evanston-Uinta County Airport-Burns Field (EVW)"
  },
  {
    "value": "EVV",
    "label": "Evansville Evansville Regional Airport (EVV)"
  },
  {
    "value": "EVE",
    "label": "Evenes Harstad/Narvik Airport, Evenes (EVE)"
  },
  {
    "value": "SWV",
    "label": "Evensk Severo-Evensk Airport (SWV)"
  },
  {
    "value": "PAE",
    "label": "Everett Seattle Paine Field International Airport (PAE)"
  },
  {
    "value": "TTN",
    "label": "Ewing Township Trenton Mercer Airport (TTN)"
  },
  {
    "value": "EXT",
    "label": "Exeter, Devon Exeter International Airport (EXT)"
  },
  {
    "value": "LEA",
    "label": "Exmouth Learmonth Airport (LEA)"
  },
  {
    "value": "EHU",
    "label": "Ezhou Ezhou Huahu Airport (EHU)"
  },
  {
    "value": "VDB",
    "label": "Fagernes Fagernes Airport, Leirin (VDB)"
  },
  {
    "value": "EIL",
    "label": "Fairbanks Eielson Air Force Base (EIL)"
  },
  {
    "value": "FAI",
    "label": "Fairbanks Fairbanks International Airport (FAI)"
  },
  {
    "value": "FBK",
    "label": "Fairbanks Ladd Army Airfield (FBK)"
  },
  {
    "value": "SUU",
    "label": "Fairfield Travis Air Force Base (SUU)"
  },
  {
    "value": "FFD",
    "label": "Fairford, Gloucestershire RAF Fairford (FFD)"
  },
  {
    "value": "LYP",
    "label": "Faisalabad Faisalabad International Airport (LYP)"
  },
  {
    "value": "AYJ",
    "label": "Faizabad Ayodhya Airport (AYJ)"
  },
  {
    "value": "FKQ",
    "label": "Fakfak Fakfak Airport (FKQ)"
  },
  {
    "value": "AOI",
    "label": "Falconara Marittima (AN) Marche Airport (AOI)"
  },
  {
    "value": "NFL",
    "label": "Fallon Fallon Naval Air Station (NFL)"
  },
  {
    "value": "FGU",
    "label": "Fangatau Fangatau Airport (FGU)"
  },
  {
    "value": "HUH",
    "label": "Fare Huahine-Fare Airport (HUH)"
  },
  {
    "value": "FAR",
    "label": "Fargo Hector International Airport (FAR)"
  },
  {
    "value": "FRG",
    "label": "Farmingdale Republic Airport (FRG)"
  },
  {
    "value": "FMN",
    "label": "Farmington Four Corners Regional Airport (FMN)"
  },
  {
    "value": "FAB",
    "label": "Farnborough, Hampshire Farnborough Airport (FAB)"
  },
  {
    "value": "FAO",
    "label": "Faro Faro Airport (FAO)"
  },
  {
    "value": "ZFA",
    "label": "Faro Faro Airport (ZFA)"
  },
  {
    "value": "FAZ",
    "label": "Fasa Fasa Airport (FAZ)"
  },
  {
    "value": "EVX",
    "label": "Fauville, Eure Évreux-Fauville (BA 105) Air Base (EVX)"
  },
  {
    "value": "FYT",
    "label": "Faya-Largeau Faya-Largeau Airport (FYT)"
  },
  {
    "value": "FYV",
    "label": "Fayetteville Drake Field (FYV)"
  },
  {
    "value": "FAY",
    "label": "Fayetteville Fayetteville Regional Airport - Grannis Field (FAY)"
  },
  {
    "value": "XNA",
    "label": "Fayetteville/Springdale/Rogers Northwest Arkansas National Airport (XNA)"
  },
  {
    "value": "GRZ",
    "label": "Feldkirchen bei Graz Graz Airport (GRZ)"
  },
  {
    "value": "FEG",
    "label": "Fergana Fergana International Airport (FEG)"
  },
  {
    "value": "FEN",
    "label": "Fernando de Noronha Fernando de Noronha Airport (FEN)"
  },
  {
    "value": "MXP",
    "label": "Ferno (VA) Milan Malpensa International Airport (MXP)"
  },
  {
    "value": "WFI",
    "label": "Fianarantsoa Fianarantsoa Airport (WFI)"
  },
  {
    "value": "FCB",
    "label": "Ficksburg Ficksburg Sentraoes Airport (FCB)"
  },
  {
    "value": "FSC",
    "label": "Figari Sud-Corse Figari Sud-Corse Airport (FSC)"
  },
  {
    "value": "FDY",
    "label": "Findlay Findlay Airport (FDY)"
  },
  {
    "value": "FLR",
    "label": "Firenze (FI) Florence Airport, Peretola (FLR)"
  },
  {
    "value": "FLG",
    "label": "Flagstaff Flagstaff Pulliam International Airport (FLG)"
  },
  {
    "value": "FNT",
    "label": "Flint Bishop International Airport (FNT)"
  },
  {
    "value": "FLO",
    "label": "Florence Florence Regional Airport (FLO)"
  },
  {
    "value": "FLA",
    "label": "Florencia Gustavo Artunduaga Paredes Airport (FLA)"
  },
  {
    "value": "FLN",
    "label": "Florianópolis Hercílio Luz International Airport (FLN)"
  },
  {
    "value": "FRO",
    "label": "Florø Florø Airport (FRO)"
  },
  {
    "value": "XCH",
    "label": "Flying Fish Cove Christmas Island Airport (XCH)"
  },
  {
    "value": "FOG",
    "label": "Foggia (FG) Foggia Gino Lisa Airport (FOG)"
  },
  {
    "value": "NWA",
    "label": "Fomboni Mohéli Bandar Es Eslam Airport (NWA)"
  },
  {
    "value": "FRB",
    "label": "Forbes Forbes Airport (FRB)"
  },
  {
    "value": "WGA",
    "label": "Forest Hill Wagga Wagga Airport (WGA)"
  },
  {
    "value": "YFE",
    "label": "Forestville Forestville Airport (YFE)"
  },
  {
    "value": "FRL",
    "label": "Forlì (FC) Forlì Luigi Ridolfi Airport (FRL)"
  },
  {
    "value": "FMA",
    "label": "Formosa Formosa National Airport (FMA)"
  },
  {
    "value": "DAA",
    "label": "Fort Belvoir Davison Army Air Field (DAA)"
  },
  {
    "value": "LSF",
    "label": "Fort Benning Lawson Army Air Field (LSF)"
  },
  {
    "value": "BIF",
    "label": "Fort Bliss/El Paso Biggs Army Air Field (Fort Bliss) (BIF)"
  },
  {
    "value": "POB",
    "label": "Fort Bragg Pope Field (POB)"
  },
  {
    "value": "FBG",
    "label": "Fort Bragg Simmons Army Air Field (FBG)"
  },
  {
    "value": "HOP",
    "label": "Fort Campbell Campbell Army Airfield (Fort Campbell) (HOP)"
  },
  {
    "value": "FCS",
    "label": "Fort Carson Butts AAF (Fort Carson) Air Field (FCS)"
  },
  {
    "value": "GRK",
    "label": "Fort Cavazos Killeen Regional Airport / Robert Gray Army Airfield (GRK)"
  },
  {
    "value": "YPY",
    "label": "Fort Chipewyan Fort Chipewyan Airport (YPY)"
  },
  {
    "value": "FOD",
    "label": "Fort Dodge Fort Dodge Regional Airport (FOD)"
  },
  {
    "value": "YAG",
    "label": "Fort Frances Fort Frances Municipal Airport (YAG)"
  },
  {
    "value": "FHU",
    "label": "Fort Huachuca / Sierra Vista Sierra Vista Municipal Airport / Libby Army Air Field (FHU)"
  },
  {
    "value": "MUI",
    "label": "Fort Indiantown Gap(Annville) Muir Army Air Field (Fort Indiantown Gap) Airport (MUI)"
  },
  {
    "value": "BYS",
    "label": "Fort Irwin/Barstow Bicycle Lake Army Air Field (BYS)"
  },
  {
    "value": "FTK",
    "label": "Fort Knox Godman Army Air Field (FTK)"
  },
  {
    "value": "FXE",
    "label": "Fort Lauderdale Fort Lauderdale Executive Airport (FXE)"
  },
  {
    "value": "FLL",
    "label": "Fort Lauderdale Fort Lauderdale Hollywood International Airport (FLL)"
  },
  {
    "value": "TBN",
    "label": "Fort Leonard Wood Waynesville-St. Robert Regional Airport-Forney Field (TBN)"
  },
  {
    "value": "GRF",
    "label": "Fort Lewis/Tacoma Gray Army Air Field (GRF)"
  },
  {
    "value": "YJF",
    "label": "Fort Liard Fort Liard Airport (YJF)"
  },
  {
    "value": "YMM",
    "label": "Fort McMurray Fort McMurray Airport (YMM)"
  },
  {
    "value": "FME",
    "label": "Fort Meade(Odenton) Tipton Airport (FME)"
  },
  {
    "value": "FMY",
    "label": "Fort Myers Page Field (FMY)"
  },
  {
    "value": "RSW",
    "label": "Fort Myers Southwest Florida International Airport (RSW)"
  },
  {
    "value": "YYE",
    "label": "Fort Nelson Fort Nelson Airport (YYE)"
  },
  {
    "value": "FPR",
    "label": "Fort Pierce St Lucie County International Airport (FPR)"
  },
  {
    "value": "POE",
    "label": "Fort Polk Polk Army Air Field (POE)"
  },
  {
    "value": "YFR",
    "label": "Fort Resolution Fort Resolution Airport (YFR)"
  },
  {
    "value": "FRI",
    "label": "Fort Riley (Junction City) Marshall Army Air Field (FRI)"
  },
  {
    "value": "OZR",
    "label": "Fort Rucker/Ozark Cairns AAF (Fort Rucker) Air Field (OZR)"
  },
  {
    "value": "YXJ",
    "label": "Fort Saint John Fort St John / North Peace Regional Airport (YXJ)"
  },
  {
    "value": "PZH",
    "label": "Fort Sandeman Zhob Airport (PZH)"
  },
  {
    "value": "FSI",
    "label": "Fort Sill Henry Post Army Air Field (FSI)"
  },
  {
    "value": "YFS",
    "label": "Fort Simpson Fort Simpson Airport (YFS)"
  },
  {
    "value": "YSM",
    "label": "Fort Smith Fort Smith Airport (YSM)"
  },
  {
    "value": "FSM",
    "label": "Fort Smith Fort Smith Regional Airport (FSM)"
  },
  {
    "value": "FST",
    "label": "Fort Stockton Fort Stockton Pecos County Airport (FST)"
  },
  {
    "value": "FWA",
    "label": "Fort Wayne Fort Wayne International Airport (FWA)"
  },
  {
    "value": "FTW",
    "label": "Fort Worth Fort Worth Meacham International Airport (FTW)"
  },
  {
    "value": "FWH",
    "label": "Fort Worth NAS Fort Worth JRB / Carswell Field (FWH)"
  },
  {
    "value": "AFW",
    "label": "Fort Worth Perot Field/Fort Worth Alliance Airport (AFW)"
  },
  {
    "value": "FYU",
    "label": "Fort Yukon Fort Yukon Airport (FYU)"
  },
  {
    "value": "FDF",
    "label": "Fort-de-France Martinique Aimé Césaire International Airport (FDF)"
  },
  {
    "value": "FOR",
    "label": "Fortaleza Pinto Martins International Airport (FOR)"
  },
  {
    "value": "FUO",
    "label": "Foshan (Nanhai) Foshan Shadi Airport (FUO)"
  },
  {
    "value": "FOM",
    "label": "Foumban Foumban Nkounja Airport (FOM)"
  },
  {
    "value": "IGU",
    "label": "Foz do Iguaçu Cataratas International Airport (IGU)"
  },
  {
    "value": "MVB",
    "label": "Franceville M'Vengue El Hadj Omar Bongo Ondimba International Airport (MVB)"
  },
  {
    "value": "FRW",
    "label": "Francistown P G Matante Intl (FRW)"
  },
  {
    "value": "HHN",
    "label": "Frankfurt am Main (Lautzenhausen) Frankfurt-Hahn Airport (HHN)"
  },
  {
    "value": "FRA",
    "label": "Frankfurt am Main Frankfurt Airport (FRA)"
  },
  {
    "value": "FKL",
    "label": "Franklin Venango Regional Airport (FKL)"
  },
  {
    "value": "YFC",
    "label": "Fredericton Fredericton Airport (YFC)"
  },
  {
    "value": "MBS",
    "label": "Freeland MBS International Airport (MBS)"
  },
  {
    "value": "FPO",
    "label": "Freeport Grand Bahama International Airport (FPO)"
  },
  {
    "value": "FNA",
    "label": "Freetown (Lungi-Town) Lungi International Airport (FNA)"
  },
  {
    "value": "FAT",
    "label": "Fresno Fresno Yosemite International Airport (FAT)"
  },
  {
    "value": "FRD",
    "label": "Friday Harbor Friday Harbor Airport (FRD)"
  },
  {
    "value": "FDH",
    "label": "Friedrichshafen Friedrichshafen Airport (FDH)"
  },
  {
    "value": "FRZ",
    "label": "Fritzlar Fritzlar Army Airfield (FRZ)"
  },
  {
    "value": "FJR",
    "label": "Fujairah Fujairah International Airport (FJR)"
  },
  {
    "value": "FKJ",
    "label": "Fukui Fukui Airport (FKJ)"
  },
  {
    "value": "FUK",
    "label": "Fukuoka Fukuoka Airport (FUK)"
  },
  {
    "value": "FUN",
    "label": "Funafuti Funafuti International Airport (FUN)"
  },
  {
    "value": "FNC",
    "label": "Funchal Madeira International Airport Cristiano Ronaldo (FNC)"
  },
  {
    "value": "OKO",
    "label": "Fussa Yokota Air Base (OKO)"
  },
  {
    "value": "FYJ",
    "label": "Fuyuan Fuyuan Dongji Airport (FYJ)"
  },
  {
    "value": "FYN",
    "label": "Fuyun Fuyun Koktokay Airport (FYN)"
  },
  {
    "value": "FOC",
    "label": "Fuzhou (Changle) Fuzhou Changle International Airport (FOC)"
  },
  {
    "value": "GBB",
    "label": "Gabala Gabala International Airport (GBB)"
  },
  {
    "value": "GAE",
    "label": "Gabès Gabès Matmata International Airport (GAE)"
  },
  {
    "value": "GBE",
    "label": "Gaborone Sir Seretse Khama International Airport (GBE)"
  },
  {
    "value": "GCH",
    "label": "Gachsaran Gachsaran Airport (GCH)"
  },
  {
    "value": "GAF",
    "label": "Gafsa Gafsa Ksar International Airport (GAF)"
  },
  {
    "value": "GNV",
    "label": "Gainesville Gainesville Regional Airport (GNV)"
  },
  {
    "value": "LCC",
    "label": "Galatina (LE) Lecce Galatina Air Base / Galatina Fortunato Cesari Airport (LCC)"
  },
  {
    "value": "GAL",
    "label": "Galena Edward G. Pitka Sr Airport (GAL)"
  },
  {
    "value": "KCT",
    "label": "Galle Koggala Airport (KCT)"
  },
  {
    "value": "GEV",
    "label": "Gällivare Gällivare Airport (GEV)"
  },
  {
    "value": "GUP",
    "label": "Gallup Gallup Municipal Airport (GUP)"
  },
  {
    "value": "GLS",
    "label": "Galveston Scholes International At Galveston Airport (GLS)"
  },
  {
    "value": "GWY",
    "label": "Galway Galway Airport (GWY)"
  },
  {
    "value": "GMB",
    "label": "Gambela Gambela Airport (GMB)"
  },
  {
    "value": "GAM",
    "label": "Gambell Gambell Airport (GAM)"
  },
  {
    "value": "GAN",
    "label": "Gan Gan International Airport (GAN)"
  },
  {
    "value": "YQX",
    "label": "Gander Gander International Airport / CFB Gander (YQX)"
  },
  {
    "value": "KAG",
    "label": "Gangneung Gangneung Airport (K-18) (KAG)"
  },
  {
    "value": "GNJ",
    "label": "Ganja Ganja International Airport (GNJ)"
  },
  {
    "value": "GXH",
    "label": "Gannan (Xiahe) Gannan Xiahe Airport (GXH)"
  },
  {
    "value": "VGA",
    "label": "Gannavaram Vijayawada Airport (VGA)"
  },
  {
    "value": "GCK",
    "label": "Garden City Garden City Regional Airport (GCK)"
  },
  {
    "value": "GOU",
    "label": "Garoua Garoua International Airport (GOU)"
  },
  {
    "value": "GYY",
    "label": "Gary Gary Chicago International Airport (GYY)"
  },
  {
    "value": "DCY",
    "label": "Garzê (Daocheng) Daocheng Yading Airport (DCY)"
  },
  {
    "value": "KGT",
    "label": "Garzê (Kangding) Kangding Airport (KGT)"
  },
  {
    "value": "MRQ",
    "label": "Gasan Marinduque Airport (MRQ)"
  },
  {
    "value": "YGP",
    "label": "Gaspé Michel-Pouliot Gaspé Airport (YGP)"
  },
  {
    "value": "YND",
    "label": "Gatineau Ottawa / Gatineau Airport (YND)"
  },
  {
    "value": "ZGU",
    "label": "Gaua Island Gaua Island Airport (ZGU)"
  },
  {
    "value": "GVX",
    "label": "Gävle / Sandviken Gävle Sandviken Airport (GVX)"
  },
  {
    "value": "GAY",
    "label": "Gaya Gaya Airport (GAY)"
  },
  {
    "value": "GZT",
    "label": "Gaziantep Gaziantep International Airport (GZT)"
  },
  {
    "value": "ADB",
    "label": "Gaziemir Adnan Menderes International Airport (ADB)"
  },
  {
    "value": "GZP",
    "label": "Gazipaşa Gazipaşa-Alanya Airport (GZP)"
  },
  {
    "value": "BDT",
    "label": "Gbadolite Gbadolite Airport (BDT)"
  },
  {
    "value": "GDN",
    "label": "Gdańsk Gdańsk Lech Wałęsa Airport (GDN)"
  },
  {
    "value": "GKE",
    "label": "Geilenkirchen Geilenkirchen Air Base (GKE)"
  },
  {
    "value": "SKE",
    "label": "Geiteryggen Skien Airport (SKE)"
  },
  {
    "value": "GDZ",
    "label": "Gelendzhik Gelendzhik Airport (GDZ)"
  },
  {
    "value": "GLU",
    "label": "Gelephu Gelephu Airport (GLU)"
  },
  {
    "value": "GMA",
    "label": "Gemena Gemena Airport (GMA)"
  },
  {
    "value": "GPO",
    "label": "General Pico General Pico Airport (GPO)"
  },
  {
    "value": "GES",
    "label": "General Santos General Santos International Airport (GES)"
  },
  {
    "value": "GVA",
    "label": "Geneva Geneva Cointrin International Airport (GVA)"
  },
  {
    "value": "GOA",
    "label": "Genova (GE) Genoa Cristoforo Colombo Airport (GOA)"
  },
  {
    "value": "GRJ",
    "label": "George George Airport (GRJ)"
  },
  {
    "value": "GCM",
    "label": "George Town Owen Roberts International Airport (GCM)"
  },
  {
    "value": "GEO",
    "label": "Georgetown Cheddi Jagan International Airport (GEO)"
  },
  {
    "value": "MNI",
    "label": "Gerald's Park John A. Osborne Airport (MNI)"
  },
  {
    "value": "YGQ",
    "label": "Geraldton Geraldton Greenstone Regional Airport (YGQ)"
  },
  {
    "value": "LTD",
    "label": "Ghadames Ghadames East Airport (LTD)"
  },
  {
    "value": "GHT",
    "label": "Ghat Ghat Airport (GHT)"
  },
  {
    "value": "MUW",
    "label": "Ghriss Ghriss Airport (MUW)"
  },
  {
    "value": "GIB",
    "label": "Gibraltar Gibraltar Airport (GIB)"
  },
  {
    "value": "QGU",
    "label": "Gifu Gifu Airport (QGU)"
  },
  {
    "value": "GIL",
    "label": "Gilgit Gilgit Airport (GIL)"
  },
  {
    "value": "GCC",
    "label": "Gillette Northeast Wyoming Regional Airport (GCC)"
  },
  {
    "value": "YGM",
    "label": "Gimli Gimli Industrial Park Airport (YGM)"
  },
  {
    "value": "JWO",
    "label": "Gimseang-ro Jungwon Air Base/Chungju Airport (JWO)"
  },
  {
    "value": "GIR",
    "label": "Girardot Santiago Vila Airport (GIR)"
  },
  {
    "value": "GRO",
    "label": "Girona Girona-Costa Brava Airport (GRO)"
  },
  {
    "value": "GIS",
    "label": "Gisborne Gisborne Airport (GIS)"
  },
  {
    "value": "GYI",
    "label": "Gisenyi Gisenyi Airport (GYI)"
  },
  {
    "value": "GLT",
    "label": "Gladstone Gladstone Airport (GLT)"
  },
  {
    "value": "GGW",
    "label": "Glasgow Glasgow Valley County Airport Wokal Field (GGW)"
  },
  {
    "value": "GLI",
    "label": "Glen Innes Glen Innes Airport (GLI)"
  },
  {
    "value": "LUF",
    "label": "Glendale Luke Air Force Base (LUF)"
  },
  {
    "value": "GDV",
    "label": "Glendive Dawson Community Airport (GDV)"
  },
  {
    "value": "GFL",
    "label": "Glens Falls Floyd Bennett Memorial Airport (GFL)"
  },
  {
    "value": "GTN",
    "label": "Glentanner Station Glentanner Airport (GTN)"
  },
  {
    "value": "SZZ",
    "label": "Glewice Solidarity Szczecin–Goleniów Airport (SZZ)"
  },
  {
    "value": "GDE",
    "label": "Gode Gode Airport (GDE)"
  },
  {
    "value": "GYN",
    "label": "Goiânia Santa Genoveva Airport (GYN)"
  },
  {
    "value": "ETZ",
    "label": "Goin Metz-Nancy-Lorraine Airport (ETZ)"
  },
  {
    "value": "OOL",
    "label": "Gold Coast Gold Coast Airport (OOL)"
  },
  {
    "value": "GSB",
    "label": "Goldsboro Seymour Johnson Air Force Base (GSB)"
  },
  {
    "value": "GLF",
    "label": "Golfito Golfito Airport (GLF)"
  },
  {
    "value": "GOQ",
    "label": "Golmud Golmud Airport (GOQ)"
  },
  {
    "value": "GMQ",
    "label": "Golog (Maqên) Golog Maqên Airport (GMQ)"
  },
  {
    "value": "GOM",
    "label": "Goma Goma International Airport (GOM)"
  },
  {
    "value": "GMO",
    "label": "Gombe Gombe Lawanti International Airport (GMO)"
  },
  {
    "value": "GME",
    "label": "Gomel Gomel Airport (GME)"
  },
  {
    "value": "GDB",
    "label": "Gondia Gondia Airport (GDB)"
  },
  {
    "value": "YNY",
    "label": "Gonghang-ro Yangyang International Airport (YNY)"
  },
  {
    "value": "CER",
    "label": "Gonneville-Le Theil, Manche Cherbourg-Maupertus Airport (CER)"
  },
  {
    "value": "GLD",
    "label": "Goodland Goodland Municipal Airport (GLD)"
  },
  {
    "value": "YYR",
    "label": "Goose Bay Goose Bay Airport (YYR)"
  },
  {
    "value": "GOP",
    "label": "Gorakhpur Gorakhpur Airport (GOP)"
  },
  {
    "value": "YZE",
    "label": "Gore Bay Gore Bay Manitoulin Airport (YZE)"
  },
  {
    "value": "GBT",
    "label": "Gorgan Gorgan Airport (GBT)"
  },
  {
    "value": "GOZ",
    "label": "Gorna Oryahovitsa Gorna Oryahovitsa Airport (GOZ)"
  },
  {
    "value": "BWK",
    "label": "Gornji Humac Brač Airport (BWK)"
  },
  {
    "value": "RGK",
    "label": "Gorno-Altaysk Gorno-Altaysk Airport (RGK)"
  },
  {
    "value": "GKA",
    "label": "Goronka Goroka Airport (GKA)"
  },
  {
    "value": "OTI",
    "label": "Gotalalamo-Morotai Island Pitu Airport (OTI)"
  },
  {
    "value": "GOT",
    "label": "Göteborg Göteborg Landvetter Airport (GOT)"
  },
  {
    "value": "GSE",
    "label": "Göteborg Säve Airport (GSE)"
  },
  {
    "value": "FUJ",
    "label": "Goto Fukue Airport (FUJ)"
  },
  {
    "value": "GVR",
    "label": "Governador Valadares Coronel Altino Machado Airport (GVR)"
  },
  {
    "value": "GHB",
    "label": "Governor's Harbour Governor's Harbour Airport (GHB)"
  },
  {
    "value": "OYA",
    "label": "Goya Goya Airport (OYA)"
  },
  {
    "value": "PLZ",
    "label": "Gqeberha (Port Elizabeth) Chief Dawid Stuurman International Airport (PLZ)"
  },
  {
    "value": "LGG",
    "label": "Grâce-Hollogne Liège Airport (LGG)"
  },
  {
    "value": "GFN",
    "label": "Grafton Clarence Valley Regional Airport (GFN)"
  },
  {
    "value": "LPA",
    "label": "Gran Canaria Island Gran Canaria Airport (LPA)"
  },
  {
    "value": "GRX",
    "label": "Granada F.G.L. Airport Granada-Jaén Airport (GRX)"
  },
  {
    "value": "GCN",
    "label": "Grand Canyon - Tusayan Grand Canyon National Park Airport (GCN)"
  },
  {
    "value": "SFG",
    "label": "Grand Case Grand Case-l'Espérance Airport (SFG)"
  },
  {
    "value": "RDR",
    "label": "Grand Forks Grand Forks Air Force Base (RDR)"
  },
  {
    "value": "ZGF",
    "label": "Grand Forks Grand Forks Airport (ZGF)"
  },
  {
    "value": "GFK",
    "label": "Grand Forks Grand Forks International Airport (GFK)"
  },
  {
    "value": "GRI",
    "label": "Grand Island Central Nebraska Regional Airport (GRI)"
  },
  {
    "value": "GJT",
    "label": "Grand Junction Grand Junction Regional Airport (GJT)"
  },
  {
    "value": "GRR",
    "label": "Grand Rapids Gerald R. Ford International Airport (GRR)"
  },
  {
    "value": "GBJ",
    "label": "Grand-Bourg Marie-Galante Airport (GBJ)"
  },
  {
    "value": "YQU",
    "label": "Grande Prairie Grande Prairie Airport (YQU)"
  },
  {
    "value": "YQA",
    "label": "Gravenhurst Muskoka Airport (YQA)"
  },
  {
    "value": "GTF",
    "label": "Great Falls Great Falls International Airport (GTF)"
  },
  {
    "value": "GRB",
    "label": "Green Bay Austin Straubel International Airport (GRB)"
  },
  {
    "value": "GSO",
    "label": "Greensboro Piedmont Triad International Airport (GSO)"
  },
  {
    "value": "GMU",
    "label": "Greenville Greenville Downtown Airport (GMU)"
  },
  {
    "value": "GLH",
    "label": "Greenville Mid Delta Regional Airport (GLH)"
  },
  {
    "value": "PGV",
    "label": "Greenville Pitt-Greenville Airport (PGV)"
  },
  {
    "value": "YZX",
    "label": "Greenwood CFB Greenwood (YZX)"
  },
  {
    "value": "GWO",
    "label": "Greenwood Greenwood–Leflore Airport (GWO)"
  },
  {
    "value": "GSP",
    "label": "Greer Greenville Spartanburg International Airport (GSP)"
  },
  {
    "value": "FMO",
    "label": "Greven Münster Osnabrück Airport (FMO)"
  },
  {
    "value": "GFF",
    "label": "Griffith Griffith Airport (GFF)"
  },
  {
    "value": "HUY",
    "label": "Grimsby, Lincolnshire Humberside Airport (HUY)"
  },
  {
    "value": "GRQ",
    "label": "Groningen Groningen Airport Eelde (GRQ)"
  },
  {
    "value": "GTE",
    "label": "Groote Eylandt Groote Eylandt Airport (GTE)"
  },
  {
    "value": "GFY",
    "label": "Grootfontein Grootfontein Airport (GFY)"
  },
  {
    "value": "GRS",
    "label": "Grosseto (GR) Grosseto Corrado Baccarini Air Base / Grosseto Airport (GRS)"
  },
  {
    "value": "GON",
    "label": "Groton Groton New London Airport (GON)"
  },
  {
    "value": "TAR",
    "label": "Grottaglie Taranto-Grottaglie Marcello Arlotta Airport (TAR)"
  },
  {
    "value": "GRV",
    "label": "Grozny Grozny Airport (GRV)"
  },
  {
    "value": "GDL",
    "label": "Guadalajara Guadalajara International Airport (GDL)"
  },
  {
    "value": "GJM",
    "label": "Guajará-Mirim Guajará-Mirim Airport (GJM)"
  },
  {
    "value": "GHU",
    "label": "Gualeguaychu Gualeguaychu Airport (GHU)"
  },
  {
    "value": "GJA",
    "label": "Guanaja La Laguna Airport (GJA)"
  },
  {
    "value": "GUQ",
    "label": "Guanare Guanare Airport (GUQ)"
  },
  {
    "value": "GYS",
    "label": "Guangyuan (Lizhou) Guangyuan Panlong Airport (GYS)"
  },
  {
    "value": "CAN",
    "label": "Guangzhou (Huadu) Guangzhou Baiyun International Airport (CAN)"
  },
  {
    "value": "NBW",
    "label": "Guantanamo Bay Naval Station Leeward Point Field (NBW)"
  },
  {
    "value": "GAO",
    "label": "Guantánamo Mariana Grajales Airport (GAO)"
  },
  {
    "value": "GPI",
    "label": "Guapi Juan Casiano Airport (GPI)"
  },
  {
    "value": "GUJ",
    "label": "Guaratinguetá Edu Chaves Field (GUJ)"
  },
  {
    "value": "CLZ",
    "label": "Guarico Calabozo Airport (CLZ)"
  },
  {
    "value": "SSZ",
    "label": "Guarujá Santos Nero Moura Air Base / Guarujá Airport (SSZ)"
  },
  {
    "value": "GDO",
    "label": "Guasdualito Guasdualito Airport (GDO)"
  },
  {
    "value": "GUA",
    "label": "Guatemala City La Aurora Airport (GUA)"
  },
  {
    "value": "GYE",
    "label": "Guayaquil José Joaquín de Olmedo International Airport (GYE)"
  },
  {
    "value": "GYA",
    "label": "Guayaramerín Guayaramerín Airport (GYA)"
  },
  {
    "value": "GYM",
    "label": "Guaymas General José María Yáñez International Airport (GYM)"
  },
  {
    "value": "ELU",
    "label": "Guemar Guemar Airport - مطار قمار بالوادي (ELU)"
  },
  {
    "value": "KWL",
    "label": "Guilin (Lingui) Guilin Liangjiang International Airport (KWL)"
  },
  {
    "value": "KWE",
    "label": "Guiyang (Nanming) Guiyang Longdongbao International Airport (KWE)"
  },
  {
    "value": "GPT",
    "label": "Gulfport Gulfport Biloxi International Airport (GPT)"
  },
  {
    "value": "GKN",
    "label": "Gulkana Gulkana Airport (GKN)"
  },
  {
    "value": "ULU",
    "label": "Gulu Gulu Airport (ULU)"
  },
  {
    "value": "GUC",
    "label": "Gunnison Gunnison Crested Butte Regional Airport (GUC)"
  },
  {
    "value": "KUV",
    "label": "Gunsan Gunsan Airport / Gunsan Air Base (KUV)"
  },
  {
    "value": "GNS",
    "label": "Gunungsitoli Binaka Airport (GNS)"
  },
  {
    "value": "GWD",
    "label": "Gurandani New Gwadar International Airport (GWD)"
  },
  {
    "value": "URY",
    "label": "Gurayat Gurayat Domestic Airport (URY)"
  },
  {
    "value": "GUR",
    "label": "Gurney Gurney Airport (GUR)"
  },
  {
    "value": "QUS",
    "label": "Gusau Gusau Airport (QUS)"
  },
  {
    "value": "SBH",
    "label": "Gustavia Saint Barthélemy - Gustaf III Airport (SBH)"
  },
  {
    "value": "GST",
    "label": "Gustavus Gustavus Airport (GST)"
  },
  {
    "value": "GAU",
    "label": "Guwahati Lokpriya Gopinath Bordoloi International Airport (GAU)"
  },
  {
    "value": "GUY",
    "label": "Guymon Guymon Municipal Airport (GUY)"
  },
  {
    "value": "GYU",
    "label": "Guyuan (Yuanzhou) Guyuan Liupanshan Airport (GYU)"
  },
  {
    "value": "HEA",
    "label": "Guzara Herat - Khwaja Abdullah Ansari International Airport (HEA)"
  },
  {
    "value": "GWL",
    "label": "Gwalior Gwalior Airport (GWL)"
  },
  {
    "value": "KWJ",
    "label": "Gwangju Gwangju Airport (KWJ)"
  },
  {
    "value": "HWN",
    "label": "Gwayi River Farms Hwange National Park Airport (HWN)"
  },
  {
    "value": "GWE",
    "label": "Gweru Gweru - Thornhill Air Base (GWE)"
  },
  {
    "value": "MQT",
    "label": "Gwinn Marquette/Sawyer International Airport (MQT)"
  },
  {
    "value": "LWN",
    "label": "Gyumri Shirak International Airport (LWN)"
  },
  {
    "value": "HAS",
    "label": "Ha'il Ha'il Airport (HAS)"
  },
  {
    "value": "HAQ",
    "label": "Haa Dhaalu Atoll Hanimaadhoo Airport (HAQ)"
  },
  {
    "value": "HAC",
    "label": "Hachijojima Hachijojima Airport (HAC)"
  },
  {
    "value": "HHE",
    "label": "Hachinohe JMSDF Hachinohe Air Base / Hachinohe Airport (HHE)"
  },
  {
    "value": "SKN",
    "label": "Hadsel Stokmarknes Airport, Skagen (SKN)"
  },
  {
    "value": "GUM",
    "label": "Hagåtña Antonio B. Won Pat International Airport (GUM)"
  },
  {
    "value": "HGR",
    "label": "Hagerstown Hagerstown Regional Richard A Henson Field (HGR)"
  },
  {
    "value": "XNN",
    "label": "Haidong (Huzhu Tu Autonomous County) Xining Caojiabao International Airport (XNN)"
  },
  {
    "value": "HFA",
    "label": "Haifa Haifa International Airport (HFA)"
  },
  {
    "value": "HAK",
    "label": "Haikou (Meilan) Haikou Meilan International Airport (HAK)"
  },
  {
    "value": "HLD",
    "label": "Hailar Hulunbuir Hailar Airport (HLD)"
  },
  {
    "value": "SUN",
    "label": "Hailey Friedman Memorial Airport (SUN)"
  },
  {
    "value": "HNS",
    "label": "Haines Haines Airport (HNS)"
  },
  {
    "value": "YHT",
    "label": "Haines Junction Haines Junction Airport (YHT)"
  },
  {
    "value": "HPH",
    "label": "Haiphong (Hai An) Cat Bi International Airport (HPH)"
  },
  {
    "value": "YKO",
    "label": "Hakkari Hakkari Yüksekova Airport (YKO)"
  },
  {
    "value": "HKD",
    "label": "Hakodate Hakodate Airport (HKD)"
  },
  {
    "value": "YHZ",
    "label": "Halifax Halifax / Stanfield International Airport (YHZ)"
  },
  {
    "value": "HAD",
    "label": "Halmstad Halmstad Airport (HAD)"
  },
  {
    "value": "HDM",
    "label": "Hamadan Hamadan Airport (HDM)"
  },
  {
    "value": "HAM",
    "label": "Hamburg Hamburg Helmut Schmidt Airport (HAM)"
  },
  {
    "value": "XFW",
    "label": "Hamburg Hamburg-Finkenwerder Airport (XFW)"
  },
  {
    "value": "HMI",
    "label": "Hami Hami Airport (HMI)"
  },
  {
    "value": "HLZ",
    "label": "Hamilton Hamilton International Airport (HLZ)"
  },
  {
    "value": "HTI",
    "label": "Hamilton Island Hamilton Island Airport (HTI)"
  },
  {
    "value": "YHM",
    "label": "Hamilton John C. Munro Hamilton International Airport (YHM)"
  },
  {
    "value": "BDA",
    "label": "Hamilton L.F. Wade International Airport (BDA)"
  },
  {
    "value": "HFT",
    "label": "Hammerfest Hammerfest Airport (HFT)"
  },
  {
    "value": "LFI",
    "label": "Hampton Langley Air Force Base (LFI)"
  },
  {
    "value": "HNM",
    "label": "Hana Hana Airport (HNM)"
  },
  {
    "value": "RSI",
    "label": "Hanak Red Sea International Airport (RSI)"
  },
  {
    "value": "HNA",
    "label": "Hanamaki Iwate Hanamaki Airport (HNA)"
  },
  {
    "value": "CMX",
    "label": "Hancock Houghton County Memorial Airport (CMX)"
  },
  {
    "value": "HDG",
    "label": "Handan Handan Airport (HDG)"
  },
  {
    "value": "HGH",
    "label": "Hangzhou Hangzhou Xiaoshan International Airport (HGH)"
  },
  {
    "value": "HAJ",
    "label": "Hannover Hannover Airport (HAJ)"
  },
  {
    "value": "HAN",
    "label": "Hanoi (Soc Son) Noi Bai International Airport (HAN)"
  },
  {
    "value": "HRE",
    "label": "Harare Robert Gabriel Mugabe International Airport (HRE)"
  },
  {
    "value": "HRB",
    "label": "Harbin Harbin Taiping International Airport (HRB)"
  },
  {
    "value": "HGA",
    "label": "Hargeisa Egal International Airport (HGA)"
  },
  {
    "value": "HRL",
    "label": "Harlingen Valley International Airport (HRL)"
  },
  {
    "value": "MDT",
    "label": "Harrisburg Harrisburg International Airport (MDT)"
  },
  {
    "value": "HRS",
    "label": "Harrismith Harrismith Airport (HRS)"
  },
  {
    "value": "HRO",
    "label": "Harrison Boone County Airport (HRO)"
  },
  {
    "value": "BDL",
    "label": "Hartford Bradley International Airport (BDL)"
  },
  {
    "value": "HFD",
    "label": "Hartford Hartford Brainard Airport (HFD)"
  },
  {
    "value": "HME",
    "label": "Hassi Messaoud Hassi Messaoud-Oued Irara Krim Belkacem Airport (HME)"
  },
  {
    "value": "HRM",
    "label": "Hassi R'Mel Hassi R'Mel Airport (HRM)"
  },
  {
    "value": "HDY",
    "label": "Hat Yai Hat Yai International Airport (HDY)"
  },
  {
    "value": "HBG",
    "label": "Hattiesburg Hattiesburg Bobby L Chain Municipal Airport (HBG)"
  },
  {
    "value": "HAV",
    "label": "Havana José Martí International Airport (HAV)"
  },
  {
    "value": "UPB",
    "label": "Havana Playa Baracoa Airport (UPB)"
  },
  {
    "value": "HAW",
    "label": "Haverfordwest Haverfordwest Airport (HAW)"
  },
  {
    "value": "HVR",
    "label": "Havre Havre City County Airport (HVR)"
  },
  {
    "value": "YGV",
    "label": "Havre-Saint-Pierre Havre-Saint-Pierre Airport (YGV)"
  },
  {
    "value": "AWA",
    "label": "Hawassa Hawassa International Airport (AWA)"
  },
  {
    "value": "HHR",
    "label": "Hawthorne Jack Northrop Field Hawthorne Municipal Airport (HHR)"
  },
  {
    "value": "YHY",
    "label": "Hay River Hay River / Merlyn Carter Airport (YHY)"
  },
  {
    "value": "HDN",
    "label": "Hayden Yampa Valley Airport (HDN)"
  },
  {
    "value": "HYS",
    "label": "Hays Hays Regional Airport (HYS)"
  },
  {
    "value": "HYR",
    "label": "Hayward Sawyer County Airport (HYR)"
  },
  {
    "value": "YHF",
    "label": "Hearst Hearst René Fontaine Municipal Airport (YHF)"
  },
  {
    "value": "HCJ",
    "label": "Hechi (Jinchengjiang) Hechi Jinchengjiang Airport (HCJ)"
  },
  {
    "value": "HFE",
    "label": "Hefei Hefei Xinqiao International Airport (HFE)"
  },
  {
    "value": "HEK",
    "label": "Heihe Heihe Aihui Airport (HEK)"
  },
  {
    "value": "DTU",
    "label": "Heihe Wudalianchi Dedu Airport (DTU)"
  },
  {
    "value": "HLN",
    "label": "Helena Helena Regional Airport (HLN)"
  },
  {
    "value": "HEL",
    "label": "Helsinki (Vantaa) Helsinki Vantaa Airport (HEL)"
  },
  {
    "value": "HCN",
    "label": "Hengchun Hengchun Airport (HCN)"
  },
  {
    "value": "HER",
    "label": "Heraklion Heraklion International Nikos Kazantzakis Airport (HER)"
  },
  {
    "value": "HMO",
    "label": "Hermosillo General Ignacio P. Garcia International Airport (HMO)"
  },
  {
    "value": "HVB",
    "label": "Hervey Bay Hervey Bay Airport (HVB)"
  },
  {
    "value": "HZA",
    "label": "Heze (Dingtao) Heze Mudan Airport (HZA)"
  },
  {
    "value": "HIB",
    "label": "Hibbing Range Regional Airport (HIB)"
  },
  {
    "value": "HKY",
    "label": "Hickory Hickory Regional Airport (HKY)"
  },
  {
    "value": "AKJ",
    "label": "Higashikagura Asahikawa Airport (AKJ)"
  },
  {
    "value": "GAJ",
    "label": "Higashine Yamagata Airport (GAJ)"
  },
  {
    "value": "YOJ",
    "label": "High Level High Level Airport (YOJ)"
  },
  {
    "value": "ITO",
    "label": "Hilo Hilo International Airport (ITO)"
  },
  {
    "value": "HHH",
    "label": "Hilton Head Island Hilton Head Airport (HHH)"
  },
  {
    "value": "HIJ",
    "label": "Hiroshima Hiroshima Airport (HIJ)"
  },
  {
    "value": "HSS",
    "label": "Hisar Hisar Airport (HSS)"
  },
  {
    "value": "IQA",
    "label": "Hīt Al Asad Air Base (IQA)"
  },
  {
    "value": "AUQ",
    "label": "Hiva Oa Island Hiva Oa-Atuona Airport (AUQ)"
  },
  {
    "value": "SGN",
    "label": "Ho Chi Minh City Tan Son Nhat International Airport (SGN)"
  },
  {
    "value": "HBA",
    "label": "Hobart (Cambridge) Hobart International Airport (HBA)"
  },
  {
    "value": "HBR",
    "label": "Hobart Hobart Regional Airport (HBR)"
  },
  {
    "value": "HOB",
    "label": "Hobbs Lea County Regional Airport (HOB)"
  },
  {
    "value": "RGO",
    "label": "Hoemun-ri Orang (Chongjin) Airport (RGO)"
  },
  {
    "value": "HOQ",
    "label": "Hof Hof-Plauen Airport (HOQ)"
  },
  {
    "value": "HFN",
    "label": "Höfn Hornafjörður Airport (HFN)"
  },
  {
    "value": "HOF",
    "label": "Hofuf Al-Ahsa International Airport (HOF)"
  },
  {
    "value": "HET",
    "label": "Hohhot Hohhot Baita International Airport (HET)"
  },
  {
    "value": "HOG",
    "label": "Holguin Frank Pais International Airport (HOG)"
  },
  {
    "value": "HUO",
    "label": "Holingol Holingol Huolinhe Airport (HUO)"
  },
  {
    "value": "HGI",
    "label": "Hollongi Itanagar Donyi Polo Hollongi Airport (HGI)"
  },
  {
    "value": "HCR",
    "label": "Holy Cross Holy Cross Airport (HCR)"
  },
  {
    "value": "HOM",
    "label": "Homer Homer Airport (HOM)"
  },
  {
    "value": "HST",
    "label": "Homestead Homestead ARB Airport (HST)"
  },
  {
    "value": "EAS",
    "label": "Hondarribia San Sebastián Airport (EAS)"
  },
  {
    "value": "HKG",
    "label": "Hong Kong Hong Kong International Airport (HKG)"
  },
  {
    "value": "HIR",
    "label": "Honiara Honiara International Airport (HIR)"
  },
  {
    "value": "HVG",
    "label": "Honningsvåg Honningsvåg Airport, Valan (HVG)"
  },
  {
    "value": "HIK",
    "label": "Honolulu Hickam Air Force Base (HIK)"
  },
  {
    "value": "HNL",
    "label": "Honolulu, Oahu Daniel K Inouye International Airport (HNL)"
  },
  {
    "value": "WOE",
    "label": "Hoogerheide Woensdrecht Air Base (WOE)"
  },
  {
    "value": "ODH",
    "label": "Hook, Hampshire RAF Odiham (ODH)"
  },
  {
    "value": "HQM",
    "label": "Hoquiam Bowerman Airport (HQM)"
  },
  {
    "value": "HID",
    "label": "Horn Horn Island Airport (HID)"
  },
  {
    "value": "YHN",
    "label": "Hornepayne Hornepayne Municipal Airport (YHN)"
  },
  {
    "value": "EIB",
    "label": "Hörselberg-Hainich Eisenach-Kindel Airport (EIB)"
  },
  {
    "value": "HOR",
    "label": "Horta Horta Airport (HOR)"
  },
  {
    "value": "HOT",
    "label": "Hot Springs Memorial Field Airport (HOT)"
  },
  {
    "value": "HTN",
    "label": "Hotan Hotan Airport (HTN)"
  },
  {
    "value": "HUL",
    "label": "Houlton Houlton International Airport (HUL)"
  },
  {
    "value": "CXO",
    "label": "Houston Conroe-North Houston Regional Airport (CXO)"
  },
  {
    "value": "EFD",
    "label": "Houston Ellington Airport (EFD)"
  },
  {
    "value": "IAH",
    "label": "Houston George Bush Intercontinental Houston Airport (IAH)"
  },
  {
    "value": "SGR",
    "label": "Houston Sugar Land Regional Airport (SGR)"
  },
  {
    "value": "HOU",
    "label": "Houston William P Hobby Airport (HOU)"
  },
  {
    "value": "GNA",
    "label": "Hrodna Hrodna Airport (GNA)"
  },
  {
    "value": "HSZ",
    "label": "Hsinchu City Hsinchu Air Base (HSZ)"
  },
  {
    "value": "HHQ",
    "label": "Hua Hin Hua Hin Airport (HHQ)"
  },
  {
    "value": "HIA",
    "label": "Huai'an Huai'an Lianshui International Airport (HIA)"
  },
  {
    "value": "HJJ",
    "label": "Huaihua Huaihua Zhijiang Airport (HJJ)"
  },
  {
    "value": "HUN",
    "label": "Hualien City Hualien Airport (HUN)"
  },
  {
    "value": "NOV",
    "label": "Huambo Nova Lisboa Airport (NOV)"
  },
  {
    "value": "TXN",
    "label": "Huangshan Tunxi International Airport (TXN)"
  },
  {
    "value": "HUU",
    "label": "Huánuco Alferez Fap David Figueroa Fernandini Airport (HUU)"
  },
  {
    "value": "HUX",
    "label": "Huatulco Bahías de Huatulco International Airport (HUX)"
  },
  {
    "value": "HBX",
    "label": "Hubli Hubli Airport (HBX)"
  },
  {
    "value": "HUI",
    "label": "Huế Phu Bai International Airport (HUI)"
  },
  {
    "value": "HUZ",
    "label": "Huizhou (Pingtan) Huizhou Pingtan Airport (HUZ)"
  },
  {
    "value": "XEN",
    "label": "Huludao (Xingcheng) Xingcheng Air Base (XEN)"
  },
  {
    "value": "SHE",
    "label": "Hunnan, Shenyang Shenyang Taoxian International Airport (SHE)"
  },
  {
    "value": "HTS",
    "label": "Huntington Tri-State Airport / Milton J. Ferguson Field (HTS)"
  },
  {
    "value": "HSV",
    "label": "Huntsville Huntsville International Carl T Jones Field (HSV)"
  },
  {
    "value": "HTV",
    "label": "Huntsville Huntsville Regional Airport (HTV)"
  },
  {
    "value": "HRG",
    "label": "Hurghada Hurghada International Airport (HRG)"
  },
  {
    "value": "HON",
    "label": "Huron Huron Regional Airport (HON)"
  },
  {
    "value": "YCE",
    "label": "Huron Park Centralia / James T. Field Memorial Aerodrome (YCE)"
  },
  {
    "value": "HZK",
    "label": "Húsavík Húsavík Airport (HZK)"
  },
  {
    "value": "HSL",
    "label": "Huslia Huslia Airport (HSL)"
  },
  {
    "value": "HUT",
    "label": "Hutchinson Hutchinson Municipal Airport (HUT)"
  },
  {
    "value": "KDM",
    "label": "Huvadhu Atoll Kaadedhdhoo Airport (KDM)"
  },
  {
    "value": "MZG",
    "label": "Huxi Penghu Magong Airport (MZG)"
  },
  {
    "value": "HYA",
    "label": "Hyannis Cape Cod Gateway Airport (HYA)"
  },
  {
    "value": "BPM",
    "label": "Hyderabad Begumpet Airport (BPM)"
  },
  {
    "value": "HYD",
    "label": "Hyderabad Rajiv Gandhi International Airport (HYD)"
  },
  {
    "value": "TLN",
    "label": "Hyères, Var Toulon-Hyères Airport (TLN)"
  },
  {
    "value": "SPN",
    "label": "I Fadang, Saipan Saipan International Airport (SPN)"
  },
  {
    "value": "CBD",
    "label": "IAF Camp Car Nicobar Air Force Base (CBD)"
  },
  {
    "value": "IAS",
    "label": "Iaşi Iaşi Airport (IAS)"
  },
  {
    "value": "IBA",
    "label": "Ibadan Ibadan Airport (IBA)"
  },
  {
    "value": "IBE",
    "label": "Ibagué Perales Airport (IBE)"
  },
  {
    "value": "IBP",
    "label": "Iberia Iberia Airport (IBP)"
  },
  {
    "value": "IBZ",
    "label": "Ibiza (Eivissa) Ibiza Airport (IBZ)"
  },
  {
    "value": "IDA",
    "label": "Idaho Falls Idaho Falls Regional Airport (IDA)"
  },
  {
    "value": "IEJ",
    "label": "Ie Iejima Airport (IEJ)"
  },
  {
    "value": "IAA",
    "label": "Igarka Igarka Airport (IAA)"
  },
  {
    "value": "IGD",
    "label": "Iğdır Iğdır Airport (IGD)"
  },
  {
    "value": "ZUC",
    "label": "Ignace Ignace Municipal Airport (ZUC)"
  },
  {
    "value": "IKI",
    "label": "Iki Iki Airport (IKI)"
  },
  {
    "value": "IIL",
    "label": "Ilam Ilam Airport (IIL)"
  },
  {
    "value": "ILP",
    "label": "Île des Pins Île des Pins Airport (ILP)"
  },
  {
    "value": "IOS",
    "label": "Ilhéus Bahia - Jorge Amado Airport (IOS)"
  },
  {
    "value": "ILI",
    "label": "Iliamna Iliamna Airport (ILI)"
  },
  {
    "value": "SKP",
    "label": "Ilinden Skopje International Airport (SKP)"
  },
  {
    "value": "VVZ",
    "label": "Illizi Illizi Takhamalt Airport (VVZ)"
  },
  {
    "value": "ILQ",
    "label": "Ilo General Jorge Fernandez Maldon Airport (ILQ)"
  },
  {
    "value": "ILR",
    "label": "Ilorin Ilorin International Airport (ILR)"
  },
  {
    "value": "JAV",
    "label": "Ilulissat Ilulissat Airport (JAV)"
  },
  {
    "value": "IMP",
    "label": "Imperatriz Prefeito Renato Moreira Airport (IMP)"
  },
  {
    "value": "IPL",
    "label": "Imperial Imperial County Airport (IPL)"
  },
  {
    "value": "IMF",
    "label": "Imphal Imphal Airport (IMF)"
  },
  {
    "value": "IAM",
    "label": "In Aménas Zarzaitine - In Aménas Airport (IAM)"
  },
  {
    "value": "INZ",
    "label": "In Salah In Salah Airport (INZ)"
  },
  {
    "value": "IND",
    "label": "Indianapolis Indianapolis International Airport (IND)"
  },
  {
    "value": "IDR",
    "label": "Indore Devi Ahilyabai Holkar Airport (IDR)"
  },
  {
    "value": "INH",
    "label": "Inhambane Inhambane Airport (INH)"
  },
  {
    "value": "INN",
    "label": "Innsbruck Innsbruck Airport (INN)"
  },
  {
    "value": "INA",
    "label": "Inta Inta Airport (INA)"
  },
  {
    "value": "INL",
    "label": "International Falls Falls International Airport (INL)"
  },
  {
    "value": "YEV",
    "label": "Inuvik Inuvik Mike Zubko Airport (YEV)"
  },
  {
    "value": "IVC",
    "label": "Invercargill Invercargill Airport (IVC)"
  },
  {
    "value": "IVR",
    "label": "Inverell Inverell Airport (IVR)"
  },
  {
    "value": "INV",
    "label": "Inverness Inverness Airport (INV)"
  },
  {
    "value": "IOA",
    "label": "Ioannina Ioannina King Pyrrhus National Airport (IOA)"
  },
  {
    "value": "IPN",
    "label": "Ipatinga Usiminas Airport (IPN)"
  },
  {
    "value": "IPI",
    "label": "Ipiales San Luis Airport (IPI)"
  },
  {
    "value": "IPH",
    "label": "Ipoh Sultan Azlan Shah Airport (IPH)"
  },
  {
    "value": "YFB",
    "label": "Iqaluit Iqaluit Airport (YFB)"
  },
  {
    "value": "IQQ",
    "label": "Iquique Diego Aracena Airport (IQQ)"
  },
  {
    "value": "IQT",
    "label": "Iquitos Coronel FAP Francisco Secada Vignetta International Airport (IQT)"
  },
  {
    "value": "IHR",
    "label": "Iranshahr Iranshahr Airport (IHR)"
  },
  {
    "value": "IKT",
    "label": "Irkutsk Irkutsk International Airport (IKT)"
  },
  {
    "value": "IFJ",
    "label": "Ísafjörður Ísafjörður Airport (IFJ)"
  },
  {
    "value": "IFN",
    "label": "Isfahan Isfahan Shahid Beheshti International Airport (IFN)"
  },
  {
    "value": "ISG",
    "label": "Ishigaki New Ishigaki Airport (ISG)"
  },
  {
    "value": "IRD",
    "label": "Ishurdi Ishurdi Airport (IRD)"
  },
  {
    "value": "IRP",
    "label": "Isiro Matari Airport (IRP)"
  },
  {
    "value": "BOC",
    "label": "Isla Colón Bocas del Toro International Airport (BOC)"
  },
  {
    "value": "SZJ",
    "label": "Isla de la Juventud Siguanea Airport (SZJ)"
  },
  {
    "value": "IPC",
    "label": "Isla De Pascua Mataveri Airport (IPC)"
  },
  {
    "value": "PMV",
    "label": "Isla Margarita Del Caribe Santiago Mariño International Airport (PMV)"
  },
  {
    "value": "YIV",
    "label": "Island Lake Island Lake Airport (YIV)"
  },
  {
    "value": "ILY",
    "label": "Isle of Islay, Argyll and Bute Islay Airport (ILY)"
  },
  {
    "value": "ISP",
    "label": "Islip Long Island Mac Arthur Airport (ISP)"
  },
  {
    "value": "CRV",
    "label": "Isola di Capo Rizzuto (KR) Crotone Sant'Anna Pythagoras Airport (CRV)"
  },
  {
    "value": "ISE",
    "label": "Isparta Süleyman Demirel International Airport (ISE)"
  },
  {
    "value": "ITA",
    "label": "Itacoatiara Itacoatiara Airport (ITA)"
  },
  {
    "value": "ITB",
    "label": "Itaituba Itaituba Airport (ITB)"
  },
  {
    "value": "ITH",
    "label": "Ithaca Ithaca Tompkins Regional Airport (ITH)"
  },
  {
    "value": "IVL",
    "label": "Ivalo Ivalo Airport (IVL)"
  },
  {
    "value": "IFO",
    "label": "Ivano-Frankivsk Ivano-Frankivsk International Airport (IFO)"
  },
  {
    "value": "IWA",
    "label": "Ivanovo Ivanovo South Airport (IWA)"
  },
  {
    "value": "IWK",
    "label": "Iwakuni Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni (IWK)"
  },
  {
    "value": "ZIH",
    "label": "Ixtapa Ixtapa-Zihuatanejo International Airport (ZIH)"
  },
  {
    "value": "IZT",
    "label": "Ixtepec General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base (IZT)"
  },
  {
    "value": "IJK",
    "label": "Izhevsk Izhevsk Airport (IJK)"
  },
  {
    "value": "OIM",
    "label": "Izu Oshima Oshima Airport (OIM)"
  },
  {
    "value": "IZO",
    "label": "Izumo Izumo Enmusubi Airport (IZO)"
  },
  {
    "value": "JLR",
    "label": "Jabalpur Jabalpur Airport (JLR)"
  },
  {
    "value": "JCR",
    "label": "Jacareacanga Jacareacanga Airport (JCR)"
  },
  {
    "value": "JXN",
    "label": "Jackson Jackson County Airport/Reynolds Field (JXN)"
  },
  {
    "value": "JAC",
    "label": "Jackson Jackson Hole Airport (JAC)"
  },
  {
    "value": "JAN",
    "label": "Jackson Jackson-Medgar Wiley Evers International Airport (JAN)"
  },
  {
    "value": "MKL",
    "label": "Jackson McKellar-Sipes Regional Airport (MKL)"
  },
  {
    "value": "VQQ",
    "label": "Jacksonville Cecil Airport (VQQ)"
  },
  {
    "value": "CRG",
    "label": "Jacksonville Jacksonville Executive at Craig Airport (CRG)"
  },
  {
    "value": "JAX",
    "label": "Jacksonville Jacksonville International Airport (JAX)"
  },
  {
    "value": "NIP",
    "label": "Jacksonville Jacksonville Naval Air Station (Towers Field) (NIP)"
  },
  {
    "value": "LRF",
    "label": "Jacksonville Little Rock Air Force Base (LRF)"
  },
  {
    "value": "NRB",
    "label": "Jacksonville Naval Station Mayport / Admiral David L McDonald Field (NRB)"
  },
  {
    "value": "JAK",
    "label": "Jacmel Jacmel Airport (JAK)"
  },
  {
    "value": "JAG",
    "label": "Jacobabad Shahbaz Air Base (JAG)"
  },
  {
    "value": "JAE",
    "label": "Jaén Shumba Airport (JAE)"
  },
  {
    "value": "JAF",
    "label": "Jaffna Jaffna International Airport (JAF)"
  },
  {
    "value": "WBG",
    "label": "Jagel Schleswig Air Base (WBG)"
  },
  {
    "value": "JAI",
    "label": "Jaipur Jaipur International Airport (JAI)"
  },
  {
    "value": "HLP",
    "label": "Jakarta Halim Perdanakusuma International Airport (HLP)"
  },
  {
    "value": "CGK",
    "label": "Jakarta Soekarno-Hatta International Airport (CGK)"
  },
  {
    "value": "JAA",
    "label": "Jalalabad Jalalabad Airport (JAA)"
  },
  {
    "value": "KNR",
    "label": "Jam Jam Airport (KNR)"
  },
  {
    "value": "JHW",
    "label": "Jamestown Chautauqua County-Jamestown Airport (JHW)"
  },
  {
    "value": "JMS",
    "label": "Jamestown Jamestown Regional Airport (JMS)"
  },
  {
    "value": "IXJ",
    "label": "Jammu Jammu Airport (IXJ)"
  },
  {
    "value": "JGA",
    "label": "Jamnagar Jamnagar Airport (JGA)"
  },
  {
    "value": "KEV",
    "label": "Jämsä Halli Airport (KEV)"
  },
  {
    "value": "IXW",
    "label": "Jamshedpur Sonari Airport (IXW)"
  },
  {
    "value": "JKR",
    "label": "Janakpur Janakpur Airport (JKR)"
  },
  {
    "value": "JSR",
    "label": "Jashore (Jessore) Jessore Airport (JSR)"
  },
  {
    "value": "RZE",
    "label": "Jasionka Rzeszów-Jasionka Airport (RZE)"
  },
  {
    "value": "JAU",
    "label": "Jauja Francisco Carle Airport (JAU)"
  },
  {
    "value": "DWC",
    "label": "Jebel Ali Al Maktoum International Airport (DWC)"
  },
  {
    "value": "JED",
    "label": "Jeddah King Abdulaziz International Airport (JED)"
  },
  {
    "value": "CJU",
    "label": "Jeju City Jeju International Airport (CJU)"
  },
  {
    "value": "JDG",
    "label": "Jeju Island Jeongseok Airport (JDG)"
  },
  {
    "value": "ZJG",
    "label": "Jenpeg Jenpeg Airport (ZJG)"
  },
  {
    "value": "JEE",
    "label": "Jeremie Jérémie Airport (JEE)"
  },
  {
    "value": "XRY",
    "label": "Jerez de la Frontera Jerez Airport (XRY)"
  },
  {
    "value": "JGS",
    "label": "Ji'an Jinggangshan Airport (JGS)"
  },
  {
    "value": "JGD",
    "label": "Jiagedaqi Daxing'anling Elunchun Airport (JGD)"
  },
  {
    "value": "JMU",
    "label": "Jiamusi Jiamusi Dongjiao Airport (JMU)"
  },
  {
    "value": "JSJ",
    "label": "Jiansanjiang Jiansanjiang Shidi Airport (JSJ)"
  },
  {
    "value": "SWA",
    "label": "Jieyang (Rongcheng) Jieyang Chaoshan International Airport (SWA)"
  },
  {
    "value": "JIJ",
    "label": "Jijiga Wilwal International Airport (JIJ)"
  },
  {
    "value": "JIM",
    "label": "Jimma Jimma Airport (JIM)"
  },
  {
    "value": "TNA",
    "label": "Jinan (Licheng) Jinan Yaoqiang International Airport (TNA)"
  },
  {
    "value": "JDZ",
    "label": "Jingdezhen Jingdezhen Luojia Airport (JDZ)"
  },
  {
    "value": "JHG",
    "label": "Jinghong (Gasa) Xishuangbanna Gasa International Airport (JHG)"
  },
  {
    "value": "SHS",
    "label": "Jingzhou (Shashi) Jingzhou Shashi Airport (SHS)"
  },
  {
    "value": "YIW",
    "label": "Jinhua (Yiwu) Yiwu Airport (YIW)"
  },
  {
    "value": "JNG",
    "label": "Jining Jining Da'an Airport (JNG)"
  },
  {
    "value": "JNZ",
    "label": "Jinzhou (Linghai) Jinzhou Bay Airport (JNZ)"
  },
  {
    "value": "JYR",
    "label": "Jiroft Jiroft Airport (JYR)"
  },
  {
    "value": "JXA",
    "label": "Jixi Jixi Xingkaihu Airport (JXA)"
  },
  {
    "value": "GIZ",
    "label": "Jizan Jizan Regional Airport / King Abdullah bin Abdulaziz Airport (GIZ)"
  },
  {
    "value": "JPA",
    "label": "João Pessoa Presidente Castro Pinto International Airport (JPA)"
  },
  {
    "value": "JDH",
    "label": "Jodhpur Jodhpur Airport (JDH)"
  },
  {
    "value": "JOE",
    "label": "Joensuu Joensuu Airport (JOE)"
  },
  {
    "value": "HLA",
    "label": "Johannesburg Lanseria International Airport (HLA)"
  },
  {
    "value": "JNB",
    "label": "Johannesburg O.R. Tambo International Airport (JNB)"
  },
  {
    "value": "QRA",
    "label": "Johannesburg Rand Airport (QRA)"
  },
  {
    "value": "JST",
    "label": "Johnstown John Murtha Johnstown Cambria County Airport (JST)"
  },
  {
    "value": "JHB",
    "label": "Johor Bahru Senai International Airport (JHB)"
  },
  {
    "value": "JOI",
    "label": "Joinville Lauro Carneiro de Loyola Airport (JOI)"
  },
  {
    "value": "JOL",
    "label": "Jolo Jolo Airport (JOL)"
  },
  {
    "value": "JBR",
    "label": "Jonesboro Jonesboro Municipal Airport (JBR)"
  },
  {
    "value": "JKG",
    "label": "Jönköping Jönköping Airport (JKG)"
  },
  {
    "value": "JLN",
    "label": "Joplin Joplin Regional Airport (JLN)"
  },
  {
    "value": "JRH",
    "label": "Jorhat Jorhat Airport (JRH)"
  },
  {
    "value": "JOS",
    "label": "Jos Yakubu Gowon Airport (JOS)"
  },
  {
    "value": "JJI",
    "label": "Juanjuí Juanjui Airport (JJI)"
  },
  {
    "value": "JUB",
    "label": "Juba Juba International Airport (JUB)"
  },
  {
    "value": "QJB",
    "label": "Jubail Jubail Airport (QJB)"
  },
  {
    "value": "JDF",
    "label": "Juiz de Fora Francisco de Assis Airport (JDF)"
  },
  {
    "value": "IZA",
    "label": "Juiz de Fora Presidente Itamar Franco Airport (IZA)"
  },
  {
    "value": "JUL",
    "label": "Juliaca Inca Manco Capac International Airport (JUL)"
  },
  {
    "value": "JCT",
    "label": "Junction Kimble County Airport (JCT)"
  },
  {
    "value": "JNU",
    "label": "Juneau Juneau International Airport (JNU)"
  },
  {
    "value": "EPL",
    "label": "Juvaincourt, Vosges Épinal-Mirecourt Airport (EPL)"
  },
  {
    "value": "JWA",
    "label": "Jwaneng Jwaneng Airport (JWA)"
  },
  {
    "value": "JYV",
    "label": "Jyväskylän Maalaiskunta Jyväskylä Airport (JYV)"
  },
  {
    "value": "KBL",
    "label": "Kabul Kabul International Airport (KBL)"
  },
  {
    "value": "CDP",
    "label": "Kadapa Kadapa Airport (CDP)"
  },
  {
    "value": "KDO",
    "label": "Kadhdhoo Kadhdhoo Airport (KDO)"
  },
  {
    "value": "KAD",
    "label": "Kaduna Kaduna Airport (KAD)"
  },
  {
    "value": "KOJ",
    "label": "Kagoshima Kagoshima Airport (KOJ)"
  },
  {
    "value": "KCM",
    "label": "Kahramanmaraş Kahramanmaraş Airport (KCM)"
  },
  {
    "value": "OGG",
    "label": "Kahului Kahului International Airport (OGG)"
  },
  {
    "value": "KAI",
    "label": "Kaieteur Falls Kaieteur International Airport (KAI)"
  },
  {
    "value": "IXH",
    "label": "Kailashahar Kailashahar Airport (IXH)"
  },
  {
    "value": "KJH",
    "label": "Kaili  (Huangping) Kaili Huangping Airport (KJH)"
  },
  {
    "value": "KOA",
    "label": "Kailua-Kona Ellison Onizuka Kona International Airport at Keahole (KOA)"
  },
  {
    "value": "KNG",
    "label": "Kaimana Kaimana Airport (KNG)"
  },
  {
    "value": "KAJ",
    "label": "Kajaani Kajaani Airport (KAJ)"
  },
  {
    "value": "SAG",
    "label": "Kakadi Shirdi Airport (SAG)"
  },
  {
    "value": "KLX",
    "label": "Kalamata Kalamata Airport (KLX)"
  },
  {
    "value": "AZO",
    "label": "Kalamazoo Kalamazoo Battle Creek International Airport (AZO)"
  },
  {
    "value": "FMI",
    "label": "Kalemie Kalemie Airport (FMI)"
  },
  {
    "value": "KLO",
    "label": "Kalibo Kalibo International Airport (KLO)"
  },
  {
    "value": "KGD",
    "label": "Kaliningrad Khrabrovo Airport (KGD)"
  },
  {
    "value": "FCA",
    "label": "Kalispell Glacier Park International Airport (FCA)"
  },
  {
    "value": "KLR",
    "label": "Kalmar Kalmar Airport (KLR)"
  },
  {
    "value": "KLF",
    "label": "Kaluga Grabtsevo Airport (KLF)"
  },
  {
    "value": "UMB",
    "label": "Kalumbila Kalumbila Airport (UMB)"
  },
  {
    "value": "BKY",
    "label": "Kamakombe Bukavu Kavumu Airport (BKY)"
  },
  {
    "value": "KME",
    "label": "Kamembe Kamembe Airport (KME)"
  },
  {
    "value": "YKA",
    "label": "Kamloops Kamloops John Moose Fulton Field Regional Airport (YKA)"
  },
  {
    "value": "EBB",
    "label": "Kampala Entebbe International Airport (EBB)"
  },
  {
    "value": "KZC",
    "label": "Kampong Chhnang Kampong Chhnang Airport (KZC)"
  },
  {
    "value": "ATG",
    "label": "Kamra Minhas Air Base (ATG)"
  },
  {
    "value": "KGA",
    "label": "Kananga Kananga Airport (KGA)"
  },
  {
    "value": "KMQ",
    "label": "Kanazawa Komatsu Airport / JASDF Komatsu Air Base (KMQ)"
  },
  {
    "value": "IXY",
    "label": "Kandla Kandla Airport (IXY)"
  },
  {
    "value": "NGF",
    "label": "Kaneohe Kaneohe Bay MCAS (Marion E. Carl Field) Airport (NGF)"
  },
  {
    "value": "SFJ",
    "label": "Kangerlussuaq Kangerlussuaq Airport (SFJ)"
  },
  {
    "value": "DHM",
    "label": "Kangra Kangra Airport (DHM)"
  },
  {
    "value": "IKK",
    "label": "Kankakee Greater Kankakee Airport (IKK)"
  },
  {
    "value": "CNN",
    "label": "Kannur Kannur International Airport (CNN)"
  },
  {
    "value": "KAN",
    "label": "Kano Mallam Aminu International Airport (KAN)"
  },
  {
    "value": "KNU",
    "label": "Kanpur Kanpur Airport (KNU)"
  },
  {
    "value": "MKC",
    "label": "Kansas City Charles B. Wheeler Downtown Airport (MKC)"
  },
  {
    "value": "MCI",
    "label": "Kansas City Kansas City International Airport (MCI)"
  },
  {
    "value": "KHH",
    "label": "Kaohsiung (Xiaogang) Kaohsiung International Airport (KHH)"
  },
  {
    "value": "KLC",
    "label": "Kaolack Kaolack Airport (KLC)"
  },
  {
    "value": "JRF",
    "label": "Kapolei Kalaeloa Airport (JRF)"
  },
  {
    "value": "YYU",
    "label": "Kapuskasing Kapuskasing Airport (YYU)"
  },
  {
    "value": "KHI",
    "label": "Karachi Jinnah International Airport (KHI)"
  },
  {
    "value": "KGF",
    "label": "Karaganda Sary-Arka Airport (KGF)"
  },
  {
    "value": "PYK",
    "label": "Karaj Payam Karaj International Airport (PYK)"
  },
  {
    "value": "KDL",
    "label": "Kärdla Kärdla Airport (KDL)"
  },
  {
    "value": "KAB",
    "label": "Kariba Kariba International Airport (KAB)"
  },
  {
    "value": "KLV",
    "label": "Karlovy Vary Karlovy Vary Airport (KLV)"
  },
  {
    "value": "KSK",
    "label": "Karlskoga Karlskoga Airport (KSK)"
  },
  {
    "value": "KSD",
    "label": "Karlstad Karlstad Airport (KSD)"
  },
  {
    "value": "HAU",
    "label": "Karmøy Haugesund Airport, Karmøy (HAU)"
  },
  {
    "value": "KGJ",
    "label": "Karonga Karonga Airport (KGJ)"
  },
  {
    "value": "AOK",
    "label": "Karpathos Island Karpathos Airport (AOK)"
  },
  {
    "value": "KTA",
    "label": "Karratha Karratha Airport (KTA)"
  },
  {
    "value": "KSY",
    "label": "Kars Kars Airport (KSY)"
  },
  {
    "value": "KCO",
    "label": "Kartepe Cengiz Topel Airport (KCO)"
  },
  {
    "value": "KRP",
    "label": "Karup Midtjyllands Airport / Air Base Karup (KRP)"
  },
  {
    "value": "XKS",
    "label": "Kasabonika Kasabonika Airport (XKS)"
  },
  {
    "value": "BBK",
    "label": "Kasane Kasane Airport (BBK)"
  },
  {
    "value": "KKS",
    "label": "Kashan Kashan Airport (KKS)"
  },
  {
    "value": "KHG",
    "label": "Kashgar Kashgar Airport (KHG)"
  },
  {
    "value": "KSL",
    "label": "Kassala Kassala Airport (KSL)"
  },
  {
    "value": "KFS",
    "label": "Kastamonu Kastamonu Airport (KFS)"
  },
  {
    "value": "SPU",
    "label": "Kaštel Štafilić Split Airport (SPU)"
  },
  {
    "value": "KTM",
    "label": "Kathmandu Tribhuvan International Airport (KTM)"
  },
  {
    "value": "KTW",
    "label": "Katowice Katowice Wojciech Korfanty International Airport (KTW)"
  },
  {
    "value": "KHJ",
    "label": "Kauhajoki Kauhajoki Airfield (KHJ)"
  },
  {
    "value": "KAU",
    "label": "Kauhava Kauhava Airfield (KAU)"
  },
  {
    "value": "MKK",
    "label": "Kaunakakai Molokai Airport (MKK)"
  },
  {
    "value": "KUN",
    "label": "Kaunas Kaunas International Airport (KUN)"
  },
  {
    "value": "KVA",
    "label": "Kavala Kavala Alexander the Great International Airport (KVA)"
  },
  {
    "value": "KVG",
    "label": "Kavieng Kavieng Airport (KVG)"
  },
  {
    "value": "KAW",
    "label": "Kawthoung Kawthoung Airport (KAW)"
  },
  {
    "value": "ASR",
    "label": "Kayseri Kayseri Erkilet Airport (ASR)"
  },
  {
    "value": "KZN",
    "label": "Kazan Kazan International Airport (KZN)"
  },
  {
    "value": "EAR",
    "label": "Kearney Kearney Regional Airport (EAR)"
  },
  {
    "value": "ABK",
    "label": "Kebri Dahar Kebri Dahar Airport (ABK)"
  },
  {
    "value": "DHX",
    "label": "Kediri Dhoho International Airport (DHX)"
  },
  {
    "value": "KGG",
    "label": "Kédougou Kédougou Airport (KGG)"
  },
  {
    "value": "EEN",
    "label": "Keene Dillant Hopkins Airport (EEN)"
  },
  {
    "value": "KMP",
    "label": "Keetmanshoop Keetmanshoop Airport (KMP)"
  },
  {
    "value": "EFL",
    "label": "Kefallinia Island Kefallinia Airport (EFL)"
  },
  {
    "value": "BKH",
    "label": "Kekaha Barking Sands Airport (BKH)"
  },
  {
    "value": "YLW",
    "label": "Kelowna Kelowna International Airport (YLW)"
  },
  {
    "value": "KES",
    "label": "Kelsey Kelsey Airport (KES)"
  },
  {
    "value": "KLS",
    "label": "Kelso Southwest Washington Regional Airport (KLS)"
  },
  {
    "value": "KEJ",
    "label": "Kemerovo Kemerovo Airport (KEJ)"
  },
  {
    "value": "KEM",
    "label": "Kemi / Tornio Kemi-Tornio Airport (KEM)"
  },
  {
    "value": "POT",
    "label": "Ken Jones Ken Jones Airport (POT)"
  },
  {
    "value": "ENA",
    "label": "Kenai Kenai Municipal Airport (ENA)"
  },
  {
    "value": "KEN",
    "label": "Kenema Kenema Airport (KEN)"
  },
  {
    "value": "KET",
    "label": "Kengtung Kengtung Airport (KET)"
  },
  {
    "value": "NNA",
    "label": "Kenitra Kenitra Air Base (NNA)"
  },
  {
    "value": "YQK",
    "label": "Kenora Kenora Airport (YQK)"
  },
  {
    "value": "ENW",
    "label": "Kenosha Kenosha Regional Airport (ENW)"
  },
  {
    "value": "KPW",
    "label": "Keperveem Keperveem Airport (KPW)"
  },
  {
    "value": "KMA",
    "label": "Kerema Kerema Airport (KMA)"
  },
  {
    "value": "KKE",
    "label": "Kerikeri Kerikeri Airport (KKE)"
  },
  {
    "value": "CFU",
    "label": "Kerkyra (Corfu) Corfu Ioannis Kapodistrias International Airport (CFU)"
  },
  {
    "value": "KER",
    "label": "Kerman Ayatollah Hashemi Rafsanjani International Airport (KER)"
  },
  {
    "value": "KSH",
    "label": "Kermanshah Shahid Ashrafi Esfahani Airport (KSH)"
  },
  {
    "value": "KJT",
    "label": "Kertajati Kertajati International Airport (KJT)"
  },
  {
    "value": "KTE",
    "label": "Kerteh Kerteh Airport (KTE)"
  },
  {
    "value": "IXK",
    "label": "Keshod Keshod Airport (IXK)"
  },
  {
    "value": "KTG",
    "label": "Ketapang Rahadi Osman Airport (KTG)"
  },
  {
    "value": "KTN",
    "label": "Ketchikan Ketchikan International Airport (KTN)"
  },
  {
    "value": "YKJ",
    "label": "Key Lake Key Lake Airport (YKJ)"
  },
  {
    "value": "EYW",
    "label": "Key West Key West International Airport (EYW)"
  },
  {
    "value": "NQX",
    "label": "Key West Naval Air Station Key West/Boca Chica Field (NQX)"
  },
  {
    "value": "KHV",
    "label": "Khabarovsk Khabarovsk Novy Airport (KHV)"
  },
  {
    "value": "HJR",
    "label": "Khajuraho Khajuraho Airport (HJR)"
  },
  {
    "value": "KMX",
    "label": "Khamis Mushait King Khalid Air Base (KMX)"
  },
  {
    "value": "HMA",
    "label": "Khanty-Mansiysk Khanty Mansiysk Airport (HMA)"
  },
  {
    "value": "KHK",
    "label": "Khark Khark Airport (KHK)"
  },
  {
    "value": "HRK",
    "label": "Kharkiv Kharkiv International Airport (HRK)"
  },
  {
    "value": "KRT",
    "label": "Khartoum Khartoum International Airport (KRT)"
  },
  {
    "value": "KHS",
    "label": "Khasab Khasab Airport (KHS)"
  },
  {
    "value": "HTG",
    "label": "Khatanga Khatanga Airport (HTG)"
  },
  {
    "value": "KHE",
    "label": "Kherson Kherson International Airport (KHE)"
  },
  {
    "value": "PGU",
    "label": "Khiyaroo Persian Gulf International Airport (PGU)"
  },
  {
    "value": "HMJ",
    "label": "Khmelnytskyi Khmelnytskyi Airport (HMJ)"
  },
  {
    "value": "KKC",
    "label": "Khon Kaen Khon Kaen Airport (KKC)"
  },
  {
    "value": "MQJ",
    "label": "Khonuu Moma Airport (MQJ)"
  },
  {
    "value": "KHT",
    "label": "Khost Khost International Airport (KHT)"
  },
  {
    "value": "HVD",
    "label": "Khovd Khovd Airport (HVD)"
  },
  {
    "value": "LBD",
    "label": "Khujand Khujand Airport (LBD)"
  },
  {
    "value": "KDH",
    "label": "Khvoshab Ahmad Shah Baba International Airport / Kandahar Airfield (KDH)"
  },
  {
    "value": "IAN",
    "label": "Kiana Bob Baker Memorial Airport (IAN)"
  },
  {
    "value": "OXF",
    "label": "Kidlington, Oxfordshire Oxford (Kidlington) Airport (OXF)"
  },
  {
    "value": "KEL",
    "label": "Kiel Kiel-Holtenau Airport (KEL)"
  },
  {
    "value": "KGL",
    "label": "Kigali Kigali International Airport (KGL)"
  },
  {
    "value": "KKX",
    "label": "Kikai Kikai Airport (KKX)"
  },
  {
    "value": "KKW",
    "label": "Kikwit Kikwit Airport (KKW)"
  },
  {
    "value": "KIR",
    "label": "Killarney Kerry Airport (KIR)"
  },
  {
    "value": "HKN",
    "label": "Kimbe Hoskins Airport (HKN)"
  },
  {
    "value": "KIM",
    "label": "Kimberley Kimberley Airport (KIM)"
  },
  {
    "value": "YKD",
    "label": "Kincardine Kincardine Municipal Airport (YKD)"
  },
  {
    "value": "CIU",
    "label": "Kincheloe Chippewa County International Airport (CIU)"
  },
  {
    "value": "YKY",
    "label": "Kindersley Kindersley Airport (YKY)"
  },
  {
    "value": "KND",
    "label": "Kindu Kindu Airport (KND)"
  },
  {
    "value": "KMC",
    "label": "King Khaled Military City King Khaled Military City Airport (KMC)"
  },
  {
    "value": "AKN",
    "label": "King Salmon King Salmon Airport (AKN)"
  },
  {
    "value": "KNF",
    "label": "King's Lynn, Norfolk RAF Marham (KNF)"
  },
  {
    "value": "IGM",
    "label": "Kingman Kingman Airport (IGM)"
  },
  {
    "value": "IMT",
    "label": "Kingsford Ford Airport (IMT)"
  },
  {
    "value": "YGK",
    "label": "Kingston Kingston Norman Rogers Airport (YGK)"
  },
  {
    "value": "KIN",
    "label": "Kingston Norman Manley International Airport (KIN)"
  },
  {
    "value": "SVD",
    "label": "Kingstown Argyle International Airport (SVD)"
  },
  {
    "value": "NQI",
    "label": "Kingsville Kingsville Naval Air Station (NQI)"
  },
  {
    "value": "FIH",
    "label": "Kinshasa Ndjili International Airport (FIH)"
  },
  {
    "value": "ISO",
    "label": "Kinston Kinston Regional Jetport At Stallings Field (ISO)"
  },
  {
    "value": "CXI",
    "label": "Kiritimati Cassidy International Airport (CXI)"
  },
  {
    "value": "KKN",
    "label": "Kirkenes Kirkenes Airport, Høybuktmoen (KKN)"
  },
  {
    "value": "YKX",
    "label": "Kirkland Lake Kirkland Lake Airport (YKX)"
  },
  {
    "value": "IRK",
    "label": "Kirksville Kirksville Regional Airport (IRK)"
  },
  {
    "value": "KIK",
    "label": "Kirkuk Kirkuk Air Base (KIK)"
  },
  {
    "value": "KVX",
    "label": "Kirov Pobedilovo Airport (KVX)"
  },
  {
    "value": "KRN",
    "label": "Kiruna Kiruna Airport (KRN)"
  },
  {
    "value": "FKI",
    "label": "Kisangani Bangoka International Airport (FKI)"
  },
  {
    "value": "KIH",
    "label": "Kish Island Kish International Airport (KIH)"
  },
  {
    "value": "KMU",
    "label": "Kismayo Kismayo Airport (KMU)"
  },
  {
    "value": "KIS",
    "label": "Kisumu Kisumu Airport (KIS)"
  },
  {
    "value": "ONJ",
    "label": "Kitaakita Odate Noshiro Airport (ONJ)"
  },
  {
    "value": "KTD",
    "label": "Kitadaitōjima Kitadaito Airport (KTD)"
  },
  {
    "value": "KKJ",
    "label": "Kitakyushu Kitakyushu Airport (KKJ)"
  },
  {
    "value": "KTL",
    "label": "Kitale Kitale Airport (KTL)"
  },
  {
    "value": "KTQ",
    "label": "Kitee Kitee Airport (KTQ)"
  },
  {
    "value": "KTT",
    "label": "Kittilä Kittilä Airport (KTT)"
  },
  {
    "value": "KIW",
    "label": "Kitwe Southdowns Airport (KIW)"
  },
  {
    "value": "KWY",
    "label": "Kiwayu Kiwayu Airport (KWY)"
  },
  {
    "value": "KRS",
    "label": "Kjevik Kristiansand Airport, Kjevik (KRS)"
  },
  {
    "value": "KLU",
    "label": "Klagenfurt am Wörthersee Klagenfurt Airport (KLU)"
  },
  {
    "value": "LMT",
    "label": "Klamath Falls Crater Lake-Klamath Regional Airport (LMT)"
  },
  {
    "value": "KLW",
    "label": "Klawock Klawock Airport (KLW)"
  },
  {
    "value": "KLZ",
    "label": "Kleinsee Kleinsee Airport (KLZ)"
  },
  {
    "value": "KXE",
    "label": "Klerksdorp P C Pelser Airport (KXE)"
  },
  {
    "value": "OSI",
    "label": "Klisa Osijek Airport (OSI)"
  },
  {
    "value": "SZL",
    "label": "Knob Noster Whiteman Air Force Base (SZL)"
  },
  {
    "value": "UKB",
    "label": "Kobe Kobe Airport (UKB)"
  },
  {
    "value": "COK",
    "label": "Kochi Cochin International Airport (COK)"
  },
  {
    "value": "ADQ",
    "label": "Kodiak Kodiak Airport (ADQ)"
  },
  {
    "value": "KGP",
    "label": "Kogalym Kogalym International Airport (KGP)"
  },
  {
    "value": "KOK",
    "label": "Kokkola / Kruunupyy Kokkola-Pietarsaari Airport (KOK)"
  },
  {
    "value": "RAB",
    "label": "Kokopo Tokua Airport (RAB)"
  },
  {
    "value": "KOV",
    "label": "Kokshetau Kokshetau Airport (KOV)"
  },
  {
    "value": "KXB",
    "label": "Kolaka Sangia Nibandera Airport (KXB)"
  },
  {
    "value": "KLH",
    "label": "Kolhapur Kolhapur Airport (KLH)"
  },
  {
    "value": "CCU",
    "label": "Kolkata Netaji Subhash Chandra Bose International Airport (CCU)"
  },
  {
    "value": "CGN",
    "label": "Köln (Cologne) Cologne Bonn Airport (CGN)"
  },
  {
    "value": "KWZ",
    "label": "Kolwezi Kolwezi Airport (KWZ)"
  },
  {
    "value": "KXK",
    "label": "Komsomolsk-on-Amur Komsomolsk-on-Amur Airport (KXK)"
  },
  {
    "value": "ZBR",
    "label": "Konarak Chabahar Konarak International Airport (ZBR)"
  },
  {
    "value": "KNQ",
    "label": "Koné Koné Airport (KNQ)"
  },
  {
    "value": "KYA",
    "label": "Konya Konya Airport (KYA)"
  },
  {
    "value": "KUT",
    "label": "Kopitnari David the Builder Kutaisi International Airport (KUT)"
  },
  {
    "value": "HGO",
    "label": "Korhogo Korhogo Airport (HGO)"
  },
  {
    "value": "KRL",
    "label": "Korla Korla Licheng Airport (KRL)"
  },
  {
    "value": "KGS",
    "label": "Kos Island Kos Airport (KGS)"
  },
  {
    "value": "KSC",
    "label": "Košice Košice International Airport (KSC)"
  },
  {
    "value": "KSN",
    "label": "Kostanay Kostanay West Airport (KSN)"
  },
  {
    "value": "KMW",
    "label": "Kostroma Kostroma Sokerkino Airport (KMW)"
  },
  {
    "value": "KBR",
    "label": "Kota Baharu Sultan Ismail Petra Airport (KBR)"
  },
  {
    "value": "BKI",
    "label": "Kota Kinabalu Kota Kinabalu International Airport (BKI)"
  },
  {
    "value": "KTU",
    "label": "Kota Kota Airport (KTU)"
  },
  {
    "value": "KSZ",
    "label": "Kotlas Kotlas Airport (KSZ)"
  },
  {
    "value": "OTZ",
    "label": "Kotzebue Ralph Wien Memorial Airport (OTZ)"
  },
  {
    "value": "KOU",
    "label": "Koulamoutou Koulamoutou Mabimbi Airport (KOU)"
  },
  {
    "value": "KWM",
    "label": "Kowanyama Kowanyama Airport (KWM)"
  },
  {
    "value": "KZI",
    "label": "Kozani Kozani National Airport Filippos (KZI)"
  },
  {
    "value": "KBV",
    "label": "Krabi Krabi Airport (KBV)"
  },
  {
    "value": "BON",
    "label": "Kralendijk Flamingo International Airport (BON)"
  },
  {
    "value": "KVO",
    "label": "Kraljevo Morava Airport (KVO)"
  },
  {
    "value": "KRR",
    "label": "Krasnodar Krasnodar Pashkovsky International Airport (KRR)"
  },
  {
    "value": "KCY",
    "label": "Krasnoyarsk Krasnoyarsk Cheremshanka Airport (KCY)"
  },
  {
    "value": "KJA",
    "label": "Krasnoyarsk Krasnoyarsk International Airport (KJA)"
  },
  {
    "value": "AAQ",
    "label": "Krasnyi Kurgan Anapa Vityazevo Airport (AAQ)"
  },
  {
    "value": "KID",
    "label": "Kristianstad Kristianstad Airport (KID)"
  },
  {
    "value": "NOI",
    "label": "Krymsk Krymsk Air Base (NOI)"
  },
  {
    "value": "KWG",
    "label": "Kryvyi Rih Kryvyi Rih International Airport (KWG)"
  },
  {
    "value": "MEQ",
    "label": "Kuala Pesisir Cut Nyak Dhien Airport (MEQ)"
  },
  {
    "value": "TGG",
    "label": "Kuala Terengganu Sultan Mahmud Airport (TGG)"
  },
  {
    "value": "KUA",
    "label": "Kuantan Kuantan Airport (KUA)"
  },
  {
    "value": "KCH",
    "label": "Kuching Kuching International Airport (KCH)"
  },
  {
    "value": "AKF",
    "label": "Kufra Kufra Airport (AKF)"
  },
  {
    "value": "SVP",
    "label": "Kuito Kuito Airport (SVP)"
  },
  {
    "value": "KFZ",
    "label": "Kukës Kukës International Airport (KFZ)"
  },
  {
    "value": "KUS",
    "label": "Kulusuk Kulusuk Airport (KUS)"
  },
  {
    "value": "TJU",
    "label": "Kulyab Kulob Airport (TJU)"
  },
  {
    "value": "KMJ",
    "label": "Kumamoto Kumamoto Airport (KMJ)"
  },
  {
    "value": "KMS",
    "label": "Kumasi Kumasi Airport (KMS)"
  },
  {
    "value": "UEO",
    "label": "Kumejima Kumejima Airport (UEO)"
  },
  {
    "value": "CMU",
    "label": "Kundiawa Chimbu Airport (CMU)"
  },
  {
    "value": "UND",
    "label": "Kunduz Kunduz Airport (UND)"
  },
  {
    "value": "KMG",
    "label": "Kunming Kunming Changshui International Airport (KMG)"
  },
  {
    "value": "KNX",
    "label": "Kununurra East Kimberley Regional (Kununurra) Airport (KNX)"
  },
  {
    "value": "KUO",
    "label": "Kuopio / Siilinjärvi Kuopio Airport (KUO)"
  },
  {
    "value": "URE",
    "label": "Kuressaare Kuressaare Airport (URE)"
  },
  {
    "value": "KRO",
    "label": "Kurgan Kurgan Airport (KRO)"
  },
  {
    "value": "KQT",
    "label": "Kurgan-Tyube Qurghonteppa International Airport (KQT)"
  },
  {
    "value": "URS",
    "label": "Kursk Kursk East Airport (URS)"
  },
  {
    "value": "KMH",
    "label": "Kuruman Johan Pienaar Airport (KMH)"
  },
  {
    "value": "KBK",
    "label": "Kushinagar Kushinagar International Airport (KBK)"
  },
  {
    "value": "KUH",
    "label": "Kushiro Kushiro Airport (KUH)"
  },
  {
    "value": "DPS",
    "label": "Kuta, Badung Denpasar I Gusti Ngurah Rai International Airport (DPS)"
  },
  {
    "value": "LSR",
    "label": "Kutacane Alas Leuser Airport (LSR)"
  },
  {
    "value": "YVP",
    "label": "Kuujjuaq Kuujjuaq Airport (YVP)"
  },
  {
    "value": "YGW",
    "label": "Kuujjuarapik Kuujjuarapik Airport (YGW)"
  },
  {
    "value": "KAO",
    "label": "Kuusamo Kuusamo Airport (KAO)"
  },
  {
    "value": "KWI",
    "label": "Kuwait City Kuwait International Airport (KWI)"
  },
  {
    "value": "KSU",
    "label": "Kvernberget Kristiansund Airport, Kvernberget (KSU)"
  },
  {
    "value": "KWA",
    "label": "Kwajalein Bucholz Army Air Field (KWA)"
  },
  {
    "value": "KYP",
    "label": "Kyaukpyu Kyaukpyu Airport (KYP)"
  },
  {
    "value": "IEV",
    "label": "Kyiv Ihor Sikorsky Kyiv International Airport (Zhuliany) (IEV)"
  },
  {
    "value": "KYZ",
    "label": "Kyzyl Kyzyl Airport (KYZ)"
  },
  {
    "value": "SYT",
    "label": "L'Hôpital-le-Mercier, Saône-et-Loire Saint-Yan Airport (SYT)"
  },
  {
    "value": "YBG",
    "label": "La Baie CFB Bagotville / Saguenay-Bagotville Airport (YBG)"
  },
  {
    "value": "LBY",
    "label": "La Baule-Escoublac La Baule-Escoublac Airport (LBY)"
  },
  {
    "value": "LCE",
    "label": "La Ceiba Goloson International Airport (LCE)"
  },
  {
    "value": "LSE",
    "label": "La Crosse La Crosse Regional Airport (LSE)"
  },
  {
    "value": "PAL",
    "label": "La Dorada German Olano Air Base (PAL)"
  },
  {
    "value": "YGL",
    "label": "La Grande Rivière La Grande Rivière Airport (YGL)"
  },
  {
    "value": "YAH",
    "label": "La Grande-4 La Grande-4 Airport (YAH)"
  },
  {
    "value": "JBQ",
    "label": "La Isabela La Isabela International Airport (JBQ)"
  },
  {
    "value": "YTM",
    "label": "La Macaza Mont-Tremblant International Airport (YTM)"
  },
  {
    "value": "MCJ",
    "label": "La Mina-Maicao Jorge Isaac Airport (MCJ)"
  },
  {
    "value": "LPB",
    "label": "La Paz / El Alto El Alto International Airport (LPB)"
  },
  {
    "value": "LAP",
    "label": "La Paz Manuel Márquez de León International Airport (LAP)"
  },
  {
    "value": "LPG",
    "label": "La Plata La Plata Airport (LPG)"
  },
  {
    "value": "IRJ",
    "label": "La Rioja Capitan V A Almonacid Airport (IRJ)"
  },
  {
    "value": "EDM",
    "label": "La Roche-sur-Yon/Les Ajoncs La Roche-sur-Yon Airport (EDM)"
  },
  {
    "value": "LRH",
    "label": "La Rochelle/Île de Ré La Rochelle-Île de Ré Airport (LRH)"
  },
  {
    "value": "LRM",
    "label": "La Romana Casa De Campo International Airport (LRM)"
  },
  {
    "value": "YVC",
    "label": "La Ronge La Ronge Airport (YVC)"
  },
  {
    "value": "LSC",
    "label": "La Serena-Coquimbo La Florida Airport (LSC)"
  },
  {
    "value": "RLG",
    "label": "Laage Rostock-Laage Airport (RLG)"
  },
  {
    "value": "LBS",
    "label": "Labasa Labasa Airport (LBS)"
  },
  {
    "value": "LBU",
    "label": "Labuan Labuan Airport (LBU)"
  },
  {
    "value": "WGT",
    "label": "Laceby Wangaratta Airport (WGT)"
  },
  {
    "value": "LAY",
    "label": "Ladysmith Ladysmith Airport (LAY)"
  },
  {
    "value": "LAE",
    "label": "Lae Nadzab Airport (LAE)"
  },
  {
    "value": "TDX",
    "label": "Laem Ngop Trat Airport (TDX)"
  },
  {
    "value": "LFT",
    "label": "Lafayette Lafayette Regional Airport (LFT)"
  },
  {
    "value": "LAJ",
    "label": "Lages Lages Airport (LAJ)"
  },
  {
    "value": "LOO",
    "label": "Laghouat Laghouat - Molay Ahmed Medeghri Airport (LOO)"
  },
  {
    "value": "LOS",
    "label": "Lagos Murtala Muhammed International Airport (LOS)"
  },
  {
    "value": "CGY",
    "label": "Laguindingan Laguindingan International Airport (CGY)"
  },
  {
    "value": "LDU",
    "label": "Lahad Datu Lahad Datu Airport (LDU)"
  },
  {
    "value": "JHM",
    "label": "Lahaina Kapalua Airport (JHM)"
  },
  {
    "value": "LHE",
    "label": "Lahore Allama Iqbal International Airport (LHE)"
  },
  {
    "value": "LHA",
    "label": "Lahr/Schwarzwald Lahr Airport (LHA)"
  },
  {
    "value": "LCH",
    "label": "Lake Charles Lake Charles Regional Airport (LCH)"
  },
  {
    "value": "HII",
    "label": "Lake Havasu City Lake Havasu City International Airport (HII)"
  },
  {
    "value": "LKY",
    "label": "Lake Manyara National Park Lake Manyara Airport (LKY)"
  },
  {
    "value": "NEL",
    "label": "Lakehurst Lakehurst Maxfield Field Airport (NEL)"
  },
  {
    "value": "LAL",
    "label": "Lakeland Lakeland Linder International Airport (LAL)"
  },
  {
    "value": "LKL",
    "label": "Lakselv Lakselv Airport, Banak (LKL)"
  },
  {
    "value": "LLC",
    "label": "Lal-lo Cagayan North International Airport (LLC)"
  },
  {
    "value": "LAA",
    "label": "Lamar Southeast Colorado Regional Airport (LAA)"
  },
  {
    "value": "LBQ",
    "label": "Lambarene Lambarene Airport (LBQ)"
  },
  {
    "value": "LFM",
    "label": "Lamerd Lamerd Airport (LFM)"
  },
  {
    "value": "SUF",
    "label": "Lamezia Terme (CZ) Lamezia Terme Sant'Eufemia International Airport (SUF)"
  },
  {
    "value": "LMP",
    "label": "Lampedusa Lampedusa Airport (LMP)"
  },
  {
    "value": "LAU",
    "label": "Lamu Manda Airport (LAU)"
  },
  {
    "value": "LNY",
    "label": "Lanai City Lanai Airport (LNY)"
  },
  {
    "value": "OBS",
    "label": "Lanas, Ardèche Aubenas-South Ardèche Airport (OBS)"
  },
  {
    "value": "WJF",
    "label": "Lancaster General William J Fox Airfield (WJF)"
  },
  {
    "value": "LNS",
    "label": "Lancaster Lancaster Airport (LNS)"
  },
  {
    "value": "BDJ",
    "label": "Landasan Ulin Syamsudin Noor International Airport (BDJ)"
  },
  {
    "value": "LND",
    "label": "Lander Hunt Field (LND)"
  },
  {
    "value": "LDV",
    "label": "Landivisiau Landivisiau Air Base (LDV)"
  },
  {
    "value": "SDB",
    "label": "Langebaanweg Langebaanweg Airport (SDB)"
  },
  {
    "value": "LUV",
    "label": "Langgur Karel Sadsuitubun Airport (LUV)"
  },
  {
    "value": "LGK",
    "label": "Langkawi Langkawi International Airport (LGK)"
  },
  {
    "value": "YLY",
    "label": "Langley Langley Airport (YLY)"
  },
  {
    "value": "LAI",
    "label": "Lannion Lannion-Côte de Granit Airport (LAI)"
  },
  {
    "value": "LAN",
    "label": "Lansing Capital City Airport (LAN)"
  },
  {
    "value": "LHW",
    "label": "Lanzhou (Yongdeng) Lanzhou Zhongchuan International Airport (LHW)"
  },
  {
    "value": "LAO",
    "label": "Laoag City Laoag International Airport (LAO)"
  },
  {
    "value": "LPP",
    "label": "Lappeenranta Lappeenranta Airport (LPP)"
  },
  {
    "value": "CEB",
    "label": "Lapu-Lapu City Mactan Cebu International Airport (CEB)"
  },
  {
    "value": "LRR",
    "label": "Lar Lar Airport (LRR)"
  },
  {
    "value": "AVV",
    "label": "Lara Avalon Airport (AVV)"
  },
  {
    "value": "LAR",
    "label": "Laramie Laramie Regional Airport (LAR)"
  },
  {
    "value": "LRD",
    "label": "Laredo Laredo International Airport (LRD)"
  },
  {
    "value": "LCA",
    "label": "Larnaca Larnaca International Airport (LCA)"
  },
  {
    "value": "LRU",
    "label": "Las Cruces Las Cruces International Airport (LRU)"
  },
  {
    "value": "LHS",
    "label": "Las Heras Las Heras Airport (LHS)"
  },
  {
    "value": "VTU",
    "label": "Las Tunas Hermanos Ameijeiras Airport (VTU)"
  },
  {
    "value": "LAS",
    "label": "Las Vegas Harry Reid International Airport (LAS)"
  },
  {
    "value": "LVS",
    "label": "Las Vegas Las Vegas Municipal Airport (LVS)"
  },
  {
    "value": "LSV",
    "label": "Las Vegas Nellis Air Force Base (LSV)"
  },
  {
    "value": "VGT",
    "label": "Las Vegas North Las Vegas Metropolitan International Airport (VGT)"
  },
  {
    "value": "LSH",
    "label": "Lashio Lashio Airport (LSH)"
  },
  {
    "value": "LTX",
    "label": "Latacunga Cotopaxi International Airport (LTX)"
  },
  {
    "value": "LTK",
    "label": "Latakia Hmeimim Air Base (LTK)"
  },
  {
    "value": "LBE",
    "label": "Latrobe Arnold Palmer Regional Airport (LBE)"
  },
  {
    "value": "LTU",
    "label": "Latur Murod Kond Airport (LTU)"
  },
  {
    "value": "LST",
    "label": "Launceston (Western Junction) Launceston Airport (LST)"
  },
  {
    "value": "LVA",
    "label": "Laval, Mayenne Laval-Entrammes Airport (LVA)"
  },
  {
    "value": "LVP",
    "label": "Lavan Airport Lavan Airport (LVP)"
  },
  {
    "value": "LWM",
    "label": "Lawrence Lawrence Municipal Airport (LWM)"
  },
  {
    "value": "LAW",
    "label": "Lawton Lawton Fort Sill Regional Airport (LAW)"
  },
  {
    "value": "LZC",
    "label": "Lázaro Cárdenas Lázaro Cárdenas Airport (LZC)"
  },
  {
    "value": "CTT",
    "label": "Le Castellet, Var Le Castellet Airport (CTT)"
  },
  {
    "value": "LEH",
    "label": "Le Havre Le Havre-Octeville Airport (LEH)"
  },
  {
    "value": "LME",
    "label": "Le Mans, Sarthe Le Mans-Arnage Airport (LME)"
  },
  {
    "value": "LTQ",
    "label": "Le Touquet-Paris-Plage Le Touquet-Côte d'Opale Airport (LTQ)"
  },
  {
    "value": "YLR",
    "label": "Leaf Rapids Leaf Rapids Airport (YLR)"
  },
  {
    "value": "LEB",
    "label": "Lebanon Lebanon Municipal Airport (LEB)"
  },
  {
    "value": "LBA",
    "label": "Leeds, West Yorkshire Leeds Bradford Airport (LBA)"
  },
  {
    "value": "LEE",
    "label": "Leesburg Leesburg International Airport (LEE)"
  },
  {
    "value": "LWR",
    "label": "Leeuwarden Leeuwarden Air Base (LWR)"
  },
  {
    "value": "GEC",
    "label": "Lefkoniko (Geçitkale) Lefkoniko Airport / Geçitkale Air Base (GEC)"
  },
  {
    "value": "DRP",
    "label": "Legazpi Bicol International Airport (DRP)"
  },
  {
    "value": "IXL",
    "label": "Leh Leh Kushok Bakula Rimpochee Airport (IXL)"
  },
  {
    "value": "SRP",
    "label": "Leirvik Stord Airport, Sørstokken (SRP)"
  },
  {
    "value": "LKN",
    "label": "Leknes Leknes Airport (LKN)"
  },
  {
    "value": "LEY",
    "label": "Lelystad Lelystad Airport (LEY)"
  },
  {
    "value": "NLC",
    "label": "Lemoore Lemoore Naval Air Station (Reeves Field) Airport (NLC)"
  },
  {
    "value": "ULK",
    "label": "Lensk Lensk Airport (ULK)"
  },
  {
    "value": "LEN",
    "label": "León León Airport (LEN)"
  },
  {
    "value": "LNO",
    "label": "Leonora Leonora Airport (LNO)"
  },
  {
    "value": "MCU",
    "label": "Lépaud, Creuse Montluçon-Guéret Airport (MCU)"
  },
  {
    "value": "LSI",
    "label": "Lerwick Sumburgh Airport (LSI)"
  },
  {
    "value": "CYA",
    "label": "Les Cayes Les Cayes Airport (CYA)"
  },
  {
    "value": "YGR",
    "label": "Les Îles-de-la-Madeleine Îles-de-la-Madeleine Airport (YGR)"
  },
  {
    "value": "LIL",
    "label": "Lesquin Lille Airport (LIL)"
  },
  {
    "value": "YQL",
    "label": "Lethbridge Lethbridge County Airport (YQL)"
  },
  {
    "value": "LTM",
    "label": "Lethem Lethem Airport (LTM)"
  },
  {
    "value": "LET",
    "label": "Leticia Alfredo Vásquez Cobo International Airport (LET)"
  },
  {
    "value": "ADX",
    "label": "Leuchars, Fife Leuchars Station Airfield (ADX)"
  },
  {
    "value": "CUF",
    "label": "Levaldigi (CN) Cuneo International Airport (CUF)"
  },
  {
    "value": "LWB",
    "label": "Lewisburg Greenbrier Valley Airport (LWB)"
  },
  {
    "value": "LWS",
    "label": "Lewiston Lewiston Nez Perce County Airport (LWS)"
  },
  {
    "value": "LWT",
    "label": "Lewistown Lewistown Municipal Airport (LWT)"
  },
  {
    "value": "LEX",
    "label": "Lexington Blue Grass Airport (LEX)"
  },
  {
    "value": "LSX",
    "label": "Lhok Sukon-Sumatra Island Lhok Sukon Airport (LSX)"
  },
  {
    "value": "XIC",
    "label": "Liangshan (Xichang) Xichang Qingshan Airport (XIC)"
  },
  {
    "value": "LYG",
    "label": "Lianyungang Lianyungang Huaguoshan International Airport (LYG)"
  },
  {
    "value": "LBL",
    "label": "Liberal Liberal Mid-America Regional Airport (LBL)"
  },
  {
    "value": "LIR",
    "label": "Liberia Guanacaste Airport (LIR)"
  },
  {
    "value": "LBV",
    "label": "Libreville Libreville Leon M'ba International Airport (LBV)"
  },
  {
    "value": "VXC",
    "label": "Lichinga Lichinga Airport (VXC)"
  },
  {
    "value": "LPX",
    "label": "Liepāja Liepāja International Airport (LPX)"
  },
  {
    "value": "LIF",
    "label": "Lifou Lifou Airport (LIF)"
  },
  {
    "value": "HPA",
    "label": "Lifuka Lifuka Island Airport (HPA)"
  },
  {
    "value": "LIH",
    "label": "Lihue Lihue Airport (LIH)"
  },
  {
    "value": "LJG",
    "label": "Lijiang (Gucheng) Lijiang Sanyi International Airport (LJG)"
  },
  {
    "value": "IXI",
    "label": "Lilabari Lilabari North Lakhimpur Airport (IXI)"
  },
  {
    "value": "LIM",
    "label": "Lima Jorge Chávez International Airport (LIM)"
  },
  {
    "value": "LMN",
    "label": "Limbang Limbang Airport (LMN)"
  },
  {
    "value": "LMR",
    "label": "Lime Acres Lime Acres Finsch Mine Airport (LMR)"
  },
  {
    "value": "LIG",
    "label": "Limoges/Bellegarde Limoges Airport (LIG)"
  },
  {
    "value": "CWJ",
    "label": "Lincang (Cangyuan) Cangyuan Washan Airport (CWJ)"
  },
  {
    "value": "LNJ",
    "label": "Lincang Lincang Boshang Airport (LNJ)"
  },
  {
    "value": "LNK",
    "label": "Lincoln Lincoln Airport (LNK)"
  },
  {
    "value": "QCY",
    "label": "Lincoln, Lincolnshire RAF Coningsby (QCY)"
  },
  {
    "value": "WTN",
    "label": "Lincoln, Lincolnshire RAF Waddington (WTN)"
  },
  {
    "value": "LFQ",
    "label": "Linfen (Yaodu) Linfen Yaodu Airport (LFQ)"
  },
  {
    "value": "LHN",
    "label": "Linhares Linhares Municipal Airport (LHN)"
  },
  {
    "value": "LPI",
    "label": "Linköping Linköping City Airport (LPI)"
  },
  {
    "value": "LIP",
    "label": "Lins Lins Airport (LIP)"
  },
  {
    "value": "LYI",
    "label": "Linyi (Hedong) Linyi Qiyang Airport (LYI)"
  },
  {
    "value": "LNZ",
    "label": "Linz Linz-Hörsching Airport / Vogler Air Base (LNZ)"
  },
  {
    "value": "LPK",
    "label": "Lipetsk Lipetsk Airport (LPK)"
  },
  {
    "value": "HZH",
    "label": "Liping Liping Airport (HZH)"
  },
  {
    "value": "LIQ",
    "label": "Lisala Lisala Airport (LIQ)"
  },
  {
    "value": "LIS",
    "label": "Lisbon Humberto Delgado Airport (Lisbon Portela Airport) (LIS)"
  },
  {
    "value": "LSY",
    "label": "Lismore Lismore Airport (LSY)"
  },
  {
    "value": "LIT",
    "label": "Little Rock Bill & Hillary Clinton National Airport/Adams Field (LIT)"
  },
  {
    "value": "LPF",
    "label": "Liupanshui (Zhongshan) Liupanshui Yuezhao Airport (LPF)"
  },
  {
    "value": "LZH",
    "label": "Liuzhou (Liujiang) Liuzhou Bailian Airport / Bailian Air Base (LZH)"
  },
  {
    "value": "LPL",
    "label": "Liverpool Liverpool John Lennon Airport (LPL)"
  },
  {
    "value": "LVM",
    "label": "Livingston Mission Field (LVM)"
  },
  {
    "value": "LVI",
    "label": "Livingstone Harry Mwanga Nkumbula International Airport (LVI)"
  },
  {
    "value": "ILD",
    "label": "Lleida Lleida-Alguaire Airport (ILD)"
  },
  {
    "value": "YLL",
    "label": "Lloydminster Lloydminster Airport (YLL)"
  },
  {
    "value": "IRG",
    "label": "Lockhart River Lockhart River Airport (IRG)"
  },
  {
    "value": "LOK",
    "label": "Lodwar Lodwar Airport (LOK)"
  },
  {
    "value": "LCJ",
    "label": "Łódź Łódź Władysław Reymont Airport (LCJ)"
  },
  {
    "value": "LGU",
    "label": "Logan Logan-Cache Airport (LGU)"
  },
  {
    "value": "RJL",
    "label": "Logroño Logroño-Agoncillo Airport (RJL)"
  },
  {
    "value": "LIW",
    "label": "Loikaw Loikaw Airport (LIW)"
  },
  {
    "value": "LKG",
    "label": "Lokichoggio Lokichoggio Airport (LKG)"
  },
  {
    "value": "LFW",
    "label": "Lomé Lomé–Tokoin International Airport (LFW)"
  },
  {
    "value": "VBG",
    "label": "Lompoc Vandenberg Space Force Base (VBG)"
  },
  {
    "value": "YXU",
    "label": "London London Airport (YXU)"
  },
  {
    "value": "BQH",
    "label": "London London Biggin Hill Airport (BQH)"
  },
  {
    "value": "LCY",
    "label": "London London City Airport (LCY)"
  },
  {
    "value": "LGW",
    "label": "London London Gatwick Airport (LGW)"
  },
  {
    "value": "LHR",
    "label": "London London Heathrow Airport (LHR)"
  },
  {
    "value": "STN",
    "label": "London London Stansted Airport (STN)"
  },
  {
    "value": "LOZ",
    "label": "London London-Corbin Airport/Magee Field (LOZ)"
  },
  {
    "value": "NHT",
    "label": "London RAF Northolt (NHT)"
  },
  {
    "value": "LDB",
    "label": "Londrina Governor José Richa Airport (LDB)"
  },
  {
    "value": "LGB",
    "label": "Long Beach Long Beach Airport (Daugherty Field) (LGB)"
  },
  {
    "value": "LNL",
    "label": "Longnan (Cheng) Longnan Chengzhou Airport (LNL)"
  },
  {
    "value": "LRE",
    "label": "Longreach Longreach Airport (LRE)"
  },
  {
    "value": "GGG",
    "label": "Longview East Texas Regional Airport (GGG)"
  },
  {
    "value": "LCX",
    "label": "Longyan (Liancheng) Liancheng Guanzhishan Airport (LCX)"
  },
  {
    "value": "LYR",
    "label": "Longyearbyen Svalbard Airport, Longyear (LYR)"
  },
  {
    "value": "LTO",
    "label": "Loreto Loreto International Airport (LTO)"
  },
  {
    "value": "LRT",
    "label": "Lorient/Lann/Bihoué Lorient South Brittany (Bretagne Sud) Airport (LRT)"
  },
  {
    "value": "LAX",
    "label": "Los Angeles Los Angeles International Airport (LAX)"
  },
  {
    "value": "LSL",
    "label": "Los Chiles Los Chiles Airport (LSL)"
  },
  {
    "value": "LMM",
    "label": "Los Mochis Valle del Fuerte International Airport (LMM)"
  },
  {
    "value": "LMO",
    "label": "Lossiemouth RAF Lossiemouth (LMO)"
  },
  {
    "value": "LOU",
    "label": "Louisville Bowman Field (LOU)"
  },
  {
    "value": "SDF",
    "label": "Louisville Louisville Muhammad Ali International Airport (SDF)"
  },
  {
    "value": "FNL",
    "label": "Loveland Northern Colorado Regional Airport (FNL)"
  },
  {
    "value": "MQS",
    "label": "Lovell Mustique Airport (MQS)"
  },
  {
    "value": "LOL",
    "label": "Lovelock Derby Field (LOL)"
  },
  {
    "value": "NBJ",
    "label": "Luanda (Ícolo e Bengo) Dr. Antonio Agostinho Neto International Airport (NBJ)"
  },
  {
    "value": "LAD",
    "label": "Luanda Quatro de Fevereiro International Airport (LAD)"
  },
  {
    "value": "LPQ",
    "label": "Luang Phabang Luang Phabang International Airport (LPQ)"
  },
  {
    "value": "LBX",
    "label": "Lubang Lubang Airport (LBX)"
  },
  {
    "value": "SDD",
    "label": "Lubango Lubango Airport (SDD)"
  },
  {
    "value": "LBB",
    "label": "Lubbock Lubbock Preston Smith International Airport (LBB)"
  },
  {
    "value": "LBC",
    "label": "Lübeck Lübeck Blankensee Airport (LBC)"
  },
  {
    "value": "LUZ",
    "label": "Lublin Lublin Airport (LUZ)"
  },
  {
    "value": "FBM",
    "label": "Lubumbashi Lubumbashi International Airport (FBM)"
  },
  {
    "value": "LKO",
    "label": "Lucknow Chaudhary Charan Singh International Airport (LKO)"
  },
  {
    "value": "LUD",
    "label": "Luderitz Luderitz Airport (LUD)"
  },
  {
    "value": "LUO",
    "label": "Luena Luena Airport (LUO)"
  },
  {
    "value": "LFK",
    "label": "Lufkin Angelina County Airport (LFK)"
  },
  {
    "value": "SON",
    "label": "Luganville Santo Pekoa International Airport (SON)"
  },
  {
    "value": "LLA",
    "label": "Luleå Luleå Airport (LLA)"
  },
  {
    "value": "LLV",
    "label": "Lüliang Lüliang Dawu Airport (LLV)"
  },
  {
    "value": "LLW",
    "label": "Lumbadzi Kamuzu International Airport (LLW)"
  },
  {
    "value": "LBT",
    "label": "Lumberton Lumberton Regional Airport (LBT)"
  },
  {
    "value": "LYA",
    "label": "Luoyang (Laocheng) Luoyang Beijiao Airport (LYA)"
  },
  {
    "value": "LUN",
    "label": "Lusaka Kenneth Kaunda International Airport (LUN)"
  },
  {
    "value": "LTN",
    "label": "Luton, Bedfordshire London Luton Airport (LTN)"
  },
  {
    "value": "LUW",
    "label": "Luwok Syukuran Aminuddin Amir Airport (LUW)"
  },
  {
    "value": "LUX",
    "label": "Luxembourg Luxembourg-Findel International Airport (LUX)"
  },
  {
    "value": "LXR",
    "label": "Luxor Luxor International Airport (LXR)"
  },
  {
    "value": "LZO",
    "label": "Luzhou (Yunlong) Luzhou Yunlong Airport (LZO)"
  },
  {
    "value": "LWO",
    "label": "Lviv Lviv International Airport (LWO)"
  },
  {
    "value": "LYC",
    "label": "Lycksele Lycksele Airport (LYC)"
  },
  {
    "value": "LYH",
    "label": "Lynchburg Lynchburg Regional Airport - Preston Glenn Field (LYH)"
  },
  {
    "value": "YYL",
    "label": "Lynn Lake Lynn Lake Airport (YYL)"
  },
  {
    "value": "VAM",
    "label": "Maamigili Villa International Airport Maamigili (VAM)"
  },
  {
    "value": "MST",
    "label": "Maastricht Maastricht Aachen Airport (MST)"
  },
  {
    "value": "CRK",
    "label": "Mabalacat Clark International Airport / Clark Air Base (CRK)"
  },
  {
    "value": "MEA",
    "label": "Macaé Macaé Benedito Lacerda Airport (MEA)"
  },
  {
    "value": "MCP",
    "label": "Macapá Macapá - Alberto Alcolumbre International Airport (MCP)"
  },
  {
    "value": "MRR",
    "label": "Macará Jose Maria Velasco Ibarra Airport (MRR)"
  },
  {
    "value": "XMS",
    "label": "Macas Coronel E Carvajal Airport (XMS)"
  },
  {
    "value": "MCZ",
    "label": "Maceió Zumbi dos Palmares Airport (MCZ)"
  },
  {
    "value": "MKY",
    "label": "Mackay Mackay Airport (MKY)"
  },
  {
    "value": "MCN",
    "label": "Macon Middle Georgia Regional Airport (MCN)"
  },
  {
    "value": "MAG",
    "label": "Madang Madang Airport (MAG)"
  },
  {
    "value": "RJA",
    "label": "Madhurapudi Rajahmundry Airport (RJA)"
  },
  {
    "value": "MSN",
    "label": "Madison Dane County Regional Truax Field (MSN)"
  },
  {
    "value": "MAD",
    "label": "Madrid Adolfo Suárez Madrid–Barajas Airport (MAD)"
  },
  {
    "value": "TOJ",
    "label": "Madrid Madrid–Torrejón Airport / Torrejón Air Base (TOJ)"
  },
  {
    "value": "IXM",
    "label": "Madurai Madurai Airport (IXM)"
  },
  {
    "value": "HGN",
    "label": "Mae Hong Son Mae Hong Son Airport (HGN)"
  },
  {
    "value": "MBD",
    "label": "Mafeking Mmabatho International Airport (MBD)"
  },
  {
    "value": "GDX",
    "label": "Magadan Sokol Airport (GDX)"
  },
  {
    "value": "GYG",
    "label": "Magan Magan Airport (GYG)"
  },
  {
    "value": "MGN",
    "label": "Magangué Baracoa Airport (MGN)"
  },
  {
    "value": "MQF",
    "label": "Magnitogorsk Magnitogorsk International Airport (MQF)"
  },
  {
    "value": "MJN",
    "label": "Mahajanga Amborovy Airport (MJN)"
  },
  {
    "value": "SEZ",
    "label": "Mahe Island Seychelles International Airport (SEZ)"
  },
  {
    "value": "MAH",
    "label": "Mahón (Maó) Menorca Airport (MAH)"
  },
  {
    "value": "BNX",
    "label": "Mahovljani Banja Luka International Airport (BNX)"
  },
  {
    "value": "MRX",
    "label": "Mahshahr Mahshahr Airport (MRX)"
  },
  {
    "value": "MIU",
    "label": "Maiduguri Maiduguri International Airport (MIU)"
  },
  {
    "value": "CCS",
    "label": "Maiquetía Maiquetía Simón Bolívar International Airport (CCS)"
  },
  {
    "value": "MAJ",
    "label": "Majuro Atoll Marshall Islands International Airport (MAJ)"
  },
  {
    "value": "MKP",
    "label": "Makemo Makemo Airport (MKP)"
  },
  {
    "value": "MCX",
    "label": "Makhachkala Makhachkala Uytash International Airport (MCX)"
  },
  {
    "value": "FSZ",
    "label": "Makinohara / Shimada Mount Fuji Shizuoka Airport (FSZ)"
  },
  {
    "value": "MKU",
    "label": "Makokou Makokou Airport (MKU)"
  },
  {
    "value": "MDI",
    "label": "Makurdi Makurdi Airport (MDI)"
  },
  {
    "value": "SSG",
    "label": "Malabo Malabo Airport (SSG)"
  },
  {
    "value": "MKZ",
    "label": "Malacca Malacca International Airport (MKZ)"
  },
  {
    "value": "AGP",
    "label": "Málaga Málaga-Costa del Sol Airport (AGP)"
  },
  {
    "value": "MAK",
    "label": "Malakal Malakal Airport (MAK)"
  },
  {
    "value": "AAM",
    "label": "Malamala Malamala Airport (AAM)"
  },
  {
    "value": "MLG",
    "label": "Malang Abdul Rachman Saleh Airport (MLG)"
  },
  {
    "value": "MEG",
    "label": "Malanje Malanje Airport (MEG)"
  },
  {
    "value": "LGS",
    "label": "Malargue Comodoro D.R. Salomón Airport (LGS)"
  },
  {
    "value": "MLX",
    "label": "Malatya Malatya Erhaç Airport (MLX)"
  },
  {
    "value": "MLE",
    "label": "Malé Malé International Airport (MLE)"
  },
  {
    "value": "MYD",
    "label": "Malindi Malindi Airport (MYD)"
  },
  {
    "value": "MMX",
    "label": "Malmö Malmö Sturup Airport (MMX)"
  },
  {
    "value": "BDU",
    "label": "Målselv Bardufoss Airport (BDU)"
  },
  {
    "value": "SCR",
    "label": "Malung-Sälen Scandinavian Mountains Airport (SCR)"
  },
  {
    "value": "CGM",
    "label": "Mambajao Camiguin Airport (CGM)"
  },
  {
    "value": "MBO",
    "label": "Mamburao Mamburao Airport (MBO)"
  },
  {
    "value": "MDC",
    "label": "Manado Sam Ratulangi Airport (MDC)"
  },
  {
    "value": "MGA",
    "label": "Managua Augusto C. Sandino (Managua) International Airport (MGA)"
  },
  {
    "value": "WVK",
    "label": "Manakara Manakara Airport (WVK)"
  },
  {
    "value": "BAH",
    "label": "Manama Bahrain International Airport (BAH)"
  },
  {
    "value": "WMR",
    "label": "Mananara Nord Mananara Nord Airport (WMR)"
  },
  {
    "value": "MNJ",
    "label": "Mananjary Mananjary Airport (MNJ)"
  },
  {
    "value": "MNZ",
    "label": "Manassas Manassas Regional Airport/Harry P. Davis Field (MNZ)"
  },
  {
    "value": "MAO",
    "label": "Manaus Eduardo Gomes International Airport (MAO)"
  },
  {
    "value": "PLL",
    "label": "Manaus Ponta Pelada Airport / Manaus Air Base (PLL)"
  },
  {
    "value": "MHT",
    "label": "Manchester Manchester-Boston Regional Airport (MHT)"
  },
  {
    "value": "MAN",
    "label": "Manchester, Greater Manchester Manchester Airport (MAN)"
  },
  {
    "value": "IGS",
    "label": "Manching Ingolstadt Manching Airport (IGS)"
  },
  {
    "value": "MDL",
    "label": "Mandalay Mandalay International Airport (MDL)"
  },
  {
    "value": "IXE",
    "label": "Mangalore Mangalore International Airport (IXE)"
  },
  {
    "value": "XJM",
    "label": "Mangla Mangla Airport (XJM)"
  },
  {
    "value": "MAY",
    "label": "Mangrove Cay Clarence A. Bain Airport (MAY)"
  },
  {
    "value": "MHK",
    "label": "Manhattan Manhattan Regional Airport (MHK)"
  },
  {
    "value": "MNX",
    "label": "Manicoré Manicoré Airport (MNX)"
  },
  {
    "value": "MNL",
    "label": "Manila (Pasay) Ninoy Aquino International Airport (MNL)"
  },
  {
    "value": "MNG",
    "label": "Maningrida Maningrida Airport (MNG)"
  },
  {
    "value": "YMG",
    "label": "Manitouwadge Manitouwadge Airport (YMG)"
  },
  {
    "value": "MZL",
    "label": "Manizales La Nubia Airport (MZL)"
  },
  {
    "value": "MHG",
    "label": "Mannheim Mannheim-City Airport (MHG)"
  },
  {
    "value": "MKW",
    "label": "Manokwari Rendani Airport (MKW)"
  },
  {
    "value": "MFD",
    "label": "Mansfield Mansfield Lahm Regional Airport (MFD)"
  },
  {
    "value": "MEC",
    "label": "Manta Eloy Alfaro International Airport (MEC)"
  },
  {
    "value": "AMZ",
    "label": "Manurewa Ardmore Airport (AMZ)"
  },
  {
    "value": "MAS",
    "label": "Manus Island Momote Airport (MAS)"
  },
  {
    "value": "ZLO",
    "label": "Manzanillo Playa de Oro International Airport (ZLO)"
  },
  {
    "value": "MZO",
    "label": "Manzanillo Sierra Maestra International Airport (MZO)"
  },
  {
    "value": "NZH",
    "label": "Manzhouli Manzhouli Xijiao Airport (NZH)"
  },
  {
    "value": "MTS",
    "label": "Manzini Matsapha Airport (MTS)"
  },
  {
    "value": "MPM",
    "label": "Maputo Maputo Airport (MPM)"
  },
  {
    "value": "MDQ",
    "label": "Mar del Plata Ástor Piazzola International Airport (MDQ)"
  },
  {
    "value": "MAB",
    "label": "Marabá João Correa da Rocha Airport (MAB)"
  },
  {
    "value": "MAR",
    "label": "Maracaibo La Chinita International Airport (MAR)"
  },
  {
    "value": "MYC",
    "label": "Maracay Escuela Mariscal Sucre Airport (MYC)"
  },
  {
    "value": "MFQ",
    "label": "Maradi Maradi Airport (MFQ)"
  },
  {
    "value": "YSP",
    "label": "Marathon Marathon Airport (YSP)"
  },
  {
    "value": "MTH",
    "label": "Marathon The Florida Keys Marathon Airport (MTH)"
  },
  {
    "value": "ANE",
    "label": "Marcé, Maine-et-Loire Angers-Loire Airport (ANE)"
  },
  {
    "value": "CQF",
    "label": "Marck Calais-Dunkerque Airport (CQF)"
  },
  {
    "value": "MQM",
    "label": "Mardin Mardin Airport (MQM)"
  },
  {
    "value": "MEE",
    "label": "Maré Maré Airport (MEE)"
  },
  {
    "value": "MRG",
    "label": "Mareeba Mareeba Airport (MRG)"
  },
  {
    "value": "MGH",
    "label": "Margate Margate Airport (MGH)"
  },
  {
    "value": "MHQ",
    "label": "Mariehamn Mariehamn Airport (MHQ)"
  },
  {
    "value": "MGE",
    "label": "Marietta Dobbins Air Reserve Base (MGE)"
  },
  {
    "value": "MRS",
    "label": "Marignane, Bouches-du-Rhône Marseille Provence Airport (MRS)"
  },
  {
    "value": "DOM",
    "label": "Marigot Douglas-Charles Airport (DOM)"
  },
  {
    "value": "MII",
    "label": "Marília Frank Miloye Milenkowichi–Marília State Airport (MII)"
  },
  {
    "value": "MGF",
    "label": "Maringá Regional de Maringá - Sílvio Name Júnior Airport (MGF)"
  },
  {
    "value": "MWA",
    "label": "Marion Veterans Airport of Southern Illinois (MWA)"
  },
  {
    "value": "MQU",
    "label": "Mariquita Mariquita Airport (MQU)"
  },
  {
    "value": "ESG",
    "label": "Mariscal Estigarribia Doctor Luis Maria Argaña International Airport (ESG)"
  },
  {
    "value": "MPW",
    "label": "Mariupol Mariupol International Airport (MPW)"
  },
  {
    "value": "WMN",
    "label": "Maroantsetra Maroantsetra Airport (WMN)"
  },
  {
    "value": "MCY",
    "label": "Maroochydore Sunshine Coast Airport (MCY)"
  },
  {
    "value": "MVR",
    "label": "Maroua Salak Airport (MVR)"
  },
  {
    "value": "RAK",
    "label": "Marrakech Menara Airport (RAK)"
  },
  {
    "value": "LMQ",
    "label": "Marsa al Brega Marsa al Brega Airport (LMQ)"
  },
  {
    "value": "RMF",
    "label": "Marsa Alam Marsa Alam International Airport (RMF)"
  },
  {
    "value": "MUH",
    "label": "Marsa Matruh Marsa Matruh International Airport (MUH)"
  },
  {
    "value": "MHH",
    "label": "Marsh Harbour Leonard M Thompson International Airport (MHH)"
  },
  {
    "value": "MRB",
    "label": "Martinsburg Eastern WV Regional Airport/Shepherd Field (MRB)"
  },
  {
    "value": "MUR",
    "label": "Marudi Marudi Airport (MUR)"
  },
  {
    "value": "MYP",
    "label": "Mary Mary International Airport (MYP)"
  },
  {
    "value": "MYV",
    "label": "Marysville Yuba County Airport (MYV)"
  },
  {
    "value": "NVS",
    "label": "Marzy, Nièvre Nevers-Fourchambault Airport (NVS)"
  },
  {
    "value": "MTZ",
    "label": "Masada Bar Yehuda Airfield (MTZ)"
  },
  {
    "value": "MRE",
    "label": "Masai Mara Mara Serena Lodge Airstrip (MRE)"
  },
  {
    "value": "MBT",
    "label": "Masbate Moises R. Espinosa Airport (MBT)"
  },
  {
    "value": "MHD",
    "label": "Mashhad Mashhad International Airport (MHD)"
  },
  {
    "value": "MSH",
    "label": "Masirah RAFO Masirah (MSH)"
  },
  {
    "value": "QMJ",
    "label": "Masjed Soleyman Shahid Asiyaee Airport (QMJ)"
  },
  {
    "value": "MCW",
    "label": "Mason City Mason City Municipal Airport (MCW)"
  },
  {
    "value": "MSW",
    "label": "Massawa Massawa International Airport (MSW)"
  },
  {
    "value": "MSS",
    "label": "Massena Massena International Airport Richards Field (MSS)"
  },
  {
    "value": "ZMT",
    "label": "Masset Masset Airport (ZMT)"
  },
  {
    "value": "MRO",
    "label": "Masterton Hood Airport (MRO)"
  },
  {
    "value": "IWJ",
    "label": "Masuda Iwami Airport (IWJ)"
  },
  {
    "value": "MVZ",
    "label": "Masvingo Masvingo International Airport (MVZ)"
  },
  {
    "value": "YNM",
    "label": "Matagami Matagami Airport (YNM)"
  },
  {
    "value": "MAM",
    "label": "Matamoros General Servando Canales International Airport (MAM)"
  },
  {
    "value": "YME",
    "label": "Matane Matane Airport (YME)"
  },
  {
    "value": "VRA",
    "label": "Matanzas Juan Gualberto Gomez International Airport (VRA)"
  },
  {
    "value": "LOP",
    "label": "Mataram (Pujut, Lombok Tengah) Lombok International Airport (LOP)"
  },
  {
    "value": "MXI",
    "label": "Mati Mati National Airport (MXI)"
  },
  {
    "value": "CAY",
    "label": "Matoury Cayenne – Félix Eboué Airport (CAY)"
  },
  {
    "value": "MFK",
    "label": "Matsu (Beigan) Matsu Beigan Airport (MFK)"
  },
  {
    "value": "LZN",
    "label": "Matsu (Nangan) Matsu Nangan Airport (LZN)"
  },
  {
    "value": "MMJ",
    "label": "Matsumoto Shinshu-Matsumoto Airport (MMJ)"
  },
  {
    "value": "MYJ",
    "label": "Matsuyama Matsuyama Airport (MYJ)"
  },
  {
    "value": "HRI",
    "label": "Mattala Mattala Rajapaksa International Airport (HRI)"
  },
  {
    "value": "IGA",
    "label": "Matthew Town Inagua Airport (IGA)"
  },
  {
    "value": "MUN",
    "label": "Maturín Maturín Airport (MUN)"
  },
  {
    "value": "MUB",
    "label": "Maun Maun Airport (MUB)"
  },
  {
    "value": "MAZ",
    "label": "Mayaguez Eugenio Maria De Hostos Airport (MAZ)"
  },
  {
    "value": "MMZ",
    "label": "Maymana Maymana Zahiraddin Faryabi Airport (MMZ)"
  },
  {
    "value": "YMA",
    "label": "Mayo Mayo Airport (YMA)"
  },
  {
    "value": "MZR",
    "label": "Mazar-i-Sharif Mazar-i-Sharif International Airport (MZR)"
  },
  {
    "value": "MZT",
    "label": "Mazatlàn General Rafael Buelna International Airport (MZT)"
  },
  {
    "value": "MSU",
    "label": "Mazenod Moshoeshoe I International Airport (MSU)"
  },
  {
    "value": "MDK",
    "label": "Mbandaka Mbandaka Airport (MDK)"
  },
  {
    "value": "SSY",
    "label": "Mbanza Congo Mbanza Congo Airport (SSY)"
  },
  {
    "value": "MBI",
    "label": "Mbeya Songwe Airport (MBI)"
  },
  {
    "value": "MJM",
    "label": "Mbuji Mayi Mbuji Mayi Airport (MJM)"
  },
  {
    "value": "MLC",
    "label": "Mc Alester Mc Alester Regional Airport (MLC)"
  },
  {
    "value": "MFE",
    "label": "McAllen McAllen Miller International Airport (MFE)"
  },
  {
    "value": "MYL",
    "label": "McCall McCall Municipal Airport (MYL)"
  },
  {
    "value": "MCB",
    "label": "McComb McComb-Pike County Airport / John E Lewis Field (MCB)"
  },
  {
    "value": "MCK",
    "label": "McCook McCook Ben Nelson Regional Airport (MCK)"
  },
  {
    "value": "MCG",
    "label": "McGrath McGrath Airport (MCG)"
  },
  {
    "value": "YLJ",
    "label": "Meadow Lake Meadow Lake Airport (YLJ)"
  },
  {
    "value": "MZW",
    "label": "Mecheria Mecheria Airport (MZW)"
  },
  {
    "value": "MES",
    "label": "Medan Soewondo Air Force Base (MES)"
  },
  {
    "value": "EOH",
    "label": "Medellín Enrique Olaya Herrera Airport (EOH)"
  },
  {
    "value": "MDE",
    "label": "Medellín Jose Maria Córdova International Airport (MDE)"
  },
  {
    "value": "MFR",
    "label": "Medford Rogue Valley International Medford Airport (MFR)"
  },
  {
    "value": "YXH",
    "label": "Medicine Hat Medicine Hat Regional Airport (YXH)"
  },
  {
    "value": "MED",
    "label": "Medina Prince Mohammad Bin Abdulaziz Airport (MED)"
  },
  {
    "value": "MEH",
    "label": "Mehamn Mehamn Airport (MEH)"
  },
  {
    "value": "MQX",
    "label": "Mekele Alula Aba Nega Airport (MQX)"
  },
  {
    "value": "MEK",
    "label": "Meknes Bassatine Airport (MEK)"
  },
  {
    "value": "MYU",
    "label": "Mekoryuk Mekoryuk Airport (MYU)"
  },
  {
    "value": "MEL",
    "label": "Melbourne Melbourne Airport (MEL)"
  },
  {
    "value": "MBW",
    "label": "Melbourne Melbourne Moorabbin Airport (MBW)"
  },
  {
    "value": "MLB",
    "label": "Melbourne Melbourne Orlando International Airport (MLB)"
  },
  {
    "value": "MLN",
    "label": "Melilla Melilla Airport (MLN)"
  },
  {
    "value": "DJE",
    "label": "Mellita Djerba Zarzis International Airport (DJE)"
  },
  {
    "value": "FMM",
    "label": "Memmingen Memmingen Allgau Airport (FMM)"
  },
  {
    "value": "MEM",
    "label": "Memphis Memphis International Airport (MEM)"
  },
  {
    "value": "MEN",
    "label": "Mende/Brénoux Mende-Brenoux Airfield (MEN)"
  },
  {
    "value": "MDU",
    "label": "Mendi Mendi Airport (MDU)"
  },
  {
    "value": "MDZ",
    "label": "Mendoza El Plumerillo Airport (MDZ)"
  },
  {
    "value": "HTT",
    "label": "Mengnai Huatugou Airport (HTT)"
  },
  {
    "value": "SPP",
    "label": "Menongue Menongue Airport (SPP)"
  },
  {
    "value": "MKQ",
    "label": "Merauke Mopah International Airport (MKQ)"
  },
  {
    "value": "MER",
    "label": "Merced Castle Airport (MER)"
  },
  {
    "value": "MCE",
    "label": "Merced Merced Regional Macready Field (MCE)"
  },
  {
    "value": "DRA",
    "label": "Mercury Desert Rock Airport (DRA)"
  },
  {
    "value": "MRD",
    "label": "Mérida Alberto Carnevalli Airport (MRD)"
  },
  {
    "value": "MID",
    "label": "Mérida Manuel Crescencio Rejón International Airport (MID)"
  },
  {
    "value": "MEI",
    "label": "Meridian Key Field / Meridian Regional Airport (MEI)"
  },
  {
    "value": "MIM",
    "label": "Merimbula Merimbula Airport (MIM)"
  },
  {
    "value": "MWE",
    "label": "Merowe Merowe Airport (MWE)"
  },
  {
    "value": "HZB",
    "label": "Merville, Nord Merville-Calonne Airport (HZB)"
  },
  {
    "value": "AZA",
    "label": "Mesa Mesa Gateway Airport (AZA)"
  },
  {
    "value": "MFH",
    "label": "Mesquite Mesquite International Airport (MFH)"
  },
  {
    "value": "ANN",
    "label": "Metlakatla Annette Island Airport (ANN)"
  },
  {
    "value": "MXL",
    "label": "Mexicali General Rodolfo Sánchez Taboada International Airport (MXL)"
  },
  {
    "value": "NLU",
    "label": "Mexico City General Felipe Ángeles International Airport (NLU)"
  },
  {
    "value": "MFU",
    "label": "Mfuwe Mfuwe Airport (MFU)"
  },
  {
    "value": "TMB",
    "label": "Miami Miami Executive Airport (TMB)"
  },
  {
    "value": "MIA",
    "label": "Miami Miami International Airport (MIA)"
  },
  {
    "value": "OPF",
    "label": "Miami Miami-Opa Locka Executive Airport (OPF)"
  },
  {
    "value": "ZVA",
    "label": "Miandrivazo Miandrivazo Airport (ZVA)"
  },
  {
    "value": "MWD",
    "label": "Mianwali Mianwali Air Base (MWD)"
  },
  {
    "value": "MIG",
    "label": "Mianyang (Fucheng) Mianyang Nanjiao Airport (MIG)"
  },
  {
    "value": "MAF",
    "label": "Midland Midland International Air and Space Port (MAF)"
  },
  {
    "value": "GCJ",
    "label": "Midrand Grand Central Airport (GCJ)"
  },
  {
    "value": "CND",
    "label": "Mihail Kogălniceanu Mihail Kogălniceanu International Airport (CND)"
  },
  {
    "value": "TCE",
    "label": "Mihail Kogălniceanu Tulcea Danube Delta Airport (TCE)"
  },
  {
    "value": "MIK",
    "label": "Mikkeli Mikkeli Airport (MIK)"
  },
  {
    "value": "MQL",
    "label": "Mildura Mildura Airport (MQL)"
  },
  {
    "value": "MLS",
    "label": "Miles City Miles City Airport - Frank Wiley Field (MLS)"
  },
  {
    "value": "SNB",
    "label": "Milikapiti Snake Bay Airport (SNB)"
  },
  {
    "value": "NQA",
    "label": "Millington Millington-Memphis Airport (NQA)"
  },
  {
    "value": "MIV",
    "label": "Millville Millville Municipal Airport (MIV)"
  },
  {
    "value": "NSE",
    "label": "Milton Whiting Field Naval Air Station - North (NSE)"
  },
  {
    "value": "MKE",
    "label": "Milwaukee General Mitchell International Airport (MKE)"
  },
  {
    "value": "MQH",
    "label": "Minaçu Minaçu Airport (MQH)"
  },
  {
    "value": "MMD",
    "label": "Minamidaito Minamidaito Airport (MMD)"
  },
  {
    "value": "MRV",
    "label": "Mineralnyye Vody Mineralnyye Vody Airport (MRV)"
  },
  {
    "value": "MXJ",
    "label": "Minna Minna Airport (MXJ)"
  },
  {
    "value": "MSP",
    "label": "Minneapolis Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field (MSP)"
  },
  {
    "value": "MIB",
    "label": "Minot Minot Air Force Base (MIB)"
  },
  {
    "value": "MOT",
    "label": "Minot Minot International Airport (MOT)"
  },
  {
    "value": "MSQ",
    "label": "Minsk Minsk National Airport (MSQ)"
  },
  {
    "value": "YCH",
    "label": "Miramichi Miramichi Airport (YCH)"
  },
  {
    "value": "MYY",
    "label": "Miri Miri Airport (MYY)"
  },
  {
    "value": "MJZ",
    "label": "Mirny Mirny Airport (MJZ)"
  },
  {
    "value": "SKZ",
    "label": "Mirpur Khas Sukkur Airport (SKZ)"
  },
  {
    "value": "MSJ",
    "label": "Misawa Misawa Airport / Misawa Air Base (MSJ)"
  },
  {
    "value": "MSO",
    "label": "Missoula Missoula International Airport (MSO)"
  },
  {
    "value": "MVP",
    "label": "Mitú Fabio Alberto Leon Bentley Airport (MVP)"
  },
  {
    "value": "MYE",
    "label": "Miyakejima Miyakejima Airport (MYE)"
  },
  {
    "value": "MMY",
    "label": "Miyakojima Miyako Airport (MMY)"
  },
  {
    "value": "SHI",
    "label": "Miyakojima Shimojishima Airport (SHI)"
  },
  {
    "value": "KMI",
    "label": "Miyazaki Miyazaki Airport (KMI)"
  },
  {
    "value": "MGZ",
    "label": "Mkeik Myeik Airport (MGZ)"
  },
  {
    "value": "MZQ",
    "label": "Mkuze Mkuze Airport (MZQ)"
  },
  {
    "value": "MQN",
    "label": "Mo i Rana Mo i Rana Airport, Røssvoll (MQN)"
  },
  {
    "value": "MOA",
    "label": "Moa Orestes Acosta Airport (MOA)"
  },
  {
    "value": "CNY",
    "label": "Moab Canyonlands Regional Airport (CNY)"
  },
  {
    "value": "BFM",
    "label": "Mobile Mobile Downtown Airport (BFM)"
  },
  {
    "value": "MOB",
    "label": "Mobile Mobile Regional Airport (MOB)"
  },
  {
    "value": "MBG",
    "label": "Mobridge Mobridge Municipal Airport (MBG)"
  },
  {
    "value": "MSZ",
    "label": "Moçâmedes Welwitschia Mirabilis International Airport (MSZ)"
  },
  {
    "value": "MZB",
    "label": "Mocímboa da Praia Mocímboa da Praia Airport (MZB)"
  },
  {
    "value": "MOD",
    "label": "Modesto Modesto City Co-Harry Sham Field (MOD)"
  },
  {
    "value": "MJD",
    "label": "Moenjodaro Moenjodaro Airport (MJD)"
  },
  {
    "value": "MGQ",
    "label": "Mogadishu Aden Adde International Airport (MGQ)"
  },
  {
    "value": "MVQ",
    "label": "Mogilev Mogilev Airport (MVQ)"
  },
  {
    "value": "OHE",
    "label": "Mohe Mohe Gulian Airport (OHE)"
  },
  {
    "value": "MLI",
    "label": "Moline Quad City International Airport (MLI)"
  },
  {
    "value": "MBA",
    "label": "Mombasa Moi International Airport (MBA)"
  },
  {
    "value": "MIR",
    "label": "Monastir Monastir Habib Bourguiba International Airport (MIR)"
  },
  {
    "value": "MBE",
    "label": "Monbetsu Monbetsu Airport (MBE)"
  },
  {
    "value": "MGL",
    "label": "Mönchengladbach Mönchengladbach Airport (MGL)"
  },
  {
    "value": "LOV",
    "label": "Monclova Monclova International Airport (LOV)"
  },
  {
    "value": "YQM",
    "label": "Moncton Greater Moncton Roméo LeBlanc International Airport (YQM)"
  },
  {
    "value": "MOG",
    "label": "Mong Hsat Mong Hsat Airport (MOG)"
  },
  {
    "value": "MNR",
    "label": "Mongu Mongu Airport (MNR)"
  },
  {
    "value": "MLU",
    "label": "Monroe Monroe Regional Airport (MLU)"
  },
  {
    "value": "ROB",
    "label": "Monrovia Roberts International Airport (ROB)"
  },
  {
    "value": "MLW",
    "label": "Monrovia Spriggs Payne Airport (MLW)"
  },
  {
    "value": "YYY",
    "label": "Mont-Joli Mont Joli Airport (YYY)"
  },
  {
    "value": "MCS",
    "label": "Monte Caseros Monte Caseros Airport (MCS)"
  },
  {
    "value": "MBJ",
    "label": "Montego Bay Sangster International Airport (MBJ)"
  },
  {
    "value": "MRY",
    "label": "Monterey Monterey Peninsula Airport (MRY)"
  },
  {
    "value": "MTR",
    "label": "Montería Los Garzones Airport (MTR)"
  },
  {
    "value": "NTR",
    "label": "Monterrey Del Norte International Airport (NTR)"
  },
  {
    "value": "MTY",
    "label": "Monterrey Monterrey International Airport (MTY)"
  },
  {
    "value": "MOC",
    "label": "Montes Claros Mário Ribeiro Airport (MOC)"
  },
  {
    "value": "MXF",
    "label": "Montgomery Maxwell Air Force Base (MXF)"
  },
  {
    "value": "MGM",
    "label": "Montgomery Montgomery Regional (Dannelly Field) Airport (MGM)"
  },
  {
    "value": "VBS",
    "label": "Montichiari (BS) Brescia Gabriele d'Annunzio Airport (VBS)"
  },
  {
    "value": "MPL",
    "label": "Montpellier/Méditerranée Montpellier-Méditerranée Airport (MPL)"
  },
  {
    "value": "YUL",
    "label": "Montréal Montreal / Pierre Elliott Trudeau International Airport (YUL)"
  },
  {
    "value": "YHU",
    "label": "Montréal Montréal / Saint-Hubert Metropolitan Airport (YHU)"
  },
  {
    "value": "YMX",
    "label": "Montréal Montreal International (Mirabel) Airport (YMX)"
  },
  {
    "value": "MTJ",
    "label": "Montrose Montrose Regional Airport (MTJ)"
  },
  {
    "value": "GET",
    "label": "Moonyoonooka Geraldton Airport (GET)"
  },
  {
    "value": "MOZ",
    "label": "Moorea-Maiao Moorea Temae Airport (MOZ)"
  },
  {
    "value": "YMJ",
    "label": "Moose Jaw Moose Jaw Air Vice Marshal C. M. McEwen Airport (YMJ)"
  },
  {
    "value": "YMO",
    "label": "Moosonee Moosonee Airport (YMO)"
  },
  {
    "value": "GOX",
    "label": "Mopa Manohar International Airport (GOX)"
  },
  {
    "value": "MXX",
    "label": "Mora Mora Airport (MXX)"
  },
  {
    "value": "MZS",
    "label": "Moradabad Moradabad Airport (MZS)"
  },
  {
    "value": "MOV",
    "label": "Moranbah Moranbah Airport (MOV)"
  },
  {
    "value": "MRZ",
    "label": "Moree Moree Airport (MRZ)"
  },
  {
    "value": "MLM",
    "label": "Morelia General Francisco J. Mujica International Airport (MLM)"
  },
  {
    "value": "MGW",
    "label": "Morgantown Morgantown Municipal Airport Walter L. (Bill) Hart Field (MGW)"
  },
  {
    "value": "SCT",
    "label": "Mori Socotra International Airport (SCT)"
  },
  {
    "value": "MXN",
    "label": "Morlaix/Ploujean Morlaix-Ploujean Airport (MXN)"
  },
  {
    "value": "MXM",
    "label": "Morombe Morombe Airport (MXM)"
  },
  {
    "value": "OZP",
    "label": "Morón Moron Air Base (OZP)"
  },
  {
    "value": "MXV",
    "label": "Mörön Mörön Airport (MXV)"
  },
  {
    "value": "MOQ",
    "label": "Morondava Morondava Airport (MOQ)"
  },
  {
    "value": "HAH",
    "label": "Moroni Prince Said Ibrahim International Airport (HAH)"
  },
  {
    "value": "MMU",
    "label": "Morristown Morristown Municipal Airport (MMU)"
  },
  {
    "value": "MYA",
    "label": "Moruya Moruya Airport (MYA)"
  },
  {
    "value": "TGN",
    "label": "Morwell Latrobe Valley Airport (TGN)"
  },
  {
    "value": "CKL",
    "label": "Moscow Chkalovskiy Air Base (CKL)"
  },
  {
    "value": "DME",
    "label": "Moscow Domodedovo International Airport (DME)"
  },
  {
    "value": "OSF",
    "label": "Moscow Ostafyevo International Airport (OSF)"
  },
  {
    "value": "SVO",
    "label": "Moscow Sheremetyevo International Airport (SVO)"
  },
  {
    "value": "VKO",
    "label": "Moscow Vnukovo International Airport (VKO)"
  },
  {
    "value": "ZIA",
    "label": "Moscow Zhukovsky International Airport (ZIA)"
  },
  {
    "value": "PIB",
    "label": "Moselle Hattiesburg Laurel Regional Airport (PIB)"
  },
  {
    "value": "MWH",
    "label": "Moses Lake Grant County International Airport (MWH)"
  },
  {
    "value": "CWA",
    "label": "Mosinee Central Wisconsin Airport (CWA)"
  },
  {
    "value": "MJF",
    "label": "Mosjøen Mosjøen Airport, Kjærstad (MJF)"
  },
  {
    "value": "OSR",
    "label": "Mošnov Ostrava Leos Janáček Airport (OSR)"
  },
  {
    "value": "GGT",
    "label": "Moss Town Exuma International Airport (GGT)"
  },
  {
    "value": "MVF",
    "label": "Mossoró Dix-Sept Rosado Airport (MVF)"
  },
  {
    "value": "OMO",
    "label": "Mostar Mostar International Airport (OMO)"
  },
  {
    "value": "OSM",
    "label": "Mosul Mosul International Airport (OSM)"
  },
  {
    "value": "BOB",
    "label": "Motu Mute Bora Bora Airport (BOB)"
  },
  {
    "value": "MJL",
    "label": "Mouila Mouilla Ville Airport (MJL)"
  },
  {
    "value": "MQQ",
    "label": "Moundou Moundou Airport (MQQ)"
  },
  {
    "value": "MTC",
    "label": "Mount Clemens Selfridge Air National Guard Base Airport (MTC)"
  },
  {
    "value": "MGB",
    "label": "Mount Gambier Mount Gambier Airport (MGB)"
  },
  {
    "value": "HGU",
    "label": "Mount Hagen Mount Hagen Kagamuga Airport (HGU)"
  },
  {
    "value": "MHU",
    "label": "Mount Hotham Mount Hotham Airport (MHU)"
  },
  {
    "value": "ISA",
    "label": "Mount Isa Mount Isa Airport (ISA)"
  },
  {
    "value": "MPN",
    "label": "Mount Pleasant Mount Pleasant Airport (MPN)"
  },
  {
    "value": "MUO",
    "label": "Mountain Home Mountain Home Air Force Base (MUO)"
  },
  {
    "value": "WMH",
    "label": "Mountain Home Ozark Regional Airport (WMH)"
  },
  {
    "value": "NUQ",
    "label": "Mountain View Moffett Federal Airfield (NUQ)"
  },
  {
    "value": "MPA",
    "label": "Mpacha Katima Mulilo Airport (MPA)"
  },
  {
    "value": "SHO",
    "label": "Mpaka King Mswati III International Airport (SHO)"
  },
  {
    "value": "MQP",
    "label": "Mpumalanga Kruger Mpumalanga International Airport (MQP)"
  },
  {
    "value": "UTT",
    "label": "Mthatha K. D. Matanzima Airport (UTT)"
  },
  {
    "value": "MYW",
    "label": "Mtwara Mtwara Airport (MYW)"
  },
  {
    "value": "MWX",
    "label": "Muan (Piseo-ri) Muan International Airport (MWX)"
  },
  {
    "value": "MDG",
    "label": "Mudanjiang Mudanjiang Hailang International Airport (MDG)"
  },
  {
    "value": "DGE",
    "label": "Mudgee Mudgee Airport (DGE)"
  },
  {
    "value": "MUD",
    "label": "Mueda Mueda Airport (MUD)"
  },
  {
    "value": "MKM",
    "label": "Mukah Mukah Airport (MKM)"
  },
  {
    "value": "MUX",
    "label": "Multan Multan International Airport (MUX)"
  },
  {
    "value": "MZV",
    "label": "Mulu Mulu Airport (MZV)"
  },
  {
    "value": "BOM",
    "label": "Mumbai Chhatrapati Shivaji International Airport (BOM)"
  },
  {
    "value": "MIE",
    "label": "Muncie Delaware County Johnson Field (MIE)"
  },
  {
    "value": "MUA",
    "label": "Munda Munda Airport (MUA)"
  },
  {
    "value": "MUC",
    "label": "Munich Munich Airport (MUC)"
  },
  {
    "value": "MMK",
    "label": "Murmansk Murmansk Airport (MMK)"
  },
  {
    "value": "MDH",
    "label": "Murphysboro Southern Illinois Airport (MDH)"
  },
  {
    "value": "MSR",
    "label": "Muş Muş Airport (MSR)"
  },
  {
    "value": "MCT",
    "label": "Muscat Muscat International Airport (MCT)"
  },
  {
    "value": "MSL",
    "label": "Muscle Shoals Northwest Alabama Regional Airport (MSL)"
  },
  {
    "value": "MKG",
    "label": "Muskegon Muskegon County Airport (MKG)"
  },
  {
    "value": "MFG",
    "label": "Muzaffarabad Muzaffarabad Airport (MFG)"
  },
  {
    "value": "MZU",
    "label": "Muzaffarpur Muzaffarpur Airport (MZU)"
  },
  {
    "value": "MWZ",
    "label": "Mwanza Mwanza Airport (MWZ)"
  },
  {
    "value": "MYT",
    "label": "Myitkyina Myitkyina Airport (MYT)"
  },
  {
    "value": "JMK",
    "label": "Mykonos Mykonos Island National Airport (JMK)"
  },
  {
    "value": "MYR",
    "label": "Myrtle Beach Myrtle Beach International Airport (MYR)"
  },
  {
    "value": "MJT",
    "label": "Mytilene Mytilene International Airport (MJT)"
  },
  {
    "value": "ZZU",
    "label": "Mzuzu Mzuzu Airport (ZZU)"
  },
  {
    "value": "NDJ",
    "label": "N'Djamena N'Djamena International Airport (NDJ)"
  },
  {
    "value": "NLO",
    "label": "N'dolo Ndolo Airport (NLO)"
  },
  {
    "value": "NGE",
    "label": "N'Gaoundéré N'Gaoundéré Airport (NGE)"
  },
  {
    "value": "USM",
    "label": "Na Thon (Ko Samui Island) Samui Airport (USM)"
  },
  {
    "value": "NBX",
    "label": "Nabire Douw Aturure Airport (NBX)"
  },
  {
    "value": "NAN",
    "label": "Nadi Nadi International Airport (NAN)"
  },
  {
    "value": "NYM",
    "label": "Nadym Nadym Airport (NYM)"
  },
  {
    "value": "WNP",
    "label": "Naga Naga Airport (WNP)"
  },
  {
    "value": "NGS",
    "label": "Nagasaki Nagasaki Airport (NGS)"
  },
  {
    "value": "NKM",
    "label": "Nagoya Nagoya Airport / JASDF Komaki Air Base (NKM)"
  },
  {
    "value": "NAG",
    "label": "Nagpur Dr. Babasaheb Ambedkar International Airport (NAG)"
  },
  {
    "value": "OKA",
    "label": "Naha Naha Airport / JASDF Naha Air Base (OKA)"
  },
  {
    "value": "NBO",
    "label": "Nairobi Jomo Kenyatta International Airport (NBO)"
  },
  {
    "value": "WIL",
    "label": "Nairobi Nairobi Wilson Airport (WIL)"
  },
  {
    "value": "NJF",
    "label": "Najaf Al Najaf International Airport (NJF)"
  },
  {
    "value": "EAM",
    "label": "Najran Najran Domestic Airport (EAM)"
  },
  {
    "value": "SHB",
    "label": "Nakashibetsu Nakashibetsu Airport (SHB)"
  },
  {
    "value": "NAJ",
    "label": "Nakhchivan Nakhchivan Airport (NAJ)"
  },
  {
    "value": "KDT",
    "label": "Nakhon Pathom Kamphaeng Saen Airport (KDT)"
  },
  {
    "value": "KOP",
    "label": "Nakhon Phanom Nakhon Phanom Airport (KOP)"
  },
  {
    "value": "NST",
    "label": "Nakhon Si Thammarat Nakhon Si Thammarat Airport (NST)"
  },
  {
    "value": "YQN",
    "label": "Nakina Nakina Airport (YQN)"
  },
  {
    "value": "NAL",
    "label": "Nalchik Nalchik Airport (NAL)"
  },
  {
    "value": "NAM",
    "label": "Namniwel Namniwel Airport (NAM)"
  },
  {
    "value": "APL",
    "label": "Nampula Nampula Airport (APL)"
  },
  {
    "value": "NMS",
    "label": "Namsang Namsang Airport (NMS)"
  },
  {
    "value": "YCD",
    "label": "Nanaimo Nanaimo Airport (YCD)"
  },
  {
    "value": "KHN",
    "label": "Nanchang Nanchang Changbei International Airport (KHN)"
  },
  {
    "value": "LZG",
    "label": "Nanchong (Langzhong) Langzhong Gucheng Airport (LZG)"
  },
  {
    "value": "NDC",
    "label": "Nanded Nanded Airport (NDC)"
  },
  {
    "value": "NPO",
    "label": "Nanga Pinoh-Borneo Island Nanga Pinoh Airport (NPO)"
  },
  {
    "value": "NKG",
    "label": "Nanjing Nanjing Lukou International Airport (NKG)"
  },
  {
    "value": "KCZ",
    "label": "Nankoku Kochi Ryoma Airport (KCZ)"
  },
  {
    "value": "NNG",
    "label": "Nanning (Jiangnan) Nanning Wuxu Airport (NNG)"
  },
  {
    "value": "NTE",
    "label": "Nantes Nantes Atlantique Airport (NTE)"
  },
  {
    "value": "NTG",
    "label": "Nantong (Tongzhou) Nantong Xingdong International Airport (NTG)"
  },
  {
    "value": "ACK",
    "label": "Nantucket Nantucket Memorial Airport (ACK)"
  },
  {
    "value": "NYK",
    "label": "Nanyuki Nanyuki Airport (NYK)"
  },
  {
    "value": "NPE",
    "label": "Napier Hawke's Bay Airport (NPE)"
  },
  {
    "value": "APF",
    "label": "Naples Naples Municipal Airport (APF)"
  },
  {
    "value": "NAP",
    "label": "Napoli Naples International Airport (NAP)"
  },
  {
    "value": "NRT",
    "label": "Narita Narita International Airport (NRT)"
  },
  {
    "value": "NAA",
    "label": "Narrabri Narrabri Airport (NAA)"
  },
  {
    "value": "NRA",
    "label": "Narrandera Narrandera Airport (NRA)"
  },
  {
    "value": "UAK",
    "label": "Narsarsuaq Narsarsuaq Airport (UAK)"
  },
  {
    "value": "NNM",
    "label": "Naryan Mar Naryan Mar Airport (NNM)"
  },
  {
    "value": "BNA",
    "label": "Nashville Nashville International Airport (BNA)"
  },
  {
    "value": "ISK",
    "label": "Nasik Nashik Airport (ISK)"
  },
  {
    "value": "XNH",
    "label": "Nasiriyah Ali Air Base (XNH)"
  },
  {
    "value": "NAS",
    "label": "Nassau Lynden Pindling International Airport (NAS)"
  },
  {
    "value": "NAT",
    "label": "Natal São Gonçalo do Amarante - Governador Aluízio Alves International Airport (NAT)"
  },
  {
    "value": "YNA",
    "label": "Natashquan Natashquan Airport (YNA)"
  },
  {
    "value": "SDJ",
    "label": "Natori Sendai Airport (SDJ)"
  },
  {
    "value": "SUV",
    "label": "Nausori Nausori International Airport (SUV)"
  },
  {
    "value": "NVT",
    "label": "Navegantes Ministro Victor Konder International Airport (NVT)"
  },
  {
    "value": "NMI",
    "label": "Navi Mumbai Navi Mumbai International Airport (NMI)"
  },
  {
    "value": "NVI",
    "label": "Navoi Navoi Airport (NVI)"
  },
  {
    "value": "WNS",
    "label": "Nawabashah Shaheed Benazirabad Airport (WNS)"
  },
  {
    "value": "NZC",
    "label": "Nazca Maria Reiche Neuman Airport (NZC)"
  },
  {
    "value": "NLA",
    "label": "Ndola Simon Mwansa Kapwepwe International Airport (NLA)"
  },
  {
    "value": "IRI",
    "label": "Nduli Iringa Airport (IRI)"
  },
  {
    "value": "VOL",
    "label": "Nea Anchialos Nea Anchialos National Airport (VOL)"
  },
  {
    "value": "NEC",
    "label": "Necochea Necochea Airport (NEC)"
  },
  {
    "value": "EED",
    "label": "Needles Needles Airport (EED)"
  },
  {
    "value": "NFG",
    "label": "Nefteyugansk Nefteyugansk Airport (NFG)"
  },
  {
    "value": "GXG",
    "label": "Negage Negage Airport (GXG)"
  },
  {
    "value": "NVA",
    "label": "Neiva Benito Salas Airport (NVA)"
  },
  {
    "value": "NSN",
    "label": "Nelson Nelson Airport (NSN)"
  },
  {
    "value": "ENN",
    "label": "Nenana Nenana Municipal Airport (ENN)"
  },
  {
    "value": "KEP",
    "label": "Nepalgunj Nepalgunj Airport (KEP)"
  },
  {
    "value": "NER",
    "label": "Neryungri Chulman Airport (NER)"
  },
  {
    "value": "NQN",
    "label": "Neuquen Presidente Peron Airport (NQN)"
  },
  {
    "value": "EWB",
    "label": "New Bedford New Bedford Regional Airport (EWB)"
  },
  {
    "value": "EWN",
    "label": "New Bern Coastal Carolina Regional Airport (EWN)"
  },
  {
    "value": "CCE",
    "label": "New Cairo Capital International Airport (CCE)"
  },
  {
    "value": "DEL",
    "label": "New Delhi Indira Gandhi International Airport (DEL)"
  },
  {
    "value": "HVN",
    "label": "New Haven Tweed New Haven Airport (HVN)"
  },
  {
    "value": "ARA",
    "label": "New Iberia Acadiana Regional Airport (ARA)"
  },
  {
    "value": "NEW",
    "label": "New Orleans Lakefront Airport (NEW)"
  },
  {
    "value": "MSY",
    "label": "New Orleans Louis Armstrong New Orleans International Airport (MSY)"
  },
  {
    "value": "NBG",
    "label": "New Orleans New Orleans NAS JRB/Alvin Callender Field (NBG)"
  },
  {
    "value": "NPL",
    "label": "New Plymouth New Plymouth Airport (NPL)"
  },
  {
    "value": "RNH",
    "label": "New Richmond New Richmond Regional Airport (RNH)"
  },
  {
    "value": "JFK",
    "label": "New York John F Kennedy International Airport (JFK)"
  },
  {
    "value": "LGA",
    "label": "New York LaGuardia Airport (LGA)"
  },
  {
    "value": "EWR",
    "label": "Newark Newark Liberty International Airport (EWR)"
  },
  {
    "value": "SWF",
    "label": "Newburgh New York Stewart International Airport (SWF)"
  },
  {
    "value": "NCS",
    "label": "Newcastle Newcastle Airport (NCS)"
  },
  {
    "value": "NCL",
    "label": "Newcastle upon Tyne, Tyne and Wear Newcastle International Airport (NCL)"
  },
  {
    "value": "ZNE",
    "label": "Newman Newman Airport (ZNE)"
  },
  {
    "value": "ONP",
    "label": "Newport Newport Municipal Airport (ONP)"
  },
  {
    "value": "FAF",
    "label": "Newport News (Fort Eustis) Felker Army Air Field (FAF)"
  },
  {
    "value": "PHF",
    "label": "Newport News Newport News Williamsburg International Airport (PHF)"
  },
  {
    "value": "NQY",
    "label": "Newquay Cornwall Airport Newquay (NQY)"
  },
  {
    "value": "AHJ",
    "label": "Ngawa (Hongyuan) Hongyuan Airport (AHJ)"
  },
  {
    "value": "JZH",
    "label": "Ngawa (Songpan) Jiuzhai Huanglong Airport (JZH)"
  },
  {
    "value": "VPE",
    "label": "Ngiva Ngjiva Pereira Airport (VPE)"
  },
  {
    "value": "GOV",
    "label": "Nhulunbuy Gove Airport (GOV)"
  },
  {
    "value": "IAG",
    "label": "Niagara Falls Niagara Falls International Airport (IAG)"
  },
  {
    "value": "YCM",
    "label": "Niagara-on-the-Lake Niagara District Airport (YCM)"
  },
  {
    "value": "NIM",
    "label": "Niamey Diori Hamani International Airport (NIM)"
  },
  {
    "value": "LRL",
    "label": "Niamtougou Niamtougou International Airport (LRL)"
  },
  {
    "value": "NCE",
    "label": "Nice, Alpes-Maritimes Nice-Côte d'Azur Airport (NCE)"
  },
  {
    "value": "NOB",
    "label": "Nicoya Nosara Airport (NOB)"
  },
  {
    "value": "KIJ",
    "label": "Niigata Niigata Airport (KIJ)"
  },
  {
    "value": "NLV",
    "label": "Nikolayev Mykolaiv International Airport (NLV)"
  },
  {
    "value": "NLI",
    "label": "Nikolayevsk-na-Amure Airport Nikolayevsk-na-Amure Airport (NLI)"
  },
  {
    "value": "FNI",
    "label": "Nîmes/Garons Nîmes-Arles-Camargue Airport (FNI)"
  },
  {
    "value": "NGB",
    "label": "Ningbo Ningbo Lishe International Airport (NGB)"
  },
  {
    "value": "NLH",
    "label": "Ninglang Ninglang Luguhu Airport (NLH)"
  },
  {
    "value": "NIT",
    "label": "Niort/Souché Niort - Marais Poitevin Airport (NIT)"
  },
  {
    "value": "INI",
    "label": "Niš Niš Constantine the Great Airport (INI)"
  },
  {
    "value": "NBC",
    "label": "Nizhnekamsk Begishevo Airport (NBC)"
  },
  {
    "value": "NJC",
    "label": "Nizhnevartovsk Nizhnevartovsk Airport (NJC)"
  },
  {
    "value": "GOJ",
    "label": "Nizhny Novgorod Nizhny Novgorod / Strigino International Airport (GOJ)"
  },
  {
    "value": "AOC",
    "label": "Nobitz Leipzig–Altenburg Airport (AOC)"
  },
  {
    "value": "OLS",
    "label": "Nogales Nogales International Airport (OLS)"
  },
  {
    "value": "OME",
    "label": "Nome Nome Airport (OME)"
  },
  {
    "value": "NMF",
    "label": "Noonu Atoll Maafaru International Airport (NMF)"
  },
  {
    "value": "OFK",
    "label": "Norfolk Karl Stefan Memorial Airport (OFK)"
  },
  {
    "value": "ORF",
    "label": "Norfolk Norfolk International Airport (ORF)"
  },
  {
    "value": "NGU",
    "label": "Norfolk Norfolk Naval Station (Chambers Field) (NGU)"
  },
  {
    "value": "NSK",
    "label": "Norilsk Norilsk-Alykel Airport (NSK)"
  },
  {
    "value": "YVQ",
    "label": "Norman Wells Norman Wells Airport (YVQ)"
  },
  {
    "value": "NMC",
    "label": "Normans Cay Normans Cay Airport (NMC)"
  },
  {
    "value": "NTN",
    "label": "Normanton Normanton Airport (NTN)"
  },
  {
    "value": "NRK",
    "label": "Norrköping Norrköping Airport (NRK)"
  },
  {
    "value": "YQW",
    "label": "North Battleford North Battleford Airport (YQW)"
  },
  {
    "value": "YYB",
    "label": "North Bay North Bay Jack Garland Airport (YYB)"
  },
  {
    "value": "OTH",
    "label": "North Bend Southwest Oregon Regional Airport (OTH)"
  },
  {
    "value": "NCA",
    "label": "North Caicos North Caicos Airport (NCA)"
  },
  {
    "value": "ELH",
    "label": "North Eleuthera North Eleuthera Airport (ELH)"
  },
  {
    "value": "NCO",
    "label": "North Kingstown Quonset State Airport (NCO)"
  },
  {
    "value": "CRE",
    "label": "North Myrtle Beach Grand Strand Airport (CRE)"
  },
  {
    "value": "LBF",
    "label": "North Platte North Platte Regional Airport Lee Bird Field (LBF)"
  },
  {
    "value": "ORT",
    "label": "Northway Northway Airport (ORT)"
  },
  {
    "value": "NWI",
    "label": "Norwich, Norfolk Norwich Airport (NWI)"
  },
  {
    "value": "OWD",
    "label": "Norwood Norwood Memorial Airport (OWD)"
  },
  {
    "value": "MFM",
    "label": "Nossa Senhora do Carmo Macau International Airport (MFM)"
  },
  {
    "value": "NOS",
    "label": "Nosy Be Fascene Airport (NOS)"
  },
  {
    "value": "NTB",
    "label": "Notodden Notodden Airport (NTB)"
  },
  {
    "value": "EMA",
    "label": "Nottingham East Midlands Airport (EMA)"
  },
  {
    "value": "NQT",
    "label": "Nottingham Nottingham Airport (NQT)"
  },
  {
    "value": "NDB",
    "label": "Nouadhibou Nouadhibou International Airport (NDB)"
  },
  {
    "value": "NKC",
    "label": "Nouakchott Nouakchott–Oumtounsy International Airport (NKC)"
  },
  {
    "value": "NOU",
    "label": "Nouméa (La Tontouta) La Tontouta International Airport (NOU)"
  },
  {
    "value": "GEA",
    "label": "Nouméa Nouméa Magenta Airport (GEA)"
  },
  {
    "value": "NOZ",
    "label": "Novokuznetsk Spichenkovo Airport (NOZ)"
  },
  {
    "value": "OVB",
    "label": "Novosibirsk Novosibirsk Tolmachevo Airport (OVB)"
  },
  {
    "value": "NUX",
    "label": "Novy Urengoy Novy Urengoy Airport (NUX)"
  },
  {
    "value": "IEG",
    "label": "Nowe Kramsko Zielona Góra-Babimost Airport (IEG)"
  },
  {
    "value": "NOA",
    "label": "Nowra Hill Naval Air Station Nowra - HMAS Albatross (NOA)"
  },
  {
    "value": "NSH",
    "label": "Nowshahr Nowshahr Airport (NSH)"
  },
  {
    "value": "WMI",
    "label": "Nowy Dwór Mazowiecki Modlin Airport (WMI)"
  },
  {
    "value": "NOJ",
    "label": "Noyabrsk Noyabrsk Airport (NOJ)"
  },
  {
    "value": "GER",
    "label": "Nueva Gerona Rafael Cabrera Airport (GER)"
  },
  {
    "value": "NLD",
    "label": "Nuevo Laredo Quetzalcóatl International Airport (NLD)"
  },
  {
    "value": "NUI",
    "label": "Nuiqsut Nuiqsut Airport (NUI)"
  },
  {
    "value": "NHV",
    "label": "Nuku Hiva Nuku Hiva Airport (NHV)"
  },
  {
    "value": "TBU",
    "label": "Nuku'alofa Fua'amotu International Airport (TBU)"
  },
  {
    "value": "NCU",
    "label": "Nukus Nukus Airport (NCU)"
  },
  {
    "value": "NUE",
    "label": "Nuremberg Nuremberg Airport (NUE)"
  },
  {
    "value": "GOH",
    "label": "Nuuk Nuuk Airport (GOH)"
  },
  {
    "value": "NYA",
    "label": "Nyagan Nyagan Airport (NYA)"
  },
  {
    "value": "UYL",
    "label": "Nyala Nyala Airport (UYL)"
  },
  {
    "value": "LZY",
    "label": "Nyingchi (Mainling) Nyingchi Mainling Airport (LZY)"
  },
  {
    "value": "NYO",
    "label": "Nyköping Stockholm Skavsta Airport (NYO)"
  },
  {
    "value": "KRF",
    "label": "Nyland Kramfors-Sollefteå Höga Kusten Airport (KRF)"
  },
  {
    "value": "NUW",
    "label": "Oak Harbor Whidbey Island Naval Air Station (Ault Field) (NUW)"
  },
  {
    "value": "OAK",
    "label": "Oakland San Francisco Bay Oakland International Airport (OAK)"
  },
  {
    "value": "OAX",
    "label": "Oaxaca Xoxocotlán International Airport (OAX)"
  },
  {
    "value": "OBO",
    "label": "Obihiro Tokachi-Obihiro Airport (OBO)"
  },
  {
    "value": "OCV",
    "label": "Ocaña Aguas Claras Airport (OCV)"
  },
  {
    "value": "ODE",
    "label": "Odense Odense Hans Christian Andersen Airport (ODE)"
  },
  {
    "value": "ODS",
    "label": "Odessa Odessa International Airport (ODS)"
  },
  {
    "value": "OEC",
    "label": "Oecussi-Ambeno Rota Do Sândalo Oecusse Airport (OEC)"
  },
  {
    "value": "IWO",
    "label": "Ogasawara Ioto (Iwo Jima) Airbase (IWO)"
  },
  {
    "value": "HIF",
    "label": "Ogden Hill Air Force Base (HIF)"
  },
  {
    "value": "OGD",
    "label": "Ogden Ogden Hinckley Airport (OGD)"
  },
  {
    "value": "OGS",
    "label": "Ogdensburg Ogdensburg International Airport (OGS)"
  },
  {
    "value": "OGL",
    "label": "Ogle Eugene F. Correira International Airport (OGL)"
  },
  {
    "value": "OHD",
    "label": "Ohrid Ohrid St. Paul the Apostle Airport (OHD)"
  },
  {
    "value": "OYK",
    "label": "Oiapoque Oiapoque Airport (OYK)"
  },
  {
    "value": "OIT",
    "label": "Oita Oita Airport (OIT)"
  },
  {
    "value": "KSA",
    "label": "Okat Kosrae International Airport (KSA)"
  },
  {
    "value": "OKJ",
    "label": "Okayama Okayama Momotaro Airport (OKJ)"
  },
  {
    "value": "OHO",
    "label": "Okhotsk Okhotsk Airport (OHO)"
  },
  {
    "value": "DNA",
    "label": "Okinawa Kadena Air Base (DNA)"
  },
  {
    "value": "OKI",
    "label": "Okinoshima Oki Global Geopark Airport (OKI)"
  },
  {
    "value": "TIK",
    "label": "Oklahoma City Tinker Air Force Base (TIK)"
  },
  {
    "value": "OKC",
    "label": "Oklahoma City Will Rogers World Airport (OKC)"
  },
  {
    "value": "OKN",
    "label": "Okondja Okondja Airport (OKN)"
  },
  {
    "value": "QRW",
    "label": "Okpe Warri Airport (QRW)"
  },
  {
    "value": "OKL",
    "label": "Oksibil Oksibil Airport (OKL)"
  },
  {
    "value": "OIR",
    "label": "Okushiri Island Okushiri Airport (OIR)"
  },
  {
    "value": "OLB",
    "label": "Olbia (SS) Olbia Costa Smeralda Airport (OLB)"
  },
  {
    "value": "SFS",
    "label": "Olongapo Subic Bay International Airport / Naval Air Station Cubi Point (SFS)"
  },
  {
    "value": "OLM",
    "label": "Olympia Olympia Regional Airport (OLM)"
  },
  {
    "value": "OLZ",
    "label": "Olyokminsk Olyokminsk Airport (OLZ)"
  },
  {
    "value": "OMA",
    "label": "Omaha Eppley Airfield (OMA)"
  },
  {
    "value": "OFF",
    "label": "Omaha Offutt Air Force Base (OFF)"
  },
  {
    "value": "OMB",
    "label": "Omboue Omboue Hospital Airport (OMB)"
  },
  {
    "value": "RJK",
    "label": "Omišalj Rijeka Airport (RJK)"
  },
  {
    "value": "IBR",
    "label": "Omitama Ibaraki Airport / JASDF Hyakuri Air Base (IBR)"
  },
  {
    "value": "OMS",
    "label": "Omsk Omsk Central Airport (OMS)"
  },
  {
    "value": "OND",
    "label": "Ondangwa Ondangwa Airport (OND)"
  },
  {
    "value": "ONT",
    "label": "Ontario Ontario International Airport (ONT)"
  },
  {
    "value": "OST",
    "label": "Oostende Oostende-Brugge International Airport (OST)"
  },
  {
    "value": "OMR",
    "label": "Oradea Oradea International Airport (OMR)"
  },
  {
    "value": "ORA",
    "label": "Orán Orán Airport (ORA)"
  },
  {
    "value": "OAG",
    "label": "Orange Orange Airport (OAG)"
  },
  {
    "value": "OGB",
    "label": "Orangeburg Orangeburg Municipal Airport (OGB)"
  },
  {
    "value": "OMD",
    "label": "Oranjemund Oranjemund Airport (OMD)"
  },
  {
    "value": "EUX",
    "label": "Oranjestad F. D. Roosevelt Airport (EUX)"
  },
  {
    "value": "AUA",
    "label": "Oranjestad Queen Beatrix International Airport (AUA)"
  },
  {
    "value": "KYD",
    "label": "Orchid Island Lanyu Airport (KYD)"
  },
  {
    "value": "DSN",
    "label": "Ordos Ordos Ejin Horo Airport (DSN)"
  },
  {
    "value": "OGU",
    "label": "Ordu Ordu–Giresun Airport (OGU)"
  },
  {
    "value": "ORB",
    "label": "Örebro Örebro Airport (ORB)"
  },
  {
    "value": "ONO",
    "label": "Oregon Ontario Municipal Airport (ONO)"
  },
  {
    "value": "MBX",
    "label": "Orehova Vas Maribor Edvard Rusjan Airport (MBX)"
  },
  {
    "value": "REN",
    "label": "Orenburg Orenburg Central Airport (REN)"
  },
  {
    "value": "BGY",
    "label": "Orio al Serio (BG) Milan Bergamo Airport / Antonio Locatelli Air Base (BGY)"
  },
  {
    "value": "TMT",
    "label": "Oriximiná Trombetas Airport (TMT)"
  },
  {
    "value": "KOI",
    "label": "Orkney Islands Kirkwall Airport (KOI)"
  },
  {
    "value": "OLA",
    "label": "Ørland Ørland Airport (OLA)"
  },
  {
    "value": "ISM",
    "label": "Orlando Kissimmee Gateway Airport (ISM)"
  },
  {
    "value": "MCO",
    "label": "Orlando Orlando International Airport (MCO)"
  },
  {
    "value": "SFB",
    "label": "Orlando Orlando Sanford International Airport (SFB)"
  },
  {
    "value": "OMC",
    "label": "Ormoc City Ormoc Airport (OMC)"
  },
  {
    "value": "OER",
    "label": "Örnsköldsvik Örnsköldsvik Airport (OER)"
  },
  {
    "value": "TXC",
    "label": "Orsha Orsha Airport - Balbasovo Air Base (TXC)"
  },
  {
    "value": "OSW",
    "label": "Orsk Orsk Airport (OSW)"
  },
  {
    "value": "HOV",
    "label": "Ørsta Ørsta-Volda Airport, Hovden (HOV)"
  },
  {
    "value": "ORU",
    "label": "Oruro Juan Mendoza Airport (ORU)"
  },
  {
    "value": "KJB",
    "label": "Orvakal Kurnool Airport (KJB)"
  },
  {
    "value": "KIX",
    "label": "Osaka Kansai International Airport (KIX)"
  },
  {
    "value": "ITM",
    "label": "Osaka Osaka International Airport (ITM)"
  },
  {
    "value": "ANU",
    "label": "Osbourn V C Bird International Airport (ANU)"
  },
  {
    "value": "OSS",
    "label": "Osh Osh Airport (OSS)"
  },
  {
    "value": "YOO",
    "label": "Oshawa Oshawa Executive Airport (YOO)"
  },
  {
    "value": "OSH",
    "label": "Oshkosh Wittman Regional Airport (OSH)"
  },
  {
    "value": "OSL",
    "label": "Oslo (Gardermoen) Oslo Airport, Gardermoen (OSL)"
  },
  {
    "value": "RYG",
    "label": "Oslo Moss Airport, Rygge (RYG)"
  },
  {
    "value": "ZOS",
    "label": "Osorno Cañal Bajo Carlos Hott Siebert Airport (ZOS)"
  },
  {
    "value": "OSD",
    "label": "Östersund Åre Östersund Airport (OSD)"
  },
  {
    "value": "HOI",
    "label": "Otepa Hao Airport (HOI)"
  },
  {
    "value": "OTP",
    "label": "Otopeni Bucharest Henri Coandă International Airport (OTP)"
  },
  {
    "value": "YRO",
    "label": "Ottawa Ottawa / Rockcliffe Airport (YRO)"
  },
  {
    "value": "YOW",
    "label": "Ottawa Ottawa Macdonald-Cartier International Airport (YOW)"
  },
  {
    "value": "OTM",
    "label": "Ottumwa Ottumwa Regional Airport (OTM)"
  },
  {
    "value": "OUA",
    "label": "Ouagadougou Ouagadougou Airport (OUA)"
  },
  {
    "value": "AJN",
    "label": "Ouani Ouani Airport (AJN)"
  },
  {
    "value": "OGX",
    "label": "Ouargla Ain Beida Airport (OGX)"
  },
  {
    "value": "OZZ",
    "label": "Ouarzazate Ouarzazate Airport (OZZ)"
  },
  {
    "value": "OUH",
    "label": "Oudtshoorn Oudtshoorn Airport (OUH)"
  },
  {
    "value": "DIJ",
    "label": "Ouges, Côte-d'Or Dijon-Bourgogne Airport (DIJ)"
  },
  {
    "value": "BUJ",
    "label": "Ouled Sidi Brahim Bou Saada Airport (BUJ)"
  },
  {
    "value": "OUL",
    "label": "Oulu / Oulunsalo Oulu Airport (OUL)"
  },
  {
    "value": "MAX",
    "label": "Ouro Sogui Ouro Sogui Airport (MAX)"
  },
  {
    "value": "UVE",
    "label": "Ouvéa Ouvéa Airport (UVE)"
  },
  {
    "value": "FTX",
    "label": "Owando Owando Airport (FTX)"
  },
  {
    "value": "YOS",
    "label": "Owen Sound Owen Sound / Billy Bishop Regional Airport (YOS)"
  },
  {
    "value": "OWB",
    "label": "Owensboro Owensboro Daviess County Airport (OWB)"
  },
  {
    "value": "QOW",
    "label": "Owerri Sam Mbakwe International Airport (QOW)"
  },
  {
    "value": "UOX",
    "label": "Oxford University Oxford Airport (UOX)"
  },
  {
    "value": "OXR",
    "label": "Oxnard Oxnard Airport (OXR)"
  },
  {
    "value": "OYE",
    "label": "Oyem Oyem Airport (OYE)"
  },
  {
    "value": "OLL",
    "label": "Oyo Oyo Ollombo Airport (OLL)"
  },
  {
    "value": "OZC",
    "label": "Ozamiz Labo Airport (OZC)"
  },
  {
    "value": "MMB",
    "label": "Ōzora Memanbetsu Airport (MMB)"
  },
  {
    "value": "PDG",
    "label": "Padang (Katapiang) Minangkabau International Airport (PDG)"
  },
  {
    "value": "AEG",
    "label": "Padang Sidempuan Aek Godang Airport (AEG)"
  },
  {
    "value": "PAH",
    "label": "Paducah Barkley Regional Airport (PAH)"
  },
  {
    "value": "PAG",
    "label": "Pagadian Pagadian Airport (PAG)"
  },
  {
    "value": "PGA",
    "label": "Page Page Municipal Airport (PGA)"
  },
  {
    "value": "PPG",
    "label": "Pago Pago Pago Pago International Airport (PPG)"
  },
  {
    "value": "GLA",
    "label": "Paisley, Renfrewshire Glasgow International Airport (GLA)"
  },
  {
    "value": "PKZ",
    "label": "Pakse Pakse International Airport (PKZ)"
  },
  {
    "value": "PLQ",
    "label": "Palanga Palanga International Airport (PLQ)"
  },
  {
    "value": "PKY",
    "label": "Palangkaraya Tjilik Riwut Airport (PKY)"
  },
  {
    "value": "PLM",
    "label": "Palembang Sultan Mahmud Badaruddin II Airport (PLM)"
  },
  {
    "value": "PMO",
    "label": "Palermo Falcone–Borsellino Airport (PMO)"
  },
  {
    "value": "TRM",
    "label": "Palm Springs Jacqueline Cochran Regional Airport (TRM)"
  },
  {
    "value": "PSP",
    "label": "Palm Springs Palm Springs International Airport (PSP)"
  },
  {
    "value": "PMI",
    "label": "Palma de Mallorca Palma de Mallorca Airport (PMI)"
  },
  {
    "value": "PMZ",
    "label": "Palmar Sur Palmar Sur Airport (PMZ)"
  },
  {
    "value": "PTM",
    "label": "Palmarito Palmarito Airport (PTM)"
  },
  {
    "value": "PMW",
    "label": "Palmas Brigadeiro Lysias Rodrigues Airport (PMW)"
  },
  {
    "value": "PMD",
    "label": "Palmdale Palmdale Regional Airport / USAF Plant 42 Airport (PMD)"
  },
  {
    "value": "PAQ",
    "label": "Palmer Warren \"Bud\" Woods Palmer Municipal Airport (PAQ)"
  },
  {
    "value": "XPL",
    "label": "Palmerola Palmerola International Airport / José Enrique Soto Cano Air Base (XPL)"
  },
  {
    "value": "PMR",
    "label": "Palmerston North Palmerston North Airport (PMR)"
  },
  {
    "value": "PAO",
    "label": "Palo Alto Palo Alto Airport (PAO)"
  },
  {
    "value": "PLW",
    "label": "Palu Mutiara - SIS Al-Jufrie Airport (PLW)"
  },
  {
    "value": "PNA",
    "label": "Pamplona Pamplona Airport (PNA)"
  },
  {
    "value": "ECP",
    "label": "Panama City Beach Northwest Florida Beaches International Airport (ECP)"
  },
  {
    "value": "PAM",
    "label": "Panama City Tyndall Air Force Base (PAM)"
  },
  {
    "value": "PNV",
    "label": "Panevėžys Panevėžys Air Base (PNV)"
  },
  {
    "value": "PGK",
    "label": "Pangkal Pinang Depati Amir Airport (PGK)"
  },
  {
    "value": "TAG",
    "label": "Panglao Bohol-Panglao International Airport (TAG)"
  },
  {
    "value": "PJG",
    "label": "Panjgur Panjgur Airport (PJG)"
  },
  {
    "value": "PNL",
    "label": "Pantelleria (TP) Pantelleria Airport (PNL)"
  },
  {
    "value": "PGH",
    "label": "Pantnagar Pantnagar Airport (PGH)"
  },
  {
    "value": "PZI",
    "label": "Panzhihua (Renhe) Panzhihua Bao'anying Airport (PZI)"
  },
  {
    "value": "PPT",
    "label": "Papeete Faa'a International Airport (PPT)"
  },
  {
    "value": "PFO",
    "label": "Paphos Paphos International Airport (PFO)"
  },
  {
    "value": "PBO",
    "label": "Paraburdoo Paraburdoo Airport (PBO)"
  },
  {
    "value": "LSP",
    "label": "Paraguaná Josefa Camejo International Airport (LSP)"
  },
  {
    "value": "PRA",
    "label": "Parana General Urquiza Airport (PRA)"
  },
  {
    "value": "CKS",
    "label": "Parauapebas Carajás Airport (CKS)"
  },
  {
    "value": "PED",
    "label": "Pardubice Pardubice Airport (PED)"
  },
  {
    "value": "LBG",
    "label": "Paris (Le Bourget, Seine-Saint-Denis) Paris-Le Bourget Airport (LBG)"
  },
  {
    "value": "ORY",
    "label": "Paris (Orly, Val-de-Marne) Paris-Orly Airport (ORY)"
  },
  {
    "value": "CDG",
    "label": "Paris (Roissy-en-France, Val-d'Oise) Charles de Gaulle International Airport (CDG)"
  },
  {
    "value": "PRX",
    "label": "Paris Cox Field (PRX)"
  },
  {
    "value": "PKB",
    "label": "Parkersburg (Williamstown) Mid Ohio Valley Regional Airport (PKB)"
  },
  {
    "value": "PKE",
    "label": "Parkes Parkes Airport (PKE)"
  },
  {
    "value": "PMF",
    "label": "Parma (PR) Parma Airport (PMF)"
  },
  {
    "value": "PHB",
    "label": "Parnaíba Parnaíba - Prefeito Doutor João Silva Filho International Airport (PHB)"
  },
  {
    "value": "EPU",
    "label": "Pärnu Pärnu Airport (EPU)"
  },
  {
    "value": "PBH",
    "label": "Paro Paro International Airport (PBH)"
  },
  {
    "value": "PSC",
    "label": "Pasco Tri Cities Airport (PSC)"
  },
  {
    "value": "PSI",
    "label": "Pasni Pasni Airport (PSI)"
  },
  {
    "value": "AOL",
    "label": "Paso de los Libres Paso De Los Libres Airport (AOL)"
  },
  {
    "value": "PRB",
    "label": "Paso Robles Paso Robles Municipal Airport (PRB)"
  },
  {
    "value": "PFB",
    "label": "Passo Fundo Lauro Kurtz Airport (PFB)"
  },
  {
    "value": "IXP",
    "label": "Pathankot Pathankot Airport (IXP)"
  },
  {
    "value": "PAT",
    "label": "Patna Jay Prakash Narayan Airport (PAT)"
  },
  {
    "value": "GPA",
    "label": "Patras Patras Araxos Agamemnon Airport (GPA)"
  },
  {
    "value": "NHK",
    "label": "Patuxent River Patuxent River Naval Air Station (Trapnell Field) (NHK)"
  },
  {
    "value": "PUF",
    "label": "Pau/Pyrénées (Uzein) Pau Pyrénées Airport (PUF)"
  },
  {
    "value": "PAV",
    "label": "Paulo Afonso Paulo Afonso Airport (PAV)"
  },
  {
    "value": "PWQ",
    "label": "Pavlodar Pavlodar Airport (PWQ)"
  },
  {
    "value": "QPG",
    "label": "Paya Lebar Paya Lebar Air Base (QPG)"
  },
  {
    "value": "VIP",
    "label": "Payerne Payerne Air Base (VIP)"
  },
  {
    "value": "PZA",
    "label": "Paz De Ariporo Paz De Ariporo Airport (PZA)"
  },
  {
    "value": "YPE",
    "label": "Peace River Peace River Airport (YPE)"
  },
  {
    "value": "PEX",
    "label": "Pechora Pechora Airport (PEX)"
  },
  {
    "value": "PEV",
    "label": "Pécs Pécs-Pogány Airport (PEV)"
  },
  {
    "value": "PJC",
    "label": "Pedro Juan Caballero Dr. Augusto Roberto Fuster Airport (PJC)"
  },
  {
    "value": "PEH",
    "label": "Pehuajó Comodoro Pedro Zanni Airport (PEH)"
  },
  {
    "value": "PKU",
    "label": "Pekanbaru Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB (PKU)"
  },
  {
    "value": "PLN",
    "label": "Pellston Pellston Regional Airport of Emmet County Airport (PLN)"
  },
  {
    "value": "PET",
    "label": "Pelotas João Simões Lopes Neto International Airport (PET)"
  },
  {
    "value": "POL",
    "label": "Pemba Pemba Airport (POL)"
  },
  {
    "value": "YTA",
    "label": "Pembroke Pembroke Airport (YTA)"
  },
  {
    "value": "PEN",
    "label": "Penang Penang International Airport (PEN)"
  },
  {
    "value": "SAW",
    "label": "Pendik, Istanbul Istanbul Sabiha Gökçen International Airport (SAW)"
  },
  {
    "value": "PDT",
    "label": "Pendleton Eastern Oregon Regional Airport at Pendleton (PDT)"
  },
  {
    "value": "NPA",
    "label": "Pensacola Naval Air Station Pensacola Forrest Sherman Field (NPA)"
  },
  {
    "value": "PNS",
    "label": "Pensacola Pensacola International Airport (PNS)"
  },
  {
    "value": "YYF",
    "label": "Penticton Penticton Airport (YYF)"
  },
  {
    "value": "PEZ",
    "label": "Penza Penza Airport (PEZ)"
  },
  {
    "value": "PIA",
    "label": "Peoria General Wayne A. Downing Peoria International Airport (PIA)"
  },
  {
    "value": "PEI",
    "label": "Pereira Matecaña International Airport (PEI)"
  },
  {
    "value": "PGX",
    "label": "Périgueux/Bassillac Périgueux-Bassillac Airport (PGX)"
  },
  {
    "value": "PMQ",
    "label": "Perito Moreno Perito Moreno Jalil Hamer Airport (PMQ)"
  },
  {
    "value": "PEE",
    "label": "Perm Perm International Airport (PEE)"
  },
  {
    "value": "PGF",
    "label": "Perpignan/Rivesaltes Perpignan-Rivesaltes (Llabanère) Airport (PGF)"
  },
  {
    "value": "PER",
    "label": "Perth Perth International Airport (PER)"
  },
  {
    "value": "JAD",
    "label": "Perth Perth Jandakot Airport (JAD)"
  },
  {
    "value": "GUS",
    "label": "Peru Grissom Air Reserve Base (GUS)"
  },
  {
    "value": "PEG",
    "label": "Perugia (PG) Perugia San Francesco d'Assisi – Umbria International Airport (PEG)"
  },
  {
    "value": "PSR",
    "label": "Pescara Abruzzo Airport (PSR)"
  },
  {
    "value": "PEW",
    "label": "Peshawar Peshawar International Airport (PEW)"
  },
  {
    "value": "YWA",
    "label": "Petawawa Petawawa Airport (YWA)"
  },
  {
    "value": "YPQ",
    "label": "Peterborough Peterborough Municipal Airport (YPQ)"
  },
  {
    "value": "PSG",
    "label": "Petersburg Petersburg James A Johnson Airport (PSG)"
  },
  {
    "value": "PNZ",
    "label": "Petrolina Senador Nilo Coelho Airport (PNZ)"
  },
  {
    "value": "PPK",
    "label": "Petropavl Petropavl Airport (PPK)"
  },
  {
    "value": "PKC",
    "label": "Petropavlovsk-Kamchatsky Yelizovo Airport (PKC)"
  },
  {
    "value": "PES",
    "label": "Petrozavodsk Petrozavodsk Airport (PES)"
  },
  {
    "value": "PHW",
    "label": "Phalaborwa Hendrik Van Eck Airport (PHW)"
  },
  {
    "value": "PNE",
    "label": "Philadelphia Northeast Philadelphia Airport (PNE)"
  },
  {
    "value": "PHL",
    "label": "Philadelphia Philadelphia International Airport (PHL)"
  },
  {
    "value": "PHS",
    "label": "Phitsanulok Phitsanulok Airport (PHS)"
  },
  {
    "value": "PNH",
    "label": "Phnom Penh (Pou Senchey) Phnom Penh International Airport (PNH)"
  },
  {
    "value": "PHX",
    "label": "Phoenix Phoenix Sky Harbor International Airport (PHX)"
  },
  {
    "value": "PQC",
    "label": "Phu Quoc Island Phu Quoc International Airport (PQC)"
  },
  {
    "value": "HKT",
    "label": "Phuket Phuket International Airport (HKT)"
  },
  {
    "value": "YPL",
    "label": "Pickle Lake Pickle Lake Airport (YPL)"
  },
  {
    "value": "PIX",
    "label": "Pico Island Pico Airport (PIX)"
  },
  {
    "value": "PDS",
    "label": "Piedras Negras Piedras Negras International Airport (PDS)"
  },
  {
    "value": "PIR",
    "label": "Pierre Pierre Regional Airport (PIR)"
  },
  {
    "value": "PZY",
    "label": "Piešťany Piešťany Airport (PZY)"
  },
  {
    "value": "PZB",
    "label": "Pietermaritzburg Pietermaritzburg Airport (PZB)"
  },
  {
    "value": "PIW",
    "label": "Pikwitonei Pikwitonei Airport (PIW)"
  },
  {
    "value": "PIL",
    "label": "Pilar Aeródromo Don Carlos Miguel Gimenez (PIL)"
  },
  {
    "value": "LCL",
    "label": "Pinar del Rio La Coloma Airport (LCL)"
  },
  {
    "value": "WPC",
    "label": "Pincher Creek Pincher Creek Airport (WPC)"
  },
  {
    "value": "PBF",
    "label": "Pine Bluff Pine Bluff Regional Airport, Grider Field (PBF)"
  },
  {
    "value": "PWY",
    "label": "Pinedale Ralph Wenz Field (PWY)"
  },
  {
    "value": "PIE",
    "label": "Pinellas Park St. Petersburg Clearwater International Airport (PIE)"
  },
  {
    "value": "PIF",
    "label": "Pingtung Pingtung Air Force Base North (PIF)"
  },
  {
    "value": "QPS",
    "label": "Pirassununga Campo Fontenelle (QPS)"
  },
  {
    "value": "GPN",
    "label": "Pirlangimpi Garden Point Airport (GPN)"
  },
  {
    "value": "PSA",
    "label": "Pisa (PI) Pisa International Airport (PSA)"
  },
  {
    "value": "PIO",
    "label": "Pisco Captain Renán Elías Olivera International Airport (PIO)"
  },
  {
    "value": "PTX",
    "label": "Pitalito Pitalito Airport (PTX)"
  },
  {
    "value": "AGC",
    "label": "Pittsburgh Allegheny County Airport (AGC)"
  },
  {
    "value": "PIT",
    "label": "Pittsburgh Pittsburgh International Airport (PIT)"
  },
  {
    "value": "THU",
    "label": "Pituffik Pituffik Space Base (THU)"
  },
  {
    "value": "PIU",
    "label": "Piura Capitán FAP Guillermo Concha Iberico International Airport (PIU)"
  },
  {
    "value": "PLJ",
    "label": "Placencia Placencia Airport (PLJ)"
  },
  {
    "value": "MRU",
    "label": "Plaine Magnien Sir Seewoosagur Ramgoolam International Airport (MRU)"
  },
  {
    "value": "PTU",
    "label": "Platinum Platinum Airport (PTU)"
  },
  {
    "value": "PBG",
    "label": "Plattsburgh Plattsburgh International Airport (PBG)"
  },
  {
    "value": "PXU",
    "label": "Pleiku Pleiku Airport (PXU)"
  },
  {
    "value": "PBZ",
    "label": "Plettenberg Bay Plettenberg Bay Airport (PBZ)"
  },
  {
    "value": "DNR",
    "label": "Pleurtuit, Ille-et-Vilaine Dinard-Pleurtuit-Saint-Malo Airport (DNR)"
  },
  {
    "value": "PDV",
    "label": "Plovdiv Plovdiv International Airport (PDV)"
  },
  {
    "value": "PIH",
    "label": "Pocatello Pocatello Regional Airport (PIH)"
  },
  {
    "value": "BCL",
    "label": "Pococi Barra del Colorado Airport (BCL)"
  },
  {
    "value": "GPL",
    "label": "Pococi Guapiles Airport (GPL)"
  },
  {
    "value": "POO",
    "label": "Poços De Caldas Poços de Caldas - Embaixador Walther Moreira Salles Airport (POO)"
  },
  {
    "value": "TGD",
    "label": "Podgorica Podgorica Airport / Podgorica Golubovci Airbase (TGD)"
  },
  {
    "value": "KPO",
    "label": "Pohang Pohang Airport (G-815/K-3) (KPO)"
  },
  {
    "value": "PNI",
    "label": "Pohnpei Island Pohnpei International Airport (PNI)"
  },
  {
    "value": "PIZ",
    "label": "Point Lay Point Lay LRRS Airport (PIZ)"
  },
  {
    "value": "NTD",
    "label": "Point Mugu Point Mugu Naval Air Station (Naval Base Ventura Co) (NTD)"
  },
  {
    "value": "PNR",
    "label": "Pointe Noire Antonio Agostinho-Neto International Airport (PNR)"
  },
  {
    "value": "PTP",
    "label": "Pointe-à-Pitre Guadeloupe - Maryse Condé International Airport (PTP)"
  },
  {
    "value": "YNL",
    "label": "Points North Landing Points North Landing Airport (YNL)"
  },
  {
    "value": "PIS",
    "label": "Poitiers/Biard Poitiers-Biard Airport (PIS)"
  },
  {
    "value": "PKR",
    "label": "Pokhara Pokhara International Airport (PKR)"
  },
  {
    "value": "PTG",
    "label": "Polokwane Polokwane International Airport (PTG)"
  },
  {
    "value": "HIM",
    "label": "Polonnaruwa Town Hingurakgoda Air Force Base (HIM)"
  },
  {
    "value": "PNC",
    "label": "Ponca City Ponca City Regional Airport (PNC)"
  },
  {
    "value": "PSE",
    "label": "Ponce Mercedita Airport (PSE)"
  },
  {
    "value": "PDL",
    "label": "Ponta Delgada João Paulo II Airport (PDL)"
  },
  {
    "value": "PGZ",
    "label": "Ponta Grossa Ponta Grossa Airport - Comandante Antonio Amilton Beraldo (PGZ)"
  },
  {
    "value": "PMG",
    "label": "Ponta Porã Ponta Porã Airport (PMG)"
  },
  {
    "value": "PTK",
    "label": "Pontiac Oakland County International Airport (PTK)"
  },
  {
    "value": "PNK",
    "label": "Pontianak Supadio Airport (PNK)"
  },
  {
    "value": "PPN",
    "label": "Popayán Guillermo León Valencia Airport (PPN)"
  },
  {
    "value": "PNP",
    "label": "Popondetta Girua Airport (PNP)"
  },
  {
    "value": "TAT",
    "label": "Poprad Poprad-Tatry Airport (TAT)"
  },
  {
    "value": "PBD",
    "label": "Porbandar Porbandar Airport (PBD)"
  },
  {
    "value": "POR",
    "label": "Pori Pori Airport (POR)"
  },
  {
    "value": "PBN",
    "label": "Port Amboim Porto Amboim Airport (PBN)"
  },
  {
    "value": "CLM",
    "label": "Port Angeles William R Fairchild International Airport (CLM)"
  },
  {
    "value": "IXZ",
    "label": "Port Blair Veer Savarkar International Airport / INS Utkrosh (IXZ)"
  },
  {
    "value": "KPC",
    "label": "Port Clarence Port Clarence Coast Guard Station (KPC)"
  },
  {
    "value": "POG",
    "label": "Port Gentil Port Gentil Airport (POG)"
  },
  {
    "value": "PHC",
    "label": "Port Harcourt Port Harcourt International Airport (PHC)"
  },
  {
    "value": "YZT",
    "label": "Port Hardy Port Hardy Airport (YZT)"
  },
  {
    "value": "YPS",
    "label": "Port Hawkesbury Port Hawkesbury Airport (YPS)"
  },
  {
    "value": "PHE",
    "label": "Port Hedland Port Hedland International Airport (PHE)"
  },
  {
    "value": "PTH",
    "label": "Port Heiden Port Heiden Airport (PTH)"
  },
  {
    "value": "PLO",
    "label": "Port Lincoln Port Lincoln Airport (PLO)"
  },
  {
    "value": "PQQ",
    "label": "Port Macquarie Port Macquarie Airport (PQQ)"
  },
  {
    "value": "RRG",
    "label": "Port Mathurin Sir Charles Gaetan Duval Airport (RRG)"
  },
  {
    "value": "POM",
    "label": "Port Moresby Port Moresby Jacksons International Airport (POM)"
  },
  {
    "value": "POS",
    "label": "Port of Spain Piarco International Airport (POS)"
  },
  {
    "value": "PSD",
    "label": "Port Said Port Said International Airport (PSD)"
  },
  {
    "value": "JOH",
    "label": "Port St Johns Port St Johns Airport (JOH)"
  },
  {
    "value": "PZU",
    "label": "Port Sudan Port Sudan New International Airport (PZU)"
  },
  {
    "value": "VLI",
    "label": "Port Vila Bauerfield International Airport (VLI)"
  },
  {
    "value": "PAP",
    "label": "Port-au-Prince Toussaint Louverture International Airport (PAP)"
  },
  {
    "value": "PAX",
    "label": "Port-de-Paix Port-de-Paix Airport (PAX)"
  },
  {
    "value": "YPN",
    "label": "Port-Menier Port-Menier Airport (YPN)"
  },
  {
    "value": "YPG",
    "label": "Portage la Prairie Portage-la-Prairie / Southport Airport (YPG)"
  },
  {
    "value": "PRM",
    "label": "Portimão Portimão Airport (PRM)"
  },
  {
    "value": "HIO",
    "label": "Portland Portland Hillsboro Airport (HIO)"
  },
  {
    "value": "PDX",
    "label": "Portland Portland International Airport (PDX)"
  },
  {
    "value": "PWM",
    "label": "Portland Portland International Jetport (PWM)"
  },
  {
    "value": "TTD",
    "label": "Portland Portland Troutdale Airport (TTD)"
  },
  {
    "value": "QNS",
    "label": "Porto Alegre Canoas Air Force Base (QNS)"
  },
  {
    "value": "POA",
    "label": "Porto Alegre Salgado Filho International Airport (POA)"
  },
  {
    "value": "OPO",
    "label": "Porto Francisco de Sá Carneiro Airport (OPO)"
  },
  {
    "value": "PNB",
    "label": "Porto Nacional Porto Nacional Airport (PNB)"
  },
  {
    "value": "BPS",
    "label": "Porto Seguro Porto Seguro Airport (BPS)"
  },
  {
    "value": "PVH",
    "label": "Porto Velho Governador Jorge Teixeira de Oliveira Airport (PVH)"
  },
  {
    "value": "PVO",
    "label": "Portoviejo Reales Tamarindos Airport (PVO)"
  },
  {
    "value": "PSM",
    "label": "Portsmouth Portsmouth International at Pease Airport (PSM)"
  },
  {
    "value": "WPR",
    "label": "Porvenir Captain Fuentes Martinez Airport (WPR)"
  },
  {
    "value": "PSS",
    "label": "Posadas Libertador Gral D Jose De San Martin Airport (PSS)"
  },
  {
    "value": "PSJ",
    "label": "Poso-Celebes Island Kasiguncu Airport (PSJ)"
  },
  {
    "value": "PCF",
    "label": "Potchefstroom Potchefstroom Airport (PCF)"
  },
  {
    "value": "POI",
    "label": "Potosí Capitan Nicolas Rojas Airport (POI)"
  },
  {
    "value": "POU",
    "label": "Poughkeepsie Dutchess County Airport (POU)"
  },
  {
    "value": "YPW",
    "label": "Powell River Powell River Airport (YPW)"
  },
  {
    "value": "PAZ",
    "label": "Poza Rica El Tajín National Airport (PAZ)"
  },
  {
    "value": "POZ",
    "label": "Poznań Poznań-Ławica Airport (POZ)"
  },
  {
    "value": "PRG",
    "label": "Prague Václav Havel Airport Prague (PRG)"
  },
  {
    "value": "TER",
    "label": "Praia da Vitória Lajes Airport (TER)"
  },
  {
    "value": "RAI",
    "label": "Praia Nelson Mandela International Airport (RAI)"
  },
  {
    "value": "PRI",
    "label": "Praslin Island Praslin Island Airport (PRI)"
  },
  {
    "value": "SNE",
    "label": "Preguiça Preguiça Airport (SNE)"
  },
  {
    "value": "PRV",
    "label": "Přerov Přerov Air Base (PRV)"
  },
  {
    "value": "PRC",
    "label": "Prescott Prescott International Airport - Ernest A. Love Field (PRC)"
  },
  {
    "value": "PPB",
    "label": "Presidente Prudente Presidente Prudente Airport (PPB)"
  },
  {
    "value": "PQI",
    "label": "Presque Isle Presque Isle International Airport (PQI)"
  },
  {
    "value": "PIK",
    "label": "Prestwick, South Ayrshire Glasgow Prestwick Airport (PIK)"
  },
  {
    "value": "WKF",
    "label": "Pretoria Waterkloof Air Force Base (WKF)"
  },
  {
    "value": "PRY",
    "label": "Pretoria Wonderboom Airport (PRY)"
  },
  {
    "value": "PVK",
    "label": "Preveza Aktion National Airport (PVK)"
  },
  {
    "value": "YPA",
    "label": "Prince Albert Prince Albert Glass Field (YPA)"
  },
  {
    "value": "YXS",
    "label": "Prince George Prince George Airport (YXS)"
  },
  {
    "value": "YPR",
    "label": "Prince Rupert Prince Rupert Airport (YPR)"
  },
  {
    "value": "PRN",
    "label": "Prishtina Priština Adem Jashari International Airport (PRN)"
  },
  {
    "value": "PPP",
    "label": "Proserpine Proserpine Whitsunday Coast Airport (PPP)"
  },
  {
    "value": "PVA",
    "label": "Providencia El Embrujo Airport (PVA)"
  },
  {
    "value": "PLS",
    "label": "Providenciales Providenciales International Airport (PLS)"
  },
  {
    "value": "PVU",
    "label": "Provo Provo-Utah Lake International Airport (PVU)"
  },
  {
    "value": "PKV",
    "label": "Pskov Pskov Airport (PKV)"
  },
  {
    "value": "JMJ",
    "label": "Pu'er (Lancang) Lancang Jingmai Airport (JMJ)"
  },
  {
    "value": "PCL",
    "label": "Pucallpa Cap FAP David Abenzur Rengifo International Airport (PCL)"
  },
  {
    "value": "PNY",
    "label": "Puducherry (Pondicherry) Pondicherry Airport (PNY)"
  },
  {
    "value": "PBC",
    "label": "Puebla Hermanos Serdán International Airport (PBC)"
  },
  {
    "value": "PUB",
    "label": "Pueblo Pueblo Memorial Airport (PUB)"
  },
  {
    "value": "PUU",
    "label": "Puerto Asís Tres De Mayo Airport (PUU)"
  },
  {
    "value": "PYH",
    "label": "Puerto Ayacucho Cacique Aramare Airport (PYH)"
  },
  {
    "value": "PBR",
    "label": "Puerto Barrios Puerto Barrios Airport (PBR)"
  },
  {
    "value": "PUZ",
    "label": "Puerto Cabezas Puerto Cabezas Airport (PUZ)"
  },
  {
    "value": "PCR",
    "label": "Puerto Carreño German Olano Airport (PCR)"
  },
  {
    "value": "PUD",
    "label": "Puerto Deseado Puerto Deseado Airport (PUD)"
  },
  {
    "value": "PXM",
    "label": "Puerto Escondido Puerto Escondido International Airport (PXM)"
  },
  {
    "value": "IGR",
    "label": "Puerto Iguazu Cataratas Del Iguazú International Airport (IGR)"
  },
  {
    "value": "PDA",
    "label": "Puerto Inírida Obando Cesar Gaviria Trujillo Airport (PDA)"
  },
  {
    "value": "PJM",
    "label": "Puerto Jimenez Puerto Jimenez Airport (PJM)"
  },
  {
    "value": "LIO",
    "label": "Puerto Limon Limon International Airport (LIO)"
  },
  {
    "value": "PMY",
    "label": "Puerto Madryn El Tehuelche Airport (PMY)"
  },
  {
    "value": "PEM",
    "label": "Puerto Maldonado Padre Aldamiz International Airport (PEM)"
  },
  {
    "value": "PMC",
    "label": "Puerto Montt El Tepual Airport (PMC)"
  },
  {
    "value": "PNT",
    "label": "Puerto Natales Lieutenant Julio Gallardo Airport (PNT)"
  },
  {
    "value": "PZO",
    "label": "Puerto Ordaz-Ciudad Guayana General Manuel Carlos Piar International Airport (PZO)"
  },
  {
    "value": "POP",
    "label": "Puerto Plata Gregorio Luperon International Airport (POP)"
  },
  {
    "value": "PPS",
    "label": "Puerto Princesa Puerto Princesa International Airport / PAF Antonio Bautista Air Base (PPS)"
  },
  {
    "value": "GSJ",
    "label": "Puerto San José San José Airport (GSJ)"
  },
  {
    "value": "RZA",
    "label": "Puerto Santa Cruz Santa Cruz Airport (RZA)"
  },
  {
    "value": "PSZ",
    "label": "Puerto Suárez Capitán Av. Salvador Ogaya G. airport (PSZ)"
  },
  {
    "value": "PVR",
    "label": "Puerto Vallarta Puerto Vallarta International Airport (PVR)"
  },
  {
    "value": "VMI",
    "label": "Puerto Vallemi Doctor Juan Plate National Airport (VMI)"
  },
  {
    "value": "WPU",
    "label": "Puerto Williams Guardiamarina Zañartu Airport (WPU)"
  },
  {
    "value": "PUY",
    "label": "Pula Pula Airport (PUY)"
  },
  {
    "value": "PUW",
    "label": "Pullman Pullman-Moscow Regional Airport (PUW)"
  },
  {
    "value": "PNQ",
    "label": "Pune Pune Airport / Lohagaon Air Force Station (PNQ)"
  },
  {
    "value": "BAI",
    "label": "Punta Arenas Buenos Aires Airport (BAI)"
  },
  {
    "value": "PUQ",
    "label": "Punta Arenas President Carlos Ibañez del Campo International Airport (PUQ)"
  },
  {
    "value": "PUJ",
    "label": "Punta Cana Punta Cana International Airport (PUJ)"
  },
  {
    "value": "PDP",
    "label": "Punta del Este Capitan Corbeta CA Curbelo International Airport (PDP)"
  },
  {
    "value": "PGD",
    "label": "Punta Gorda Punta Gorda Airport (PGD)"
  },
  {
    "value": "PND",
    "label": "Punta Gorda Punta Gorda Airport (PND)"
  },
  {
    "value": "PBU",
    "label": "Putao Putao Airport (PBU)"
  },
  {
    "value": "PUT",
    "label": "Puttaparthi Sri Sathya Sai Airport (PUT)"
  },
  {
    "value": "PSU",
    "label": "Putussibau-Borneo Island Pangsuma Airport (PSU)"
  },
  {
    "value": "YPX",
    "label": "Puvirnituq Puvirnituq Airport (YPX)"
  },
  {
    "value": "OSN",
    "label": "Pyeongtaek Osan Air Base (OSN)"
  },
  {
    "value": "NYT",
    "label": "Pyinmana Nay Pyi Taw International Airport (NYT)"
  },
  {
    "value": "FNJ",
    "label": "Pyongyang Pyongyang Sunan International Airport (FNJ)"
  },
  {
    "value": "AQI",
    "label": "Qaisumah Al Qaisumah/Hafr Al Batin Airport (AQI)"
  },
  {
    "value": "KAC",
    "label": "Qamishly Qamishli Airport (KAC)"
  },
  {
    "value": "RQW",
    "label": "Qayyarah Qayyarah West Airport (RQW)"
  },
  {
    "value": "GZW",
    "label": "Qazvin Qazvin Airport (GZW)"
  },
  {
    "value": "YSQ",
    "label": "Qian Gorlos Mongol Autonomous County Songyuan Chaganhu Airport (YSQ)"
  },
  {
    "value": "JIQ",
    "label": "Qianjiang Qianjiang Wulingshan Airport (JIQ)"
  },
  {
    "value": "IQM",
    "label": "Qiemo Qiemo Yudu Airport (IQM)"
  },
  {
    "value": "TAO",
    "label": "Qingdao (Jiaozhou) Qingdao Jiaodong International Airport (TAO)"
  },
  {
    "value": "IQN",
    "label": "Qingyang (Xifeng) Qingyang Xifeng Airport (IQN)"
  },
  {
    "value": "BPE",
    "label": "Qinhuangdao (Changli) Qinhuangdao Beidaihe Airport (BPE)"
  },
  {
    "value": "BAR",
    "label": "Qionghai (Basuo) Qionghai Bo'ao Airport (BAR)"
  },
  {
    "value": "NDG",
    "label": "Qiqihar Qiqihar Sanjiazi Airport (NDG)"
  },
  {
    "value": "XQU",
    "label": "Qualicum Beach Qualicum Beach Airport (XQU)"
  },
  {
    "value": "NYG",
    "label": "Quantico Quantico Marine Corps Airfield / Turner Field (NYG)"
  },
  {
    "value": "JJN",
    "label": "Quanzhou Quanzhou Jinjiang International Airport (JJN)"
  },
  {
    "value": "YQB",
    "label": "Quebec Quebec Jean Lesage International Airport (YQB)"
  },
  {
    "value": "UTW",
    "label": "Queenstown Queenstown Airport (UTW)"
  },
  {
    "value": "ZQN",
    "label": "Queenstown Queenstown International Airport (ZQN)"
  },
  {
    "value": "UEL",
    "label": "Quelimane Quelimane Airport (UEL)"
  },
  {
    "value": "XQP",
    "label": "Quepos Quepos Managua Airport (XQP)"
  },
  {
    "value": "QRO",
    "label": "Querétaro Querétaro Intercontinental Airport (QRO)"
  },
  {
    "value": "YQZ",
    "label": "Quesnel Quesnel Airport (YQZ)"
  },
  {
    "value": "UET",
    "label": "Quetta Quetta International Airport (UET)"
  },
  {
    "value": "UIB",
    "label": "Quibdó El Caraño Airport (UIB)"
  },
  {
    "value": "UIP",
    "label": "Quimper/Pluguffan Quimper-Cornouaille Airport (UIP)"
  },
  {
    "value": "UIN",
    "label": "Quincy Quincy Regional Airport Baldwin Field (UIN)"
  },
  {
    "value": "UIO",
    "label": "Quito Mariscal Sucre International Airport (UIO)"
  },
  {
    "value": "UIH",
    "label": "Quy Nohn Phu Cat Airport (UIH)"
  },
  {
    "value": "JUZ",
    "label": "Quzhou (Kezheng) Quzhou Airport (JUZ)"
  },
  {
    "value": "RBA",
    "label": "Rabat Rabat-Salé Airport (RBA)"
  },
  {
    "value": "BVC",
    "label": "Rabil Rabil Airport (BVC)"
  },
  {
    "value": "VKG",
    "label": "Rach Gia Rach Gia Airport (VKG)"
  },
  {
    "value": "RDO",
    "label": "Radom Warsaw Radom Airport (RDO)"
  },
  {
    "value": "RAH",
    "label": "Rafha Rafha Domestic Airport (RAH)"
  },
  {
    "value": "RJN",
    "label": "Rafsanjan Rafsanjan Airport (RJN)"
  },
  {
    "value": "RYK",
    "label": "Rahim Yar Khan Shaikh Zaid Airport (RYK)"
  },
  {
    "value": "YOP",
    "label": "Rainbow Lake Rainbow Lake Airport (YOP)"
  },
  {
    "value": "RPR",
    "label": "Raipur Swami Vivekananda Airport (RPR)"
  },
  {
    "value": "KKR",
    "label": "Raitahiti Kaukura Airport (KKR)"
  },
  {
    "value": "RAJ",
    "label": "Rajkot Rajkot Airport (RAJ)"
  },
  {
    "value": "HSR",
    "label": "Rajkot Rajkot International Airport (HSR)"
  },
  {
    "value": "RJH",
    "label": "Rajshahi Shah Mokhdum Airport (RJH)"
  },
  {
    "value": "RDU",
    "label": "Raleigh/Durham Raleigh Durham International Airport (RDU)"
  },
  {
    "value": "RZR",
    "label": "Ramsar Ramsar Airport (RZR)"
  },
  {
    "value": "RMS",
    "label": "Ramstein-Miesenbach Ramstein Air Base (RMS)"
  },
  {
    "value": "NTX",
    "label": "Ranai-Natuna Besar Island Ranai Airport (NTX)"
  },
  {
    "value": "IXR",
    "label": "Ranchi Birsa Munda Airport (IXR)"
  },
  {
    "value": "YRT",
    "label": "Rankin Inlet Rankin Inlet Airport (YRT)"
  },
  {
    "value": "OVD",
    "label": "Ranón Asturias Airport (OVD)"
  },
  {
    "value": "UNN",
    "label": "Ranong Ranong Airport (UNN)"
  },
  {
    "value": "RCA",
    "label": "Rapid City Ellsworth Air Force Base (RCA)"
  },
  {
    "value": "RAP",
    "label": "Rapid City Rapid City Regional Airport (RAP)"
  },
  {
    "value": "RKT",
    "label": "Ras Al Khaimah Ras Al Khaimah International Airport (RKT)"
  },
  {
    "value": "RAS",
    "label": "Rasht Sardar-e-Jangal Airport (RAS)"
  },
  {
    "value": "RBE",
    "label": "Ratanakiri Ratanakiri Airport (RBE)"
  },
  {
    "value": "RAZ",
    "label": "Rawalakot Rawalakot Airport (RAZ)"
  },
  {
    "value": "RWL",
    "label": "Rawlins Rawlins Municipal Airport/Harvey Field (RWL)"
  },
  {
    "value": "REL",
    "label": "Rawson Almirante Marco Andres Zar Airport (REL)"
  },
  {
    "value": "UTP",
    "label": "Rayong U-Tapao International Airport (UTP)"
  },
  {
    "value": "RDG",
    "label": "Reading Reading Regional Airport (Carl A Spaatz Field) (RDG)"
  },
  {
    "value": "REA",
    "label": "Reao Reao Airport (REA)"
  },
  {
    "value": "TGM",
    "label": "Recea Târgu Mureş Transilvania International Airport (TGM)"
  },
  {
    "value": "REC",
    "label": "Recife Recife/Guararapes - Gilberto Freyre International Airport (REC)"
  },
  {
    "value": "RCQ",
    "label": "Reconquista Reconquista Airport (RCQ)"
  },
  {
    "value": "RBL",
    "label": "Red Bluff Red Bluff Municipal Airport (RBL)"
  },
  {
    "value": "YRL",
    "label": "Red Lake Red Lake Airport (YRL)"
  },
  {
    "value": "RDD",
    "label": "Redding Redding Municipal Airport (RDD)"
  },
  {
    "value": "RDM",
    "label": "Redmond Roberts Field (RDM)"
  },
  {
    "value": "HUA",
    "label": "Redstone Arsnl Huntsville Redstone Army Air Field (HUA)"
  },
  {
    "value": "RWF",
    "label": "Redwood Falls Redwood Falls Municipal Airport (RWF)"
  },
  {
    "value": "REG",
    "label": "Reggio Calabria Reggio Calabria Airport (REG)"
  },
  {
    "value": "YQR",
    "label": "Regina Regina International Airport (YQR)"
  },
  {
    "value": "RGT",
    "label": "Rengat-Sumatra Island Japura Airport (RGT)"
  },
  {
    "value": "RNO",
    "label": "Reno Reno Tahoe International Airport (RNO)"
  },
  {
    "value": "TAY",
    "label": "Reola Tartu Airport (TAY)"
  },
  {
    "value": "RES",
    "label": "Resistencia Resistencia International Airport (RES)"
  },
  {
    "value": "YRB",
    "label": "Resolute Bay Resolute Bay Airport (YRB)"
  },
  {
    "value": "RER",
    "label": "Retalhuleu Retalhuleu Airport (RER)"
  },
  {
    "value": "REU",
    "label": "Reus Reus Airport (REU)"
  },
  {
    "value": "YRV",
    "label": "Revelstoke Revelstoke Airport (YRV)"
  },
  {
    "value": "REW",
    "label": "Rewa Rewa Airport, Chorhata, REWA (REW)"
  },
  {
    "value": "KEF",
    "label": "Reykjavík Keflavik International Airport (KEF)"
  },
  {
    "value": "RKV",
    "label": "Reykjavík Reykjavík Domestic Airport (RKV)"
  },
  {
    "value": "REX",
    "label": "Reynosa General Lucio Blanco International Airport (REX)"
  },
  {
    "value": "FKB",
    "label": "Rheinmünster Karlsruhe Baden-Baden Airport (FKB)"
  },
  {
    "value": "RHI",
    "label": "Rhinelander Rhinelander Oneida County Airport (RHI)"
  },
  {
    "value": "RHO",
    "label": "Rhodes Diagoras Airport (RHO)"
  },
  {
    "value": "CWL",
    "label": "Rhoose, Vale of Glamorgan Cardiff International Airport (CWL)"
  },
  {
    "value": "RAO",
    "label": "Ribeirão Preto Leite Lopes Airport (RAO)"
  },
  {
    "value": "RIB",
    "label": "Riberalta Capitán Av. Selin Zeitun Lopez Airport (RIB)"
  },
  {
    "value": "RCB",
    "label": "Richards Bay Richards Bay Airport (RCB)"
  },
  {
    "value": "OAJ",
    "label": "Richlands Albert J Ellis Airport (OAJ)"
  },
  {
    "value": "XRH",
    "label": "Richmond RAAF Base Richmond (XRH)"
  },
  {
    "value": "RIC",
    "label": "Richmond Richmond International Airport (RIC)"
  },
  {
    "value": "RIL",
    "label": "Rifle Garfield County Regional Airport (RIL)"
  },
  {
    "value": "RIX",
    "label": "Riga Riga International Airport (RIX)"
  },
  {
    "value": "GLZ",
    "label": "Rijen Gilze Rijen Air Base (GLZ)"
  },
  {
    "value": "RMI",
    "label": "Rimini (RN) Federico Fellini International Airport (RMI)"
  },
  {
    "value": "YXK",
    "label": "Rimouski Rimouski Airport (YXK)"
  },
  {
    "value": "TIA",
    "label": "Rinas Tirana International Airport Mother Teresa (TIA)"
  },
  {
    "value": "RDS",
    "label": "Rincon de los Sauces Rincon De Los Sauces Airport (RDS)"
  },
  {
    "value": "RBR",
    "label": "Rio Branco Rio Branco-Plácido de Castro International Airport (RBR)"
  },
  {
    "value": "RCU",
    "label": "Rio Cuarto Area De Material Airport (RCU)"
  },
  {
    "value": "GIG",
    "label": "Rio De Janeiro Rio Galeão – Tom Jobim International Airport (GIG)"
  },
  {
    "value": "SNZ",
    "label": "Rio de Janeiro Santa Cruz Air Force Base (SNZ)"
  },
  {
    "value": "SDU",
    "label": "Rio de Janeiro Santos Dumont Airport (SDU)"
  },
  {
    "value": "RGL",
    "label": "Rio Gallegos Piloto Civil N. Fernández Airport (RGL)"
  },
  {
    "value": "RGA",
    "label": "Rio Grande Gobernador Ramón Trejo Noel International Airport (RGA)"
  },
  {
    "value": "RCH",
    "label": "Riohacha Almirante Padilla Airport (RCH)"
  },
  {
    "value": "RIJ",
    "label": "Rioja Juan Simons Vela Airport (RIJ)"
  },
  {
    "value": "RIS",
    "label": "Rishiri Rishiri Airport (RIS)"
  },
  {
    "value": "RIV",
    "label": "Riverside March Air Reserve Base (RIV)"
  },
  {
    "value": "RAL",
    "label": "Riverside Riverside Municipal Airport (RAL)"
  },
  {
    "value": "RIW",
    "label": "Riverton Central Wyoming Regional Airport (RIW)"
  },
  {
    "value": "YRI",
    "label": "Rivière-du-Loup Rivière-du-Loup Airport (YRI)"
  },
  {
    "value": "RWN",
    "label": "Rivne Rivne International Airport (RWN)"
  },
  {
    "value": "RUH",
    "label": "Riyadh King Khaled International Airport (RUH)"
  },
  {
    "value": "RIY",
    "label": "Riyan Riyan Mukalla International Airport (RIY)"
  },
  {
    "value": "RZV",
    "label": "Rize Rize–Artvin Airport (RZV)"
  },
  {
    "value": "RIZ",
    "label": "Rizhao (Donggang) Rizhao Shanzihe Airport (RIZ)"
  },
  {
    "value": "ROA",
    "label": "Roanoke Roanoke–Blacksburg Regional Airport (ROA)"
  },
  {
    "value": "ROD",
    "label": "Robertson Robertson Airport (ROD)"
  },
  {
    "value": "YRJ",
    "label": "Roberval Roberval Airport (YRJ)"
  },
  {
    "value": "RCO",
    "label": "Rochefort/Saint-Agnant Rochefort-Saint-Agnant (BA 721) Airport (RCO)"
  },
  {
    "value": "ROC",
    "label": "Rochester Frederick Douglass Greater Rochester International Airport (ROC)"
  },
  {
    "value": "RST",
    "label": "Rochester Rochester International Airport (RST)"
  },
  {
    "value": "RSD",
    "label": "Rock Sound Rock Sound Airport (RSD)"
  },
  {
    "value": "RKS",
    "label": "Rock Springs Southwest Wyoming Regional Airport (RKS)"
  },
  {
    "value": "ROK",
    "label": "Rockhampton Rockhampton Airport (ROK)"
  },
  {
    "value": "RKD",
    "label": "Rockland Knox County Regional Airport (RKD)"
  },
  {
    "value": "RWI",
    "label": "Rocky Mount Rocky Mount Wilson Regional Airport (RWI)"
  },
  {
    "value": "MRW",
    "label": "Rødby Lolland Falster Maribo Airport (MRW)"
  },
  {
    "value": "RDZ",
    "label": "Rodez/Marcillac Rodez–Aveyron Airport (RDZ)"
  },
  {
    "value": "ROI",
    "label": "Roi Et Roi Et Airport (ROI)"
  },
  {
    "value": "RMA",
    "label": "Roma Roma Airport (RMA)"
  },
  {
    "value": "CIA",
    "label": "Rome Ciampino–G. B. Pastine International Airport (CIA)"
  },
  {
    "value": "RME",
    "label": "Rome Griffiss International Airport (RME)"
  },
  {
    "value": "RMG",
    "label": "Rome Richard B Russell Airport (RMG)"
  },
  {
    "value": "FCO",
    "label": "Rome Rome–Fiumicino Leonardo da Vinci International Airport (FCO)"
  },
  {
    "value": "LYX",
    "label": "Romney Marsh, Kent Lydd London Ashford Airport (LYX)"
  },
  {
    "value": "TRS",
    "label": "Ronchi dei Legionari (GO) Trieste–Friuli Venezia Giulia Airport (TRS)"
  },
  {
    "value": "ROO",
    "label": "Rondonópolis Maestro Marinho Franco Airport (ROO)"
  },
  {
    "value": "RNN",
    "label": "Rønne Bornholm Airport (RNN)"
  },
  {
    "value": "RNB",
    "label": "Ronneby Ronneby Airport (RNB)"
  },
  {
    "value": "WVB",
    "label": "Rooikop Walvis Bay Airport (WVB)"
  },
  {
    "value": "RRS",
    "label": "Røros Røros Airport (RRS)"
  },
  {
    "value": "RVK",
    "label": "Rørvik Rørvik Airport, Ryum (RVK)"
  },
  {
    "value": "ROS",
    "label": "Rosario Rosario Islas Malvinas International Airport (ROS)"
  },
  {
    "value": "RPN",
    "label": "Rosh Pina Rosh Pina Airport (RPN)"
  },
  {
    "value": "RKE",
    "label": "Roskilde Copenhagen Roskilde Airport (RKE)"
  },
  {
    "value": "XRR",
    "label": "Ross River Ross River Airport (XRR)"
  },
  {
    "value": "ROV",
    "label": "Rostov-on-Don Platov International Airport (ROV)"
  },
  {
    "value": "ROW",
    "label": "Roswell Roswell Air Center Airport (ROW)"
  },
  {
    "value": "ROP",
    "label": "Rota Island Rota International Airport (ROP)"
  },
  {
    "value": "ROZ",
    "label": "Rota Rota Naval Station Airport (ROZ)"
  },
  {
    "value": "ROT",
    "label": "Rotorua Rotorua Regional Airport (ROT)"
  },
  {
    "value": "RTM",
    "label": "Rotterdam Rotterdam The Hague Airport (RTM)"
  },
  {
    "value": "RRK",
    "label": "Rourkela Rourkela Airport (RRK)"
  },
  {
    "value": "YUY",
    "label": "Rouyn-Noranda Rouyn Noranda Airport (YUY)"
  },
  {
    "value": "RVN",
    "label": "Rovaniemi Rovaniemi Airport (RVN)"
  },
  {
    "value": "RXS",
    "label": "Roxas City Roxas Airport (RXS)"
  },
  {
    "value": "RYN",
    "label": "Royan/Médis Royan-Médis Airport (RYN)"
  },
  {
    "value": "RUV",
    "label": "Rubelsanto Rubelsanto Airport (RUV)"
  },
  {
    "value": "RBY",
    "label": "Ruby Ruby Airport (RBY)"
  },
  {
    "value": "RUG",
    "label": "Rugao (Nantong) Rugao Air Base (RUG)"
  },
  {
    "value": "NDU",
    "label": "Rundu Rundu Airport (NDU)"
  },
  {
    "value": "RQA",
    "label": "Ruoqiang Town Ruoqiang Loulan Airport (RQA)"
  },
  {
    "value": "RSL",
    "label": "Russell Russell Municipal Airport (RSL)"
  },
  {
    "value": "RUT",
    "label": "Rutland Rutland - Southern Vermont Regional Airport (RUT)"
  },
  {
    "value": "RYB",
    "label": "Rybinsk Staroselye Airport (RYB)"
  },
  {
    "value": "SCN",
    "label": "Saarbrücken Saarbrücken Airport (SCN)"
  },
  {
    "value": "SBT",
    "label": "Sabetta Sabetta International Airport (SBT)"
  },
  {
    "value": "SEB",
    "label": "Sabha Sabha Airport (SEB)"
  },
  {
    "value": "AFZ",
    "label": "Sabzevar Sabzevar National Airport (AFZ)"
  },
  {
    "value": "HIN",
    "label": "Sacheon Sacheon Airport / Sacheon Air Base (HIN)"
  },
  {
    "value": "MCC",
    "label": "Sacramento McClellan Airfield (MCC)"
  },
  {
    "value": "SAC",
    "label": "Sacramento Sacramento Executive Airport (SAC)"
  },
  {
    "value": "SMF",
    "label": "Sacramento Sacramento International Airport (SMF)"
  },
  {
    "value": "MHR",
    "label": "Sacramento Sacramento Mather Airport (MHR)"
  },
  {
    "value": "SDS",
    "label": "Sado Sado Airport (SDS)"
  },
  {
    "value": "HSG",
    "label": "Saga Saga Airport (HSG)"
  },
  {
    "value": "SPD",
    "label": "Saidpur Saidpur Airport (SPD)"
  },
  {
    "value": "SDT",
    "label": "Saidu Sharif Saidu Sharif Airport (SDT)"
  },
  {
    "value": "ACI",
    "label": "Saint Anne Alderney Airport (ACI)"
  },
  {
    "value": "SKV",
    "label": "Saint Catherine Saint Catherine International Airport (SKV)"
  },
  {
    "value": "STC",
    "label": "Saint Cloud Saint Cloud Regional Airport (STC)"
  },
  {
    "value": "GND",
    "label": "Saint George's Maurice Bishop International Airport (GND)"
  },
  {
    "value": "JER",
    "label": "Saint Helier Jersey Airport (JER)"
  },
  {
    "value": "YSJ",
    "label": "Saint John Saint John Airport (YSJ)"
  },
  {
    "value": "XLS",
    "label": "Saint Louis Saint Louis Airport (XLS)"
  },
  {
    "value": "STP",
    "label": "Saint Paul Saint Paul Downtown Holman Field (STP)"
  },
  {
    "value": "GCI",
    "label": "Saint Peter Port Guernsey Airport (GCI)"
  },
  {
    "value": "AOT",
    "label": "Saint-Christophe (AO) Aosta Corrado Gex Airport (AOT)"
  },
  {
    "value": "GNB",
    "label": "Saint-Étienne-de-Saint-Geoirs, Isère Grenoble Alpes Isère Airport (GNB)"
  },
  {
    "value": "OYP",
    "label": "Saint-Georges-de-l'Oyapock Saint-Georges-de-l'Oyapock Airport (OYP)"
  },
  {
    "value": "RNS",
    "label": "Saint-Jacques-de-la-Lande, Ille-et-Vilaine Rennes-Saint-Jacques Airport (RNS)"
  },
  {
    "value": "RNE",
    "label": "Saint-Léger-sur-Roanne Roanne-Renaison Airport (RNE)"
  },
  {
    "value": "YSL",
    "label": "Saint-Léonard Saint-Léonard Airport (YSL)"
  },
  {
    "value": "BSL",
    "label": "Saint-Louis EuroAirport Basel-Mulhouse-Freiburg (BSL)"
  },
  {
    "value": "SNR",
    "label": "Saint-Nazaire/Montoir Saint-Nazaire-Montoir Airport (SNR)"
  },
  {
    "value": "ZSE",
    "label": "Saint-Pierre Pierrefonds Airport (ZSE)"
  },
  {
    "value": "FSP",
    "label": "Saint-Pierre St Pierre Airport (FSP)"
  },
  {
    "value": "RUN",
    "label": "Sainte-Marie Roland Garros Airport (RUN)"
  },
  {
    "value": "FEZ",
    "label": "Saïss Fes Saïss International Airport (FEZ)"
  },
  {
    "value": "SLL",
    "label": "Salalah Salalah Airport (SLL)"
  },
  {
    "value": "SLM",
    "label": "Salamanca Salamanca Airport (SLM)"
  },
  {
    "value": "SXE",
    "label": "Sale West Sale Airport (SXE)"
  },
  {
    "value": "SLY",
    "label": "Salekhard Salekhard Airport (SLY)"
  },
  {
    "value": "SXV",
    "label": "Salem Salem Airport (SXV)"
  },
  {
    "value": "SLE",
    "label": "Salem Salem-Willamette Valley Airport/McNary Field (SLE)"
  },
  {
    "value": "QSR",
    "label": "Salerno Salerno Costa d'Amalfi Airport (QSR)"
  },
  {
    "value": "SLN",
    "label": "Salina Salina Municipal Airport (SLN)"
  },
  {
    "value": "SNC",
    "label": "Salinas General Ulpiano Paez Airport (SNC)"
  },
  {
    "value": "SNS",
    "label": "Salinas Salinas Municipal Airport (SNS)"
  },
  {
    "value": "SBY",
    "label": "Salisbury Salisbury Ocean City Wicomico Regional Airport (SBY)"
  },
  {
    "value": "YSN",
    "label": "Salmon Arm Shuswap Regional Airport (YSN)"
  },
  {
    "value": "SMN",
    "label": "Salmon Lemhi County Airport (SMN)"
  },
  {
    "value": "SLC",
    "label": "Salt Lake City Salt Lake City International Airport (SLC)"
  },
  {
    "value": "SLA",
    "label": "Salta Martin Miguel De Guemes International Airport (SLA)"
  },
  {
    "value": "SLW",
    "label": "Saltillo Plan De Guadalupe International Airport (SLW)"
  },
  {
    "value": "STY",
    "label": "Salto Nueva Hesperides International Airport (STY)"
  },
  {
    "value": "SSA",
    "label": "Salvador Deputado Luiz Eduardo Magalhães International Airport (SSA)"
  },
  {
    "value": "SZG",
    "label": "Salzburg Salzburg Airport (SZG)"
  },
  {
    "value": "AZS",
    "label": "Samana Samaná El Catey International Airport (AZS)"
  },
  {
    "value": "KUF",
    "label": "Samara Kurumoch International Airport (KUF)"
  },
  {
    "value": "AAP",
    "label": "Samarinda Aji Pangeran Tumenggung Pranoto International Airport (AAP)"
  },
  {
    "value": "SKD",
    "label": "Samarkand Samarkand Airport (SKD)"
  },
  {
    "value": "SVB",
    "label": "Sambava Sambava Airport (SVB)"
  },
  {
    "value": "SMV",
    "label": "Samedan Samedan Airport (SMV)"
  },
  {
    "value": "SMI",
    "label": "Samos Island Samos Airport (SMI)"
  },
  {
    "value": "SZF",
    "label": "Samsun Samsun-Çarşamba Airport (SZF)"
  },
  {
    "value": "ADZ",
    "label": "San Andrés Gustavo Rojas Pinilla International Airport (ADZ)"
  },
  {
    "value": "SJT",
    "label": "San Angelo San Angelo Regional Mathis Field (SJT)"
  },
  {
    "value": "SKF",
    "label": "San Antonio Lackland Air Force Base (SKF)"
  },
  {
    "value": "SAT",
    "label": "San Antonio San Antonio International Airport (SAT)"
  },
  {
    "value": "SSF",
    "label": "San Antonio Stinson Municipal Airport (SSF)"
  },
  {
    "value": "ACE",
    "label": "San Bartolomé César Manrique-Lanzarote Airport (ACE)"
  },
  {
    "value": "FRS",
    "label": "San Benito Mundo Maya International Airport (FRS)"
  },
  {
    "value": "SBD",
    "label": "San Bernardino San Bernardino International Airport (SBD)"
  },
  {
    "value": "BRC",
    "label": "San Carlos de Bariloche San Carlos de Bariloche Airport (BRC)"
  },
  {
    "value": "STB",
    "label": "San Carlos del Zulia Miguel Urdaneta Fernández Airport (STB)"
  },
  {
    "value": "SQL",
    "label": "San Carlos San Carlos Airport (SQL)"
  },
  {
    "value": "SDM",
    "label": "San Diego Brown Field Municipal Airport (SDM)"
  },
  {
    "value": "NKX",
    "label": "San Diego Miramar Marine Corps Air Station - Mitscher Field (NKX)"
  },
  {
    "value": "NZY",
    "label": "San Diego North Island Naval Air Station-Halsey Field (NZY)"
  },
  {
    "value": "SAN",
    "label": "San Diego San Diego International Airport (SAN)"
  },
  {
    "value": "SNF",
    "label": "San Felipe Sub Teniente Nestor Arias Airport (SNF)"
  },
  {
    "value": "SFD",
    "label": "San Fernando de Apure San Fernando de Apure Las Flecheras National Airport (SFD)"
  },
  {
    "value": "SFE",
    "label": "San Fernando San Fernando Airport (SFE)"
  },
  {
    "value": "SFO",
    "label": "San Francisco San Francisco International Airport (SFO)"
  },
  {
    "value": "MJV",
    "label": "San Javier San Javier Airport (MJV)"
  },
  {
    "value": "SJO",
    "label": "San José (Alajuela) Juan Santamaría International Airport (SJO)"
  },
  {
    "value": "SJD",
    "label": "San José del Cabo Los Cabos International Airport (SJD)"
  },
  {
    "value": "SJE",
    "label": "San José Del Guaviare Jorge E. Gonzalez Torres Airport (SJE)"
  },
  {
    "value": "EUQ",
    "label": "San Jose Evelio Javier Airport (EUQ)"
  },
  {
    "value": "SJC",
    "label": "San Jose Norman Y. Mineta San Jose International Airport (SJC)"
  },
  {
    "value": "SJI",
    "label": "San Jose San Jose Airport (SJI)"
  },
  {
    "value": "SYQ",
    "label": "San Jose Tobías Bolaños International Airport (SYQ)"
  },
  {
    "value": "UAQ",
    "label": "San Juan Domingo Faustino Sarmiento Airport (UAQ)"
  },
  {
    "value": "SIG",
    "label": "San Juan Fernando Luis Ribas Dominicci Airport (SIG)"
  },
  {
    "value": "SJU",
    "label": "San Juan Luis Munoz Marin International Airport (SJU)"
  },
  {
    "value": "ULA",
    "label": "San Julian Capitan D Daniel Vazquez Airport (ULA)"
  },
  {
    "value": "LUQ",
    "label": "San Luis Brigadier Mayor D Cesar Raul Ojeda Airport (LUQ)"
  },
  {
    "value": "SBP",
    "label": "San Luis Obispo San Luis County Regional Airport (SBP)"
  },
  {
    "value": "SLP",
    "label": "San Luis Potosí Ponciano Arriaga International Airport (SLP)"
  },
  {
    "value": "TUC",
    "label": "San Miguel de Tucumán Teniente Benjamin Matienzo Airport (TUC)"
  },
  {
    "value": "SPR",
    "label": "San Pedro John Greif II Airport (SPR)"
  },
  {
    "value": "SAP",
    "label": "San Pedro Sula Ramón Villeda Morales International Airport (SAP)"
  },
  {
    "value": "AFA",
    "label": "San Rafael Suboficial Ay Santiago Germano Airport (AFA)"
  },
  {
    "value": "SAL",
    "label": "San Salvador (San Luis Talpa) Monseñor Óscar Arnulfo Romero International Airport (SAL)"
  },
  {
    "value": "JUJ",
    "label": "San Salvador de Jujuy Gobernador Horacio Guzman International Airport (JUJ)"
  },
  {
    "value": "ILS",
    "label": "San Salvador Ilopango International Airport (ILS)"
  },
  {
    "value": "ZSA",
    "label": "San Salvador San Salvador Airport (ZSA)"
  },
  {
    "value": "SVI",
    "label": "San Vicente Del Caguán Eduardo Falla Solano Airport (SVI)"
  },
  {
    "value": "SAH",
    "label": "Sanaa Sanaa International Airport (SAH)"
  },
  {
    "value": "MDY",
    "label": "Sand Island Henderson Field (MDY)"
  },
  {
    "value": "SDP",
    "label": "Sand Point Sand Point Airport (SDP)"
  },
  {
    "value": "SDK",
    "label": "Sandakan Sandakan Airport (SDK)"
  },
  {
    "value": "SNJ",
    "label": "Sandino San Julián Air Base (SNJ)"
  },
  {
    "value": "YZP",
    "label": "Sandspit Sandspit Airport (YZP)"
  },
  {
    "value": "ZSJ",
    "label": "Sandy Lake Sandy Lake Airport (ZSJ)"
  },
  {
    "value": "TTE",
    "label": "Sango Sultan Babullah Airport (TTE)"
  },
  {
    "value": "YUX",
    "label": "Sanirajak Hall Beach Airport (YUX)"
  },
  {
    "value": "GNY",
    "label": "Şanlıurfa Şanlıurfa GAP Airport (GNY)"
  },
  {
    "value": "SQJ",
    "label": "Sanming (Sha) Sanming Shaxian Airport (SQJ)"
  },
  {
    "value": "SBL",
    "label": "Santa Ana del Yacuma Santa Ana Del Yacuma Airport (SBL)"
  },
  {
    "value": "SNA",
    "label": "Santa Ana John Wayne Orange County International Airport (SNA)"
  },
  {
    "value": "SBA",
    "label": "Santa Barbara Santa Barbara Municipal Airport (SBA)"
  },
  {
    "value": "SNU",
    "label": "Santa Clara Abel Santamaria Airport (SNU)"
  },
  {
    "value": "GRW",
    "label": "Santa Cruz da Graciosa Graciosa Airport (GRW)"
  },
  {
    "value": "FLW",
    "label": "Santa Cruz das Flores Flores Airport (FLW)"
  },
  {
    "value": "SRZ",
    "label": "Santa Cruz El Trompillo Airport (SRZ)"
  },
  {
    "value": "VVI",
    "label": "Santa Cruz Viru Viru International Airport (VVI)"
  },
  {
    "value": "SAF",
    "label": "Santa Fe Santa Fe Municipal Airport (SAF)"
  },
  {
    "value": "SFN",
    "label": "Santa Fe Sauce Viejo Airport (SFN)"
  },
  {
    "value": "RIA",
    "label": "Santa Maria Santa Maria Airport (RIA)"
  },
  {
    "value": "SMX",
    "label": "Santa Maria Santa Maria Public Airport Captain G Allan Hancock Field (SMX)"
  },
  {
    "value": "VRO",
    "label": "Santa Marta Kawama Airport (VRO)"
  },
  {
    "value": "SMR",
    "label": "Santa Marta Simón Bolívar International Airport (SMR)"
  },
  {
    "value": "SMO",
    "label": "Santa Monica Santa Monica Municipal Airport (SMO)"
  },
  {
    "value": "STS",
    "label": "Santa Rosa Charles M. Schulz Sonoma County Airport (STS)"
  },
  {
    "value": "ETR",
    "label": "Santa Rosa Santa Rosa - Artillery Colonel Victor Larrea International Airport (ETR)"
  },
  {
    "value": "RSA",
    "label": "Santa Rosa Santa Rosa Airport (RSA)"
  },
  {
    "value": "SST",
    "label": "Santa Teresita Santa Teresita Airport (SST)"
  },
  {
    "value": "SDR",
    "label": "Santander Seve Ballesteros-Santander Airport (SDR)"
  },
  {
    "value": "STM",
    "label": "Santarém Santarém - Maestro Wilson Fonseca International Airport (STM)"
  },
  {
    "value": "SCU",
    "label": "Santiago Antonio Maceo International Airport (SCU)"
  },
  {
    "value": "STI",
    "label": "Santiago Cibao International Airport (STI)"
  },
  {
    "value": "SCL",
    "label": "Santiago Comodoro Arturo Merino Benítez International Airport (SCL)"
  },
  {
    "value": "SCQ",
    "label": "Santiago de Compostela Santiago-Rosalía de Castro Airport (SCQ)"
  },
  {
    "value": "SDE",
    "label": "Santiago del Estero Vicecomodoro Angel D. La Paz Aragonés Airport (SDE)"
  },
  {
    "value": "SYP",
    "label": "Santiago Ruben Cantu Airport (SYP)"
  },
  {
    "value": "GEL",
    "label": "Santo Ângelo Santo Ângelo Airport (GEL)"
  },
  {
    "value": "SDQ",
    "label": "Santo Domingo Las Américas International Airport (SDQ)"
  },
  {
    "value": "STD",
    "label": "Santo Domingo Mayor Buenaventura Vivas International Airport (STD)"
  },
  {
    "value": "JTR",
    "label": "Santorini Island Santorini Airport (JTR)"
  },
  {
    "value": "SYX",
    "label": "Sanya (Tianya) Sanya Phoenix International Airport (SYX)"
  },
  {
    "value": "SJL",
    "label": "São Gabriel da Cachoeira São Gabriel da Cachoeira Airport (SJL)"
  },
  {
    "value": "SJP",
    "label": "São José do Rio Preto Prof. Eribelto Manoel Reino State Airport (SJP)"
  },
  {
    "value": "SJK",
    "label": "São José Dos Campos Professor Urbano Ernesto Stumpf Airport (SJK)"
  },
  {
    "value": "SLZ",
    "label": "São Luís Marechal Cunha Machado International Airport (SLZ)"
  },
  {
    "value": "RTE",
    "label": "São Paulo Campo de Marte Airport (RTE)"
  },
  {
    "value": "CGH",
    "label": "São Paulo Congonhas Airport (CGH)"
  },
  {
    "value": "GRU",
    "label": "São Paulo Guarulhos - Governador André Franco Montoro International Airport (GRU)"
  },
  {
    "value": "VXE",
    "label": "São Pedro São Pedro Airport (VXE)"
  },
  {
    "value": "JHF",
    "label": "São Roque São Paulo Catarina Executive Airport (JHF)"
  },
  {
    "value": "PCP",
    "label": "São Tomé & Príncipe Principe Airport (PCP)"
  },
  {
    "value": "TMS",
    "label": "São Tomé São Tomé International Airport (TMS)"
  },
  {
    "value": "CTS",
    "label": "Sapporo New Chitose Airport (CTS)"
  },
  {
    "value": "OKD",
    "label": "Sapporo Sapporo Okadama Airport (OKD)"
  },
  {
    "value": "SJJ",
    "label": "Sarajevo Sarajevo International Airport (SJJ)"
  },
  {
    "value": "CKT",
    "label": "Sarakhs Sarakhs Airport (CKT)"
  },
  {
    "value": "SLK",
    "label": "Saranac Lake Adirondack Regional Airport (SLK)"
  },
  {
    "value": "SKX",
    "label": "Saransk Saransk Airport (SKX)"
  },
  {
    "value": "SRQ",
    "label": "Sarasota/Bradenton Sarasota Bradenton International Airport (SRQ)"
  },
  {
    "value": "GSV",
    "label": "Saratov Gagarin International Airport (GSV)"
  },
  {
    "value": "SGI",
    "label": "Sargodha Mushaf Air Base (SGI)"
  },
  {
    "value": "SRY",
    "label": "Sari Sari Dasht-e Naz International Airport (SRY)"
  },
  {
    "value": "UAB",
    "label": "Sarıçam İncirlik Air Base (UAB)"
  },
  {
    "value": "SOB",
    "label": "Sármellék Hévíz–Balaton Airport (SOB)"
  },
  {
    "value": "YZR",
    "label": "Sarnia Chris Hadfield Airport (YZR)"
  },
  {
    "value": "SJX",
    "label": "Sartaneja Sartaneja Airport (SJX)"
  },
  {
    "value": "YXE",
    "label": "Saskatoon Saskatoon John G. Diefenbaker International Airport (YXE)"
  },
  {
    "value": "SYS",
    "label": "Saskylakh Saskylakh Airport (SYS)"
  },
  {
    "value": "SUJ",
    "label": "Satu Mare Satu Mare International Airport (SUJ)"
  },
  {
    "value": "YAM",
    "label": "Sault Ste Marie Sault Ste Marie Airport (YAM)"
  },
  {
    "value": "VHC",
    "label": "Saurimo Saurimo Airport (VHC)"
  },
  {
    "value": "SVN",
    "label": "Savannah Hunter Army Air Field (SVN)"
  },
  {
    "value": "SAV",
    "label": "Savannah Savannah Hilton Head International Airport (SAV)"
  },
  {
    "value": "SVL",
    "label": "Savonlinna Savonlinna Airport (SVL)"
  },
  {
    "value": "SVA",
    "label": "Savoonga Savoonga Airport (SVA)"
  },
  {
    "value": "CMI",
    "label": "Savoy University of Illinois Willard Airport (CMI)"
  },
  {
    "value": "TAB",
    "label": "Scarborough A.N.R. Robinson International Airport (TAB)"
  },
  {
    "value": "YKL",
    "label": "Schefferville Schefferville Airport (YKL)"
  },
  {
    "value": "SCH",
    "label": "Schenectady Schenectady County Airport (SCH)"
  },
  {
    "value": "LEJ",
    "label": "Schkeuditz Leipzig/Halle Airport (LEJ)"
  },
  {
    "value": "BFF",
    "label": "Scottsbluff Western Neb. Rgnl/William B. Heilig Airport (BFF)"
  },
  {
    "value": "BFI",
    "label": "Seattle Boeing Field King County International Airport (BFI)"
  },
  {
    "value": "SEA",
    "label": "Seattle Seattle–Tacoma International Airport (SEA)"
  },
  {
    "value": "POW",
    "label": "Sečovlje Portorož Airport (POW)"
  },
  {
    "value": "ZEC",
    "label": "Secunda Secunda Airport (ZEC)"
  },
  {
    "value": "LIN",
    "label": "Segrate (MI) Milano Linate Airport (LIN)"
  },
  {
    "value": "SYW",
    "label": "Sehwan Sharif Sehwan Sharif Airport (SYW)"
  },
  {
    "value": "SJY",
    "label": "Seinäjoki / Ilmajoki Seinäjoki Airport (SJY)"
  },
  {
    "value": "GXF",
    "label": "Seiyun Seiyun Hadhramaut International Airport (GXF)"
  },
  {
    "value": "TKD",
    "label": "Sekondi-Takoradi Takoradi Airport (TKD)"
  },
  {
    "value": "PKW",
    "label": "Selebi Phikwe Selebi Phikwe Airport (PKW)"
  },
  {
    "value": "XSP",
    "label": "Seletar Seletar Airport (XSP)"
  },
  {
    "value": "SRG",
    "label": "Semarang Achmad Yani Airport (SRG)"
  },
  {
    "value": "PLX",
    "label": "Semey Semey Airport (PLX)"
  },
  {
    "value": "DJJ",
    "label": "Sentani Dortheys Hiyo Eluay International Airport (DJJ)"
  },
  {
    "value": "SSN",
    "label": "Seongnam Seoul Air Base (K-16) (SSN)"
  },
  {
    "value": "GMP",
    "label": "Seoul Gimpo International Airport (GMP)"
  },
  {
    "value": "ICN",
    "label": "Seoul Incheon International Airport (ICN)"
  },
  {
    "value": "KUL",
    "label": "Sepang Kuala Lumpur International Airport (KUL)"
  },
  {
    "value": "YZV",
    "label": "Sept-Îles Sept-Îles Airport (YZV)"
  },
  {
    "value": "ZRI",
    "label": "Serui Stevanus Rumbewas Airport (ZRI)"
  },
  {
    "value": "QSF",
    "label": "Sétif Ain Arnat Airport (QSF)"
  },
  {
    "value": "MZI",
    "label": "Sévaré Mopti Ambodédjo International Airport (MZI)"
  },
  {
    "value": "UKS",
    "label": "Sevastopol Sevastopol International Airport / Belbek Air Base (UKS)"
  },
  {
    "value": "VEO",
    "label": "Severo-Yeniseysk Severo-Yeniseysk Airport (VEO)"
  },
  {
    "value": "SVQ",
    "label": "Sevilla Sevilla Airport (SVQ)"
  },
  {
    "value": "SWD",
    "label": "Seward Seward Airport (SWD)"
  },
  {
    "value": "ADA",
    "label": "Seyhan Adana Şakirpaşa Airport (ADA)"
  },
  {
    "value": "SFA",
    "label": "Sfax Sfax Thyna International Airport (SFA)"
  },
  {
    "value": "QSZ",
    "label": "Shache Shache Airport (QSZ)"
  },
  {
    "value": "CQD",
    "label": "Shahrekord Shahrekord Airport (CQD)"
  },
  {
    "value": "KNH",
    "label": "Shang-I Kinmen Airport (KNH)"
  },
  {
    "value": "SHA",
    "label": "Shanghai (Minhang) Shanghai Hongqiao International Airport (SHA)"
  },
  {
    "value": "PVG",
    "label": "Shanghai (Pudong) Shanghai Pudong International Airport (PVG)"
  },
  {
    "value": "SQD",
    "label": "Shangrao (Hengfeng) Shangrao Sanqingshan Airport (SQD)"
  },
  {
    "value": "LXA",
    "label": "Shannan (Gonggar) Lhasa Gonggar Airport (LXA)"
  },
  {
    "value": "SNN",
    "label": "Shannon Shannon Airport (SNN)"
  },
  {
    "value": "SXJ",
    "label": "Shanshan Shanshan Airport (SXJ)"
  },
  {
    "value": "HSC",
    "label": "Shaoguan Shaoguan Danxia Airport (HSC)"
  },
  {
    "value": "WGN",
    "label": "Shaoyang (Wugang) Shaoyang Wugang Airport (WGN)"
  },
  {
    "value": "SHJ",
    "label": "Sharjah Sharjah International Airport (SHJ)"
  },
  {
    "value": "SSH",
    "label": "Sharm El Sheikh Sharm El Sheikh International Airport (SSH)"
  },
  {
    "value": "NUM",
    "label": "Sharma Neom Bay Airport (NUM)"
  },
  {
    "value": "SHW",
    "label": "Sharurah Sharurah Domestic Airport (SHW)"
  },
  {
    "value": "YEM",
    "label": "Sheguiandah Manitoulin East Municipal Airport (YEM)"
  },
  {
    "value": "SYA",
    "label": "Shemya Eareckson Air Station (SYA)"
  },
  {
    "value": "HPG",
    "label": "Shennongjia (Hongping) Shennongjia Hongping Airport (HPG)"
  },
  {
    "value": "SZX",
    "label": "Shenzhen (Bao'an) Shenzhen Bao'an International Airport (SZX)"
  },
  {
    "value": "YSC",
    "label": "Sherbrooke Sherbrooke Airport (YSC)"
  },
  {
    "value": "SHR",
    "label": "Sheridan Sheridan County Airport (SHR)"
  },
  {
    "value": "SJW",
    "label": "Shijiazhuang Shijiazhuang Zhengding International Airport (SJW)"
  },
  {
    "value": "SHL",
    "label": "Shillong Shillong Airport (SHL)"
  },
  {
    "value": "RQY",
    "label": "Shimoga Rashtrakavi Kuvempu Airport (RQY)"
  },
  {
    "value": "NGQ",
    "label": "Shiquanhe Ngari Gunsa Airport (NGQ)"
  },
  {
    "value": "SHM",
    "label": "Shirahama Nanki Shirahama Airport (SHM)"
  },
  {
    "value": "SYZ",
    "label": "Shiraz Shiraz Shahid Dastghaib International Airport (SYZ)"
  },
  {
    "value": "WDS",
    "label": "Shiyan (Maojian) Shiyan Wudangshan Airport (WDS)"
  },
  {
    "value": "SYO",
    "label": "Shonai Shonai Airport (SYO)"
  },
  {
    "value": "SOW",
    "label": "Show Low Show Low Regional Airport (SOW)"
  },
  {
    "value": "IMQ",
    "label": "Showt Maku National Airport (IMQ)"
  },
  {
    "value": "SHV",
    "label": "Shreveport Shreveport Regional Airport (SHV)"
  },
  {
    "value": "CHG",
    "label": "Shuangta, Chaoyang Chaoyang Airport (CHG)"
  },
  {
    "value": "CYI",
    "label": "Shuishang Chiayi Airport (CYI)"
  },
  {
    "value": "CIT",
    "label": "Shymkent Shymkent Airport (CIT)"
  },
  {
    "value": "SKT",
    "label": "Sialkot Sialkot International Airport (SKT)"
  },
  {
    "value": "SQQ",
    "label": "Šiauliai Šiauliai International Airport (SQQ)"
  },
  {
    "value": "SBZ",
    "label": "Sibiu Sibiu International Airport (SBZ)"
  },
  {
    "value": "FLZ",
    "label": "Sibolga (Pinangsori) Dr. Ferdinand Lumban Tobing Airport (FLZ)"
  },
  {
    "value": "SBW",
    "label": "Sibu Sibu Airport (SBW)"
  },
  {
    "value": "BWA",
    "label": "Siddharthanagar (Bhairahawa) Gautam Buddha International Airport (BWA)"
  },
  {
    "value": "SDY",
    "label": "Sidney Sidney - Richland Regional Airport (SDY)"
  },
  {
    "value": "SNY",
    "label": "Sidney Sidney Municipal Airport Lloyd W Carr Field (SNY)"
  },
  {
    "value": "SAI",
    "label": "Siem Reap Siem Reap-Angkor International Airport (SAI)"
  },
  {
    "value": "SIJ",
    "label": "Siglufjörður Siglufjörður Airport (SIJ)"
  },
  {
    "value": "NSY",
    "label": "Sigonella (CT) Sigonella Navy Air Base (NSY)"
  },
  {
    "value": "SXZ",
    "label": "Siirt Siirt Airport (SXZ)"
  },
  {
    "value": "BJX",
    "label": "Silao Del Bajío International Airport (BJX)"
  },
  {
    "value": "IXS",
    "label": "Silchar Silchar Airport (IXS)"
  },
  {
    "value": "IXB",
    "label": "Siliguri Bagdogra Airport (IXB)"
  },
  {
    "value": "SVC",
    "label": "Silver City Grant County Airport (SVC)"
  },
  {
    "value": "SIP",
    "label": "Simferopol Simferopol International Airport (SIP)"
  },
  {
    "value": "CNL",
    "label": "Sindal Sindal Airport (CNL)"
  },
  {
    "value": "SDW",
    "label": "Sindhudurg Sindhudurg Airport (SDW)"
  },
  {
    "value": "SIN",
    "label": "Singapore Singapore Changi Airport (SIN)"
  },
  {
    "value": "NOP",
    "label": "Sinop Sinop Airport (NOP)"
  },
  {
    "value": "SXM",
    "label": "Sint Maarten Princess Juliana International Airport (SXM)"
  },
  {
    "value": "SQG",
    "label": "Sintang Tebelian Airport (SQG)"
  },
  {
    "value": "SIR",
    "label": "Sion Sion Airport (SIR)"
  },
  {
    "value": "SUX",
    "label": "Sioux City Sioux Gateway Airport / Brigadier General Bud Day Field (SUX)"
  },
  {
    "value": "FSD",
    "label": "Sioux Falls Sioux Falls Regional Airport / Joe Foss Field (FSD)"
  },
  {
    "value": "YXL",
    "label": "Sioux Lookout Sioux Lookout Airport (YXL)"
  },
  {
    "value": "XSB",
    "label": "Sir Bani Yas Sir Bani Yas Airport (XSB)"
  },
  {
    "value": "SXI",
    "label": "Siri Siri Airport (SXI)"
  },
  {
    "value": "SYJ",
    "label": "Sirjan Sirjan Airport (SYJ)"
  },
  {
    "value": "SRX",
    "label": "Sirt Sirt International Airport / Ghardabiya Airbase (SRX)"
  },
  {
    "value": "SIS",
    "label": "Sishen Sishen Airport (SIS)"
  },
  {
    "value": "JHS",
    "label": "Sisimiut Sisimiut Airport (JHS)"
  },
  {
    "value": "SIT",
    "label": "Sitka Sitka Rocky Gutierrez Airport (SIT)"
  },
  {
    "value": "AKY",
    "label": "Sittwe Sittwe Airport (AKY)"
  },
  {
    "value": "NKT",
    "label": "Şırnak Şırnak Şerafettin Elçi Airport (NKT)"
  },
  {
    "value": "KDU",
    "label": "Skardu Skardu Airport (KDU)"
  },
  {
    "value": "SFT",
    "label": "Skellefteå Skellefteå Airport (SFT)"
  },
  {
    "value": "JSI",
    "label": "Skiathos Skiathos Island National Airport (JSI)"
  },
  {
    "value": "SQW",
    "label": "Skive Skive Airport (SQW)"
  },
  {
    "value": "STA",
    "label": "Skjern Stauning Vestjylland  Airport (STA)"
  },
  {
    "value": "KVB",
    "label": "Skövde Skövde Airport (KVB)"
  },
  {
    "value": "SZK",
    "label": "Skukuza Skukuza Airport (SZK)"
  },
  {
    "value": "YZH",
    "label": "Slave Lake Slave Lake Airport (YZH)"
  },
  {
    "value": "YSU",
    "label": "Slemon Park Summerside Airport (YSU)"
  },
  {
    "value": "SLD",
    "label": "Sliač Sliač Airport (SLD)"
  },
  {
    "value": "SXL",
    "label": "Sligo Sligo Airport (SXL)"
  },
  {
    "value": "SMW",
    "label": "Smara Smara Airport (SMW)"
  },
  {
    "value": "YYD",
    "label": "Smithers Smithers Airport (YYD)"
  },
  {
    "value": "YSH",
    "label": "Smiths Falls Smiths Falls-Montague (Russ Beach) Airport (YSH)"
  },
  {
    "value": "LNX",
    "label": "Smolensk Smolensk North Airport (LNX)"
  },
  {
    "value": "MQY",
    "label": "Smyrna Smyrna Airport (MQY)"
  },
  {
    "value": "JSO",
    "label": "Sobral Dr. Luciano de Arruda Coelho Regional Airport (JSO)"
  },
  {
    "value": "AER",
    "label": "Sochi Sochi International Airport (AER)"
  },
  {
    "value": "SOT",
    "label": "Sodankyla Sodankyla Airport (SOT)"
  },
  {
    "value": "SOO",
    "label": "Söderhamn Söderhamn Airport (SOO)"
  },
  {
    "value": "SOF",
    "label": "Sofia Sofia Airport (SOF)"
  },
  {
    "value": "SKO",
    "label": "Sokoto Sadiq Abubakar III International Airport (SKO)"
  },
  {
    "value": "SSE",
    "label": "Solapur Solapur Airport (SSE)"
  },
  {
    "value": "SXQ",
    "label": "Soldotna Soldotna Airport (SXQ)"
  },
  {
    "value": "SOZ",
    "label": "Solenzara Solenzara (BA 126) Air Base (SOZ)"
  },
  {
    "value": "SME",
    "label": "Somerset Lake Cumberland Regional Airport (SME)"
  },
  {
    "value": "SGD",
    "label": "Sønderborg Sønderborg Airport (SGD)"
  },
  {
    "value": "DSO",
    "label": "Sŏndŏng-ni Sondok Airport (DSO)"
  },
  {
    "value": "SOJ",
    "label": "Sørkjosen Sørkjosen Airport (SOJ)"
  },
  {
    "value": "SOQ",
    "label": "Sorong Domine Eduard Osok Airport (SOQ)"
  },
  {
    "value": "SRT",
    "label": "Soroti Soroti Airport (SRT)"
  },
  {
    "value": "CHQ",
    "label": "Souda Chania International Airport (CHQ)"
  },
  {
    "value": "SBN",
    "label": "South Bend South Bend Regional Airport (SBN)"
  },
  {
    "value": "BIM",
    "label": "South Bimini South Bimini Airport (BIM)"
  },
  {
    "value": "BTV",
    "label": "South Burlington Burlington International Airport (BTV)"
  },
  {
    "value": "XSC",
    "label": "South Caicos South Caicos Airport (XSC)"
  },
  {
    "value": "TVL",
    "label": "South Lake Tahoe Lake Tahoe Airport (TVL)"
  },
  {
    "value": "ZBF",
    "label": "South Tetagouche Bathurst Airport (ZBF)"
  },
  {
    "value": "SOU",
    "label": "Southampton Southampton Airport (SOU)"
  },
  {
    "value": "SEN",
    "label": "Southend-on-Sea, Essex London Southend Airport (SEN)"
  },
  {
    "value": "GVN",
    "label": "Sovetskaya Gavan Sovetskaya Gavan (Maygatka) Airport (GVN)"
  },
  {
    "value": "OVS",
    "label": "Sovetskiy Sovetskiy Airport (OVS)"
  },
  {
    "value": "SXN",
    "label": "Sowa Sua Pan Airport (SXN)"
  },
  {
    "value": "SZA",
    "label": "Soyo Soyo Airport (SZA)"
  },
  {
    "value": "SVW",
    "label": "Sparrevohn Sparrevohn LRRS Airport (SVW)"
  },
  {
    "value": "ATH",
    "label": "Spata-Artemida Athens Eleftherios Venizelos International Airport (ATH)"
  },
  {
    "value": "SKA",
    "label": "Spokane Fairchild Air Force Base (SKA)"
  },
  {
    "value": "SFF",
    "label": "Spokane Felts Field (SFF)"
  },
  {
    "value": "GEG",
    "label": "Spokane Spokane International Airport (GEG)"
  },
  {
    "value": "AXP",
    "label": "Spring Point Spring Point Airport (AXP)"
  },
  {
    "value": "SBU",
    "label": "Springbok Springbok Airport (SBU)"
  },
  {
    "value": "YQF",
    "label": "Springbrook Red Deer Regional Airport (YQF)"
  },
  {
    "value": "SPI",
    "label": "Springfield Abraham Lincoln Capital Airport (SPI)"
  },
  {
    "value": "SGF",
    "label": "Springfield Springfield Branson National Airport (SGF)"
  },
  {
    "value": "SGH",
    "label": "Springfield Springfield-Beckley Municipal Airport (SGH)"
  },
  {
    "value": "SEK",
    "label": "Srednekolymsk Srednekolymsk Airport (SEK)"
  },
  {
    "value": "SXR",
    "label": "Srinagar Sheikh ul Alam International Airport (SXR)"
  },
  {
    "value": "UST",
    "label": "St Augustine Northeast Florida Regional Airport (UST)"
  },
  {
    "value": "STG",
    "label": "St George St George Airport (STG)"
  },
  {
    "value": "SGU",
    "label": "St George St George Regional Airport (SGU)"
  },
  {
    "value": "YJN",
    "label": "St Jean St Jean Airport (YJN)"
  },
  {
    "value": "STJ",
    "label": "St Joseph Rosecrans Memorial Airport (STJ)"
  },
  {
    "value": "SUS",
    "label": "St Louis Spirit of St Louis Airport (SUS)"
  },
  {
    "value": "STL",
    "label": "St Louis St. Louis Lambert International Airport (STL)"
  },
  {
    "value": "SNP",
    "label": "St Paul Island St Paul Island Airport (SNP)"
  },
  {
    "value": "SSI",
    "label": "St Simons Island St Simons Island Airport (SSI)"
  },
  {
    "value": "YQS",
    "label": "St Thomas St Thomas Municipal Airport (YQS)"
  },
  {
    "value": "YIF",
    "label": "St-Augustin St Augustin Airport (YIF)"
  },
  {
    "value": "YAY",
    "label": "St. Anthony St. Anthony Airport (YAY)"
  },
  {
    "value": "ACH",
    "label": "St. Gallen Sankt Gallen Altenrhein Airport (ACH)"
  },
  {
    "value": "YYT",
    "label": "St. John's St. John's International Airport (YYT)"
  },
  {
    "value": "LED",
    "label": "St. Petersburg Pulkovo Airport (LED)"
  },
  {
    "value": "SPC",
    "label": "Sta Cruz de la Palma, La Palma Island La Palma Airport (SPC)"
  },
  {
    "value": "TYM",
    "label": "Staniel Cay Staniel Cay Airport (TYM)"
  },
  {
    "value": "PSY",
    "label": "Stanley Port Stanley Airport (PSY)"
  },
  {
    "value": "UZC",
    "label": "Stapari Ponikve Airport (UZC)"
  },
  {
    "value": "SCE",
    "label": "State College State College Regional Airport (SCE)"
  },
  {
    "value": "SVG",
    "label": "Stavanger Stavanger Airport, Sola (SVG)"
  },
  {
    "value": "GLO",
    "label": "Staverton Gloucestershire Airport (GLO)"
  },
  {
    "value": "STW",
    "label": "Stavropol Stavropol Shpakovskoye Airport (STW)"
  },
  {
    "value": "SML",
    "label": "Stella Maris Stella Maris Airport (SML)"
  },
  {
    "value": "YJT",
    "label": "Stephenville Dymond Airport (YJT)"
  },
  {
    "value": "ZST",
    "label": "Stewart Stewart Airport (ZST)"
  },
  {
    "value": "SWO",
    "label": "Stillwater Stillwater Regional Airport (SWO)"
  },
  {
    "value": "VST",
    "label": "Stockholm / Västerås Stockholm Västerås Airport (VST)"
  },
  {
    "value": "ARN",
    "label": "Stockholm Stockholm-Arlanda Airport (ARN)"
  },
  {
    "value": "BMA",
    "label": "Stockholm Stockholm-Bromma Airport (BMA)"
  },
  {
    "value": "SCK",
    "label": "Stockton Stockton Metropolitan Airport (SCK)"
  },
  {
    "value": "YSF",
    "label": "Stony Rapids Stony Rapids Airport (YSF)"
  },
  {
    "value": "SYY",
    "label": "Stornoway, Western Isles Stornoway Airport (SYY)"
  },
  {
    "value": "SQO",
    "label": "Storuman Storuman Airport (SQO)"
  },
  {
    "value": "SXB",
    "label": "Strasbourg Strasbourg Airport (SXB)"
  },
  {
    "value": "SWT",
    "label": "Strezhevoy Strezhevoy Airport (SWT)"
  },
  {
    "value": "STR",
    "label": "Stuttgart Stuttgart Airport (STR)"
  },
  {
    "value": "UAI",
    "label": "Suai Suai Airport (UAI)"
  },
  {
    "value": "SZB",
    "label": "Subang Sultan Abdul Aziz Shah International Airport (SZB)"
  },
  {
    "value": "SCV",
    "label": "Suceava Suceava Stefan cel Mare Airport (SCV)"
  },
  {
    "value": "YSB",
    "label": "Sudbury Sudbury Airport (YSB)"
  },
  {
    "value": "UGU",
    "label": "Sugapa Bilogai-Sugapa Airport (UGU)"
  },
  {
    "value": "HMB",
    "label": "Suhaj Suhaj Mubarak International Airport (HMB)"
  },
  {
    "value": "SUL",
    "label": "Sui Sui Airport (SUL)"
  },
  {
    "value": "FKS",
    "label": "Sukagawa Fukushima Airport (FKS)"
  },
  {
    "value": "SUI",
    "label": "Sukhumi Sukhumi Babushara /  Vladislav Ardzinba International Airport (SUI)"
  },
  {
    "value": "ISU",
    "label": "Sulaymaniyah Sulaymaniyah International Airport (ISU)"
  },
  {
    "value": "NDD",
    "label": "Sumbe Sumbe Airport (NDD)"
  },
  {
    "value": "SSC",
    "label": "Sumter Shaw Air Force Base (SSC)"
  },
  {
    "value": "SDL",
    "label": "Sundsvall/ Härnösand Sundsvall-Härnösand Airport (SDL)"
  },
  {
    "value": "NYI",
    "label": "Sunyani Sunyani Airport (NYI)"
  },
  {
    "value": "IGT",
    "label": "Sunzha Magas Airport (IGT)"
  },
  {
    "value": "SUB",
    "label": "Surabaya Juanda International Airport (SUB)"
  },
  {
    "value": "SOC",
    "label": "Surakarta Adisumarmo Airport (SOC)"
  },
  {
    "value": "AAV",
    "label": "Surallah Allah Valley Airport (AAV)"
  },
  {
    "value": "STV",
    "label": "Surat Surat Airport (STV)"
  },
  {
    "value": "URT",
    "label": "Surat Thani Surat Thani Airport (URT)"
  },
  {
    "value": "SGC",
    "label": "Surgut Surgut Airport (SGC)"
  },
  {
    "value": "SUG",
    "label": "Surigao City Surigao Airport (SUG)"
  },
  {
    "value": "PXR",
    "label": "Surin Surin Airport (PXR)"
  },
  {
    "value": "SWU",
    "label": "Suwon Suwon Airport (SWU)"
  },
  {
    "value": "SZV",
    "label": "Suzhou Suzhou Guangfu Airport (SZV)"
  },
  {
    "value": "SES",
    "label": "Svetlogorsk Svetlogorsk Airport (SES)"
  },
  {
    "value": "SVJ",
    "label": "Svolvær Svolvær Airport, Helle (SVJ)"
  },
  {
    "value": "ZJN",
    "label": "Swan River Swan River Airport (ZJN)"
  },
  {
    "value": "SWS",
    "label": "Swansea Swansea Airport (SWS)"
  },
  {
    "value": "YYN",
    "label": "Swift Current Swift Current Airport (YYN)"
  },
  {
    "value": "SYD",
    "label": "Sydney (Mascot) Sydney Kingsford Smith International Airport (SYD)"
  },
  {
    "value": "YQY",
    "label": "Sydney Sydney / J.A. Douglas McCurdy Airport (YQY)"
  },
  {
    "value": "BWU",
    "label": "Sydney Sydney Bankstown Airport (BWU)"
  },
  {
    "value": "SCW",
    "label": "Syktyvkar Syktyvkar Airport (SCW)"
  },
  {
    "value": "ZYL",
    "label": "Sylhet Osmany International Airport (ZYL)"
  },
  {
    "value": "GWT",
    "label": "Sylt Westerland Sylt Airport (GWT)"
  },
  {
    "value": "SYR",
    "label": "Syracuse Syracuse Hancock International Airport (SYR)"
  },
  {
    "value": "SZY",
    "label": "Szymany Olsztyn-Mazury Airport (SZY)"
  },
  {
    "value": "TIF",
    "label": "Ta’if Ta’if Regional Airport (TIF)"
  },
  {
    "value": "TAI",
    "label": "Ta'izz Ta'izz International Airport (TAI)"
  },
  {
    "value": "TCP",
    "label": "Taba Taba International Airport (TCP)"
  },
  {
    "value": "TBJ",
    "label": "Tabarka Tabarka-Aïn Draham International Airport (TBJ)"
  },
  {
    "value": "TCX",
    "label": "Tabas Tabas Airport (TCX)"
  },
  {
    "value": "TBT",
    "label": "Tabatinga Tabatinga Airport (TBT)"
  },
  {
    "value": "TBH",
    "label": "Tablas Island Tugdan Airport (TBH)"
  },
  {
    "value": "TBZ",
    "label": "Tabriz Tabriz International Airport (TBZ)"
  },
  {
    "value": "TUU",
    "label": "Tabuk Tabuk Airport (TUU)"
  },
  {
    "value": "NAH",
    "label": "Tabukan Utara, Sangihe Islands Naha Airport (NAH)"
  },
  {
    "value": "THL",
    "label": "Tachileik Tachileik Airport (THL)"
  },
  {
    "value": "ESM",
    "label": "Tachina Carlos Concha Torres International Airport (ESM)"
  },
  {
    "value": "TAC",
    "label": "Tacloban City Daniel Z. Romualdez Airport (TAC)"
  },
  {
    "value": "TCQ",
    "label": "Tacna Coronel FAP Carlos Ciriani Santa Rosa International Airport (TCQ)"
  },
  {
    "value": "TCM",
    "label": "Tacoma McChord Air Force Base (TCM)"
  },
  {
    "value": "TIW",
    "label": "Tacoma Tacoma Narrows Airport (TIW)"
  },
  {
    "value": "PMS",
    "label": "Tadmur Palmyra Airport (PMS)"
  },
  {
    "value": "TAF",
    "label": "Tafraoui Oran Tafraoui Airport (TAF)"
  },
  {
    "value": "TGK",
    "label": "Taganrog Taganrog Yuzhny Airport (TGK)"
  },
  {
    "value": "GJL",
    "label": "Tahir Jijel Ferhat Abbas Airport (GJL)"
  },
  {
    "value": "THZ",
    "label": "Tahoua Tahoua Airport (THZ)"
  },
  {
    "value": "RMQ",
    "label": "Taichung (Qingshui) Taichung International Airport / Ching Chuang Kang Air Base (RMQ)"
  },
  {
    "value": "TNN",
    "label": "Tainan (Rende) Tainan International Airport / Tainan Air Base (TNN)"
  },
  {
    "value": "TSA",
    "label": "Taipei (Songshan) Taipei Songshan Airport (TSA)"
  },
  {
    "value": "TTT",
    "label": "Taitung City Taitung Airport (TTT)"
  },
  {
    "value": "TYN",
    "label": "Taiyuan Taiyuan Wusu International Airport (TYN)"
  },
  {
    "value": "HYN",
    "label": "Taizhou (Luqiao) Taizhou Luqiao Airport (HYN)"
  },
  {
    "value": "TAK",
    "label": "Takamatsu Takamatsu Airport (TAK)"
  },
  {
    "value": "TXE",
    "label": "Takengon Rembele Airport (TXE)"
  },
  {
    "value": "TLJ",
    "label": "Takotna Tatalina LRRS Airport (TLJ)"
  },
  {
    "value": "PDO",
    "label": "Talang Gudang-Sumatra Island Pendopo Airport (PDO)"
  },
  {
    "value": "TYL",
    "label": "Talara Captain Victor Montes Arias International Airport (TYL)"
  },
  {
    "value": "TLX",
    "label": "Talca Panguilemo Airport (TLX)"
  },
  {
    "value": "TDK",
    "label": "Taldykorgan Taldykorgan Airport (TDK)"
  },
  {
    "value": "TKA",
    "label": "Talkeetna Talkeetna Airport (TKA)"
  },
  {
    "value": "TLH",
    "label": "Tallahassee Tallahassee Regional Airport (TLH)"
  },
  {
    "value": "TLL",
    "label": "Tallinn Lennart Meri Tallinn Airport (TLL)"
  },
  {
    "value": "TTC",
    "label": "Taltal Las Breas Airport (TTC)"
  },
  {
    "value": "TML",
    "label": "Tamale Tamale Airport (TML)"
  },
  {
    "value": "TMR",
    "label": "Tamanrasset Aguenar – Hadj Bey Akhamok Airport (TMR)"
  },
  {
    "value": "TUD",
    "label": "Tambacounda Tambacounda Airport (TUD)"
  },
  {
    "value": "TBW",
    "label": "Tambov Donskoye Airport (TBW)"
  },
  {
    "value": "IKU",
    "label": "Tamchy Issyk-Kul International Airport (IKU)"
  },
  {
    "value": "TME",
    "label": "Tame Gustavo Vargas Airport (TME)"
  },
  {
    "value": "MCF",
    "label": "Tampa MacDill Air Force Base (MCF)"
  },
  {
    "value": "TPA",
    "label": "Tampa Tampa International Airport (TPA)"
  },
  {
    "value": "TMP",
    "label": "Tampere / Pirkkala Tampere-Pirkkala Airport (TMP)"
  },
  {
    "value": "TAM",
    "label": "Tampico General Francisco Javier Mina International Airport (TAM)"
  },
  {
    "value": "TMW",
    "label": "Tamworth Tamworth Airport (TMW)"
  },
  {
    "value": "TTA",
    "label": "Tan Tan Tan Tan Airport (TTA)"
  },
  {
    "value": "TMH",
    "label": "Tanah Merah Tanah Merah Airport (TMH)"
  },
  {
    "value": "TDG",
    "label": "Tandag Tandag Airport (TDG)"
  },
  {
    "value": "TDL",
    "label": "Tandil Héroes de Malvinas Airport (TDL)"
  },
  {
    "value": "TNE",
    "label": "Tanegashima New Tanegashima Airport (TNE)"
  },
  {
    "value": "TGT",
    "label": "Tanga Tanga Airport (TGT)"
  },
  {
    "value": "WUZ",
    "label": "Tangbu Wuzhou Xijiang Airport (WUZ)"
  },
  {
    "value": "TNG",
    "label": "Tangier Tangier Ibn Battuta Airport (TNG)"
  },
  {
    "value": "BEJ",
    "label": "Tanjung Redeb - Borneo Island Kalimarau Airport (BEJ)"
  },
  {
    "value": "TJG",
    "label": "Tanta-Tabalong Warukin Airport (TJG)"
  },
  {
    "value": "TSM",
    "label": "Taos Taos Regional Airport (TSM)"
  },
  {
    "value": "TPE",
    "label": "Taoyuan Taiwan Taoyuan International Airport (TPE)"
  },
  {
    "value": "TAP",
    "label": "Tapachula Tapachula International Airport (TAP)"
  },
  {
    "value": "TPJ",
    "label": "Taplejung Taplejung Airport (TPJ)"
  },
  {
    "value": "TRK",
    "label": "Tarakan Juwata International Airport / Suharnoko Harbani AFB (TRK)"
  },
  {
    "value": "TRA",
    "label": "Tarama Tarama Airport (TRA)"
  },
  {
    "value": "TPC",
    "label": "Tarapoa Tarapoa Airport (TPC)"
  },
  {
    "value": "TPP",
    "label": "Tarapoto Cadete FAP Guillermo Del Castillo Paredes Airport (TPP)"
  },
  {
    "value": "TRQ",
    "label": "Tarauacá Tarauacá Airport (TRQ)"
  },
  {
    "value": "TRW",
    "label": "Tarawa Bonriki International Airport (TRW)"
  },
  {
    "value": "DMB",
    "label": "Taraz Taraz Airport (DMB)"
  },
  {
    "value": "LDE",
    "label": "Tarbes/Lourdes/Pyrénées Tarbes-Lourdes-Pyrénées Airport (LDE)"
  },
  {
    "value": "TRO",
    "label": "Taree Taree Airport (TRO)"
  },
  {
    "value": "TJA",
    "label": "Tarija Capitan Oriel Lea Plaza Airport (TJA)"
  },
  {
    "value": "COV",
    "label": "Tarsus Çukurova International Airport (COV)"
  },
  {
    "value": "TTG",
    "label": "Tartagal General Enrique Mosconi Airport (TTG)"
  },
  {
    "value": "HQL",
    "label": "Tashikuergan Tashikuergan Hongqilafu Airport (HQL)"
  },
  {
    "value": "TAS",
    "label": "Tashkent Tashkent International Airport (TAS)"
  },
  {
    "value": "TUO",
    "label": "Taupo Taupo Airport (TUO)"
  },
  {
    "value": "TRG",
    "label": "Tauranga Tauranga Airport (TRG)"
  },
  {
    "value": "BAY",
    "label": "Tăuții-Măgherăuș Maramureș International Airport (BAY)"
  },
  {
    "value": "DLE",
    "label": "Tavaux, Jura Dole-Jura Airport (DLE)"
  },
  {
    "value": "TWU",
    "label": "Tawau Tawau Airport (TWU)"
  },
  {
    "value": "TBS",
    "label": "Tbilisi Tbilisi International Airport (TBS)"
  },
  {
    "value": "CHT",
    "label": "Te One Chatham Islands / Tuuta Airport (CHT)"
  },
  {
    "value": "TEE",
    "label": "Tébessi Cheikh Larbi Tébessi Airport (TEE)"
  },
  {
    "value": "TFF",
    "label": "Tefé Tefé Airport (TFF)"
  },
  {
    "value": "TGU",
    "label": "Tegucigalpa Toncontín International Airport (TGU)"
  },
  {
    "value": "IKA",
    "label": "Tehran Imam Khomeini International Airport (IKA)"
  },
  {
    "value": "THR",
    "label": "Tehran Mehrabad International Airport (THR)"
  },
  {
    "value": "TLV",
    "label": "Tel Aviv Ben Gurion International Airport (TLV)"
  },
  {
    "value": "TEA",
    "label": "Tela Tela Airport (TEA)"
  },
  {
    "value": "TEC",
    "label": "Telêmaco Borba Telêmaco Borba Airport (TEC)"
  },
  {
    "value": "TEX",
    "label": "Telluride Telluride Regional Airport (TEX)"
  },
  {
    "value": "CVJ",
    "label": "Temixco General Mariano Matamoros International Airport (CVJ)"
  },
  {
    "value": "TEM",
    "label": "Temora Temora Airport (TEM)"
  },
  {
    "value": "TPL",
    "label": "Temple Draughon Miller Central Texas Regional Airport (TPL)"
  },
  {
    "value": "ZCO",
    "label": "Temuco La Araucanía Airport (ZCO)"
  },
  {
    "value": "PZS",
    "label": "Temuco Maquehue Airport (PZS)"
  },
  {
    "value": "TFN",
    "label": "Tenerife Tenerife Norte-Ciudad de La Laguna Airport (TFN)"
  },
  {
    "value": "TFS",
    "label": "Tenerife Tenerife Sur Airport (TFS)"
  },
  {
    "value": "TCA",
    "label": "Tennant Creek Tennant Creek Airport (TCA)"
  },
  {
    "value": "TPQ",
    "label": "Tepic Amado Nervo National Airport (TPQ)"
  },
  {
    "value": "THE",
    "label": "Teresina Senador Petrônio Portela Airport (THE)"
  },
  {
    "value": "RHD",
    "label": "Termas de Río Hondo Termas de Río Hondo international Airport (RHD)"
  },
  {
    "value": "TMJ",
    "label": "Termez Termez Airport (TMJ)"
  },
  {
    "value": "YXT",
    "label": "Terrace Northwest Regional Airport Terrace-Kitimat (YXT)"
  },
  {
    "value": "HUF",
    "label": "Terre Haute Terre Haute Regional Airport, Hulman Field (HUF)"
  },
  {
    "value": "TEV",
    "label": "Teruel Teruel Airport (TEV)"
  },
  {
    "value": "YZW",
    "label": "Teslin Teslin Airport (YZW)"
  },
  {
    "value": "TET",
    "label": "Tete Chingozi Airport (TET)"
  },
  {
    "value": "TEB",
    "label": "Teterboro Teterboro Airport (TEB)"
  },
  {
    "value": "TTU",
    "label": "Tétouan Sania Ramel Airport (TTU)"
  },
  {
    "value": "TXK",
    "label": "Texarkana Texarkana Regional Airport (Webb Field) (TXK)"
  },
  {
    "value": "SNW",
    "label": "Thandwe Thandwe Airport (SNW)"
  },
  {
    "value": "XTG",
    "label": "Thargomindah Thargomindah Airport (XTG)"
  },
  {
    "value": "YQD",
    "label": "The Pas The Pas Airport (YQD)"
  },
  {
    "value": "AXA",
    "label": "The Valley Clayton J Lloyd International Airport (AXA)"
  },
  {
    "value": "SKG",
    "label": "Thessaloniki Thessaloniki Macedonia International Airport (SKG)"
  },
  {
    "value": "YTD",
    "label": "Thicket Portage Thicket Portage Airport (YTD)"
  },
  {
    "value": "TVF",
    "label": "Thief River Falls Thief River Falls Regional Airport (TVF)"
  },
  {
    "value": "TRV",
    "label": "Thiruvananthapuram Thiruvananthapuram International Airport (TRV)"
  },
  {
    "value": "TED",
    "label": "Thisted Thisted Airport (TED)"
  },
  {
    "value": "YTH",
    "label": "Thompson Thompson Airport (YTH)"
  },
  {
    "value": "TTH",
    "label": "Thumrait Thumrait Air Base (TTH)"
  },
  {
    "value": "YQT",
    "label": "Thunder Bay Thunder Bay Airport (YQT)"
  },
  {
    "value": "TSN",
    "label": "Tianjin Tianjin Binhai International Airport (TSN)"
  },
  {
    "value": "THQ",
    "label": "Tianshui (Maiji) Tianshui Maijishan Airport (THQ)"
  },
  {
    "value": "TID",
    "label": "Tiaret Abdelhafid Boussouf Bou Chekif Airport (TID)"
  },
  {
    "value": "TGJ",
    "label": "Tiga Tiga Airport (TGJ)"
  },
  {
    "value": "TIJ",
    "label": "Tijuana General Abelardo L. Rodriguez International Airport (TIJ)"
  },
  {
    "value": "TKC",
    "label": "Tiko Tiko Airport (TKC)"
  },
  {
    "value": "IKS",
    "label": "Tiksi Tiksi Airport (IKS)"
  },
  {
    "value": "BVA",
    "label": "Tillé Paris-Beauvais Airport (BVA)"
  },
  {
    "value": "TOM",
    "label": "Timbuktu Timbuktu Airport (TOM)"
  },
  {
    "value": "TIM",
    "label": "Timika Mozes Kilangin Airport (TIM)"
  },
  {
    "value": "TMX",
    "label": "Timimoun Timimoun Airport (TMX)"
  },
  {
    "value": "TSR",
    "label": "Timişoara Timişoara Traian Vuia Airport (TSR)"
  },
  {
    "value": "YTS",
    "label": "Timmins Timmins/Victor M. Power (YTS)"
  },
  {
    "value": "TIN",
    "label": "Tindouf Tindouf Airport (TIN)"
  },
  {
    "value": "TIQ",
    "label": "Tinian Island Tinian International Airport (TIQ)"
  },
  {
    "value": "KTP",
    "label": "Tinson Pen Tinson Pen Airport (KTP)"
  },
  {
    "value": "TOD",
    "label": "Tioman Island Tioman Airport (TOD)"
  },
  {
    "value": "TRZ",
    "label": "Tiruchirappalli Tiruchirappalli International Airport (TRZ)"
  },
  {
    "value": "TIX",
    "label": "Titusville Space Coast Regional Airport (TIX)"
  },
  {
    "value": "TIV",
    "label": "Tivat Tivat Airport (TIV)"
  },
  {
    "value": "TMM",
    "label": "Toamasina Toamasina Ambalamanasy Airport (TMM)"
  },
  {
    "value": "RMZ",
    "label": "Tobolsk Remezov Airport (RMZ)"
  },
  {
    "value": "TOQ",
    "label": "Tocopilla Barriles Airport (TOQ)"
  },
  {
    "value": "PTY",
    "label": "Tocumen Tocumen International Airport (PTY)"
  },
  {
    "value": "YAZ",
    "label": "Tofino Tofino / Long Beach Airport (YAZ)"
  },
  {
    "value": "TJK",
    "label": "Tokat Tokat Airport (TJK)"
  },
  {
    "value": "NGO",
    "label": "Tokoname Chubu Centrair International Airport (NGO)"
  },
  {
    "value": "TKS",
    "label": "Tokushima Tokushima Awaodori Airport / JMSDF Tokushima Air Base (TKS)"
  },
  {
    "value": "HND",
    "label": "Tokyo Tokyo Haneda International Airport (HND)"
  },
  {
    "value": "FTU",
    "label": "Tôlanaro Tôlanaro Airport (FTU)"
  },
  {
    "value": "TOL",
    "label": "Toledo Eugene F. Kranz Toledo Express Airport (TOL)"
  },
  {
    "value": "TLE",
    "label": "Toliara Toliara Airport (TLE)"
  },
  {
    "value": "TLC",
    "label": "Toluca Adolfo López Mateos International Airport (TLC)"
  },
  {
    "value": "ENC",
    "label": "Tomblaine, Meurthe-et-Moselle Nancy-Essey Airport (ENC)"
  },
  {
    "value": "TOF",
    "label": "Tomsk Bogashevo Airport (TOF)"
  },
  {
    "value": "BOR",
    "label": "Ton Phueng Bokeo International Airport (BOR)"
  },
  {
    "value": "TNH",
    "label": "Tonghua Tonghua Sanyuanpu Airport (TNH)"
  },
  {
    "value": "TGO",
    "label": "Tongliao Tongliao Airport (TGO)"
  },
  {
    "value": "TEN",
    "label": "Tongren (Daxing) Tongren Fenghuang Airport (TEN)"
  },
  {
    "value": "TPH",
    "label": "Tonopah Tonopah Airport (TPH)"
  },
  {
    "value": "WTB",
    "label": "Toowoomba Toowoomba Wellcamp Airport (WTB)"
  },
  {
    "value": "TOP",
    "label": "Topeka Philip Billard Municipal Airport (TOP)"
  },
  {
    "value": "FOE",
    "label": "Topeka Topeka Regional Airport (FOE)"
  },
  {
    "value": "TRT",
    "label": "Toraja Toraja Airport (TRT)"
  },
  {
    "value": "YTZ",
    "label": "Toronto Billy Bishop Toronto City Centre Airport (YTZ)"
  },
  {
    "value": "YYZ",
    "label": "Toronto Toronto Lester B. Pearson International Airport (YYZ)"
  },
  {
    "value": "TRF",
    "label": "Torp Sandefjord Airport, Torp (TRF)"
  },
  {
    "value": "TRC",
    "label": "Torreón Francisco Sarabia Tinoco International Airport (TRC)"
  },
  {
    "value": "TYF",
    "label": "Torsby Torsby Airport (TYF)"
  },
  {
    "value": "TTJ",
    "label": "Tottori Tottori Sand Dunes Conan Airport (TTJ)"
  },
  {
    "value": "TGR",
    "label": "Touggourt Touggourt Sidi Madhi Airport (TGR)"
  },
  {
    "value": "TOU",
    "label": "Touho Touho Airport (TOU)"
  },
  {
    "value": "TLS",
    "label": "Toulouse/Blagnac Toulouse-Blagnac Airport (TLS)"
  },
  {
    "value": "TUF",
    "label": "Tours, Indre-et-Loire Tours Val de Loire Airport (TUF)"
  },
  {
    "value": "TNF",
    "label": "Toussus-le-Noble, Yvelines Toussus-le-Noble Airport (TNF)"
  },
  {
    "value": "TSV",
    "label": "Townsville Townsville Airport / RAAF Base Townsville (TSV)"
  },
  {
    "value": "TOY",
    "label": "Toyama Toyama Airport (TOY)"
  },
  {
    "value": "TJH",
    "label": "Toyooka Konotori Tajima Airport (TJH)"
  },
  {
    "value": "TOE",
    "label": "Tozeur Tozeur Nefta International Airport (TOE)"
  },
  {
    "value": "TZX",
    "label": "Trabzon Trabzon International Airport (TZX)"
  },
  {
    "value": "TST",
    "label": "Trang Trang Airport (TST)"
  },
  {
    "value": "TPS",
    "label": "Trapani (TP) Vincenzo Florio Airport Trapani-Birgi (TPS)"
  },
  {
    "value": "TVC",
    "label": "Traverse City Cherry Capital Airport (TVC)"
  },
  {
    "value": "TCB",
    "label": "Treasure Cay Treasure Cay Airport (TCB)"
  },
  {
    "value": "SBK",
    "label": "Trémuson, Côtes-d'Armor Saint-Brieuc-Armor Airport (SBK)"
  },
  {
    "value": "YTR",
    "label": "Trenton CFB Trenton (YTR)"
  },
  {
    "value": "OYO",
    "label": "Tres Arroyos Tres Arroyos Airport (OYO)"
  },
  {
    "value": "TQS",
    "label": "Tres Esquinas Captain Ernesto Esguerra Cubides Air Base (TQS)"
  },
  {
    "value": "TSF",
    "label": "Treviso (TV) Treviso Antonio Canova Airport (TSF)"
  },
  {
    "value": "SPM",
    "label": "Trier Spangdahlem Air Base (SPM)"
  },
  {
    "value": "TRR",
    "label": "Trincomalee China Bay Airport (TRR)"
  },
  {
    "value": "TND",
    "label": "Trinidad Alberto Delgado Airport (TND)"
  },
  {
    "value": "TDD",
    "label": "Trinidad Teniente Av. Jorge Henrich Arauz Airport (TDD)"
  },
  {
    "value": "MJI",
    "label": "Tripoli Mitiga International Airport (MJI)"
  },
  {
    "value": "KYE",
    "label": "Tripoli Rene Mouawad Air Base / Kleyate Airport (KYE)"
  },
  {
    "value": "YRQ",
    "label": "Trois-Rivières Trois-Rivières Airport (YRQ)"
  },
  {
    "value": "FNB",
    "label": "Trollenhagen Neubrandenburg Trollenhagen Airport (FNB)"
  },
  {
    "value": "THN",
    "label": "Trollhättan Trollhättan-Vänersborg Airport (THN)"
  },
  {
    "value": "TOS",
    "label": "Tromsø Tromsø Airport, Langnes (TOS)"
  },
  {
    "value": "TRD",
    "label": "Trondheim Trondheim Airport, Værnes (TRD)"
  },
  {
    "value": "TOI",
    "label": "Troy Troy Municipal Airport at N Kenneth Campbell Field (TOI)"
  },
  {
    "value": "TKF",
    "label": "Truckee Truckee Tahoe Airport (TKF)"
  },
  {
    "value": "TRU",
    "label": "Trujillo Capitan FAP Carlos Martinez De Pinillos International Airport (TRU)"
  },
  {
    "value": "TJI",
    "label": "Trujillo Trujillo Airport (TJI)"
  },
  {
    "value": "TCS",
    "label": "Truth or Consequences Truth or Consequences Municipal Airport (TCS)"
  },
  {
    "value": "TSB",
    "label": "Tsumeb Tsumeb Airport (TSB)"
  },
  {
    "value": "TSJ",
    "label": "Tsushima Tsushima Airport (TSJ)"
  },
  {
    "value": "DMA",
    "label": "Tucson Davis Monthan Air Force Base (DMA)"
  },
  {
    "value": "TUS",
    "label": "Tucson Tucson International Airport / Morris Air National Guard Base (TUS)"
  },
  {
    "value": "TCC",
    "label": "Tucumcari Tucumcari Municipal Airport (TCC)"
  },
  {
    "value": "TUV",
    "label": "Tucupita Tucupita Airport (TUV)"
  },
  {
    "value": "TUR",
    "label": "Tucuruí Tucuruí Airport (TUR)"
  },
  {
    "value": "TUG",
    "label": "Tuguegarao City Tuguegarao Airport (TUG)"
  },
  {
    "value": "TUA",
    "label": "Tulcán Lieutenant Colonel Luis A. Mantilla International Airport (TUA)"
  },
  {
    "value": "TUL",
    "label": "Tulsa Tulsa International Airport (TUL)"
  },
  {
    "value": "RVS",
    "label": "Tulsa Tulsa Riverside Airport (RVS)"
  },
  {
    "value": "ULQ",
    "label": "Tuluá Heriberto Gíl Martínez Airport (ULQ)"
  },
  {
    "value": "TQO",
    "label": "Tulum Felipe Carrillo Puerto International Airport (TQO)"
  },
  {
    "value": "TCO",
    "label": "Tumaco La Florida Airport (TCO)"
  },
  {
    "value": "TBP",
    "label": "Tumbes Captain Pedro Canga Rodríguez International Airport (TBP)"
  },
  {
    "value": "TUM",
    "label": "Tumut Tumut Aerodrome (TUM)"
  },
  {
    "value": "TUN",
    "label": "Tunis Tunis Carthage International Airport (TUN)"
  },
  {
    "value": "TUP",
    "label": "Tupelo Tupelo Regional Airport (TUP)"
  },
  {
    "value": "TUI",
    "label": "Turaif Turaif Domestic Airport (TUI)"
  },
  {
    "value": "TUK",
    "label": "Turbat Turbat International Airport (TUK)"
  },
  {
    "value": "HSA",
    "label": "Turkıstan Hazrat Sultan International Airport (HSA)"
  },
  {
    "value": "CRZ",
    "label": "Türkmenabat Türkmenabat International Airport (CRZ)"
  },
  {
    "value": "KRW",
    "label": "Turkmenbashi Turkmenbashi International Airport (KRW)"
  },
  {
    "value": "TKU",
    "label": "Turku Turku Airport (TKU)"
  },
  {
    "value": "TLQ",
    "label": "Turpan Turpan Jiaohe Airport (TLQ)"
  },
  {
    "value": "TCL",
    "label": "Tuscaloosa Tuscaloosa National Airport (TCL)"
  },
  {
    "value": "TGZ",
    "label": "Tuxtla Gutiérrez Angel Albino Corzo International Airport (TGZ)"
  },
  {
    "value": "TBB",
    "label": "Tuy Hoa Dong Tac Airport (TBB)"
  },
  {
    "value": "KLD",
    "label": "Tver Migalovo Air Base (KLD)"
  },
  {
    "value": "TWF",
    "label": "Twin Falls Joslin Field Magic Valley Regional Airport (TWF)"
  },
  {
    "value": "TWZ",
    "label": "Twitzel Pukaki Airport (TWZ)"
  },
  {
    "value": "TYR",
    "label": "Tyler Tyler Pounds Regional Airport (TYR)"
  },
  {
    "value": "ECN",
    "label": "Tymbou (Kirklar) Nicosia (Lefkoşa) Ercan International Airport (ECN)"
  },
  {
    "value": "TJM",
    "label": "Tyumen Roshchino International Airport (TJM)"
  },
  {
    "value": "LTA",
    "label": "Tzaneen Tzaneen Airport (LTA)"
  },
  {
    "value": "UBJ",
    "label": "Ube Yamaguchi Ube Airport (UBJ)"
  },
  {
    "value": "UBA",
    "label": "Uberaba Mário de Almeida Franco Airport (UBA)"
  },
  {
    "value": "UDI",
    "label": "Uberlândia Ten. Cel. Aviador César Bombonato Airport (UDI)"
  },
  {
    "value": "UBP",
    "label": "Ubon Ratchathani Ubon Ratchathani Airport (UBP)"
  },
  {
    "value": "UDR",
    "label": "Udaipur Maharana Pratap Airport (UDR)"
  },
  {
    "value": "UDE",
    "label": "Uden Volkel Air Base (UDE)"
  },
  {
    "value": "UTH",
    "label": "Udon Thani Udon Thani Airport (UTH)"
  },
  {
    "value": "UFA",
    "label": "Ufa Ufa International Airport (UFA)"
  },
  {
    "value": "UHE",
    "label": "Uherské Hradiště Kunovice Airport (UHE)"
  },
  {
    "value": "UGO",
    "label": "Uige Uige Airport (UGO)"
  },
  {
    "value": "UPG",
    "label": "Ujung Pandang Hasanuddin International Airport (UPG)"
  },
  {
    "value": "UCT",
    "label": "Ukhta Ukhta Airport (UCT)"
  },
  {
    "value": "UKI",
    "label": "Ukiah Ukiah Municipal Airport (UKI)"
  },
  {
    "value": "UBN",
    "label": "Ulaanbaatar (Sergelen) Ulaanbaatar Chinggis Khaan International Airport (UBN)"
  },
  {
    "value": "ULN",
    "label": "Ulaanbaatar Buyant-Ukhaa International Airport (ULN)"
  },
  {
    "value": "UUD",
    "label": "Ulan Ude Baikal International Airport (UUD)"
  },
  {
    "value": "UCB",
    "label": "Ulanqab Ulanqab Jining Airport (UCB)"
  },
  {
    "value": "USN",
    "label": "Ulsan Ulsan Airport (USN)"
  },
  {
    "value": "ULD",
    "label": "Ulundi Prince Mangosuthu Buthelezi Airport (ULD)"
  },
  {
    "value": "ULV",
    "label": "Ulyanovsk Ulyanovsk Baratayevka Airport (ULV)"
  },
  {
    "value": "UME",
    "label": "Umeå Umeå Airport (UME)"
  },
  {
    "value": "UNK",
    "label": "Unalakleet Unalakleet Airport (UNK)"
  },
  {
    "value": "DUT",
    "label": "Unalaska Tom Madsen (Dutch Harbor) Airport (DUT)"
  },
  {
    "value": "UNI",
    "label": "Union Island Union Island International Airport (UNI)"
  },
  {
    "value": "RND",
    "label": "Universal City Randolph Air Force Base (RND)"
  },
  {
    "value": "UPL",
    "label": "Upala Upala Airport (UPL)"
  },
  {
    "value": "UTN",
    "label": "Upington Pierre Van Ryneveld Airport (UTN)"
  },
  {
    "value": "URA",
    "label": "Uralsk Uralsk Airport (URA)"
  },
  {
    "value": "URJ",
    "label": "Uray Uray Airport (URJ)"
  },
  {
    "value": "UGC",
    "label": "Urgench Urgench Airport (UGC)"
  },
  {
    "value": "OMH",
    "label": "Urmia Urmia Airport (OMH)"
  },
  {
    "value": "UPN",
    "label": "Uruapan Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport (UPN)"
  },
  {
    "value": "URG",
    "label": "Uruguaiana Rubem Berta Airport (URG)"
  },
  {
    "value": "URC",
    "label": "Ürümqi Ürümqi Diwopu International Airport (URC)"
  },
  {
    "value": "USQ",
    "label": "Uşak Uşak Airport (USQ)"
  },
  {
    "value": "USH",
    "label": "Ushuaia Malvinas Argentinas Airport (USH)"
  },
  {
    "value": "USK",
    "label": "Usinsk Usinsk Airport (USK)"
  },
  {
    "value": "UKK",
    "label": "Ust-Kamenogorsk (Oskemen) Ust-Kamenogorsk Airport (UKK)"
  },
  {
    "value": "UKX",
    "label": "Ust-Kut Ust-Kut Airport (UKX)"
  },
  {
    "value": "USR",
    "label": "Ust-Nera Ust-Nera Airport (USR)"
  },
  {
    "value": "UTS",
    "label": "Ust-Tsylma Ust-Tsylma Airport (UTS)"
  },
  {
    "value": "UTO",
    "label": "Utopia Creek Indian Mountain LRRS Airport (UTO)"
  },
  {
    "value": "BRW",
    "label": "Utqiaġvik Wiley Post Will Rogers Memorial Airport (BRW)"
  },
  {
    "value": "UTI",
    "label": "Utti / Valkeala Utti Air Base (UTI)"
  },
  {
    "value": "RFP",
    "label": "Uturoa Raiatea Airport (RFP)"
  },
  {
    "value": "QUO",
    "label": "Uyo Akwa Ibom International Airport (QUO)"
  },
  {
    "value": "UDJ",
    "label": "Uzhhorod Uzhhorod International Airport (UDJ)"
  },
  {
    "value": "VAA",
    "label": "Vaasa Vaasa Airport (VAA)"
  },
  {
    "value": "BDQ",
    "label": "Vadodara Vadodara Airport (BDQ)"
  },
  {
    "value": "VDS",
    "label": "Vadsø Vadsø Airport (VDS)"
  },
  {
    "value": "FAE",
    "label": "Vágar Vágar Airport (FAE)"
  },
  {
    "value": "YVO",
    "label": "Val-d'Or Val-d'Or Airport (YVO)"
  },
  {
    "value": "VDZ",
    "label": "Valdez Valdez Pioneer Field (VDZ)"
  },
  {
    "value": "ZAL",
    "label": "Valdivia Pichoy Airport (ZAL)"
  },
  {
    "value": "VAD",
    "label": "Valdosta Moody Air Force Base (VAD)"
  },
  {
    "value": "VLD",
    "label": "Valdosta Valdosta Regional Airport (VLD)"
  },
  {
    "value": "VLN",
    "label": "Valencia Arturo Michelena International Airport (VLN)"
  },
  {
    "value": "VLC",
    "label": "Valencia Valencia Airport (VLC)"
  },
  {
    "value": "VTN",
    "label": "Valentine Miller Field (VTN)"
  },
  {
    "value": "VLV",
    "label": "Valera Dr. Antonio Nicolás Briceño Airport (VLV)"
  },
  {
    "value": "VLL",
    "label": "Valladolid Valladolid Airport (VLL)"
  },
  {
    "value": "VUP",
    "label": "Valledupar Alfonso López Pumarejo Airport (VUP)"
  },
  {
    "value": "VLR",
    "label": "Vallenar Vallenar Airport (VLR)"
  },
  {
    "value": "MLA",
    "label": "Valletta Malta International Airport (MLA)"
  },
  {
    "value": "VPS",
    "label": "Valparaiso Destin-Fort Walton Beach Airport (VPS)"
  },
  {
    "value": "VPZ",
    "label": "Valparaiso Porter County Municipal Airport (VPZ)"
  },
  {
    "value": "VDO",
    "label": "Van Don Van Don International Airport (VDO)"
  },
  {
    "value": "VNY",
    "label": "Van Nuys Van Nuys Airport (VNY)"
  },
  {
    "value": "VAN",
    "label": "Van Van Ferit Melen Airport (VAN)"
  },
  {
    "value": "VAQ",
    "label": "Vanavara Vanavara Airport (VAQ)"
  },
  {
    "value": "YVR",
    "label": "Vancouver Vancouver International Airport (YVR)"
  },
  {
    "value": "VAI",
    "label": "Vanimo Vanimo Airport (VAI)"
  },
  {
    "value": "VNE",
    "label": "Vannes/Meucon Vannes-Meucon Airport (VNE)"
  },
  {
    "value": "VNS",
    "label": "Varanasi Lal Bahadur Shastri Airport (VNS)"
  },
  {
    "value": "VAW",
    "label": "Vardø Vardø Airport, Svartnes (VAW)"
  },
  {
    "value": "VAG",
    "label": "Varginha Major Brigadeiro Trompowsky Airport (VAG)"
  },
  {
    "value": "VRK",
    "label": "Varkaus / Joroinen Varkaus Airport (VRK)"
  },
  {
    "value": "VAR",
    "label": "Varna Varna Airport (VAR)"
  },
  {
    "value": "GOI",
    "label": "Vasco da Gama Dabolim Airport (GOI)"
  },
  {
    "value": "VAV",
    "label": "Vava'u Island Vava'u International Airport (VAV)"
  },
  {
    "value": "VXO",
    "label": "Växjö Växjö Kronoberg Airport (VXO)"
  },
  {
    "value": "SJZ",
    "label": "Velas São Jorge Airport (SJZ)"
  },
  {
    "value": "ZAG",
    "label": "Velika Gorica Zagreb Franjo Tuđman International Airport (ZAG)"
  },
  {
    "value": "VUS",
    "label": "Velikiy Ustyug Velikiy Ustyug Airport (VUS)"
  },
  {
    "value": "VIY",
    "label": "Vélizy-Villacoublay, Yvelines Vélizy-Villacoublay Air Base (VIY)"
  },
  {
    "value": "VCE",
    "label": "Venezia (VE) Venice Marco Polo Airport (VCE)"
  },
  {
    "value": "VER",
    "label": "Veracruz General Heriberto Jara International Airport (VER)"
  },
  {
    "value": "VEL",
    "label": "Vernal Vernal Regional Airport (VEL)"
  },
  {
    "value": "YVE",
    "label": "Vernon Vernon Regional Airport (YVE)"
  },
  {
    "value": "VRB",
    "label": "Vero Beach Vero Beach Regional Airport (VRB)"
  },
  {
    "value": "VEY",
    "label": "Vestmannaeyjar Vestmannaeyjar Airport (VEY)"
  },
  {
    "value": "VFA",
    "label": "Victoria Falls Victoria Falls International Airport (VFA)"
  },
  {
    "value": "ZIC",
    "label": "Victoria Victoria Airport (ZIC)"
  },
  {
    "value": "YYJ",
    "label": "Victoria Victoria International Airport (YYJ)"
  },
  {
    "value": "VCT",
    "label": "Victoria Victoria Regional Airport (VCT)"
  },
  {
    "value": "VDM",
    "label": "Viedma / Carmen de Patagones Gobernador Castello Airport (VDM)"
  },
  {
    "value": "VIE",
    "label": "Vienna Vienna International Airport (VIE)"
  },
  {
    "value": "VTE",
    "label": "Vientiane Wattay International Airport (VTE)"
  },
  {
    "value": "VQS",
    "label": "Vieques Antonio Rivera Rodriguez Airport (VQS)"
  },
  {
    "value": "UVF",
    "label": "Vieux Fort Hewanorra International Airport (UVF)"
  },
  {
    "value": "VGO",
    "label": "Vigo Vigo Airport (VGO)"
  },
  {
    "value": "PXO",
    "label": "Vila Baleira Porto Santo Airport (PXO)"
  },
  {
    "value": "MMO",
    "label": "Vila do Maio Maio Airport (MMO)"
  },
  {
    "value": "SMA",
    "label": "Vila do Porto Santa Maria Airport (SMA)"
  },
  {
    "value": "AVR",
    "label": "Vila Franca de Xira Alverca Air Base (AVR)"
  },
  {
    "value": "VRL",
    "label": "Vila Real Vila Real Airport (VRL)"
  },
  {
    "value": "VNX",
    "label": "Vilanculo Vilankulo Airport (VNX)"
  },
  {
    "value": "VHM",
    "label": "Vilhelmina Vilhelmina South Lapland Airport (VHM)"
  },
  {
    "value": "BVH",
    "label": "Vilhena Brigadeiro Camarão Airport (BVH)"
  },
  {
    "value": "VDR",
    "label": "Villa Dolores Villa Dolores Airport (VDR)"
  },
  {
    "value": "VLG",
    "label": "Villa Gesell Villa Gesell Airport (VLG)"
  },
  {
    "value": "VME",
    "label": "Villa Mercedes Villa Reynolds Airport (VME)"
  },
  {
    "value": "VSA",
    "label": "Villahermosa Carlos Rovirosa Pérez International Airport (VSA)"
  },
  {
    "value": "VLM",
    "label": "Villamontes Teniente Coronel Rafael Pabón Airport (VLM)"
  },
  {
    "value": "ALL",
    "label": "Villanova d'Albenga (SV) Riviera Villanova d'Albenga International Airport (ALL)"
  },
  {
    "value": "VVC",
    "label": "Villavicencio Vanguardia Airport (VVC)"
  },
  {
    "value": "VNO",
    "label": "Vilnius Vilnius International Airport (VNO)"
  },
  {
    "value": "VYI",
    "label": "Vilyuisk Vilyuisk Airport (VYI)"
  },
  {
    "value": "KNA",
    "label": "Viña del Mar Viña del Mar Airport (KNA)"
  },
  {
    "value": "VII",
    "label": "Vinh Vinh Airport (VII)"
  },
  {
    "value": "VIN",
    "label": "Vinnitsa Vinnytsia/Gavyryshivka International Airport (VIN)"
  },
  {
    "value": "VRC",
    "label": "Virac Virac Airport (VRC)"
  },
  {
    "value": "NTU",
    "label": "Virginia Beach Oceana Naval Air Station (NTU)"
  },
  {
    "value": "VTZ",
    "label": "Visakhapatnam Visakhapatnam Airport (VTZ)"
  },
  {
    "value": "VIS",
    "label": "Visalia Visalia Municipal Airport (VIS)"
  },
  {
    "value": "VBY",
    "label": "Visby Visby Airport (VBY)"
  },
  {
    "value": "VSE",
    "label": "Viseu Aerodromo Goncalves Lobato (Viseu Airport) (VSE)"
  },
  {
    "value": "VTB",
    "label": "Vitebsk Vitebsk Vostochny Airport (VTB)"
  },
  {
    "value": "VDC",
    "label": "Vitória da Conquista Glauber de Andrade Rocha Airport (VDC)"
  },
  {
    "value": "VIX",
    "label": "Vitória Eurico de Aguiar Salles Airport (VIX)"
  },
  {
    "value": "CMF",
    "label": "Viviers-du-Lac Chambéry Savoie Mont Blanc Airport (CMF)"
  },
  {
    "value": "VOD",
    "label": "Vodochody Vodochody Airport (VOD)"
  },
  {
    "value": "VOH",
    "label": "Vohemar Vohemar Airport (VOH)"
  },
  {
    "value": "SMS",
    "label": "Vohilava Sainte Marie Airport (SMS)"
  },
  {
    "value": "SKS",
    "label": "Vojens Skrydstrup Air Base (SKS)"
  },
  {
    "value": "VOG",
    "label": "Volgograd Volgograd International Airport (VOG)"
  },
  {
    "value": "VGD",
    "label": "Vologda Vologda Airport (VGD)"
  },
  {
    "value": "VKT",
    "label": "Vorkuta Vorkuta Airport (VKT)"
  },
  {
    "value": "VOZ",
    "label": "Voronezh Voronezh International Airport (VOZ)"
  },
  {
    "value": "VRE",
    "label": "Vredendal Vredendal Airport (VRE)"
  },
  {
    "value": "VRU",
    "label": "Vyrburg Vryburg Airport (VRU)"
  },
  {
    "value": "YWK",
    "label": "Wabush Wabush Airport (YWK)"
  },
  {
    "value": "ACT",
    "label": "Waco Waco Regional Airport (ACT)"
  },
  {
    "value": "PKT",
    "label": "Wadeye Port Keats Airport (PKT)"
  },
  {
    "value": "WAE",
    "label": "Wadi Al Dawasir Wadi Al Dawasir Domestic Airport (WAE)"
  },
  {
    "value": "OKE",
    "label": "Wadomari Okinoerabu Airport (OKE)"
  },
  {
    "value": "MUE",
    "label": "Waimea (Kamuela) Waimea Kohala Airport (MUE)"
  },
  {
    "value": "AIN",
    "label": "Wainwright Wainwright Airport (AIN)"
  },
  {
    "value": "WIR",
    "label": "Wairoa Wairoa Airport (WIR)"
  },
  {
    "value": "NTQ",
    "label": "Wajima Noto Satoyama Airport (NTQ)"
  },
  {
    "value": "WJR",
    "label": "Wajir Wajir Airport (WJR)"
  },
  {
    "value": "AWK",
    "label": "Wake Island Wake Island Airfield (AWK)"
  },
  {
    "value": "WKJ",
    "label": "Wakkanai Wakkanai Airport (WKJ)"
  },
  {
    "value": "ALW",
    "label": "Walla Walla Walla Walla Regional Airport (ALW)"
  },
  {
    "value": "BEX",
    "label": "Wallingford, Oxfordshire RAF Benson (BEX)"
  },
  {
    "value": "WLS",
    "label": "Wallis Island Hihifo Airport (WLS)"
  },
  {
    "value": "WMX",
    "label": "Wamena Wamena Airport (WMX)"
  },
  {
    "value": "WKA",
    "label": "Wanaka Wanaka Airport (WKA)"
  },
  {
    "value": "WAG",
    "label": "Wanganui Wanganui Airport (WAG)"
  },
  {
    "value": "WNI",
    "label": "Wangi-wangi Island Matahora Airport (WNI)"
  },
  {
    "value": "WBM",
    "label": "Wapenamanda Wapenamanda Airport (WBM)"
  },
  {
    "value": "WRB",
    "label": "Warner Robins Robins Air Force Base (WRB)"
  },
  {
    "value": "WAW",
    "label": "Warsaw Warsaw Chopin Airport (WAW)"
  },
  {
    "value": "WRT",
    "label": "Warton Warton Aerodrome (WRT)"
  },
  {
    "value": "PVD",
    "label": "Warwick Theodore Francis Green State Airport (PVD)"
  },
  {
    "value": "DCA",
    "label": "Washington Ronald Reagan Washington National Airport (DCA)"
  },
  {
    "value": "WWA",
    "label": "Wasilla Wasilla Airport (WWA)"
  },
  {
    "value": "WAT",
    "label": "Waterford Waterford Airport (WAT)"
  },
  {
    "value": "ALO",
    "label": "Waterloo Waterloo Regional Airport (ALO)"
  },
  {
    "value": "ART",
    "label": "Watertown Watertown International Airport (ART)"
  },
  {
    "value": "ATY",
    "label": "Watertown Watertown Regional Airport (ATY)"
  },
  {
    "value": "YQH",
    "label": "Watson Lake Watson Lake Airport (YQH)"
  },
  {
    "value": "WUU",
    "label": "Wau Wau Airport (WUU)"
  },
  {
    "value": "AUW",
    "label": "Wausau Wausau Downtown Airport (AUW)"
  },
  {
    "value": "YXZ",
    "label": "Wawa Wawa Airport (YXZ)"
  },
  {
    "value": "NRN",
    "label": "Weeze Weeze Airport (NRN)"
  },
  {
    "value": "WEF",
    "label": "Weifang (Kuiwen) Weifang Nanyuan Airport (WEF)"
  },
  {
    "value": "WEH",
    "label": "Weihai Weihai Dashuibo Airport (WEH)"
  },
  {
    "value": "WEI",
    "label": "Weipa Weipa Airport (WEI)"
  },
  {
    "value": "WLG",
    "label": "Wellington Wellington International Airport (WLG)"
  },
  {
    "value": "EAT",
    "label": "Wenatchee Pangborn Memorial Airport (EAT)"
  },
  {
    "value": "ENV",
    "label": "Wendover Wendover Airport (ENV)"
  },
  {
    "value": "TKK",
    "label": "Weno Island Chuuk International Airport (TKK)"
  },
  {
    "value": "WNZ",
    "label": "Wenzhou (Longwan) Wenzhou Longwan International Airport (WNZ)"
  },
  {
    "value": "OBF",
    "label": "Weßling Oberpfaffenhofen Airport (OBF)"
  },
  {
    "value": "CYB",
    "label": "West End Charles Kirkconnell International Airport (CYB)"
  },
  {
    "value": "CCK",
    "label": "West Island Cocos (Keeling) Islands Airport (CCK)"
  },
  {
    "value": "LAF",
    "label": "West Lafayette Purdue University Airport (LAF)"
  },
  {
    "value": "PBI",
    "label": "West Palm Beach Palm Beach International Airport (PBI)"
  },
  {
    "value": "WWY",
    "label": "West Wyalong West Wyalong Airport (WWY)"
  },
  {
    "value": "WYS",
    "label": "West Yellowstone Yellowstone Airport (WYS)"
  },
  {
    "value": "WST",
    "label": "Westerly Westerly State Airport (WST)"
  },
  {
    "value": "TGA",
    "label": "Western Water Catchment Tengah Air Base (TGA)"
  },
  {
    "value": "BAF",
    "label": "Westfield Westfield-Barnes Regional Airport (BAF)"
  },
  {
    "value": "WSZ",
    "label": "Westport Westport Airport (WSZ)"
  },
  {
    "value": "KJK",
    "label": "Wevelgem Flanders International Airport Kortrijk-Wevelgem (KJK)"
  },
  {
    "value": "WWK",
    "label": "Wewak Wewak International Airport (WWK)"
  },
  {
    "value": "SHD",
    "label": "Weyers Cave Shenandoah Valley Regional Airport (SHD)"
  },
  {
    "value": "WRE",
    "label": "Whangarei Whangarei Airport (WRE)"
  },
  {
    "value": "HLG",
    "label": "Wheeling Wheeling Ohio County Airport (HLG)"
  },
  {
    "value": "HPN",
    "label": "White Plains Westchester County Airport (HPN)"
  },
  {
    "value": "YZU",
    "label": "Whitecourt Whitecourt Airport (YZU)"
  },
  {
    "value": "YXY",
    "label": "Whitehorse Whitehorse / Erik Nielsen International Airport (YXY)"
  },
  {
    "value": "WYA",
    "label": "Whyalla Whyalla Airport (WYA)"
  },
  {
    "value": "YVV",
    "label": "Wiarton Wiarton Airport (YVV)"
  },
  {
    "value": "SPS",
    "label": "Wichita Falls Wichita Falls Municipal Airport / Sheppard Air Force Base (SPS)"
  },
  {
    "value": "IAB",
    "label": "Wichita McConnell Air Force Base (IAB)"
  },
  {
    "value": "ICT",
    "label": "Wichita Wichita Eisenhower National Airport (ICT)"
  },
  {
    "value": "WIC",
    "label": "Wick Wick Airport (WIC)"
  },
  {
    "value": "WIE",
    "label": "Wiesbaden Wiesbaden Army Airfield (WIE)"
  },
  {
    "value": "WWD",
    "label": "Wildwood Cape May County Airport (WWD)"
  },
  {
    "value": "AVP",
    "label": "Wilkes-Barre/Scranton Wilkes Barre Scranton International Airport (AVP)"
  },
  {
    "value": "CUR",
    "label": "Willemstad Hato International Airport (CUR)"
  },
  {
    "value": "YWL",
    "label": "Williams Lake Williams Lake Airport (YWL)"
  },
  {
    "value": "IPT",
    "label": "Williamsport Williamsport Regional Airport (IPT)"
  },
  {
    "value": "NTL",
    "label": "Williamtown Newcastle Airport (NTL)"
  },
  {
    "value": "XWA",
    "label": "Williston Williston Basin International Airport (XWA)"
  },
  {
    "value": "ILN",
    "label": "Wilmington Wilmington Airpark (ILN)"
  },
  {
    "value": "ILG",
    "label": "Wilmington Wilmington Airport (ILG)"
  },
  {
    "value": "ILM",
    "label": "Wilmington Wilmington International Airport (ILM)"
  },
  {
    "value": "ERS",
    "label": "Windhoek Eros Airport (ERS)"
  },
  {
    "value": "WDH",
    "label": "Windhoek Hosea Kutako International Airport (WDH)"
  },
  {
    "value": "WNR",
    "label": "Windorah Windorah Airport (WNR)"
  },
  {
    "value": "YQG",
    "label": "Windsor Windsor Airport (YQG)"
  },
  {
    "value": "INK",
    "label": "Wink Winkler County Airport (INK)"
  },
  {
    "value": "WMC",
    "label": "Winnemucca Winnemucca Municipal Airport (WMC)"
  },
  {
    "value": "YWG",
    "label": "Winnipeg Winnipeg / James Armstrong Richardson International Airport (YWG)"
  },
  {
    "value": "INW",
    "label": "Winslow Winslow Lindbergh Regional Airport (INW)"
  },
  {
    "value": "INT",
    "label": "Winston Salem Smith Reynolds Airport (INT)"
  },
  {
    "value": "OLF",
    "label": "Wolf Point L M Clayton Airport (OLF)"
  },
  {
    "value": "WJU",
    "label": "Wonju Wonju Airport / Hoengseong Air Base (K-38/K-46) (WJU)"
  },
  {
    "value": "WOS",
    "label": "Wonsan Wonsan Kalma International Airport (WOS)"
  },
  {
    "value": "WWR",
    "label": "Woodward West Woodward Airport (WWR)"
  },
  {
    "value": "ORH",
    "label": "Worcester Worcester Regional Airport (ORH)"
  },
  {
    "value": "WRL",
    "label": "Worland Worland Municipal Airport (WRL)"
  },
  {
    "value": "WRG",
    "label": "Wrangell Wrangell Airport (WRG)"
  },
  {
    "value": "WRI",
    "label": "Wrightstown Mc Guire Air Force Base (WRI)"
  },
  {
    "value": "YWY",
    "label": "Wrigley Wrigley Airport (YWY)"
  },
  {
    "value": "WRO",
    "label": "Wrocław Copernicus Wrocław Airport (WRO)"
  },
  {
    "value": "WHN",
    "label": "Wuhan (Hannan) Wuhan Hannan Municipal Airport (WHN)"
  },
  {
    "value": "WUH",
    "label": "Wuhan (Huangpi) Wuhan Tianhe International Airport (WUH)"
  },
  {
    "value": "WHA",
    "label": "Wuhu Wuhu Xuanzhou Airport (WHA)"
  },
  {
    "value": "CQW",
    "label": "Wulong Chongqing Xiannüshan Airport (CQW)"
  },
  {
    "value": "BRT",
    "label": "Wurrumiyanga Bathurst Island Airport (BRT)"
  },
  {
    "value": "FCN",
    "label": "Wurster Nordseeküste Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase (FCN)"
  },
  {
    "value": "WUX",
    "label": "Wuxi Sunan Shuofang International Airport (WUX)"
  },
  {
    "value": "WUS",
    "label": "Wuyishan Nanping Wuyishan Airport (WUS)"
  },
  {
    "value": "XGN",
    "label": "Xangongo Xangongo Airport (XGN)"
  },
  {
    "value": "SIA",
    "label": "Xi'an (Baqiao) Xi'an Xiguan Airport (SIA)"
  },
  {
    "value": "XMN",
    "label": "Xiamen Xiamen Gaoqi International Airport (XMN)"
  },
  {
    "value": "LHK",
    "label": "Xiangyang (Laohekou) Guangzhou MR Air Base / Guanghua Airport (LHK)"
  },
  {
    "value": "XFN",
    "label": "Xiangyang (Xiangzhou) Xiangyang Liuji Airport (XFN)"
  },
  {
    "value": "XIY",
    "label": "Xianyang (Weicheng) Xi'an Xianyang International Airport (XIY)"
  },
  {
    "value": "DDR",
    "label": "Xigazê (Dingri) Rikaze Dingri Airport (DDR)"
  },
  {
    "value": "RKZ",
    "label": "Xigazê (Samzhubzê) Xigaze Peace Airport / Shigatse Air Base (RKZ)"
  },
  {
    "value": "XIL",
    "label": "Xilinhot Xilinhot Airport (XIL)"
  },
  {
    "value": "ACX",
    "label": "Xingyi Xingyi Wanfenglin Airport (ACX)"
  },
  {
    "value": "XAI",
    "label": "Xinyang Xinyang Minggang Airport (XAI)"
  },
  {
    "value": "NLT",
    "label": "Xinyuan Xinyuan Nalati Airport (NLT)"
  },
  {
    "value": "XUZ",
    "label": "Xuzhou Xuzhou Guanyin International Airport (XUZ)"
  },
  {
    "value": "BYC",
    "label": "Yacuíba Yacuiba Airport (BYC)"
  },
  {
    "value": "YKM",
    "label": "Yakima Yakima Air Terminal McAllister Field (YKM)"
  },
  {
    "value": "KUM",
    "label": "Yakushima Yakushima Airport (KUM)"
  },
  {
    "value": "YAK",
    "label": "Yakutat Yakutat Airport (YAK)"
  },
  {
    "value": "PYJ",
    "label": "Yakutia Polyarny Airport (PYJ)"
  },
  {
    "value": "YKS",
    "label": "Yakutsk Yakutsk Airport (YKS)"
  },
  {
    "value": "ASK",
    "label": "Yamoussoukro Yamoussoukro Airport (ASK)"
  },
  {
    "value": "SRE",
    "label": "Yamparaez Alcantarí Airport (SRE)"
  },
  {
    "value": "ENY",
    "label": "Yan'an (Baota) Yan'an Nanniwan Airport (ENY)"
  },
  {
    "value": "YNB",
    "label": "Yanbu Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport (YNB)"
  },
  {
    "value": "YNZ",
    "label": "Yancheng (Tinghu) Yancheng Nanyang International Airport (YNZ)"
  },
  {
    "value": "RGN",
    "label": "Yangon Yangon International Airport (RGN)"
  },
  {
    "value": "YTY",
    "label": "Yangzhou Yangzhou Taizhou Airport (YTY)"
  },
  {
    "value": "YNJ",
    "label": "Yanji Yanji Chaoyangchuan Airport (YNJ)"
  },
  {
    "value": "YKN",
    "label": "Yankton Chan Gurney Municipal Airport (YKN)"
  },
  {
    "value": "YNT",
    "label": "Yantai Yantai Penglai International Airport (YNT)"
  },
  {
    "value": "YAO",
    "label": "Yaoundé Yaoundé Airport (YAO)"
  },
  {
    "value": "NSI",
    "label": "Yaoundé Yaoundé Nsimalen International Airport (NSI)"
  },
  {
    "value": "YAP",
    "label": "Yap Island Yap International Airport (YAP)"
  },
  {
    "value": "INU",
    "label": "Yaren District Nauru International Airport (INU)"
  },
  {
    "value": "YQI",
    "label": "Yarmouth Yarmouth Airport (YQI)"
  },
  {
    "value": "YES",
    "label": "Yasuj Yasuj Airport (YES)"
  },
  {
    "value": "AZD",
    "label": "Yazd Shahid Sadooghi Airport (AZD)"
  },
  {
    "value": "YEC",
    "label": "Yecheon-ri Yecheon Airbase (YEC)"
  },
  {
    "value": "SVX",
    "label": "Yekaterinburg Koltsovo Airport (SVX)"
  },
  {
    "value": "YZF",
    "label": "Yellowknife Yellowknife International Airport (YZF)"
  },
  {
    "value": "WYE",
    "label": "Yengema Yengema Airport (WYE)"
  },
  {
    "value": "YEI",
    "label": "Yenişehir Bursa Yenişehir Airport (YEI)"
  },
  {
    "value": "EIE",
    "label": "Yeniseysk Yeniseysk Airport (EIE)"
  },
  {
    "value": "RSU",
    "label": "Yeosu Yeosu Airport (RSU)"
  },
  {
    "value": "YEO",
    "label": "Yeovil, Somerset RNAS Yeovilton (YEO)"
  },
  {
    "value": "EVN",
    "label": "Yerevan Zvartnots International Airport (EVN)"
  },
  {
    "value": "EIK",
    "label": "Yeysk Yeysk Airport (EIK)"
  },
  {
    "value": "YBP",
    "label": "Yibin (Cuiping) Yibin Wuliangye Airport (YBP)"
  },
  {
    "value": "YIH",
    "label": "Yichang (Xiaoting) Yichang Sanxia Airport (YIH)"
  },
  {
    "value": "LDS",
    "label": "Yichun Yichun Lindu Airport (LDS)"
  },
  {
    "value": "YIC",
    "label": "Yichun Yichun Mingyueshan Airport (YIC)"
  },
  {
    "value": "UAM",
    "label": "Yigo Andersen Air Force Base (UAM)"
  },
  {
    "value": "INC",
    "label": "Yinchuan Yinchuan Hedong International Airport (INC)"
  },
  {
    "value": "YKH",
    "label": "Yingkou (Laobian) Yingkou Lanqi Airport (YKH)"
  },
  {
    "value": "FUG",
    "label": "Yingzhou, Fuyang Fuyang Xiguan Airport (FUG)"
  },
  {
    "value": "YLI",
    "label": "Ylivieska Ylivieska Airfield (YLI)"
  },
  {
    "value": "JOG",
    "label": "Yogyakarta Adisutjipto Airport (JOG)"
  },
  {
    "value": "YIA",
    "label": "Yogyakarta Yogyakarta International Airport (YIA)"
  },
  {
    "value": "YOL",
    "label": "Yola Yola Airport (YOL)"
  },
  {
    "value": "YGJ",
    "label": "Yonago Yonago Kitaro Airport / JASDF Miho Air Base (YGJ)"
  },
  {
    "value": "OGN",
    "label": "Yonaguni Yonaguni Airport (OGN)"
  },
  {
    "value": "LLF",
    "label": "Yongzhou Yongzhou Lingling Airport (LLF)"
  },
  {
    "value": "EYP",
    "label": "Yopal El Alcaravan - Yopal Airport (EYP)"
  },
  {
    "value": "YQV",
    "label": "Yorkton Yorkton Municipal Airport (YQV)"
  },
  {
    "value": "RNJ",
    "label": "Yoron Yoron Airport (RNJ)"
  },
  {
    "value": "JOK",
    "label": "Yoshkar-Ola Yoshkar-Ola Airport (JOK)"
  },
  {
    "value": "YNG",
    "label": "Youngstown/Warren Youngstown Warren Regional Airport (YNG)"
  },
  {
    "value": "YYA",
    "label": "Yueyang (Yueyanglou) Yueyang Sanhe Airport (YYA)"
  },
  {
    "value": "AYQ",
    "label": "Yulara Ayers Rock Connellan Airport (AYQ)"
  },
  {
    "value": "YLX",
    "label": "Yùlín Yulin Fumian Airport (YLX)"
  },
  {
    "value": "YUM",
    "label": "Yuma Yuma International Airport / Marine Corps Air Station Yuma (YUM)"
  },
  {
    "value": "YCU",
    "label": "Yuncheng (Yanhu) Yuncheng Zhangxiao Airport (YCU)"
  },
  {
    "value": "BJL",
    "label": "Yundum Banjul International Airport (BJL)"
  },
  {
    "value": "YMS",
    "label": "Yurimaguas Moises Benzaquen Rengifo Airport (YMS)"
  },
  {
    "value": "YUS",
    "label": "Yushu (Batang) Yushu Batang Airport (YUS)"
  },
  {
    "value": "UUS",
    "label": "Yuzhno-Sakhalinsk Yuzhno-Sakhalinsk Airport (UUS)"
  },
  {
    "value": "ACZ",
    "label": "Zabol Zabol Airport (ACZ)"
  },
  {
    "value": "ZXT",
    "label": "Zabrat Zabrat Airport (ZXT)"
  },
  {
    "value": "ZCL",
    "label": "Zacatecas General Leobardo C. Ruiz International Airport (ZCL)"
  },
  {
    "value": "OZG",
    "label": "Zagora Zagora Airport (OZG)"
  },
  {
    "value": "ZAH",
    "label": "Zahedan Zahedan International Airport (ZAH)"
  },
  {
    "value": "ZTH",
    "label": "Zakynthos Zakynthos International Airport Dionysios Solomos (ZTH)"
  },
  {
    "value": "ZAM",
    "label": "Zamboanga Zamboanga International Airport (ZAM)"
  },
  {
    "value": "PBM",
    "label": "Zandery Johan Adolf Pengel International Airport (PBM)"
  },
  {
    "value": "ZZV",
    "label": "Zanesville Zanesville Municipal Airport (ZZV)"
  },
  {
    "value": "JWN",
    "label": "Zanjan Zanjan Airport (JWN)"
  },
  {
    "value": "ZNZ",
    "label": "Zanzibar Abeid Amani Karume International Airport (ZNZ)"
  },
  {
    "value": "APZ",
    "label": "Zapala Zapala Airport (APZ)"
  },
  {
    "value": "OZH",
    "label": "Zaporizhia Zaporizhzhia International Airport (OZH)"
  },
  {
    "value": "ZTU",
    "label": "Zaqatala Zaqatala International Airport (ZTU)"
  },
  {
    "value": "ZAZ",
    "label": "Zaragoza Zaragoza Airport (ZAZ)"
  },
  {
    "value": "ZAR",
    "label": "Zaria Zaria Airport (ZAR)"
  },
  {
    "value": "BRU",
    "label": "Zaventem Brussels Airport (BRU)"
  },
  {
    "value": "BJY",
    "label": "Zemun Batajnica Air Base (BJY)"
  },
  {
    "value": "ZAD",
    "label": "Zemunik Donji (Zadar) Zadar Airport (ZAD)"
  },
  {
    "value": "TLM",
    "label": "Zenata Zenata – Messali El Hadj Airport (TLM)"
  },
  {
    "value": "LJU",
    "label": "Zgornji Brnik Ljubljana Jože Pučnik Airport (LJU)"
  },
  {
    "value": "NZL",
    "label": "Zhalantun Zhalantun Genghis Khan Airport (NZL)"
  },
  {
    "value": "ZQZ",
    "label": "Zhangjiakou Zhangjiakou Ningyuan Airport (ZQZ)"
  },
  {
    "value": "ZHA",
    "label": "Zhanjiang Zhanjiang Wuchuan Airport (ZHA)"
  },
  {
    "value": "CGO",
    "label": "Zhengzhou Zhengzhou Xinzheng International Airport (CGO)"
  },
  {
    "value": "DZN",
    "label": "Zhezkazgan Zhezkazgan National Airport (DZN)"
  },
  {
    "value": "ZIX",
    "label": "Zhigansk Zhigansk Airport (ZIX)"
  },
  {
    "value": "ZHY",
    "label": "Zhongwei (Shapotou) Zhongwei Shapotou Airport (ZHY)"
  },
  {
    "value": "HSN",
    "label": "Zhoushan Zhoushan Putuoshan Airport (HSN)"
  },
  {
    "value": "ZUH",
    "label": "Zhuhai (Jinwan) Zhuhai Jinwan Airport (ZUH)"
  },
  {
    "value": "ZIG",
    "label": "Ziguinchor Ziguinchor Airport (ZIG)"
  },
  {
    "value": "ZND",
    "label": "Zinder Zinder Airport (ZND)"
  },
  {
    "value": "SAB",
    "label": "Zion's Hill Juancho E. Yrausquin Airport (SAB)"
  },
  {
    "value": "HDF",
    "label": "Zirchow Heringsdorf Airport (HDF)"
  },
  {
    "value": "ZER",
    "label": "Ziro Ziro Airport (ZER)"
  },
  {
    "value": "ONQ",
    "label": "Zonguldak Zonguldak Çaycuma Airport (ONQ)"
  },
  {
    "value": "WMT",
    "label": "Zunyi Zunyi Maotai Airport (WMT)"
  },
  {
    "value": "ZYI",
    "label": "Zunyi Zunyi Xinzhou Airport (ZYI)"
  },
  {
    "value": "ZRH",
    "label": "Zurich Zürich Airport (ZRH)"
  },
  {
    "value": "ZKP",
    "label": "Zyryanka Zyryanka Airport (ZKP)"
  }
]; 

export default airports